/*! DiplanStyle v16.0.2 | MIT License | https://www.dev.diplanung.de/DefaultCollection/DiPlanStyle/_git/diplan-style */
import * as Bootstrap from "bootstrap";
import { ref, readonly, getCurrentInstance, onMounted, nextTick, watch, reactive, defineComponent, createBlock, openBlock, resolveDynamicComponent, normalizeClass, withCtx, createElementVNode, resolveComponent, createElementBlock, renderSlot, Fragment, createCommentVNode, toDisplayString, renderList, createTextVNode, mergeProps, withDirectives, vShow, withModifiers, withKeys, createVNode, Transition, normalizeStyle, createSlots, normalizeProps, guardReactiveProps, computed, onBeforeUnmount } from "vue";
import DatePicker from "vue-datepicker-next";
import moment from "moment";
var oe$1 = Object.defineProperty;
var K = Object.getOwnPropertySymbols;
var ue = Object.prototype.hasOwnProperty, fe$1 = Object.prototype.propertyIsEnumerable;
var N = (e, t, n) => t in e ? oe$1(e, t, { enumerable: true, configurable: true, writable: true, value: n }) : e[t] = n, d$1 = (e, t) => {
  for (var n in t || (t = {})) ue.call(t, n) && N(e, n, t[n]);
  if (K) for (var n of K(t)) fe$1.call(t, n) && N(e, n, t[n]);
  return e;
};
function a(e) {
  return e == null || e === "" || Array.isArray(e) && e.length === 0 || !(e instanceof Date) && typeof e == "object" && Object.keys(e).length === 0;
}
function l(e) {
  return typeof e == "function" && "call" in e && "apply" in e;
}
function s$1(e) {
  return !a(e);
}
function i(e, t = true) {
  return e instanceof Object && e.constructor === Object && (t || Object.keys(e).length !== 0);
}
function $(e = {}, t = {}) {
  let n = d$1({}, e);
  return Object.keys(t).forEach((r) => {
    let o = r;
    i(t[o]) && o in e && i(e[o]) ? n[o] = $(e[o], t[o]) : n[o] = t[o];
  }), n;
}
function w(...e) {
  return e.reduce((t, n, r) => r === 0 ? n : $(t, n), {});
}
function m(e, ...t) {
  return l(e) ? e(...t) : e;
}
function p(e, t = true) {
  return typeof e == "string" && (t || e !== "");
}
function _$1(e) {
  return s$1(e) && !isNaN(e);
}
function z(e, t) {
  if (t) {
    let n = t.test(e);
    return t.lastIndex = 0, n;
  }
  return false;
}
function U(...e) {
  return w(...e);
}
function G(e) {
  return e && e.replace(/\/\*(?:(?!\*\/)[\s\S])*\*\/|[\r\n\t]+/g, "").replace(/ {2,}/g, " ").replace(/ ([{:}]) /g, "$1").replace(/([;,]) /g, "$1").replace(/ !/g, "!").replace(/: /g, ":").trim();
}
function ee(e) {
  return p(e) ? e.replace(/(_)/g, "-").replace(/[A-Z]/g, (t, n) => n === 0 ? t : "-" + t.toLowerCase()).toLowerCase() : e;
}
function s() {
  let r = /* @__PURE__ */ new Map();
  return { on(e, t) {
    let n = r.get(e);
    return n ? n.push(t) : n = [t], r.set(e, n), this;
  }, off(e, t) {
    let n = r.get(e);
    return n && n.splice(n.indexOf(t) >>> 0, 1), this;
  }, emit(e, t) {
    let n = r.get(e);
    n && n.forEach((i2) => {
      i2(t);
    });
  }, clear() {
    r.clear();
  } };
}
function y(t) {
  if (t) {
    let e = t.parentNode;
    return e && e instanceof ShadowRoot && e.host && (e = e.host), e;
  }
  return null;
}
function T$1(t) {
  return !!(t !== null && typeof t != "undefined" && t.nodeName && y(t));
}
function c(t) {
  return typeof Element != "undefined" ? t instanceof Element : t !== null && typeof t == "object" && t.nodeType === 1 && typeof t.nodeName == "string";
}
function A(t, e = {}) {
  if (c(t)) {
    let o = (n, r) => {
      var l2, d2;
      let i2 = (l2 = t == null ? void 0 : t.$attrs) != null && l2[n] ? [(d2 = t == null ? void 0 : t.$attrs) == null ? void 0 : d2[n]] : [];
      return [r].flat().reduce((s2, a2) => {
        if (a2 != null) {
          let u = typeof a2;
          if (u === "string" || u === "number") s2.push(a2);
          else if (u === "object") {
            let p2 = Array.isArray(a2) ? o(n, a2) : Object.entries(a2).map(([f, g2]) => n === "style" && (g2 || g2 === 0) ? `${f.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}:${g2}` : g2 ? f : void 0);
            s2 = p2.length ? s2.concat(p2.filter((f) => !!f)) : s2;
          }
        }
        return s2;
      }, i2);
    };
    Object.entries(e).forEach(([n, r]) => {
      if (r != null) {
        let i2 = n.match(/^on(.+)/);
        i2 ? t.addEventListener(i2[1].toLowerCase(), r) : n === "p-bind" || n === "pBind" ? A(t, r) : (r = n === "class" ? [...new Set(o("class", r))].join(" ").trim() : n === "style" ? o("style", r).join(";").trim() : r, (t.$attrs = t.$attrs || {}) && (t.$attrs[n] = r), t.setAttribute(n, r));
      }
    });
  }
}
function tt() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
function Kt(t, e = "", o) {
  c(t) && o !== null && o !== void 0 && t.setAttribute(e, o);
}
var Qe = Object.defineProperty, Ye = Object.defineProperties;
var et = Object.getOwnPropertyDescriptors;
var F = Object.getOwnPropertySymbols;
var fe = Object.prototype.hasOwnProperty, ye = Object.prototype.propertyIsEnumerable;
var he = (e, t, r) => t in e ? Qe(e, t, { enumerable: true, configurable: true, writable: true, value: r }) : e[t] = r, d = (e, t) => {
  for (var r in t || (t = {})) fe.call(t, r) && he(e, r, t[r]);
  if (F) for (var r of F(t)) ye.call(t, r) && he(e, r, t[r]);
  return e;
}, _ = (e, t) => Ye(e, et(t));
var b = (e, t) => {
  var r = {};
  for (var s2 in e) fe.call(e, s2) && t.indexOf(s2) < 0 && (r[s2] = e[s2]);
  if (e != null && F) for (var s2 of F(e)) t.indexOf(s2) < 0 && ye.call(e, s2) && (r[s2] = e[s2]);
  return r;
};
var st = s(), R = st;
var v = /{([^}]*)}/g, lt = /(\d+\s+[\+\-\*\/]\s+\d+)/g, ct = /var\([^)]+\)/g;
function ke(e) {
  return i(e) && e.hasOwnProperty("$value") && e.hasOwnProperty("$type") ? e.$value : e;
}
function mt(e) {
  return e.replaceAll(/ /g, "").replace(/[^\w]/g, "-");
}
function Q(e = "", t = "") {
  return mt(`${p(e, false) && p(t, false) ? `${e}-` : e}${t}`);
}
function ne(e = "", t = "") {
  return `--${Q(e, t)}`;
}
function dt(e = "") {
  let t = (e.match(/{/g) || []).length, r = (e.match(/}/g) || []).length;
  return (t + r) % 2 !== 0;
}
function Y(e, t = "", r = "", s2 = [], o) {
  if (p(e)) {
    let a2 = e.trim();
    if (dt(a2)) return;
    if (z(a2, v)) {
      let n = a2.replaceAll(v, (l2) => {
        let c2 = l2.replace(/{|}/g, "").split(".").filter((m2) => !s2.some((u) => z(m2, u)));
        return `var(${ne(r, ee(c2.join("-")))}${s$1(o) ? `, ${o}` : ""})`;
      });
      return z(n.replace(ct, "0"), lt) ? `calc(${n})` : n;
    }
    return a2;
  } else if (_$1(e)) return e;
}
function _e(e, t, r) {
  p(t, false) && e.push(`${t}:${r};`);
}
function T(e, t) {
  return e ? `${e}{${t}}` : "";
}
function oe(e, t) {
  if (e.indexOf("dt(") === -1) return e;
  function r(n, l2) {
    let i2 = [], c2 = 0, m2 = "", u = null, p2 = 0;
    for (; c2 <= n.length; ) {
      let h = n[c2];
      if ((h === '"' || h === "'" || h === "`") && n[c2 - 1] !== "\\" && (u = u === h ? null : h), !u && (h === "(" && p2++, h === ")" && p2--, (h === "," || c2 === n.length) && p2 === 0)) {
        let y2 = m2.trim();
        y2.startsWith("dt(") ? i2.push(oe(y2, l2)) : i2.push(s2(y2)), m2 = "", c2++;
        continue;
      }
      h !== void 0 && (m2 += h), c2++;
    }
    return i2;
  }
  function s2(n) {
    let l2 = n[0];
    if ((l2 === '"' || l2 === "'" || l2 === "`") && n[n.length - 1] === l2) return n.slice(1, -1);
    let i2 = Number(n);
    return isNaN(i2) ? n : i2;
  }
  let o = [], a2 = [];
  for (let n = 0; n < e.length; n++) if (e[n] === "d" && e.slice(n, n + 3) === "dt(") a2.push(n), n += 2;
  else if (e[n] === ")" && a2.length > 0) {
    let l2 = a2.pop();
    a2.length === 0 && o.push([l2, n]);
  }
  if (!o.length) return e;
  for (let n = o.length - 1; n >= 0; n--) {
    let [l2, i2] = o[n], c2 = e.slice(l2 + 3, i2), m2 = r(c2, t), u = t(...m2);
    e = e.slice(0, l2) + u + e.slice(i2 + 1);
  }
  return e;
}
var P = (...e) => le(g.getTheme(), ...e), le = (e = {}, t, r, s2) => {
  if (t) {
    let { variable: o, options: a$1 } = g.defaults || {}, { prefix: n, transform: l2 } = (e == null ? void 0 : e.options) || a$1 || {}, i2 = z(t, v) ? t : `{${t}}`;
    return s2 === "value" || a(s2) && l2 === "strict" ? g.getTokenValue(t) : Y(i2, void 0, n, [o.excludedKeyRegex], r);
  }
  return "";
};
function ar(e, ...t) {
  if (e instanceof Array) {
    let r = e.reduce((s2, o, a2) => {
      var n;
      return s2 + o + ((n = m(t[a2], { dt: P })) != null ? n : "");
    }, "");
    return oe(r, P);
  }
  return m(e, { dt: P });
}
function ce(e, t = {}) {
  let r = g.defaults.variable, { prefix: s2 = r.prefix, selector: o = r.selector, excludedKeyRegex: a2 = r.excludedKeyRegex } = t, n = [], l2 = [], i$1 = [{ node: e, path: s2 }];
  for (; i$1.length; ) {
    let { node: m2, path: u } = i$1.pop();
    for (let p2 in m2) {
      let h = m2[p2], y2 = ke(h), x = z(p2, a2) ? Q(u) : Q(u, ee(p2));
      if (i(y2)) i$1.push({ node: y2, path: x });
      else {
        let k = ne(x), w2 = Y(y2, x, s2, [a2]);
        _e(l2, k, w2);
        let $2 = x;
        s2 && $2.startsWith(s2 + "-") && ($2 = $2.slice(s2.length + 1)), n.push($2.replace(/-/g, "."));
      }
    }
  }
  let c2 = l2.join("");
  return { value: l2, tokens: n, declarations: c2, css: T(o, c2) };
}
var S = { regex: { rules: { class: { pattern: /^\.([a-zA-Z][\w-]*)$/, resolve(e) {
  return { type: "class", selector: e, matched: this.pattern.test(e.trim()) };
} }, attr: { pattern: /^\[(.*)\]$/, resolve(e) {
  return { type: "attr", selector: `:root${e}`, matched: this.pattern.test(e.trim()) };
} }, media: { pattern: /^@media (.*)$/, resolve(e) {
  return { type: "media", selector: e, matched: this.pattern.test(e.trim()) };
} }, system: { pattern: /^system$/, resolve(e) {
  return { type: "system", selector: "@media (prefers-color-scheme: dark)", matched: this.pattern.test(e.trim()) };
} }, custom: { resolve(e) {
  return { type: "custom", selector: e, matched: true };
} } }, resolve(e) {
  let t = Object.keys(this.rules).filter((r) => r !== "custom").map((r) => this.rules[r]);
  return [e].flat().map((r) => {
    var s2;
    return (s2 = t.map((o) => o.resolve(r)).find((o) => o.matched)) != null ? s2 : this.rules.custom.resolve(r);
  });
} }, _toVariables(e, t) {
  return ce(e, { prefix: t == null ? void 0 : t.prefix });
}, getCommon({ name: e = "", theme: t = {}, params: r, set: s2, defaults: o }) {
  var w2, $2, j, V, D, z2, E;
  let { preset: a2, options: n } = t, l2, i2, c2, m$1, u, p2, h;
  if (s$1(a2) && n.transform !== "strict") {
    let { primitive: L, semantic: te, extend: re } = a2, y2 = te || {}, { colorScheme: K2 } = y2, M = b(y2, ["colorScheme"]), N2 = re || {}, { colorScheme: X } = N2, B = b(N2, ["colorScheme"]), x = K2 || {}, { dark: G2 } = x, I = b(x, ["dark"]), k = X || {}, { dark: U2 } = k, H = b(k, ["dark"]), W = s$1(L) ? this._toVariables({ primitive: L }, n) : {}, q = s$1(M) ? this._toVariables({ semantic: M }, n) : {}, Z = s$1(I) ? this._toVariables({ light: I }, n) : {}, de = s$1(G2) ? this._toVariables({ dark: G2 }, n) : {}, ue2 = s$1(B) ? this._toVariables({ semantic: B }, n) : {}, pe = s$1(H) ? this._toVariables({ light: H }, n) : {}, ge = s$1(U2) ? this._toVariables({ dark: U2 }, n) : {}, [Le, Me] = [(w2 = W.declarations) != null ? w2 : "", W.tokens], [Ae, je] = [($2 = q.declarations) != null ? $2 : "", q.tokens || []], [De, ze] = [(j = Z.declarations) != null ? j : "", Z.tokens || []], [Ke, Xe] = [(V = de.declarations) != null ? V : "", de.tokens || []], [Be, Ge] = [(D = ue2.declarations) != null ? D : "", ue2.tokens || []], [Ie, Ue] = [(z2 = pe.declarations) != null ? z2 : "", pe.tokens || []], [He, We] = [(E = ge.declarations) != null ? E : "", ge.tokens || []];
    l2 = this.transformCSS(e, Le, "light", "variable", n, s2, o), i2 = Me;
    let qe = this.transformCSS(e, `${Ae}${De}`, "light", "variable", n, s2, o), Ze = this.transformCSS(e, `${Ke}`, "dark", "variable", n, s2, o);
    c2 = `${qe}${Ze}`, m$1 = [.../* @__PURE__ */ new Set([...je, ...ze, ...Xe])];
    let Fe = this.transformCSS(e, `${Be}${Ie}color-scheme:light`, "light", "variable", n, s2, o), Je = this.transformCSS(e, `${He}color-scheme:dark`, "dark", "variable", n, s2, o);
    u = `${Fe}${Je}`, p2 = [.../* @__PURE__ */ new Set([...Ge, ...Ue, ...We])], h = m(a2.css, { dt: P });
  }
  return { primitive: { css: l2, tokens: i2 }, semantic: { css: c2, tokens: m$1 }, global: { css: u, tokens: p2 }, style: h };
}, getPreset({ name: e = "", preset: t = {}, options: r, params: s2, set: o, defaults: a2, selector: n }) {
  var y2, N2, x;
  let l2, i2, c2;
  if (s$1(t) && r.transform !== "strict") {
    let k = e.replace("-directive", ""), m$1 = t, { colorScheme: w2, extend: $2, css: j } = m$1, V = b(m$1, ["colorScheme", "extend", "css"]), u = $2 || {}, { colorScheme: D } = u, z2 = b(u, ["colorScheme"]), p2 = w2 || {}, { dark: E } = p2, L = b(p2, ["dark"]), h = D || {}, { dark: te } = h, re = b(h, ["dark"]), K2 = s$1(V) ? this._toVariables({ [k]: d(d({}, V), z2) }, r) : {}, M = s$1(L) ? this._toVariables({ [k]: d(d({}, L), re) }, r) : {}, X = s$1(E) ? this._toVariables({ [k]: d(d({}, E), te) }, r) : {}, [B, G2] = [(y2 = K2.declarations) != null ? y2 : "", K2.tokens || []], [I, U2] = [(N2 = M.declarations) != null ? N2 : "", M.tokens || []], [H, W] = [(x = X.declarations) != null ? x : "", X.tokens || []], q = this.transformCSS(k, `${B}${I}`, "light", "variable", r, o, a2, n), Z = this.transformCSS(k, H, "dark", "variable", r, o, a2, n);
    l2 = `${q}${Z}`, i2 = [.../* @__PURE__ */ new Set([...G2, ...U2, ...W])], c2 = m(j, { dt: P });
  }
  return { css: l2, tokens: i2, style: c2 };
}, getPresetC({ name: e = "", theme: t = {}, params: r, set: s2, defaults: o }) {
  var i2;
  let { preset: a2, options: n } = t, l2 = (i2 = a2 == null ? void 0 : a2.components) == null ? void 0 : i2[e];
  return this.getPreset({ name: e, preset: l2, options: n, params: r, set: s2, defaults: o });
}, getPresetD({ name: e = "", theme: t = {}, params: r, set: s2, defaults: o }) {
  var c2, m2;
  let a2 = e.replace("-directive", ""), { preset: n, options: l2 } = t, i2 = ((c2 = n == null ? void 0 : n.components) == null ? void 0 : c2[a2]) || ((m2 = n == null ? void 0 : n.directives) == null ? void 0 : m2[a2]);
  return this.getPreset({ name: a2, preset: i2, options: l2, params: r, set: s2, defaults: o });
}, applyDarkColorScheme(e) {
  return !(e.darkModeSelector === "none" || e.darkModeSelector === false);
}, getColorSchemeOption(e, t) {
  var r;
  return this.applyDarkColorScheme(e) ? this.regex.resolve(e.darkModeSelector === true ? t.options.darkModeSelector : (r = e.darkModeSelector) != null ? r : t.options.darkModeSelector) : [];
}, getLayerOrder(e, t = {}, r, s2) {
  let { cssLayer: o } = t;
  return o ? `@layer ${m(o.order || o.name || "primeui", r)}` : "";
}, getCommonStyleSheet({ name: e = "", theme: t = {}, params: r, props: s2 = {}, set: o, defaults: a2 }) {
  let n = this.getCommon({ name: e, theme: t, params: r, set: o, defaults: a2 }), l2 = Object.entries(s2).reduce((i2, [c2, m2]) => i2.push(`${c2}="${m2}"`) && i2, []).join(" ");
  return Object.entries(n || {}).reduce((i$1, [c2, m2]) => {
    if (i(m2) && Object.hasOwn(m2, "css")) {
      let u = G(m2.css), p2 = `${c2}-variables`;
      i$1.push(`<style type="text/css" data-primevue-style-id="${p2}" ${l2}>${u}</style>`);
    }
    return i$1;
  }, []).join("");
}, getStyleSheet({ name: e = "", theme: t = {}, params: r, props: s2 = {}, set: o, defaults: a2 }) {
  var c2;
  let n = { name: e, theme: t, params: r, set: o, defaults: a2 }, l2 = (c2 = e.includes("-directive") ? this.getPresetD(n) : this.getPresetC(n)) == null ? void 0 : c2.css, i2 = Object.entries(s2).reduce((m2, [u, p2]) => m2.push(`${u}="${p2}"`) && m2, []).join(" ");
  return l2 ? `<style type="text/css" data-primevue-style-id="${e}-variables" ${i2}>${G(l2)}</style>` : "";
}, createTokens(e = {}, t, r = "", s2 = "", o = {}) {
  return {};
}, getTokenValue(e, t, r) {
  var l2;
  let o = ((i2) => i2.split(".").filter((m2) => !z(m2.toLowerCase(), r.variable.excludedKeyRegex)).join("."))(t), a2 = t.includes("colorScheme.light") ? "light" : t.includes("colorScheme.dark") ? "dark" : void 0, n = [(l2 = e[o]) == null ? void 0 : l2.computed(a2)].flat().filter((i2) => i2);
  return n.length === 1 ? n[0].value : n.reduce((i2 = {}, c2) => {
    let p2 = c2, { colorScheme: m2 } = p2, u = b(p2, ["colorScheme"]);
    return i2[m2] = u, i2;
  }, void 0);
}, getSelectorRule(e, t, r, s2) {
  return r === "class" || r === "attr" ? T(s$1(t) ? `${e}${t},${e} ${t}` : e, s2) : T(e, T(t != null ? t : ":root", s2));
}, transformCSS(e, t, r, s2, o = {}, a2, n, l2) {
  if (s$1(t)) {
    let { cssLayer: i$1 } = o;
    if (s2 !== "style") {
      let c2 = this.getColorSchemeOption(o, n);
      t = r === "dark" ? c2.reduce((m2, { type: u, selector: p2 }) => (s$1(p2) && (m2 += p2.includes("[CSS]") ? p2.replace("[CSS]", t) : this.getSelectorRule(p2, l2, u, t)), m2), "") : T(l2 != null ? l2 : ":root", t);
    }
    if (i$1) {
      let c2 = { name: "primeui" };
      i(i$1) && (c2.name = m(i$1.name, { name: e, type: s2 })), s$1(c2.name) && (t = T(`@layer ${c2.name}`, t), a2 == null || a2.layerNames(c2.name));
    }
    return t;
  }
  return "";
} };
var g = { defaults: { variable: { prefix: "p", selector: ":root", excludedKeyRegex: /^(primitive|semantic|components|directives|variables|colorscheme|light|dark|common|root|states|extend|css)$/gi }, options: { prefix: "p", darkModeSelector: "system", cssLayer: false } }, _theme: void 0, _layerNames: /* @__PURE__ */ new Set(), _loadedStyleNames: /* @__PURE__ */ new Set(), _loadingStyles: /* @__PURE__ */ new Set(), _tokens: {}, update(e = {}) {
  let { theme: t } = e;
  t && (this._theme = _(d({}, t), { options: d(d({}, this.defaults.options), t.options) }), this._tokens = S.createTokens(this.preset, this.defaults), this.clearLoadedStyleNames());
}, get theme() {
  return this._theme;
}, get preset() {
  var e;
  return ((e = this.theme) == null ? void 0 : e.preset) || {};
}, get options() {
  var e;
  return ((e = this.theme) == null ? void 0 : e.options) || {};
}, get tokens() {
  return this._tokens;
}, getTheme() {
  return this.theme;
}, setTheme(e) {
  this.update({ theme: e }), R.emit("theme:change", e);
}, getPreset() {
  return this.preset;
}, setPreset(e) {
  this._theme = _(d({}, this.theme), { preset: e }), this._tokens = S.createTokens(e, this.defaults), this.clearLoadedStyleNames(), R.emit("preset:change", e), R.emit("theme:change", this.theme);
}, getOptions() {
  return this.options;
}, setOptions(e) {
  this._theme = _(d({}, this.theme), { options: e }), this.clearLoadedStyleNames(), R.emit("options:change", e), R.emit("theme:change", this.theme);
}, getLayerNames() {
  return [...this._layerNames];
}, setLayerNames(e) {
  this._layerNames.add(e);
}, getLoadedStyleNames() {
  return this._loadedStyleNames;
}, isStyleNameLoaded(e) {
  return this._loadedStyleNames.has(e);
}, setLoadedStyleName(e) {
  this._loadedStyleNames.add(e);
}, deleteLoadedStyleName(e) {
  this._loadedStyleNames.delete(e);
}, clearLoadedStyleNames() {
  this._loadedStyleNames.clear();
}, getTokenValue(e) {
  return S.getTokenValue(this.tokens, e, this.defaults);
}, getCommon(e = "", t) {
  return S.getCommon({ name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
}, getComponent(e = "", t) {
  let r = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
  return S.getPresetC(r);
}, getDirective(e = "", t) {
  let r = { name: e, theme: this.theme, params: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
  return S.getPresetD(r);
}, getCustomPreset(e = "", t, r, s2) {
  let o = { name: e, preset: t, options: this.options, selector: r, params: s2, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
  return S.getPreset(o);
}, getLayerOrderCSS(e = "") {
  return S.getLayerOrder(e, this.options, { names: this.getLayerNames() }, this.defaults);
}, transformCSS(e = "", t, r = "style", s2) {
  return S.transformCSS(e, t, s2, r, this.options, { layerNames: this.setLayerNames.bind(this) }, this.defaults);
}, getCommonStyleSheet(e = "", t, r = {}) {
  return S.getCommonStyleSheet({ name: e, theme: this.theme, params: t, props: r, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
}, getStyleSheet(e, t, r = {}) {
  return S.getStyleSheet({ name: e, theme: this.theme, params: t, props: r, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
}, onStyleMounted(e) {
  this._loadingStyles.add(e);
}, onStyleUpdated(e) {
  this._loadingStyles.add(e);
}, onStyleLoaded(e, { name: t }) {
  this._loadingStyles.size && (this._loadingStyles.delete(t), R.emit(`theme:${t}:load`, e), !this._loadingStyles.size && R.emit("theme:load"));
} };
function _typeof$2(o) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$2(o);
}
function ownKeys$2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$2(Object(t), true).forEach(function(r2) {
      _defineProperty$2(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty$2(e, r, t) {
  return (r = _toPropertyKey$2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey$2(t) {
  var i2 = _toPrimitive$2(t, "string");
  return "symbol" == _typeof$2(i2) ? i2 : i2 + "";
}
function _toPrimitive$2(t, r) {
  if ("object" != _typeof$2(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i2 = e.call(t, r);
    if ("object" != _typeof$2(i2)) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function tryOnMounted(fn) {
  var sync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  if (getCurrentInstance() && getCurrentInstance().components) onMounted(fn);
  else if (sync) fn();
  else nextTick(fn);
}
var _id = 0;
function useStyle(css3) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var isLoaded = ref(false);
  var cssRef = ref(css3);
  var styleRef = ref(null);
  var defaultDocument = tt() ? window.document : void 0;
  var _options$document = options.document, document2 = _options$document === void 0 ? defaultDocument : _options$document, _options$immediate = options.immediate, immediate = _options$immediate === void 0 ? true : _options$immediate, _options$manual = options.manual, manual = _options$manual === void 0 ? false : _options$manual, _options$name = options.name, name = _options$name === void 0 ? "style_".concat(++_id) : _options$name, _options$id = options.id, id = _options$id === void 0 ? void 0 : _options$id, _options$media = options.media, media = _options$media === void 0 ? void 0 : _options$media, _options$nonce = options.nonce, nonce = _options$nonce === void 0 ? void 0 : _options$nonce, _options$first = options.first, first = _options$first === void 0 ? false : _options$first, _options$onMounted = options.onMounted, onStyleMounted = _options$onMounted === void 0 ? void 0 : _options$onMounted, _options$onUpdated = options.onUpdated, onStyleUpdated = _options$onUpdated === void 0 ? void 0 : _options$onUpdated, _options$onLoad = options.onLoad, onStyleLoaded = _options$onLoad === void 0 ? void 0 : _options$onLoad, _options$props = options.props, props = _options$props === void 0 ? {} : _options$props;
  var stop = function stop2() {
  };
  var load2 = function load3(_css) {
    var _props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!document2) return;
    var _styleProps = _objectSpread$2(_objectSpread$2({}, props), _props);
    var _name = _styleProps.name || name, _id2 = _styleProps.id || id, _nonce = _styleProps.nonce || nonce;
    styleRef.value = document2.querySelector('style[data-primevue-style-id="'.concat(_name, '"]')) || document2.getElementById(_id2) || document2.createElement("style");
    if (!styleRef.value.isConnected) {
      cssRef.value = _css || css3;
      A(styleRef.value, {
        type: "text/css",
        id: _id2,
        media,
        nonce: _nonce
      });
      first ? document2.head.prepend(styleRef.value) : document2.head.appendChild(styleRef.value);
      Kt(styleRef.value, "data-primevue-style-id", _name);
      A(styleRef.value, _styleProps);
      styleRef.value.onload = function(event) {
        return onStyleLoaded === null || onStyleLoaded === void 0 ? void 0 : onStyleLoaded(event, {
          name: _name
        });
      };
      onStyleMounted === null || onStyleMounted === void 0 || onStyleMounted(_name);
    }
    if (isLoaded.value) return;
    stop = watch(cssRef, function(value) {
      styleRef.value.textContent = value;
      onStyleUpdated === null || onStyleUpdated === void 0 || onStyleUpdated(_name);
    }, {
      immediate: true
    });
    isLoaded.value = true;
  };
  var unload = function unload2() {
    if (!document2 || !isLoaded.value) return;
    stop();
    T$1(styleRef.value) && document2.head.removeChild(styleRef.value);
    isLoaded.value = false;
    styleRef.value = null;
  };
  if (immediate && !manual) tryOnMounted(load2);
  return {
    id,
    name,
    el: styleRef,
    css: cssRef,
    unload,
    load: load2,
    isLoaded: readonly(isLoaded)
  };
}
var style = "\n    *,\n    ::before,\n    ::after {\n        box-sizing: border-box;\n    }\n\n    /* Non vue overlay animations */\n    .p-connected-overlay {\n        opacity: 0;\n        transform: scaleY(0.8);\n        transition:\n            transform 0.12s cubic-bezier(0, 0, 0.2, 1),\n            opacity 0.12s cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-connected-overlay-visible {\n        opacity: 1;\n        transform: scaleY(1);\n    }\n\n    .p-connected-overlay-hidden {\n        opacity: 0;\n        transform: scaleY(1);\n        transition: opacity 0.1s linear;\n    }\n\n    /* Vue based overlay animations */\n    .p-connected-overlay-enter-from {\n        opacity: 0;\n        transform: scaleY(0.8);\n    }\n\n    .p-connected-overlay-leave-to {\n        opacity: 0;\n    }\n\n    .p-connected-overlay-enter-active {\n        transition:\n            transform 0.12s cubic-bezier(0, 0, 0.2, 1),\n            opacity 0.12s cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-connected-overlay-leave-active {\n        transition: opacity 0.1s linear;\n    }\n\n    /* Toggleable Content */\n    .p-toggleable-content-enter-from,\n    .p-toggleable-content-leave-to {\n        max-height: 0;\n    }\n\n    .p-toggleable-content-enter-to,\n    .p-toggleable-content-leave-from {\n        max-height: 1000px;\n    }\n\n    .p-toggleable-content-leave-active {\n        overflow: hidden;\n        transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);\n    }\n\n    .p-toggleable-content-enter-active {\n        overflow: hidden;\n        transition: max-height 1s ease-in-out;\n    }\n\n    .p-disabled,\n    .p-disabled * {\n        cursor: default;\n        pointer-events: none;\n        user-select: none;\n    }\n\n    .p-disabled,\n    .p-component:disabled {\n        opacity: dt('disabled.opacity');\n    }\n\n    .pi {\n        font-size: dt('icon.size');\n    }\n\n    .p-icon {\n        width: dt('icon.size');\n        height: dt('icon.size');\n    }\n\n    .p-overlay-mask {\n        background: dt('mask.background');\n        color: dt('mask.color');\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n    }\n\n    .p-overlay-mask-enter {\n        animation: p-overlay-mask-enter-animation dt('mask.transition.duration') forwards;\n    }\n\n    .p-overlay-mask-leave {\n        animation: p-overlay-mask-leave-animation dt('mask.transition.duration') forwards;\n    }\n\n    @keyframes p-overlay-mask-enter-animation {\n        from {\n            background: transparent;\n        }\n        to {\n            background: dt('mask.background');\n        }\n    }\n    @keyframes p-overlay-mask-leave-animation {\n        from {\n            background: dt('mask.background');\n        }\n        to {\n            background: transparent;\n        }\n    }\n";
function _typeof$1(o) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof$1(o);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a2) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a2);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a2) : void 0;
  }
}
function _arrayLikeToArray(r, a2) {
  (null == a2 || a2 > r.length) && (a2 = r.length);
  for (var e = 0, n = Array(a2); e < a2; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l2) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i2, u, a2 = [], f = true, o = false;
    try {
      if (i2 = (t = t.call(r)).next, 0 === l2) ;
      else for (; !(f = (e = i2.call(t)).done) && (a2.push(e.value), a2.length !== l2); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a2;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), true).forEach(function(r2) {
      _defineProperty$1(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty$1(e, r, t) {
  return (r = _toPropertyKey$1(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey$1(t) {
  var i2 = _toPrimitive$1(t, "string");
  return "symbol" == _typeof$1(i2) ? i2 : i2 + "";
}
function _toPrimitive$1(t, r) {
  if ("object" != _typeof$1(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i2 = e.call(t, r);
    if ("object" != _typeof$1(i2)) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var css = function css2(_ref) {
  var dt2 = _ref.dt;
  return "\n.p-hidden-accessible {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    opacity: 0;\n    overflow: hidden;\n    padding: 0;\n    pointer-events: none;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n}\n\n.p-overflow-hidden {\n    overflow: hidden;\n    padding-right: ".concat(dt2("scrollbar.width"), ";\n}\n");
};
var classes = {};
var inlineStyles = {};
var BaseStyle = {
  name: "base",
  css,
  style,
  classes,
  inlineStyles,
  load: function load(style2) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var transform = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(cs) {
      return cs;
    };
    var computedStyle = transform(ar(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), style2));
    return s$1(computedStyle) ? useStyle(G(computedStyle), _objectSpread$1({
      name: this.name
    }, options)) : {};
  },
  loadCSS: function loadCSS() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.load(this.css, options);
  },
  loadStyle: function loadStyle() {
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var style2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return this.load(this.style, options, function() {
      var computedStyle = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return g.transformCSS(options.name || _this.name, "".concat(computedStyle).concat(ar(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), style2)));
    });
  },
  getCommonTheme: function getCommonTheme(params) {
    return g.getCommon(this.name, params);
  },
  getComponentTheme: function getComponentTheme(params) {
    return g.getComponent(this.name, params);
  },
  getDirectiveTheme: function getDirectiveTheme(params) {
    return g.getDirective(this.name, params);
  },
  getPresetTheme: function getPresetTheme(preset, selector, params) {
    return g.getCustomPreset(this.name, preset, selector, params);
  },
  getLayerOrderThemeCSS: function getLayerOrderThemeCSS() {
    return g.getLayerOrderCSS(this.name);
  },
  getStyleSheet: function getStyleSheet() {
    var extendedCSS = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.css) {
      var _css = m(this.css, {
        dt: P
      }) || "";
      var _style = G(ar(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", "", ""])), _css, extendedCSS));
      var _props = Object.entries(props).reduce(function(acc, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 2), k = _ref3[0], v2 = _ref3[1];
        return acc.push("".concat(k, '="').concat(v2, '"')) && acc;
      }, []).join(" ");
      return s$1(_style) ? '<style type="text/css" data-primevue-style-id="'.concat(this.name, '" ').concat(_props, ">").concat(_style, "</style>") : "";
    }
    return "";
  },
  getCommonThemeStyleSheet: function getCommonThemeStyleSheet(params) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return g.getCommonStyleSheet(this.name, params, props);
  },
  getThemeStyleSheet: function getThemeStyleSheet(params) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var css3 = [g.getStyleSheet(this.name, params, props)];
    if (this.style) {
      var name = this.name === "base" ? "global-style" : "".concat(this.name, "-style");
      var _css = ar(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), m(this.style, {
        dt: P
      }));
      var _style = G(g.transformCSS(name, _css));
      var _props = Object.entries(props).reduce(function(acc, _ref4) {
        var _ref5 = _slicedToArray(_ref4, 2), k = _ref5[0], v2 = _ref5[1];
        return acc.push("".concat(k, '="').concat(v2, '"')) && acc;
      }, []).join(" ");
      s$1(_style) && css3.push('<style type="text/css" data-primevue-style-id="'.concat(name, '" ').concat(_props, ">").concat(_style, "</style>"));
    }
    return css3.join("");
  },
  extend: function extend(inStyle) {
    return _objectSpread$1(_objectSpread$1({}, this), {}, {
      css: void 0,
      style: void 0
    }, inStyle);
  }
};
var PrimeVueService = s();
var FilterMatchMode = {
  STARTS_WITH: "startsWith",
  CONTAINS: "contains",
  NOT_CONTAINS: "notContains",
  ENDS_WITH: "endsWith",
  EQUALS: "equals",
  NOT_EQUALS: "notEquals",
  LESS_THAN: "lt",
  LESS_THAN_OR_EQUAL_TO: "lte",
  GREATER_THAN: "gt",
  GREATER_THAN_OR_EQUAL_TO: "gte",
  DATE_IS: "dateIs",
  DATE_IS_NOT: "dateIsNot",
  DATE_BEFORE: "dateBefore",
  DATE_AFTER: "dateAfter"
};
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i2 = _toPrimitive(t, "string");
  return "symbol" == _typeof(i2) ? i2 : i2 + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i2 = e.call(t, r);
    if ("object" != _typeof(i2)) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var defaultOptions = {
  ripple: false,
  inputStyle: null,
  inputVariant: null,
  locale: {
    startsWith: "Starts with",
    contains: "Contains",
    notContains: "Not contains",
    endsWith: "Ends with",
    equals: "Equals",
    notEquals: "Not equals",
    noFilter: "No Filter",
    lt: "Less than",
    lte: "Less than or equal to",
    gt: "Greater than",
    gte: "Greater than or equal to",
    dateIs: "Date is",
    dateIsNot: "Date is not",
    dateBefore: "Date is before",
    dateAfter: "Date is after",
    clear: "Clear",
    apply: "Apply",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Add Rule",
    removeRule: "Remove Rule",
    accept: "Yes",
    reject: "No",
    choose: "Choose",
    upload: "Upload",
    cancel: "Cancel",
    completed: "Completed",
    pending: "Pending",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    chooseYear: "Choose Year",
    chooseMonth: "Choose Month",
    chooseDate: "Choose Date",
    prevDecade: "Previous Decade",
    nextDecade: "Next Decade",
    prevYear: "Previous Year",
    nextYear: "Next Year",
    prevMonth: "Previous Month",
    nextMonth: "Next Month",
    prevHour: "Previous Hour",
    nextHour: "Next Hour",
    prevMinute: "Previous Minute",
    nextMinute: "Next Minute",
    prevSecond: "Previous Second",
    nextSecond: "Next Second",
    am: "am",
    pm: "pm",
    today: "Today",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    showMonthAfterYear: false,
    dateFormat: "mm/dd/yy",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    passwordPrompt: "Enter a password",
    emptyFilterMessage: "No results found",
    searchMessage: "{0} results are available",
    selectionMessage: "{0} items selected",
    emptySelectionMessage: "No selected item",
    emptySearchMessage: "No results found",
    fileChosenMessage: "{0} files",
    noFileChosenMessage: "No file chosen",
    emptyMessage: "No available options",
    aria: {
      trueLabel: "True",
      falseLabel: "False",
      nullLabel: "Not Selected",
      star: "1 star",
      stars: "{star} stars",
      selectAll: "All items selected",
      unselectAll: "All items unselected",
      close: "Close",
      previous: "Previous",
      next: "Next",
      navigation: "Navigation",
      scrollTop: "Scroll Top",
      moveTop: "Move Top",
      moveUp: "Move Up",
      moveDown: "Move Down",
      moveBottom: "Move Bottom",
      moveToTarget: "Move to Target",
      moveToSource: "Move to Source",
      moveAllToTarget: "Move All to Target",
      moveAllToSource: "Move All to Source",
      pageLabel: "Page {page}",
      firstPageLabel: "First Page",
      lastPageLabel: "Last Page",
      nextPageLabel: "Next Page",
      prevPageLabel: "Previous Page",
      rowsPerPageLabel: "Rows per page",
      jumpToPageDropdownLabel: "Jump to Page Dropdown",
      jumpToPageInputLabel: "Jump to Page Input",
      selectRow: "Row Selected",
      unselectRow: "Row Unselected",
      expandRow: "Row Expanded",
      collapseRow: "Row Collapsed",
      showFilterMenu: "Show Filter Menu",
      hideFilterMenu: "Hide Filter Menu",
      filterOperator: "Filter Operator",
      filterConstraint: "Filter Constraint",
      editRow: "Row Edit",
      saveEdit: "Save Edit",
      cancelEdit: "Cancel Edit",
      listView: "List View",
      gridView: "Grid View",
      slide: "Slide",
      slideNumber: "{slideNumber}",
      zoomImage: "Zoom Image",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      rotateRight: "Rotate Right",
      rotateLeft: "Rotate Left",
      listLabel: "Option List"
    }
  },
  filterMatchModeOptions: {
    text: [FilterMatchMode.STARTS_WITH, FilterMatchMode.CONTAINS, FilterMatchMode.NOT_CONTAINS, FilterMatchMode.ENDS_WITH, FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS],
    numeric: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS, FilterMatchMode.LESS_THAN, FilterMatchMode.LESS_THAN_OR_EQUAL_TO, FilterMatchMode.GREATER_THAN, FilterMatchMode.GREATER_THAN_OR_EQUAL_TO],
    date: [FilterMatchMode.DATE_IS, FilterMatchMode.DATE_IS_NOT, FilterMatchMode.DATE_BEFORE, FilterMatchMode.DATE_AFTER]
  },
  zIndex: {
    modal: 1100,
    overlay: 1e3,
    menu: 1e3,
    tooltip: 1100
  },
  theme: void 0,
  unstyled: false,
  pt: void 0,
  ptOptions: {
    mergeSections: true,
    mergeProps: false
  },
  csp: {
    nonce: void 0
  }
};
var PrimeVueSymbol = Symbol();
function setup(app, options) {
  var PrimeVue2 = {
    config: reactive(options)
  };
  app.config.globalProperties.$primevue = PrimeVue2;
  app.provide(PrimeVueSymbol, PrimeVue2);
  clearConfig();
  setupConfig(app, PrimeVue2);
  return PrimeVue2;
}
var stopWatchers = [];
function clearConfig() {
  R.clear();
  stopWatchers.forEach(function(fn) {
    return fn === null || fn === void 0 ? void 0 : fn();
  });
  stopWatchers = [];
}
function setupConfig(app, PrimeVue2) {
  var isThemeChanged = ref(false);
  var loadCommonTheme = function loadCommonTheme2() {
    var _PrimeVue$config;
    if (((_PrimeVue$config = PrimeVue2.config) === null || _PrimeVue$config === void 0 ? void 0 : _PrimeVue$config.theme) === "none") return;
    if (!g.isStyleNameLoaded("common")) {
      var _BaseStyle$getCommonT, _PrimeVue$config2;
      var _ref = ((_BaseStyle$getCommonT = BaseStyle.getCommonTheme) === null || _BaseStyle$getCommonT === void 0 ? void 0 : _BaseStyle$getCommonT.call(BaseStyle)) || {}, primitive = _ref.primitive, semantic = _ref.semantic, global = _ref.global, style2 = _ref.style;
      var styleOptions = {
        nonce: (_PrimeVue$config2 = PrimeVue2.config) === null || _PrimeVue$config2 === void 0 || (_PrimeVue$config2 = _PrimeVue$config2.csp) === null || _PrimeVue$config2 === void 0 ? void 0 : _PrimeVue$config2.nonce
      };
      BaseStyle.load(primitive === null || primitive === void 0 ? void 0 : primitive.css, _objectSpread({
        name: "primitive-variables"
      }, styleOptions));
      BaseStyle.load(semantic === null || semantic === void 0 ? void 0 : semantic.css, _objectSpread({
        name: "semantic-variables"
      }, styleOptions));
      BaseStyle.load(global === null || global === void 0 ? void 0 : global.css, _objectSpread({
        name: "global-variables"
      }, styleOptions));
      BaseStyle.loadStyle(_objectSpread({
        name: "global-style"
      }, styleOptions), style2);
      g.setLoadedStyleName("common");
    }
  };
  R.on("theme:change", function(newTheme) {
    if (!isThemeChanged.value) {
      app.config.globalProperties.$primevue.config.theme = newTheme;
      isThemeChanged.value = true;
    }
  });
  var stopConfigWatcher = watch(PrimeVue2.config, function(newValue, oldValue) {
    PrimeVueService.emit("config:change", {
      newValue,
      oldValue
    });
  }, {
    immediate: true,
    deep: true
  });
  var stopRippleWatcher = watch(function() {
    return PrimeVue2.config.ripple;
  }, function(newValue, oldValue) {
    PrimeVueService.emit("config:ripple:change", {
      newValue,
      oldValue
    });
  }, {
    immediate: true,
    deep: true
  });
  var stopThemeWatcher = watch(function() {
    return PrimeVue2.config.theme;
  }, function(newValue, oldValue) {
    if (!isThemeChanged.value) {
      g.setTheme(newValue);
    }
    if (!PrimeVue2.config.unstyled) {
      loadCommonTheme();
    }
    isThemeChanged.value = false;
    PrimeVueService.emit("config:theme:change", {
      newValue,
      oldValue
    });
  }, {
    immediate: true,
    deep: false
  });
  var stopUnstyledWatcher = watch(function() {
    return PrimeVue2.config.unstyled;
  }, function(newValue, oldValue) {
    if (!newValue && PrimeVue2.config.theme) {
      loadCommonTheme();
    }
    PrimeVueService.emit("config:unstyled:change", {
      newValue,
      oldValue
    });
  }, {
    immediate: true,
    deep: true
  });
  stopWatchers.push(stopConfigWatcher);
  stopWatchers.push(stopRippleWatcher);
  stopWatchers.push(stopThemeWatcher);
  stopWatchers.push(stopUnstyledWatcher);
}
var PrimeVue = {
  install: function install(app, options) {
    var configOptions = U(defaultOptions, options);
    setup(app, configOptions);
  }
};
function mergeDeep(target, source) {
  const isObject = (obj) => obj && typeof obj === "object";
  if (!isObject(target) || !isObject(source)) return source;
  Object.keys(source).forEach((key) => {
    const targetValue = target[key];
    const sourceValue = source[key];
    if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
      target[key] = targetValue.concat(sourceValue);
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      target[key] = mergeDeep({ ...targetValue }, sourceValue);
    } else {
      target[key] = sourceValue;
    }
  });
  return target;
}
const dpsPrimeVueConfig = {
  // unstyle all predefined classes
  unstyled: true,
  pt: {
    // button: DpsButtonConfig,
  }
};
const DpsPrimeVuePlugin = {
  install: (app, options = {}) => {
    const primeVueConfig = mergeDeep(dpsPrimeVueConfig, options);
    app.use(PrimeVue, primeVueConfig);
  }
};
let idIncrementor = 0;
function getUniqueId(prefix = "", suffix = "") {
  const idInfix = Math.random().toString(16).substring(2);
  return `${prefix}${idInfix}${idIncrementor++}${suffix}`;
}
const _sfc_main$v = defineComponent({
  name: "DpsIconButton",
  props: {
    /**
     * Icon to be displayed in the button.
     */
    icon: {
      type: String,
      required: true
    },
    /**
     * Applies the 'danger' styles to the button.
     * @default false
     */
    danger: {
      type: Boolean,
      default: false,
      required: false
    },
    /**
     * Disables the button.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    /**
     * Show a loading spinner.
     * @default undefined
     */
    loading: {
      type: Boolean,
      default: void 0,
      required: false
    },
    /**
     * The HTML button type attribute. If undefined
     * the type defaults to 'button'.
     * @default undefined
     */
    type: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * The URL that the hyperlink points to.
     * If href is set an anchor
     * element is rendered instead of a button.
     * @default undefined
     */
    href: {
      type: String,
      required: false,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when the button gets clicked.
     */
    "click"
  ],
  computed: {
    typeAttribute() {
      if (this.href) {
        return void 0;
      }
      if (this.type) {
        return this.type;
      }
      return "button";
    }
  },
  methods: {
    handleClick(event) {
      if (this.disabled || this.loading) {
        event.preventDefault();
      } else {
        this.$emit("click", event);
      }
    }
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _hoisted_1$r = ["role"];
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.href ? "a" : "button"), {
    class: normalizeClass(["dps-icon-button", {
      "dps-icon-button--danger": _ctx.danger,
      "dps-icon-button--disabled": _ctx.disabled,
      "dps-icon-button--loading": _ctx.loading
    }]),
    type: _ctx.typeAttribute,
    href: _ctx.href,
    disabled: _ctx.disabled || _ctx.loading,
    onClick: _ctx.handleClick
  }, {
    default: withCtx(() => [
      createElementVNode("span", {
        class: normalizeClass(["dps-icon", {
          "dps-icon--loading-circle": _ctx.loading,
          ["dps-icon--" + _ctx.icon]: !_ctx.loading
        }]),
        role: _ctx.loading ? "status" : void 0,
        "aria-hidden": "true"
      }, null, 10, _hoisted_1$r)
    ]),
    _: 1
  }, 8, ["class", "type", "href", "disabled", "onClick"]);
}
const DpsIconButton = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$u]]);
const _sfc_main$u = defineComponent({
  name: "DpsActionMenu",
  components: { DpsIconButton },
  props: {
    /**
     * The unique identifier for the menu.
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * The HTML tag to be used for the menu container.
     * @default "ul"
     */
    tag: {
      type: String,
      default: "ul",
      required: false
    },
    /**
     * The icon to be used for the trigger button.
     * @default "more"
     */
    icon: {
      type: String,
      default: "more",
      required: false
    },
    /**
     * The label for the trigger button.
     * @default ""
     */
    label: {
      type: String,
      default: "",
      required: false
    },
    /**
     * The title attribute for the trigger button.
     * @default "Aktions-Menu öffnen"
     */
    title: {
      type: String,
      default: "Aktions-Menu öffnen",
      required: false
    },
    /**
     * Whether to show a close button in the menu.
     * @default false
     */
    showCloseButton: {
      type: Boolean,
      default: false,
      required: false
    },
    /**
     * Whether to show a chevron icon in the trigger button.
     * @default false
     */
    showTriggerChevron: {
      type: Boolean,
      default: false,
      required: false
    },
    /**
     * The headline text for the menu.
     * @default undefined
     */
    headline: {
      type: String,
      default: void 0,
      required: false
    },
    /**
     * Whether the menu should automatically close after an action is selected.
     * @default true
     */
    autoClose: {
      type: Boolean,
      default: true,
      required: false
    },
    /**
     * Whether the menu is disabled.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: [
    /**
     * Emitted when the menu is hidden.
     * @event module:DpsActionMenu#hide
     */
    "hide",
    /**
     * Emitted when the menu is shown.
     * @event module:DpsActionMenu#show
     */
    "show"
  ],
  computed: {
    uniqueId() {
      return this.id ? this.id : getUniqueId("dps-action-menu-");
    },
    dropdownElement() {
      return document.getElementById(this.uniqueId);
    },
    dropdownBootstrapElement() {
      if (this.dropdownElement) {
        return new window.Bootstrap.Dropdown(this.dropdownElement);
      }
      return void 0;
    },
    isHeaderVisible() {
      return this.showCloseButton || this.headline;
    }
  },
  mounted() {
    if (this.dropdownElement) {
      this.dropdownElement.addEventListener(
        "hide.bs.dropdown",
        (event) => {
          this.$emit("hide", event);
        }
      );
      this.dropdownElement.addEventListener(
        "show.bs.dropdown",
        (event) => {
          this.$emit("show", event);
        }
      );
    }
  }
});
const _hoisted_1$q = { class: "dps-action-menu" };
const _hoisted_2$j = ["id", "title", "disabled", "data-bs-auto-close"];
const _hoisted_3$i = { class: "dps-action-menu__trigger-button-label" };
const _hoisted_4$b = {
  key: 0,
  class: "dps-icon dps-icon--chevron-down"
};
const _hoisted_5$7 = ["aria-labelledby"];
const _hoisted_6$6 = {
  key: 0,
  class: "dps-action-menu__dropdown-header"
};
const _hoisted_7$4 = {
  key: 0,
  class: "dps-action-menu__dropdown-headline"
};
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpsIconButton = resolveComponent("DpsIconButton");
  return openBlock(), createElementBlock("div", _hoisted_1$q, [
    renderSlot(_ctx.$slots, "trigger", {}, () => [
      createElementVNode("button", {
        id: _ctx.uniqueId,
        type: "button",
        class: normalizeClass(["dps-action-menu__trigger-button", {
          "dps-action-menu__trigger-button--icon": !_ctx.label,
          "dps-action-menu__trigger-button--text": _ctx.label,
          "dps-action-menu__trigger-button--disabled": _ctx.disabled
        }]),
        title: _ctx.title,
        disabled: _ctx.disabled,
        "aria-label": "Toggle dropdown",
        "data-bs-toggle": "dropdown",
        "aria-expanded": "false",
        "data-bs-offset": "0,10",
        "data-bs-auto-close": _ctx.autoClose ? "true" : "outside"
      }, [
        _ctx.label ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("span", _hoisted_3$i, toDisplayString(_ctx.label), 1),
          _ctx.showTriggerChevron ? (openBlock(), createElementBlock("span", _hoisted_4$b)) : createCommentVNode("", true)
        ], 64)) : (openBlock(), createElementBlock("span", {
          key: 1,
          class: normalizeClass(["dps-icon", "dps-icon--" + _ctx.icon])
        }, null, 2))
      ], 10, _hoisted_2$j)
    ]),
    createElementVNode("div", {
      class: normalizeClass(["dps-action-menu__dropdown dropdown-menu", { "dps-action-menu__dropdown--with-header": _ctx.isHeaderVisible }]),
      "aria-labelledby": _ctx.uniqueId
    }, [
      _ctx.isHeaderVisible ? (openBlock(), createElementBlock("header", _hoisted_6$6, [
        _ctx.headline ? (openBlock(), createElementBlock("div", _hoisted_7$4, toDisplayString(_ctx.headline), 1)) : createCommentVNode("", true),
        _ctx.showCloseButton ? (openBlock(), createBlock(_component_DpsIconButton, {
          key: 1,
          class: "dps-action-menu__dropdown-close-button",
          title: "Schließen",
          "aria-label": "Schließen",
          icon: "close",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.dropdownBootstrapElement?.hide())
        })) : createCommentVNode("", true)
      ])) : createCommentVNode("", true),
      (openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), { class: "dps-action-menu__dropdown-list" }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }))
    ], 10, _hoisted_5$7)
  ]);
}
const DpsActionMenu = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$t]]);
const _sfc_main$t = defineComponent({
  name: "DpsActionMenuItem",
  props: {
    /**
     * The icon displayed before the menu item
     * @default undefined
     */
    icon: {
      type: String,
      default: void 0,
      required: false
    },
    /**
     * The title attribute of the menu item
     * @default undefined
     */
    title: {
      type: String,
      default: void 0,
      required: false
    },
    /**
     * Disables the menu item.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    /**
     * The link target attribute.(e.g.: _blank)
     * @default undefined
     */
    target: {
      type: String,
      default: void 0,
      required: false
    },
    /**
     * The URL that the hyperlink points to.
     * @default undefined
     */
    href: {
      type: String,
      default: void 0,
      required: false
    },
    /**
     * The relationship of the linked URL as space-separated link types.
     * @default undefined
     */
    rel: {
      type: String,
      default: void 0,
      required: false
    },
    /**
     * Applies the 'danger' styles (red on hover).
     * @default false
     */
    danger: {
      type: Boolean,
      default: false,
      required: false
    },
    /**
     * HTML tag of the wrapper element.
     * @default 'li'
     */
    tag: {
      type: String,
      default: "li"
    }
  },
  emits: [
    /**
     * Emitted when the element is clicked.
     * @event module:DPSActionMenuItem#click
     */
    "click"
  ],
  methods: {
    handleClick(event) {
      if (!this.disabled) {
        this.$emit("click", event);
      }
    }
  }
});
const _hoisted_1$p = { class: "dps-action-menu-item__text" };
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), { class: "dps-action-menu-item" }, {
    default: withCtx(() => [
      (openBlock(), createBlock(resolveDynamicComponent(_ctx.href ? "a" : "button"), {
        type: _ctx.href ? void 0 : "button",
        href: _ctx.href,
        rel: _ctx.rel,
        target: _ctx.target,
        title: _ctx.title,
        class: normalizeClass(["dps-action-menu-item__element", {
          "dps-action-menu-item__element--danger": _ctx.danger,
          "dps-action-menu-item__element--disabled": _ctx.disabled
        }]),
        disabled: _ctx.disabled,
        onClick: _ctx.handleClick
      }, {
        default: withCtx(() => [
          _ctx.icon ? (openBlock(), createElementBlock("span", {
            key: 0,
            class: normalizeClass(["dps-action-menu-item__icon dps-icon", "dps-icon--" + _ctx.icon])
          }, null, 2)) : createCommentVNode("", true),
          createElementVNode("span", _hoisted_1$p, [
            renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      }, 8, ["type", "href", "rel", "target", "title", "class", "disabled", "onClick"]))
    ]),
    _: 3
  });
}
const DpsActionMenuItem = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["render", _sfc_render$s]]);
const _sfc_main$s = defineComponent({
  name: "DpsAlphabeticFilter",
  props: {
    /**
     * Array of available filter options.
     * @default ["A-G", "H-N", "O-U", "V-Z"]
     */
    options: {
      type: Array,
      default: () => ["A-G", "H-N", "O-U", "V-Z"],
      required: false
    },
    /**
     * The modelValue
     * @default undefined
     */
    modelValue: {
      type: String,
      default: void 0,
      required: false
    },
    /**
     * Requires some option to be active.
     * @default false
     */
    required: {
      type: Boolean,
      default: false,
      required: false
    },
    /**
     * Disables the component.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: [
    /**
     * Emitted when the selected value changes.
     * @event module:DpsAlphabeticFilter#update:modelValue
     */
    "update:modelValue"
  ],
  methods: {
    selectOption(value) {
      let newValue = value;
      if (this.disabled) {
        return;
      }
      if (this.required) {
        if (newValue !== this.modelValue) {
          this.$emit("update:modelValue", newValue);
        }
      } else {
        newValue = newValue === this.modelValue ? void 0 : value;
        this.$emit("update:modelValue", newValue);
      }
    }
  }
});
const _hoisted_1$o = ["aria-selected", "disabled", "onClick"];
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("ul", {
    role: "tablist",
    class: normalizeClass(["dps-alphabetic-filter", { "dps-alphabetic-filter--disabled": _ctx.disabled }])
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (option, key) => {
      return openBlock(), createElementBlock("li", {
        key: "alphabetic-filter-" + key,
        class: "dps-alphabetic-filter__list-item",
        role: "presentation"
      }, [
        createElementVNode("button", {
          class: normalizeClass(["dps-alphabetic-filter__option-button", {
            "dps-alphabetic-filter__option-button--active": _ctx.modelValue === option
          }]),
          type: "button",
          role: "tab",
          "aria-controls": "filter",
          "aria-selected": _ctx.modelValue === option,
          disabled: _ctx.disabled,
          onClick: ($event) => _ctx.selectOption(option)
        }, toDisplayString(option), 11, _hoisted_1$o)
      ]);
    }), 128))
  ], 2);
}
const DpsAlphabeticFilter = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$r]]);
const _sfc_main$r = defineComponent({
  name: "DpsBadge",
  props: {
    /**
     * Determines the styling of the badge.
     * @default undefined
     */
    variant: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Rounds the badge.
     * @default false
     */
    rounded: {
      type: Boolean,
      default: false
    }
  }
});
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", {
    class: normalizeClass(["dps-badge", {
      ["dps-badge--" + _ctx.variant]: _ctx.variant,
      "dps-badge--rounded": _ctx.rounded
    }])
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2);
}
const DpsBadge = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$q]]);
const _sfc_main$q = defineComponent({
  name: "DpsButton",
  props: {
    /**
     * The HTML button type (ignored when used as a link).
     * When not set defaults to 'button'.
     * @default undefined
     */
    type: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * The URL that the hyperlink points to.
     * When set the component will be rendered as an anchor element.
     * @default undefined
     */
    href: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Disables the button.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Determines the styling of the component.
     * @default undefined
     */
    variant: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Determines the size of the button.
     * @default undefined
     */
    size: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Squared edges.
     * @default false
     */
    squared: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Optional icon displayed inside the button.
     * @default undefined
     */
    icon: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Position of the icon.
     * @default 'start'
     */
    iconPosition: {
      type: String,
      required: false,
      default: "start"
    },
    /**
     * Removes the padding.
     * @default false
     */
    noPadding: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when the button gets clicked.
     * @event module:DpsButton#click
     */
    "click"
  ],
  computed: {
    typeAttribute() {
      if (this.href) {
        return void 0;
      }
      if (this.type) {
        return this.type;
      }
      return "button";
    }
  },
  methods: {
    handleClick(event) {
      if (this.disabled || this.loading) {
        event.preventDefault();
      } else {
        this.$emit("click", event);
      }
    }
  }
});
const _hoisted_1$n = ["role"];
const _hoisted_2$i = {
  key: 1,
  class: "dps-button__text"
};
const _hoisted_3$h = ["role"];
const _hoisted_4$a = {
  key: 1,
  class: "dps-button__text"
};
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.href ? "a" : "button"), {
    class: normalizeClass(["dps-button", {
      "dps-button--squared": _ctx.squared,
      ["dps-button--size-" + _ctx.size]: _ctx.size,
      ["dps-button--" + _ctx.variant]: _ctx.variant,
      "dps-button--disabled": _ctx.disabled,
      "dps-button--loading": _ctx.loading,
      "dps-button--no-padding": _ctx.noPadding
    }]),
    type: _ctx.typeAttribute,
    href: _ctx.href,
    disabled: _ctx.disabled || _ctx.loading,
    onClick: _ctx.handleClick
  }, {
    default: withCtx(() => [
      _ctx.icon || _ctx.loading ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        _ctx.iconPosition === "start" ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(["dps-icon", {
            "dps-icon--loading-circle": _ctx.loading,
            ["dps-icon--" + _ctx.icon]: !_ctx.loading
          }]),
          role: _ctx.loading ? "status" : void 0,
          "aria-hidden": "true"
        }, null, 10, _hoisted_1$n)) : createCommentVNode("", true),
        _ctx.$slots.default ? (openBlock(), createElementBlock("span", _hoisted_2$i, [
          renderSlot(_ctx.$slots, "default")
        ])) : createCommentVNode("", true),
        _ctx.iconPosition === "end" ? (openBlock(), createElementBlock("span", {
          key: 2,
          class: normalizeClass(["dps-icon", {
            "dps-icon--loading-circle": _ctx.loading,
            ["dps-icon--" + _ctx.icon]: !_ctx.loading
          }]),
          role: _ctx.loading ? "status" : void 0,
          "aria-hidden": "true"
        }, null, 10, _hoisted_3$h)) : createCommentVNode("", true)
      ], 64)) : _ctx.variant === "link" || _ctx.variant === "link-darker" ? (openBlock(), createElementBlock("span", _hoisted_4$a, [
        renderSlot(_ctx.$slots, "default")
      ])) : renderSlot(_ctx.$slots, "default", { key: 2 })
    ]),
    _: 3
  }, 8, ["class", "type", "href", "disabled", "onClick"]);
}
const DpsButton = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$p]]);
const _sfc_main$p = defineComponent({
  name: "DpsCollapsible",
  props: {
    /**
     * The unique identifier for the menu (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Collapsible expanded.
     * @default false
     */
    expanded: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Whether the collapsible can not be interacted with.
     * @default false
     */
    locked: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Size of the collapsible.
     * @default undefined
     */
    size: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Styling of the collapsible.
     * @default undefined
     */
    variant: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Headline text when collapsible is expanded.
     * @default undefined
     */
    toggleTextExpanded: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Headline text when collapsible is not expanded.
     * @default undefined
     */
    toggleText: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Custom icon class for the trigger button.
     * @default undefined
     */
    icon: {
      type: String,
      required: false,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted immediately when collapsible content gets hidden.
     * @event module:DpsCollapsible#hide-collapsible
     */
    "hide-collapsible",
    /**
     * Emitted when collapsible content has been hidden (after CSS transitions).
     * @event module:DpsCollapsible#hidden-collapsible
     */
    "hidden-collapsible",
    /**
     * Emitted immediately when collapsible content gets shown.
     * @event module:DpsCollapsible#show-collapsible
     */
    "show-collapsible",
    /**
     * Emitted when collapsible content has been made visible (after CSS transitions).
     * @event module:DpsCollapsible#shown-collapsible
     */
    "shown-collapsible"
  ],
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    uniqueId() {
      return this.id ? this.id : getUniqueId("dps-collapsible-");
    }
  },
  watch: {
    expanded(value) {
      this.isExpanded = value;
    }
  },
  mounted() {
    const collapsibleEl = this.$refs.collapsible;
    this.isExpanded = this.expanded;
    if (!collapsibleEl) return;
    collapsibleEl.addEventListener("hide.bs.collapse", (ev) => {
      if (ev.target !== ev.currentTarget) return;
      ev.stopPropagation();
      this.isExpanded = false;
      this.$emit("hide-collapsible", ev);
    });
    collapsibleEl.addEventListener("hidden.bs.collapse", (ev) => {
      if (ev.target !== ev.currentTarget) return;
      ev.stopPropagation();
      this.$emit("hidden-collapsible", ev);
    });
    collapsibleEl.addEventListener("show.bs.collapse", (ev) => {
      if (ev.target !== ev.currentTarget) return;
      ev.stopPropagation();
      this.isExpanded = true;
      this.$emit("show-collapsible", ev);
    });
    collapsibleEl.addEventListener("shown.bs.collapse", (ev) => {
      if (ev.target !== ev.currentTarget) return;
      ev.stopPropagation();
      this.$emit("shown-collapsible", ev);
    });
  }
});
const _hoisted_1$m = { class: "dps-collapsible__header" };
const _hoisted_2$h = ["data-bs-target", "aria-expanded", "aria-controls"];
const _hoisted_3$g = ["id"];
const _hoisted_4$9 = { class: "dps-collapsible__body" };
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["dps-collapsible", {
      "dps-collapsible--expanded": _ctx.isExpanded,
      ["dps-collapsible--" + _ctx.variant]: _ctx.variant,
      ["dps-collapsible--size-" + _ctx.size]: _ctx.size
    }])
  }, [
    createElementVNode("div", _hoisted_1$m, [
      _ctx.locked ? renderSlot(_ctx.$slots, "header", { key: 0 }, () => [
        createTextVNode(toDisplayString(_ctx.isExpanded && _ctx.toggleTextExpanded || _ctx.toggleText), 1)
      ]) : (openBlock(), createElementBlock("button", {
        key: 1,
        class: "dps-collapsible__trigger-button",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#" + _ctx.uniqueId,
        "aria-expanded": _ctx.expanded,
        "aria-controls": _ctx.uniqueId
      }, [
        createElementVNode("span", {
          class: normalizeClass([
            "dps-icon",
            _ctx.icon ? "dps-icon--" + _ctx.icon : {
              "dps-icon--chevron-down": _ctx.size === "lg" && _ctx.variant !== "tertiary",
              "dps-icon--chevron-down-small": _ctx.size !== "lg" && _ctx.variant !== "tertiary",
              "dps-icon--plus": _ctx.variant === "tertiary" && !_ctx.isExpanded,
              "dps-icon--minus": _ctx.variant === "tertiary" && _ctx.isExpanded
            }
          ])
        }, null, 2),
        renderSlot(_ctx.$slots, "header", {}, () => [
          createTextVNode(toDisplayString(_ctx.isExpanded && _ctx.toggleTextExpanded || _ctx.toggleText), 1)
        ])
      ], 8, _hoisted_2$h))
    ]),
    createElementVNode("div", {
      id: !_ctx.locked ? _ctx.uniqueId : void 0,
      ref: "collapsible",
      class: normalizeClass(["dps-collapsible__collapsible collapse", { show: _ctx.expanded }])
    }, [
      createElementVNode("div", _hoisted_4$9, [
        renderSlot(_ctx.$slots, "default")
      ])
    ], 10, _hoisted_3$g)
  ], 2);
}
const DpsCollapsible = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$o]]);
const _sfc_main$o = defineComponent({
  name: "DpsFilterButton",
  props: {
    /**
     * Disables the button.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    /**
     * Makes the button readonly.
     * @default false
     */
    readonly: {
      type: Boolean,
      default: false,
      required: false
    },
    /**
     * Title attribute of the button.
     * @default undefined
     */
    title: {
      type: String,
      default: void 0,
      required: false
    }
  },
  emits: [
    /**
     * Emitted when the button is clicked.
     * @event module:DpsFilterButton#click
     */
    "click"
  ],
  computed: {
    titleAttribute() {
      if (this.title) {
        return this.title;
      }
      return "Filter entfernen";
    }
  },
  methods: {
    handleClick(event) {
      if (!this.disabled) {
        this.$emit("click", event);
      }
    }
  }
});
const _hoisted_1$l = ["title", "disabled"];
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("button", {
    class: normalizeClass(["dps-filter-button", {
      "dps-filter-button--disabled": _ctx.disabled,
      "dps-filter-button--readonly": _ctx.readonly
    }]),
    type: "button",
    title: _ctx.titleAttribute,
    disabled: _ctx.disabled || _ctx.readonly,
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleClick && _ctx.handleClick(...args))
  }, [
    createElementVNode("span", null, [
      renderSlot(_ctx.$slots, "default")
    ]),
    _cache[1] || (_cache[1] = createElementVNode("span", { class: "dps-icon dps-icon--close" }, null, -1))
  ], 10, _hoisted_1$l);
}
const DpsFilterButton = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$n]]);
const _sfc_main$n = defineComponent({
  name: "DpsFormCheckbox",
  inheritAttrs: false,
  props: {
    /**
     * The unique identifier for the checkbox (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * modelValue of the checkbox.
     * @default undefined
     */
    modelValue: {
      type: [String, Boolean, Number, Array],
      required: false,
      default: void 0
    },
    /**
     * Name attribute of the input.
     * @default undefined
     */
    name: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Value attribute of the input.
     * @default true
     */
    value: {
      type: [String, Boolean, Number],
      required: false,
      default: true
    },
    /**
     * Title attribute of the component.
     * @default undefined
     */
    tooltip: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Disables the checkbox.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Checkbox is displayed as block.
     * @default false
     */
    block: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Truncates the label.
     * @default false
     */
    truncate: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Hides the label.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * The size of the component.
     * @default undefined
     */
    size: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * For styling the node element
     * (fallthough attributes are added to the native form element)
     * @default ""
     */
    class: {
      type: String,
      required: false,
      default: ""
    }
  },
  emits: [
    /**
     * Emitted when the value changes.
     * @event module:DpsFormCheckbox#update:modelValue
     */
    "update:modelValue"
  ],
  computed: {
    outerClass() {
      return this.class;
    },
    uniqueId() {
      return this.id ? this.id : getUniqueId("dps-form-checkbox-");
    },
    isChecked() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.includes(this.value);
      }
      return this.modelValue === this.value;
    }
  },
  methods: {
    handleChange(event) {
      const target = event.target;
      const value = target.value;
      let newModelValue;
      if (Array.isArray(this.modelValue)) {
        newModelValue = [...this.modelValue];
        if (this.modelValue.includes(value)) {
          newModelValue = newModelValue.filter((item) => item !== value);
        } else {
          newModelValue = [...newModelValue, value];
        }
      } else if (typeof this.modelValue === "boolean") {
        newModelValue = false;
        if (this.modelValue !== Boolean(value)) {
          newModelValue = Boolean(value);
        }
      } else if (typeof this.modelValue === "number") {
        newModelValue = 0;
        if (this.modelValue !== Number(value)) {
          newModelValue = Number(value);
        }
      } else {
        newModelValue = "";
        if (this.modelValue !== value) {
          newModelValue = value;
        }
      }
      this.$emit("update:modelValue", newModelValue);
    }
  }
});
const _hoisted_1$k = ["id", "name", "value", "checked", "disabled", "readonly"];
const _hoisted_2$g = ["for", "title"];
const _hoisted_3$f = {
  key: 0,
  class: "sr-only"
};
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["dps-form-checkbox dps-input-wrapper", {
      ["dps-form-checkbox--size-" + _ctx.size]: _ctx.size,
      "dps-form-checkbox--block": _ctx.block || _ctx.truncate,
      [_ctx.outerClass]: true
    }])
  }, [
    createElementVNode("input", mergeProps(_ctx.$attrs, {
      id: _ctx.uniqueId,
      class: ["dps-form-checkbox__input dps-checkbox", {
        ["dps-checkbox--size-" + _ctx.size]: _ctx.size,
        "dps-checkbox--error": _ctx.error
      }],
      type: "checkbox",
      name: _ctx.name,
      value: _ctx.value,
      checked: _ctx.isChecked,
      disabled: _ctx.disabled || _ctx.readonly,
      readonly: _ctx.readonly,
      onChange: _cache[0] || (_cache[0] = (...args) => _ctx.handleChange && _ctx.handleChange(...args))
    }), null, 16, _hoisted_1$k),
    createElementVNode("label", {
      for: _ctx.uniqueId,
      title: _ctx.tooltip,
      class: normalizeClass(["dps-form-checkbox__label dps-label", {
        "dps-form-checkbox__label--input-only": _ctx.hideLabel,
        "dps-text--ellipse": _ctx.truncate
      }])
    }, [
      _ctx.hideLabel ? (openBlock(), createElementBlock("span", _hoisted_3$f, [
        renderSlot(_ctx.$slots, "default")
      ])) : renderSlot(_ctx.$slots, "default", { key: 1 })
    ], 10, _hoisted_2$g)
  ], 2);
}
const DpsFormCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$m]]);
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (Object.prototype.hasOwnProperty.call(n, "__esModule")) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a2 = function a3() {
      var isInstance = false;
      try {
        isInstance = this instanceof a3;
      } catch {
      }
      if (isInstance) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a2.prototype = f.prototype;
  } else a2 = {};
  Object.defineProperty(a2, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d2 = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a2, k, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a2;
}
var lib$5 = {};
var Parser = {};
var Tokenizer = {};
var decode = {};
var decodeDataHtml = {};
var hasRequiredDecodeDataHtml;
function requireDecodeDataHtml() {
  if (hasRequiredDecodeDataHtml) return decodeDataHtml;
  hasRequiredDecodeDataHtml = 1;
  Object.defineProperty(decodeDataHtml, "__esModule", { value: true });
  decodeDataHtml.default = new Uint16Array(
    // prettier-ignore
    'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(c2) {
      return c2.charCodeAt(0);
    })
  );
  return decodeDataHtml;
}
var decodeDataXml = {};
var hasRequiredDecodeDataXml;
function requireDecodeDataXml() {
  if (hasRequiredDecodeDataXml) return decodeDataXml;
  hasRequiredDecodeDataXml = 1;
  Object.defineProperty(decodeDataXml, "__esModule", { value: true });
  decodeDataXml.default = new Uint16Array(
    // prettier-ignore
    "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(c2) {
      return c2.charCodeAt(0);
    })
  );
  return decodeDataXml;
}
var decode_codepoint = {};
var hasRequiredDecode_codepoint;
function requireDecode_codepoint() {
  if (hasRequiredDecode_codepoint) return decode_codepoint;
  hasRequiredDecode_codepoint = 1;
  (function(exports) {
    var _a;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.replaceCodePoint = exports.fromCodePoint = void 0;
    var decodeMap = /* @__PURE__ */ new Map([
      [0, 65533],
      // C1 Unicode control character reference replacements
      [128, 8364],
      [130, 8218],
      [131, 402],
      [132, 8222],
      [133, 8230],
      [134, 8224],
      [135, 8225],
      [136, 710],
      [137, 8240],
      [138, 352],
      [139, 8249],
      [140, 338],
      [142, 381],
      [145, 8216],
      [146, 8217],
      [147, 8220],
      [148, 8221],
      [149, 8226],
      [150, 8211],
      [151, 8212],
      [152, 732],
      [153, 8482],
      [154, 353],
      [155, 8250],
      [156, 339],
      [158, 382],
      [159, 376]
    ]);
    exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
    (_a = String.fromCodePoint) !== null && _a !== void 0 ? _a : function(codePoint) {
      var output = "";
      if (codePoint > 65535) {
        codePoint -= 65536;
        output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
      }
      output += String.fromCharCode(codePoint);
      return output;
    };
    function replaceCodePoint(codePoint) {
      var _a2;
      if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
        return 65533;
      }
      return (_a2 = decodeMap.get(codePoint)) !== null && _a2 !== void 0 ? _a2 : codePoint;
    }
    exports.replaceCodePoint = replaceCodePoint;
    function decodeCodePoint(codePoint) {
      return (0, exports.fromCodePoint)(replaceCodePoint(codePoint));
    }
    exports.default = decodeCodePoint;
  })(decode_codepoint);
  return decode_codepoint;
}
var hasRequiredDecode;
function requireDecode() {
  if (hasRequiredDecode) return decode;
  hasRequiredDecode = 1;
  (function(exports) {
    var __createBinding = decode && decode.__createBinding || (Object.create ? function(o, m2, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m2, k);
      if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m2[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m2, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m2[k];
    });
    var __setModuleDefault = decode && decode.__setModuleDefault || (Object.create ? function(o, v2) {
      Object.defineProperty(o, "default", { enumerable: true, value: v2 });
    } : function(o, v2) {
      o["default"] = v2;
    });
    var __importStar = decode && decode.__importStar || function(mod) {
      if (mod && mod.__esModule) return mod;
      var result2 = {};
      if (mod != null) {
        for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result2, mod, k);
      }
      __setModuleDefault(result2, mod);
      return result2;
    };
    var __importDefault = decode && decode.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.decodeXML = exports.decodeHTMLStrict = exports.decodeHTMLAttribute = exports.decodeHTML = exports.determineBranch = exports.EntityDecoder = exports.DecodingMode = exports.BinTrieFlags = exports.fromCodePoint = exports.replaceCodePoint = exports.decodeCodePoint = exports.xmlDecodeTree = exports.htmlDecodeTree = void 0;
    var decode_data_html_js_1 = __importDefault(/* @__PURE__ */ requireDecodeDataHtml());
    exports.htmlDecodeTree = decode_data_html_js_1.default;
    var decode_data_xml_js_1 = __importDefault(/* @__PURE__ */ requireDecodeDataXml());
    exports.xmlDecodeTree = decode_data_xml_js_1.default;
    var decode_codepoint_js_1 = __importStar(/* @__PURE__ */ requireDecode_codepoint());
    exports.decodeCodePoint = decode_codepoint_js_1.default;
    var decode_codepoint_js_2 = /* @__PURE__ */ requireDecode_codepoint();
    Object.defineProperty(exports, "replaceCodePoint", { enumerable: true, get: function() {
      return decode_codepoint_js_2.replaceCodePoint;
    } });
    Object.defineProperty(exports, "fromCodePoint", { enumerable: true, get: function() {
      return decode_codepoint_js_2.fromCodePoint;
    } });
    var CharCodes;
    (function(CharCodes2) {
      CharCodes2[CharCodes2["NUM"] = 35] = "NUM";
      CharCodes2[CharCodes2["SEMI"] = 59] = "SEMI";
      CharCodes2[CharCodes2["EQUALS"] = 61] = "EQUALS";
      CharCodes2[CharCodes2["ZERO"] = 48] = "ZERO";
      CharCodes2[CharCodes2["NINE"] = 57] = "NINE";
      CharCodes2[CharCodes2["LOWER_A"] = 97] = "LOWER_A";
      CharCodes2[CharCodes2["LOWER_F"] = 102] = "LOWER_F";
      CharCodes2[CharCodes2["LOWER_X"] = 120] = "LOWER_X";
      CharCodes2[CharCodes2["LOWER_Z"] = 122] = "LOWER_Z";
      CharCodes2[CharCodes2["UPPER_A"] = 65] = "UPPER_A";
      CharCodes2[CharCodes2["UPPER_F"] = 70] = "UPPER_F";
      CharCodes2[CharCodes2["UPPER_Z"] = 90] = "UPPER_Z";
    })(CharCodes || (CharCodes = {}));
    var TO_LOWER_BIT = 32;
    var BinTrieFlags;
    (function(BinTrieFlags2) {
      BinTrieFlags2[BinTrieFlags2["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
      BinTrieFlags2[BinTrieFlags2["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
      BinTrieFlags2[BinTrieFlags2["JUMP_TABLE"] = 127] = "JUMP_TABLE";
    })(BinTrieFlags = exports.BinTrieFlags || (exports.BinTrieFlags = {}));
    function isNumber(code) {
      return code >= CharCodes.ZERO && code <= CharCodes.NINE;
    }
    function isHexadecimalCharacter(code) {
      return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_F || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_F;
    }
    function isAsciiAlphaNumeric(code) {
      return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_Z || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_Z || isNumber(code);
    }
    function isEntityInAttributeInvalidEnd(code) {
      return code === CharCodes.EQUALS || isAsciiAlphaNumeric(code);
    }
    var EntityDecoderState;
    (function(EntityDecoderState2) {
      EntityDecoderState2[EntityDecoderState2["EntityStart"] = 0] = "EntityStart";
      EntityDecoderState2[EntityDecoderState2["NumericStart"] = 1] = "NumericStart";
      EntityDecoderState2[EntityDecoderState2["NumericDecimal"] = 2] = "NumericDecimal";
      EntityDecoderState2[EntityDecoderState2["NumericHex"] = 3] = "NumericHex";
      EntityDecoderState2[EntityDecoderState2["NamedEntity"] = 4] = "NamedEntity";
    })(EntityDecoderState || (EntityDecoderState = {}));
    var DecodingMode;
    (function(DecodingMode2) {
      DecodingMode2[DecodingMode2["Legacy"] = 0] = "Legacy";
      DecodingMode2[DecodingMode2["Strict"] = 1] = "Strict";
      DecodingMode2[DecodingMode2["Attribute"] = 2] = "Attribute";
    })(DecodingMode = exports.DecodingMode || (exports.DecodingMode = {}));
    var EntityDecoder = (
      /** @class */
      function() {
        function EntityDecoder2(decodeTree, emitCodePoint, errors) {
          this.decodeTree = decodeTree;
          this.emitCodePoint = emitCodePoint;
          this.errors = errors;
          this.state = EntityDecoderState.EntityStart;
          this.consumed = 1;
          this.result = 0;
          this.treeIndex = 0;
          this.excess = 1;
          this.decodeMode = DecodingMode.Strict;
        }
        EntityDecoder2.prototype.startEntity = function(decodeMode) {
          this.decodeMode = decodeMode;
          this.state = EntityDecoderState.EntityStart;
          this.result = 0;
          this.treeIndex = 0;
          this.excess = 1;
          this.consumed = 1;
        };
        EntityDecoder2.prototype.write = function(str, offset) {
          switch (this.state) {
            case EntityDecoderState.EntityStart: {
              if (str.charCodeAt(offset) === CharCodes.NUM) {
                this.state = EntityDecoderState.NumericStart;
                this.consumed += 1;
                return this.stateNumericStart(str, offset + 1);
              }
              this.state = EntityDecoderState.NamedEntity;
              return this.stateNamedEntity(str, offset);
            }
            case EntityDecoderState.NumericStart: {
              return this.stateNumericStart(str, offset);
            }
            case EntityDecoderState.NumericDecimal: {
              return this.stateNumericDecimal(str, offset);
            }
            case EntityDecoderState.NumericHex: {
              return this.stateNumericHex(str, offset);
            }
            case EntityDecoderState.NamedEntity: {
              return this.stateNamedEntity(str, offset);
            }
          }
        };
        EntityDecoder2.prototype.stateNumericStart = function(str, offset) {
          if (offset >= str.length) {
            return -1;
          }
          if ((str.charCodeAt(offset) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
            this.state = EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
          }
          this.state = EntityDecoderState.NumericDecimal;
          return this.stateNumericDecimal(str, offset);
        };
        EntityDecoder2.prototype.addToNumericResult = function(str, start, end, base) {
          if (start !== end) {
            var digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
          }
        };
        EntityDecoder2.prototype.stateNumericHex = function(str, offset) {
          var startIdx = offset;
          while (offset < str.length) {
            var char = str.charCodeAt(offset);
            if (isNumber(char) || isHexadecimalCharacter(char)) {
              offset += 1;
            } else {
              this.addToNumericResult(str, startIdx, offset, 16);
              return this.emitNumericEntity(char, 3);
            }
          }
          this.addToNumericResult(str, startIdx, offset, 16);
          return -1;
        };
        EntityDecoder2.prototype.stateNumericDecimal = function(str, offset) {
          var startIdx = offset;
          while (offset < str.length) {
            var char = str.charCodeAt(offset);
            if (isNumber(char)) {
              offset += 1;
            } else {
              this.addToNumericResult(str, startIdx, offset, 10);
              return this.emitNumericEntity(char, 2);
            }
          }
          this.addToNumericResult(str, startIdx, offset, 10);
          return -1;
        };
        EntityDecoder2.prototype.emitNumericEntity = function(lastCp, expectedLength) {
          var _a;
          if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
          }
          if (lastCp === CharCodes.SEMI) {
            this.consumed += 1;
          } else if (this.decodeMode === DecodingMode.Strict) {
            return 0;
          }
          this.emitCodePoint((0, decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
          if (this.errors) {
            if (lastCp !== CharCodes.SEMI) {
              this.errors.missingSemicolonAfterCharacterReference();
            }
            this.errors.validateNumericCharacterReference(this.result);
          }
          return this.consumed;
        };
        EntityDecoder2.prototype.stateNamedEntity = function(str, offset) {
          var decodeTree = this.decodeTree;
          var current = decodeTree[this.treeIndex];
          var valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
          for (; offset < str.length; offset++, this.excess++) {
            var char = str.charCodeAt(offset);
            this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) {
              return this.result === 0 || // If we are parsing an attribute
              this.decodeMode === DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
              (valueLength === 0 || // And there should be no invalid characters.
              isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            }
            current = decodeTree[this.treeIndex];
            valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
            if (valueLength !== 0) {
              if (char === CharCodes.SEMI) {
                return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
              }
              if (this.decodeMode !== DecodingMode.Strict) {
                this.result = this.treeIndex;
                this.consumed += this.excess;
                this.excess = 0;
              }
            }
          }
          return -1;
        };
        EntityDecoder2.prototype.emitNotTerminatedNamedEntity = function() {
          var _a;
          var _b = this, result2 = _b.result, decodeTree = _b.decodeTree;
          var valueLength = (decodeTree[result2] & BinTrieFlags.VALUE_LENGTH) >> 14;
          this.emitNamedEntityData(result2, valueLength, this.consumed);
          (_a = this.errors) === null || _a === void 0 ? void 0 : _a.missingSemicolonAfterCharacterReference();
          return this.consumed;
        };
        EntityDecoder2.prototype.emitNamedEntityData = function(result2, valueLength, consumed) {
          var decodeTree = this.decodeTree;
          this.emitCodePoint(valueLength === 1 ? decodeTree[result2] & ~BinTrieFlags.VALUE_LENGTH : decodeTree[result2 + 1], consumed);
          if (valueLength === 3) {
            this.emitCodePoint(decodeTree[result2 + 2], consumed);
          }
          return consumed;
        };
        EntityDecoder2.prototype.end = function() {
          var _a;
          switch (this.state) {
            case EntityDecoderState.NamedEntity: {
              return this.result !== 0 && (this.decodeMode !== DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            }
            // Otherwise, emit a numeric entity if we have one.
            case EntityDecoderState.NumericDecimal: {
              return this.emitNumericEntity(0, 2);
            }
            case EntityDecoderState.NumericHex: {
              return this.emitNumericEntity(0, 3);
            }
            case EntityDecoderState.NumericStart: {
              (_a = this.errors) === null || _a === void 0 ? void 0 : _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
              return 0;
            }
            case EntityDecoderState.EntityStart: {
              return 0;
            }
          }
        };
        return EntityDecoder2;
      }()
    );
    exports.EntityDecoder = EntityDecoder;
    function getDecoder(decodeTree) {
      var ret = "";
      var decoder = new EntityDecoder(decodeTree, function(str) {
        return ret += (0, decode_codepoint_js_1.fromCodePoint)(str);
      });
      return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while ((offset = str.indexOf("&", offset)) >= 0) {
          ret += str.slice(lastIndex, offset);
          decoder.startEntity(decodeMode);
          var len = decoder.write(
            str,
            // Skip the "&"
            offset + 1
          );
          if (len < 0) {
            lastIndex = offset + decoder.end();
            break;
          }
          lastIndex = offset + len;
          offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result2 = ret + str.slice(lastIndex);
        ret = "";
        return result2;
      };
    }
    function determineBranch(decodeTree, current, nodeIdx, char) {
      var branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
      var jumpOffset = current & BinTrieFlags.JUMP_TABLE;
      if (branchCount === 0) {
        return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
      }
      if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
      }
      var lo = nodeIdx;
      var hi = lo + branchCount - 1;
      while (lo <= hi) {
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) {
          lo = mid + 1;
        } else if (midVal > char) {
          hi = mid - 1;
        } else {
          return decodeTree[mid + branchCount];
        }
      }
      return -1;
    }
    exports.determineBranch = determineBranch;
    var htmlDecoder = getDecoder(decode_data_html_js_1.default);
    var xmlDecoder = getDecoder(decode_data_xml_js_1.default);
    function decodeHTML(str, mode) {
      if (mode === void 0) {
        mode = DecodingMode.Legacy;
      }
      return htmlDecoder(str, mode);
    }
    exports.decodeHTML = decodeHTML;
    function decodeHTMLAttribute(str) {
      return htmlDecoder(str, DecodingMode.Attribute);
    }
    exports.decodeHTMLAttribute = decodeHTMLAttribute;
    function decodeHTMLStrict(str) {
      return htmlDecoder(str, DecodingMode.Strict);
    }
    exports.decodeHTMLStrict = decodeHTMLStrict;
    function decodeXML(str) {
      return xmlDecoder(str, DecodingMode.Strict);
    }
    exports.decodeXML = decodeXML;
  })(decode);
  return decode;
}
var hasRequiredTokenizer;
function requireTokenizer() {
  if (hasRequiredTokenizer) return Tokenizer;
  hasRequiredTokenizer = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.QuoteType = void 0;
    var decode_js_1 = /* @__PURE__ */ requireDecode();
    var CharCodes;
    (function(CharCodes2) {
      CharCodes2[CharCodes2["Tab"] = 9] = "Tab";
      CharCodes2[CharCodes2["NewLine"] = 10] = "NewLine";
      CharCodes2[CharCodes2["FormFeed"] = 12] = "FormFeed";
      CharCodes2[CharCodes2["CarriageReturn"] = 13] = "CarriageReturn";
      CharCodes2[CharCodes2["Space"] = 32] = "Space";
      CharCodes2[CharCodes2["ExclamationMark"] = 33] = "ExclamationMark";
      CharCodes2[CharCodes2["Number"] = 35] = "Number";
      CharCodes2[CharCodes2["Amp"] = 38] = "Amp";
      CharCodes2[CharCodes2["SingleQuote"] = 39] = "SingleQuote";
      CharCodes2[CharCodes2["DoubleQuote"] = 34] = "DoubleQuote";
      CharCodes2[CharCodes2["Dash"] = 45] = "Dash";
      CharCodes2[CharCodes2["Slash"] = 47] = "Slash";
      CharCodes2[CharCodes2["Zero"] = 48] = "Zero";
      CharCodes2[CharCodes2["Nine"] = 57] = "Nine";
      CharCodes2[CharCodes2["Semi"] = 59] = "Semi";
      CharCodes2[CharCodes2["Lt"] = 60] = "Lt";
      CharCodes2[CharCodes2["Eq"] = 61] = "Eq";
      CharCodes2[CharCodes2["Gt"] = 62] = "Gt";
      CharCodes2[CharCodes2["Questionmark"] = 63] = "Questionmark";
      CharCodes2[CharCodes2["UpperA"] = 65] = "UpperA";
      CharCodes2[CharCodes2["LowerA"] = 97] = "LowerA";
      CharCodes2[CharCodes2["UpperF"] = 70] = "UpperF";
      CharCodes2[CharCodes2["LowerF"] = 102] = "LowerF";
      CharCodes2[CharCodes2["UpperZ"] = 90] = "UpperZ";
      CharCodes2[CharCodes2["LowerZ"] = 122] = "LowerZ";
      CharCodes2[CharCodes2["LowerX"] = 120] = "LowerX";
      CharCodes2[CharCodes2["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
    })(CharCodes || (CharCodes = {}));
    var State;
    (function(State2) {
      State2[State2["Text"] = 1] = "Text";
      State2[State2["BeforeTagName"] = 2] = "BeforeTagName";
      State2[State2["InTagName"] = 3] = "InTagName";
      State2[State2["InSelfClosingTag"] = 4] = "InSelfClosingTag";
      State2[State2["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
      State2[State2["InClosingTagName"] = 6] = "InClosingTagName";
      State2[State2["AfterClosingTagName"] = 7] = "AfterClosingTagName";
      State2[State2["BeforeAttributeName"] = 8] = "BeforeAttributeName";
      State2[State2["InAttributeName"] = 9] = "InAttributeName";
      State2[State2["AfterAttributeName"] = 10] = "AfterAttributeName";
      State2[State2["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
      State2[State2["InAttributeValueDq"] = 12] = "InAttributeValueDq";
      State2[State2["InAttributeValueSq"] = 13] = "InAttributeValueSq";
      State2[State2["InAttributeValueNq"] = 14] = "InAttributeValueNq";
      State2[State2["BeforeDeclaration"] = 15] = "BeforeDeclaration";
      State2[State2["InDeclaration"] = 16] = "InDeclaration";
      State2[State2["InProcessingInstruction"] = 17] = "InProcessingInstruction";
      State2[State2["BeforeComment"] = 18] = "BeforeComment";
      State2[State2["CDATASequence"] = 19] = "CDATASequence";
      State2[State2["InSpecialComment"] = 20] = "InSpecialComment";
      State2[State2["InCommentLike"] = 21] = "InCommentLike";
      State2[State2["BeforeSpecialS"] = 22] = "BeforeSpecialS";
      State2[State2["SpecialStartSequence"] = 23] = "SpecialStartSequence";
      State2[State2["InSpecialTag"] = 24] = "InSpecialTag";
      State2[State2["BeforeEntity"] = 25] = "BeforeEntity";
      State2[State2["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
      State2[State2["InNamedEntity"] = 27] = "InNamedEntity";
      State2[State2["InNumericEntity"] = 28] = "InNumericEntity";
      State2[State2["InHexEntity"] = 29] = "InHexEntity";
    })(State || (State = {}));
    function isWhitespace(c2) {
      return c2 === CharCodes.Space || c2 === CharCodes.NewLine || c2 === CharCodes.Tab || c2 === CharCodes.FormFeed || c2 === CharCodes.CarriageReturn;
    }
    function isEndOfTagSection(c2) {
      return c2 === CharCodes.Slash || c2 === CharCodes.Gt || isWhitespace(c2);
    }
    function isNumber(c2) {
      return c2 >= CharCodes.Zero && c2 <= CharCodes.Nine;
    }
    function isASCIIAlpha(c2) {
      return c2 >= CharCodes.LowerA && c2 <= CharCodes.LowerZ || c2 >= CharCodes.UpperA && c2 <= CharCodes.UpperZ;
    }
    function isHexDigit(c2) {
      return c2 >= CharCodes.UpperA && c2 <= CharCodes.UpperF || c2 >= CharCodes.LowerA && c2 <= CharCodes.LowerF;
    }
    var QuoteType;
    (function(QuoteType2) {
      QuoteType2[QuoteType2["NoValue"] = 0] = "NoValue";
      QuoteType2[QuoteType2["Unquoted"] = 1] = "Unquoted";
      QuoteType2[QuoteType2["Single"] = 2] = "Single";
      QuoteType2[QuoteType2["Double"] = 3] = "Double";
    })(QuoteType = exports.QuoteType || (exports.QuoteType = {}));
    var Sequences = {
      Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
      CdataEnd: new Uint8Array([93, 93, 62]),
      CommentEnd: new Uint8Array([45, 45, 62]),
      ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
      StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
      TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
      // `</title`
    };
    var Tokenizer2 = (
      /** @class */
      function() {
        function Tokenizer3(_a, cbs) {
          var _b = _a.xmlMode, xmlMode = _b === void 0 ? false : _b, _c = _a.decodeEntities, decodeEntities = _c === void 0 ? true : _c;
          this.cbs = cbs;
          this.state = State.Text;
          this.buffer = "";
          this.sectionStart = 0;
          this.index = 0;
          this.baseState = State.Text;
          this.isSpecial = false;
          this.running = true;
          this.offset = 0;
          this.currentSequence = void 0;
          this.sequenceIndex = 0;
          this.trieIndex = 0;
          this.trieCurrent = 0;
          this.entityResult = 0;
          this.entityExcess = 0;
          this.xmlMode = xmlMode;
          this.decodeEntities = decodeEntities;
          this.entityTrie = xmlMode ? decode_js_1.xmlDecodeTree : decode_js_1.htmlDecodeTree;
        }
        Tokenizer3.prototype.reset = function() {
          this.state = State.Text;
          this.buffer = "";
          this.sectionStart = 0;
          this.index = 0;
          this.baseState = State.Text;
          this.currentSequence = void 0;
          this.running = true;
          this.offset = 0;
        };
        Tokenizer3.prototype.write = function(chunk) {
          this.offset += this.buffer.length;
          this.buffer = chunk;
          this.parse();
        };
        Tokenizer3.prototype.end = function() {
          if (this.running)
            this.finish();
        };
        Tokenizer3.prototype.pause = function() {
          this.running = false;
        };
        Tokenizer3.prototype.resume = function() {
          this.running = true;
          if (this.index < this.buffer.length + this.offset) {
            this.parse();
          }
        };
        Tokenizer3.prototype.getIndex = function() {
          return this.index;
        };
        Tokenizer3.prototype.getSectionStart = function() {
          return this.sectionStart;
        };
        Tokenizer3.prototype.stateText = function(c2) {
          if (c2 === CharCodes.Lt || !this.decodeEntities && this.fastForwardTo(CharCodes.Lt)) {
            if (this.index > this.sectionStart) {
              this.cbs.ontext(this.sectionStart, this.index);
            }
            this.state = State.BeforeTagName;
            this.sectionStart = this.index;
          } else if (this.decodeEntities && c2 === CharCodes.Amp) {
            this.state = State.BeforeEntity;
          }
        };
        Tokenizer3.prototype.stateSpecialStartSequence = function(c2) {
          var isEnd = this.sequenceIndex === this.currentSequence.length;
          var isMatch = isEnd ? (
            // If we are at the end of the sequence, make sure the tag name has ended
            isEndOfTagSection(c2)
          ) : (
            // Otherwise, do a case-insensitive comparison
            (c2 | 32) === this.currentSequence[this.sequenceIndex]
          );
          if (!isMatch) {
            this.isSpecial = false;
          } else if (!isEnd) {
            this.sequenceIndex++;
            return;
          }
          this.sequenceIndex = 0;
          this.state = State.InTagName;
          this.stateInTagName(c2);
        };
        Tokenizer3.prototype.stateInSpecialTag = function(c2) {
          if (this.sequenceIndex === this.currentSequence.length) {
            if (c2 === CharCodes.Gt || isWhitespace(c2)) {
              var endOfText = this.index - this.currentSequence.length;
              if (this.sectionStart < endOfText) {
                var actualIndex = this.index;
                this.index = endOfText;
                this.cbs.ontext(this.sectionStart, endOfText);
                this.index = actualIndex;
              }
              this.isSpecial = false;
              this.sectionStart = endOfText + 2;
              this.stateInClosingTagName(c2);
              return;
            }
            this.sequenceIndex = 0;
          }
          if ((c2 | 32) === this.currentSequence[this.sequenceIndex]) {
            this.sequenceIndex += 1;
          } else if (this.sequenceIndex === 0) {
            if (this.currentSequence === Sequences.TitleEnd) {
              if (this.decodeEntities && c2 === CharCodes.Amp) {
                this.state = State.BeforeEntity;
              }
            } else if (this.fastForwardTo(CharCodes.Lt)) {
              this.sequenceIndex = 1;
            }
          } else {
            this.sequenceIndex = Number(c2 === CharCodes.Lt);
          }
        };
        Tokenizer3.prototype.stateCDATASequence = function(c2) {
          if (c2 === Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === Sequences.Cdata.length) {
              this.state = State.InCommentLike;
              this.currentSequence = Sequences.CdataEnd;
              this.sequenceIndex = 0;
              this.sectionStart = this.index + 1;
            }
          } else {
            this.sequenceIndex = 0;
            this.state = State.InDeclaration;
            this.stateInDeclaration(c2);
          }
        };
        Tokenizer3.prototype.fastForwardTo = function(c2) {
          while (++this.index < this.buffer.length + this.offset) {
            if (this.buffer.charCodeAt(this.index - this.offset) === c2) {
              return true;
            }
          }
          this.index = this.buffer.length + this.offset - 1;
          return false;
        };
        Tokenizer3.prototype.stateInCommentLike = function(c2) {
          if (c2 === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
              if (this.currentSequence === Sequences.CdataEnd) {
                this.cbs.oncdata(this.sectionStart, this.index, 2);
              } else {
                this.cbs.oncomment(this.sectionStart, this.index, 2);
              }
              this.sequenceIndex = 0;
              this.sectionStart = this.index + 1;
              this.state = State.Text;
            }
          } else if (this.sequenceIndex === 0) {
            if (this.fastForwardTo(this.currentSequence[0])) {
              this.sequenceIndex = 1;
            }
          } else if (c2 !== this.currentSequence[this.sequenceIndex - 1]) {
            this.sequenceIndex = 0;
          }
        };
        Tokenizer3.prototype.isTagStartChar = function(c2) {
          return this.xmlMode ? !isEndOfTagSection(c2) : isASCIIAlpha(c2);
        };
        Tokenizer3.prototype.startSpecial = function(sequence, offset) {
          this.isSpecial = true;
          this.currentSequence = sequence;
          this.sequenceIndex = offset;
          this.state = State.SpecialStartSequence;
        };
        Tokenizer3.prototype.stateBeforeTagName = function(c2) {
          if (c2 === CharCodes.ExclamationMark) {
            this.state = State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
          } else if (c2 === CharCodes.Questionmark) {
            this.state = State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
          } else if (this.isTagStartChar(c2)) {
            var lower = c2 | 32;
            this.sectionStart = this.index;
            if (!this.xmlMode && lower === Sequences.TitleEnd[2]) {
              this.startSpecial(Sequences.TitleEnd, 3);
            } else {
              this.state = !this.xmlMode && lower === Sequences.ScriptEnd[2] ? State.BeforeSpecialS : State.InTagName;
            }
          } else if (c2 === CharCodes.Slash) {
            this.state = State.BeforeClosingTagName;
          } else {
            this.state = State.Text;
            this.stateText(c2);
          }
        };
        Tokenizer3.prototype.stateInTagName = function(c2) {
          if (isEndOfTagSection(c2)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = State.BeforeAttributeName;
            this.stateBeforeAttributeName(c2);
          }
        };
        Tokenizer3.prototype.stateBeforeClosingTagName = function(c2) {
          if (isWhitespace(c2)) ;
          else if (c2 === CharCodes.Gt) {
            this.state = State.Text;
          } else {
            this.state = this.isTagStartChar(c2) ? State.InClosingTagName : State.InSpecialComment;
            this.sectionStart = this.index;
          }
        };
        Tokenizer3.prototype.stateInClosingTagName = function(c2) {
          if (c2 === CharCodes.Gt || isWhitespace(c2)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = State.AfterClosingTagName;
            this.stateAfterClosingTagName(c2);
          }
        };
        Tokenizer3.prototype.stateAfterClosingTagName = function(c2) {
          if (c2 === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
            this.state = State.Text;
            this.baseState = State.Text;
            this.sectionStart = this.index + 1;
          }
        };
        Tokenizer3.prototype.stateBeforeAttributeName = function(c2) {
          if (c2 === CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
              this.state = State.InSpecialTag;
              this.sequenceIndex = 0;
            } else {
              this.state = State.Text;
            }
            this.baseState = this.state;
            this.sectionStart = this.index + 1;
          } else if (c2 === CharCodes.Slash) {
            this.state = State.InSelfClosingTag;
          } else if (!isWhitespace(c2)) {
            this.state = State.InAttributeName;
            this.sectionStart = this.index;
          }
        };
        Tokenizer3.prototype.stateInSelfClosingTag = function(c2) {
          if (c2 === CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = State.Text;
            this.baseState = State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false;
          } else if (!isWhitespace(c2)) {
            this.state = State.BeforeAttributeName;
            this.stateBeforeAttributeName(c2);
          }
        };
        Tokenizer3.prototype.stateInAttributeName = function(c2) {
          if (c2 === CharCodes.Eq || isEndOfTagSection(c2)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = State.AfterAttributeName;
            this.stateAfterAttributeName(c2);
          }
        };
        Tokenizer3.prototype.stateAfterAttributeName = function(c2) {
          if (c2 === CharCodes.Eq) {
            this.state = State.BeforeAttributeValue;
          } else if (c2 === CharCodes.Slash || c2 === CharCodes.Gt) {
            this.cbs.onattribend(QuoteType.NoValue, this.index);
            this.state = State.BeforeAttributeName;
            this.stateBeforeAttributeName(c2);
          } else if (!isWhitespace(c2)) {
            this.cbs.onattribend(QuoteType.NoValue, this.index);
            this.state = State.InAttributeName;
            this.sectionStart = this.index;
          }
        };
        Tokenizer3.prototype.stateBeforeAttributeValue = function(c2) {
          if (c2 === CharCodes.DoubleQuote) {
            this.state = State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
          } else if (c2 === CharCodes.SingleQuote) {
            this.state = State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
          } else if (!isWhitespace(c2)) {
            this.sectionStart = this.index;
            this.state = State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c2);
          }
        };
        Tokenizer3.prototype.handleInAttributeValue = function(c2, quote) {
          if (c2 === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === CharCodes.DoubleQuote ? QuoteType.Double : QuoteType.Single, this.index);
            this.state = State.BeforeAttributeName;
          } else if (this.decodeEntities && c2 === CharCodes.Amp) {
            this.baseState = this.state;
            this.state = State.BeforeEntity;
          }
        };
        Tokenizer3.prototype.stateInAttributeValueDoubleQuotes = function(c2) {
          this.handleInAttributeValue(c2, CharCodes.DoubleQuote);
        };
        Tokenizer3.prototype.stateInAttributeValueSingleQuotes = function(c2) {
          this.handleInAttributeValue(c2, CharCodes.SingleQuote);
        };
        Tokenizer3.prototype.stateInAttributeValueNoQuotes = function(c2) {
          if (isWhitespace(c2) || c2 === CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(QuoteType.Unquoted, this.index);
            this.state = State.BeforeAttributeName;
            this.stateBeforeAttributeName(c2);
          } else if (this.decodeEntities && c2 === CharCodes.Amp) {
            this.baseState = this.state;
            this.state = State.BeforeEntity;
          }
        };
        Tokenizer3.prototype.stateBeforeDeclaration = function(c2) {
          if (c2 === CharCodes.OpeningSquareBracket) {
            this.state = State.CDATASequence;
            this.sequenceIndex = 0;
          } else {
            this.state = c2 === CharCodes.Dash ? State.BeforeComment : State.InDeclaration;
          }
        };
        Tokenizer3.prototype.stateInDeclaration = function(c2) {
          if (c2 === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = State.Text;
            this.sectionStart = this.index + 1;
          }
        };
        Tokenizer3.prototype.stateInProcessingInstruction = function(c2) {
          if (c2 === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = State.Text;
            this.sectionStart = this.index + 1;
          }
        };
        Tokenizer3.prototype.stateBeforeComment = function(c2) {
          if (c2 === CharCodes.Dash) {
            this.state = State.InCommentLike;
            this.currentSequence = Sequences.CommentEnd;
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
          } else {
            this.state = State.InDeclaration;
          }
        };
        Tokenizer3.prototype.stateInSpecialComment = function(c2) {
          if (c2 === CharCodes.Gt || this.fastForwardTo(CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = State.Text;
            this.sectionStart = this.index + 1;
          }
        };
        Tokenizer3.prototype.stateBeforeSpecialS = function(c2) {
          var lower = c2 | 32;
          if (lower === Sequences.ScriptEnd[3]) {
            this.startSpecial(Sequences.ScriptEnd, 4);
          } else if (lower === Sequences.StyleEnd[3]) {
            this.startSpecial(Sequences.StyleEnd, 4);
          } else {
            this.state = State.InTagName;
            this.stateInTagName(c2);
          }
        };
        Tokenizer3.prototype.stateBeforeEntity = function(c2) {
          this.entityExcess = 1;
          this.entityResult = 0;
          if (c2 === CharCodes.Number) {
            this.state = State.BeforeNumericEntity;
          } else if (c2 === CharCodes.Amp) ;
          else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.state = State.InNamedEntity;
            this.stateInNamedEntity(c2);
          }
        };
        Tokenizer3.prototype.stateInNamedEntity = function(c2) {
          this.entityExcess += 1;
          this.trieIndex = (0, decode_js_1.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c2);
          if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this.index--;
            return;
          }
          this.trieCurrent = this.entityTrie[this.trieIndex];
          var masked = this.trieCurrent & decode_js_1.BinTrieFlags.VALUE_LENGTH;
          if (masked) {
            var valueLength = (masked >> 14) - 1;
            if (!this.allowLegacyEntity() && c2 !== CharCodes.Semi) {
              this.trieIndex += valueLength;
            } else {
              var entityStart = this.index - this.entityExcess + 1;
              if (entityStart > this.sectionStart) {
                this.emitPartial(this.sectionStart, entityStart);
              }
              this.entityResult = this.trieIndex;
              this.trieIndex += valueLength;
              this.entityExcess = 0;
              this.sectionStart = this.index + 1;
              if (valueLength === 0) {
                this.emitNamedEntity();
              }
            }
          }
        };
        Tokenizer3.prototype.emitNamedEntity = function() {
          this.state = this.baseState;
          if (this.entityResult === 0) {
            return;
          }
          var valueLength = (this.entityTrie[this.entityResult] & decode_js_1.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (valueLength) {
            case 1: {
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~decode_js_1.BinTrieFlags.VALUE_LENGTH);
              break;
            }
            case 2: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            }
            case 3: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
            }
          }
        };
        Tokenizer3.prototype.stateBeforeNumericEntity = function(c2) {
          if ((c2 | 32) === CharCodes.LowerX) {
            this.entityExcess++;
            this.state = State.InHexEntity;
          } else {
            this.state = State.InNumericEntity;
            this.stateInNumericEntity(c2);
          }
        };
        Tokenizer3.prototype.emitNumericEntity = function(strict) {
          var entityStart = this.index - this.entityExcess - 1;
          var numberStart = entityStart + 2 + Number(this.state === State.InHexEntity);
          if (numberStart !== this.index) {
            if (entityStart > this.sectionStart) {
              this.emitPartial(this.sectionStart, entityStart);
            }
            this.sectionStart = this.index + Number(strict);
            this.emitCodePoint((0, decode_js_1.replaceCodePoint)(this.entityResult));
          }
          this.state = this.baseState;
        };
        Tokenizer3.prototype.stateInNumericEntity = function(c2) {
          if (c2 === CharCodes.Semi) {
            this.emitNumericEntity(true);
          } else if (isNumber(c2)) {
            this.entityResult = this.entityResult * 10 + (c2 - CharCodes.Zero);
            this.entityExcess++;
          } else {
            if (this.allowLegacyEntity()) {
              this.emitNumericEntity(false);
            } else {
              this.state = this.baseState;
            }
            this.index--;
          }
        };
        Tokenizer3.prototype.stateInHexEntity = function(c2) {
          if (c2 === CharCodes.Semi) {
            this.emitNumericEntity(true);
          } else if (isNumber(c2)) {
            this.entityResult = this.entityResult * 16 + (c2 - CharCodes.Zero);
            this.entityExcess++;
          } else if (isHexDigit(c2)) {
            this.entityResult = this.entityResult * 16 + ((c2 | 32) - CharCodes.LowerA + 10);
            this.entityExcess++;
          } else {
            if (this.allowLegacyEntity()) {
              this.emitNumericEntity(false);
            } else {
              this.state = this.baseState;
            }
            this.index--;
          }
        };
        Tokenizer3.prototype.allowLegacyEntity = function() {
          return !this.xmlMode && (this.baseState === State.Text || this.baseState === State.InSpecialTag);
        };
        Tokenizer3.prototype.cleanup = function() {
          if (this.running && this.sectionStart !== this.index) {
            if (this.state === State.Text || this.state === State.InSpecialTag && this.sequenceIndex === 0) {
              this.cbs.ontext(this.sectionStart, this.index);
              this.sectionStart = this.index;
            } else if (this.state === State.InAttributeValueDq || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueNq) {
              this.cbs.onattribdata(this.sectionStart, this.index);
              this.sectionStart = this.index;
            }
          }
        };
        Tokenizer3.prototype.shouldContinue = function() {
          return this.index < this.buffer.length + this.offset && this.running;
        };
        Tokenizer3.prototype.parse = function() {
          while (this.shouldContinue()) {
            var c2 = this.buffer.charCodeAt(this.index - this.offset);
            switch (this.state) {
              case State.Text: {
                this.stateText(c2);
                break;
              }
              case State.SpecialStartSequence: {
                this.stateSpecialStartSequence(c2);
                break;
              }
              case State.InSpecialTag: {
                this.stateInSpecialTag(c2);
                break;
              }
              case State.CDATASequence: {
                this.stateCDATASequence(c2);
                break;
              }
              case State.InAttributeValueDq: {
                this.stateInAttributeValueDoubleQuotes(c2);
                break;
              }
              case State.InAttributeName: {
                this.stateInAttributeName(c2);
                break;
              }
              case State.InCommentLike: {
                this.stateInCommentLike(c2);
                break;
              }
              case State.InSpecialComment: {
                this.stateInSpecialComment(c2);
                break;
              }
              case State.BeforeAttributeName: {
                this.stateBeforeAttributeName(c2);
                break;
              }
              case State.InTagName: {
                this.stateInTagName(c2);
                break;
              }
              case State.InClosingTagName: {
                this.stateInClosingTagName(c2);
                break;
              }
              case State.BeforeTagName: {
                this.stateBeforeTagName(c2);
                break;
              }
              case State.AfterAttributeName: {
                this.stateAfterAttributeName(c2);
                break;
              }
              case State.InAttributeValueSq: {
                this.stateInAttributeValueSingleQuotes(c2);
                break;
              }
              case State.BeforeAttributeValue: {
                this.stateBeforeAttributeValue(c2);
                break;
              }
              case State.BeforeClosingTagName: {
                this.stateBeforeClosingTagName(c2);
                break;
              }
              case State.AfterClosingTagName: {
                this.stateAfterClosingTagName(c2);
                break;
              }
              case State.BeforeSpecialS: {
                this.stateBeforeSpecialS(c2);
                break;
              }
              case State.InAttributeValueNq: {
                this.stateInAttributeValueNoQuotes(c2);
                break;
              }
              case State.InSelfClosingTag: {
                this.stateInSelfClosingTag(c2);
                break;
              }
              case State.InDeclaration: {
                this.stateInDeclaration(c2);
                break;
              }
              case State.BeforeDeclaration: {
                this.stateBeforeDeclaration(c2);
                break;
              }
              case State.BeforeComment: {
                this.stateBeforeComment(c2);
                break;
              }
              case State.InProcessingInstruction: {
                this.stateInProcessingInstruction(c2);
                break;
              }
              case State.InNamedEntity: {
                this.stateInNamedEntity(c2);
                break;
              }
              case State.BeforeEntity: {
                this.stateBeforeEntity(c2);
                break;
              }
              case State.InHexEntity: {
                this.stateInHexEntity(c2);
                break;
              }
              case State.InNumericEntity: {
                this.stateInNumericEntity(c2);
                break;
              }
              default: {
                this.stateBeforeNumericEntity(c2);
              }
            }
            this.index++;
          }
          this.cleanup();
        };
        Tokenizer3.prototype.finish = function() {
          if (this.state === State.InNamedEntity) {
            this.emitNamedEntity();
          }
          if (this.sectionStart < this.index) {
            this.handleTrailingData();
          }
          this.cbs.onend();
        };
        Tokenizer3.prototype.handleTrailingData = function() {
          var endIndex = this.buffer.length + this.offset;
          if (this.state === State.InCommentLike) {
            if (this.currentSequence === Sequences.CdataEnd) {
              this.cbs.oncdata(this.sectionStart, endIndex, 0);
            } else {
              this.cbs.oncomment(this.sectionStart, endIndex, 0);
            }
          } else if (this.state === State.InNumericEntity && this.allowLegacyEntity()) {
            this.emitNumericEntity(false);
          } else if (this.state === State.InHexEntity && this.allowLegacyEntity()) {
            this.emitNumericEntity(false);
          } else if (this.state === State.InTagName || this.state === State.BeforeAttributeName || this.state === State.BeforeAttributeValue || this.state === State.AfterAttributeName || this.state === State.InAttributeName || this.state === State.InAttributeValueSq || this.state === State.InAttributeValueDq || this.state === State.InAttributeValueNq || this.state === State.InClosingTagName) ;
          else {
            this.cbs.ontext(this.sectionStart, endIndex);
          }
        };
        Tokenizer3.prototype.emitPartial = function(start, endIndex) {
          if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
            this.cbs.onattribdata(start, endIndex);
          } else {
            this.cbs.ontext(start, endIndex);
          }
        };
        Tokenizer3.prototype.emitCodePoint = function(cp) {
          if (this.baseState !== State.Text && this.baseState !== State.InSpecialTag) {
            this.cbs.onattribentity(cp);
          } else {
            this.cbs.ontextentity(cp);
          }
        };
        return Tokenizer3;
      }()
    );
    exports.default = Tokenizer2;
  })(Tokenizer);
  return Tokenizer;
}
var hasRequiredParser$1;
function requireParser$1() {
  if (hasRequiredParser$1) return Parser;
  hasRequiredParser$1 = 1;
  var __createBinding = Parser && Parser.__createBinding || (Object.create ? function(o, m2, k, k2) {
    if (k2 === void 0) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m2, k);
    if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m2[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m2, k, k2) {
    if (k2 === void 0) k2 = k;
    o[k2] = m2[k];
  });
  var __setModuleDefault = Parser && Parser.__setModuleDefault || (Object.create ? function(o, v2) {
    Object.defineProperty(o, "default", { enumerable: true, value: v2 });
  } : function(o, v2) {
    o["default"] = v2;
  });
  var __importStar = Parser && Parser.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result2 = {};
    if (mod != null) {
      for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result2, mod, k);
    }
    __setModuleDefault(result2, mod);
    return result2;
  };
  Object.defineProperty(Parser, "__esModule", { value: true });
  Parser.Parser = void 0;
  var Tokenizer_js_1 = __importStar(/* @__PURE__ */ requireTokenizer());
  var decode_js_1 = /* @__PURE__ */ requireDecode();
  var formTags = /* @__PURE__ */ new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
  ]);
  var pTag = /* @__PURE__ */ new Set(["p"]);
  var tableSectionTags = /* @__PURE__ */ new Set(["thead", "tbody"]);
  var ddtTags = /* @__PURE__ */ new Set(["dd", "dt"]);
  var rtpTags = /* @__PURE__ */ new Set(["rt", "rp"]);
  var openImpliesClose = /* @__PURE__ */ new Map([
    ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
    ["th", /* @__PURE__ */ new Set(["th"])],
    ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
    ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
    ["li", /* @__PURE__ */ new Set(["li"])],
    ["p", pTag],
    ["h1", pTag],
    ["h2", pTag],
    ["h3", pTag],
    ["h4", pTag],
    ["h5", pTag],
    ["h6", pTag],
    ["select", formTags],
    ["input", formTags],
    ["output", formTags],
    ["button", formTags],
    ["datalist", formTags],
    ["textarea", formTags],
    ["option", /* @__PURE__ */ new Set(["option"])],
    ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
    ["dd", ddtTags],
    ["dt", ddtTags],
    ["address", pTag],
    ["article", pTag],
    ["aside", pTag],
    ["blockquote", pTag],
    ["details", pTag],
    ["div", pTag],
    ["dl", pTag],
    ["fieldset", pTag],
    ["figcaption", pTag],
    ["figure", pTag],
    ["footer", pTag],
    ["form", pTag],
    ["header", pTag],
    ["hr", pTag],
    ["main", pTag],
    ["nav", pTag],
    ["ol", pTag],
    ["pre", pTag],
    ["section", pTag],
    ["table", pTag],
    ["ul", pTag],
    ["rt", rtpTags],
    ["rp", rtpTags],
    ["tbody", tableSectionTags],
    ["tfoot", tableSectionTags]
  ]);
  var voidElements = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]);
  var foreignContextElements = /* @__PURE__ */ new Set(["math", "svg"]);
  var htmlIntegrationElements = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
  ]);
  var reNameEnd = /\s|\//;
  var Parser$1 = (
    /** @class */
    function() {
      function Parser2(cbs, options) {
        if (options === void 0) {
          options = {};
        }
        var _a, _b, _c, _d, _e2;
        this.options = options;
        this.startIndex = 0;
        this.endIndex = 0;
        this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_js_1.default)(this.options, this);
        (_e2 = (_d = this.cbs).onparserinit) === null || _e2 === void 0 ? void 0 : _e2.call(_d, this);
      }
      Parser2.prototype.ontext = function(start, endIndex) {
        var _a, _b;
        var data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data);
        this.startIndex = endIndex;
      };
      Parser2.prototype.ontextentity = function(cp) {
        var _a, _b;
        var index = this.tokenizer.getSectionStart();
        this.endIndex = index - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, (0, decode_js_1.fromCodePoint)(cp));
        this.startIndex = index;
      };
      Parser2.prototype.isVoidElement = function(name) {
        return !this.options.xmlMode && voidElements.has(name);
      };
      Parser2.prototype.onopentagname = function(start, endIndex) {
        this.endIndex = endIndex;
        var name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) {
          name = name.toLowerCase();
        }
        this.emitOpenTag(name);
      };
      Parser2.prototype.emitOpenTag = function(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        var impliesClose = !this.options.xmlMode && openImpliesClose.get(name);
        if (impliesClose) {
          while (this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])) {
            var element = this.stack.pop();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, element, true);
          }
        }
        if (!this.isVoidElement(name)) {
          this.stack.push(name);
          if (foreignContextElements.has(name)) {
            this.foreignContext.push(true);
          } else if (htmlIntegrationElements.has(name)) {
            this.foreignContext.push(false);
          }
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name);
        if (this.cbs.onopentag)
          this.attribs = {};
      };
      Parser2.prototype.endOpenTag = function(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
          (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs, isImplied);
          this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
          this.cbs.onclosetag(this.tagname, true);
        }
        this.tagname = "";
      };
      Parser2.prototype.onopentagend = function(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        this.startIndex = endIndex + 1;
      };
      Parser2.prototype.onclosetag = function(start, endIndex) {
        var _a, _b, _c, _d, _e2, _f;
        this.endIndex = endIndex;
        var name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) {
          name = name.toLowerCase();
        }
        if (foreignContextElements.has(name) || htmlIntegrationElements.has(name)) {
          this.foreignContext.pop();
        }
        if (!this.isVoidElement(name)) {
          var pos = this.stack.lastIndexOf(name);
          if (pos !== -1) {
            if (this.cbs.onclosetag) {
              var count = this.stack.length - pos;
              while (count--) {
                this.cbs.onclosetag(this.stack.pop(), count !== 0);
              }
            } else
              this.stack.length = pos;
          } else if (!this.options.xmlMode && name === "p") {
            this.emitOpenTag("p");
            this.closeCurrentTag(true);
          }
        } else if (!this.options.xmlMode && name === "br") {
          (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, "br");
          (_d = (_c = this.cbs).onopentag) === null || _d === void 0 ? void 0 : _d.call(_c, "br", {}, true);
          (_f = (_e2 = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e2, "br", false);
        }
        this.startIndex = endIndex + 1;
      };
      Parser2.prototype.onselfclosingtag = function(endIndex) {
        this.endIndex = endIndex;
        if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
          this.closeCurrentTag(false);
          this.startIndex = endIndex + 1;
        } else {
          this.onopentagend(endIndex);
        }
      };
      Parser2.prototype.closeCurrentTag = function(isOpenImplied) {
        var _a, _b;
        var name = this.tagname;
        this.endOpenTag(isOpenImplied);
        if (this.stack[this.stack.length - 1] === name) {
          (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name, !isOpenImplied);
          this.stack.pop();
        }
      };
      Parser2.prototype.onattribname = function(start, endIndex) {
        this.startIndex = start;
        var name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
      };
      Parser2.prototype.onattribdata = function(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
      };
      Parser2.prototype.onattribentity = function(cp) {
        this.attribvalue += (0, decode_js_1.fromCodePoint)(cp);
      };
      Parser2.prototype.onattribend = function(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote === Tokenizer_js_1.QuoteType.Double ? '"' : quote === Tokenizer_js_1.QuoteType.Single ? "'" : quote === Tokenizer_js_1.QuoteType.NoValue ? void 0 : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
          this.attribs[this.attribname] = this.attribvalue;
        }
        this.attribvalue = "";
      };
      Parser2.prototype.getInstructionName = function(value) {
        var index = value.search(reNameEnd);
        var name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) {
          name = name.toLowerCase();
        }
        return name;
      };
      Parser2.prototype.ondeclaration = function(start, endIndex) {
        this.endIndex = endIndex;
        var value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
          var name = this.getInstructionName(value);
          this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
        }
        this.startIndex = endIndex + 1;
      };
      Parser2.prototype.onprocessinginstruction = function(start, endIndex) {
        this.endIndex = endIndex;
        var value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
          var name = this.getInstructionName(value);
          this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
        }
        this.startIndex = endIndex + 1;
      };
      Parser2.prototype.oncomment = function(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
        this.startIndex = endIndex + 1;
      };
      Parser2.prototype.oncdata = function(start, endIndex, offset) {
        var _a, _b, _c, _d, _e2, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        var value = this.getSlice(start, endIndex - offset);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
          (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
          (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
          (_f = (_e2 = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e2);
        } else {
          (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, "[CDATA[".concat(value, "]]"));
          (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
        }
        this.startIndex = endIndex + 1;
      };
      Parser2.prototype.onend = function() {
        var _a, _b;
        if (this.cbs.onclosetag) {
          this.endIndex = this.startIndex;
          for (var index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true))
            ;
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
      };
      Parser2.prototype.reset = function() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
        this.buffers.length = 0;
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
      };
      Parser2.prototype.parseComplete = function(data) {
        this.reset();
        this.end(data);
      };
      Parser2.prototype.getSlice = function(start, end) {
        while (start - this.bufferOffset >= this.buffers[0].length) {
          this.shiftBuffer();
        }
        var slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while (end - this.bufferOffset > this.buffers[0].length) {
          this.shiftBuffer();
          slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
      };
      Parser2.prototype.shiftBuffer = function() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
      };
      Parser2.prototype.write = function(chunk) {
        var _a, _b;
        if (this.ended) {
          (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".write() after done!"));
          return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
          this.tokenizer.write(chunk);
          this.writeIndex++;
        }
      };
      Parser2.prototype.end = function(chunk) {
        var _a, _b;
        if (this.ended) {
          (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(".end() after done!"));
          return;
        }
        if (chunk)
          this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
      };
      Parser2.prototype.pause = function() {
        this.tokenizer.pause();
      };
      Parser2.prototype.resume = function() {
        this.tokenizer.resume();
        while (this.tokenizer.running && this.writeIndex < this.buffers.length) {
          this.tokenizer.write(this.buffers[this.writeIndex++]);
        }
        if (this.ended)
          this.tokenizer.end();
      };
      Parser2.prototype.parseChunk = function(chunk) {
        this.write(chunk);
      };
      Parser2.prototype.done = function(chunk) {
        this.end(chunk);
      };
      return Parser2;
    }()
  );
  Parser.Parser = Parser$1;
  return Parser;
}
var lib$4 = {};
var lib$3 = {};
var hasRequiredLib$5;
function requireLib$5() {
  if (hasRequiredLib$5) return lib$3;
  hasRequiredLib$5 = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
    var ElementType;
    (function(ElementType2) {
      ElementType2["Root"] = "root";
      ElementType2["Text"] = "text";
      ElementType2["Directive"] = "directive";
      ElementType2["Comment"] = "comment";
      ElementType2["Script"] = "script";
      ElementType2["Style"] = "style";
      ElementType2["Tag"] = "tag";
      ElementType2["CDATA"] = "cdata";
      ElementType2["Doctype"] = "doctype";
    })(ElementType = exports.ElementType || (exports.ElementType = {}));
    function isTag(elem) {
      return elem.type === ElementType.Tag || elem.type === ElementType.Script || elem.type === ElementType.Style;
    }
    exports.isTag = isTag;
    exports.Root = ElementType.Root;
    exports.Text = ElementType.Text;
    exports.Directive = ElementType.Directive;
    exports.Comment = ElementType.Comment;
    exports.Script = ElementType.Script;
    exports.Style = ElementType.Style;
    exports.Tag = ElementType.Tag;
    exports.CDATA = ElementType.CDATA;
    exports.Doctype = ElementType.Doctype;
  })(lib$3);
  return lib$3;
}
var node$1 = {};
var hasRequiredNode$1;
function requireNode$1() {
  if (hasRequiredNode$1) return node$1;
  hasRequiredNode$1 = 1;
  var __extends = node$1 && node$1.__extends || /* @__PURE__ */ function() {
    var extendStatics = function(d2, b2) {
      extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
        d3.__proto__ = b3;
      } || function(d3, b3) {
        for (var p2 in b3) if (Object.prototype.hasOwnProperty.call(b3, p2)) d3[p2] = b3[p2];
      };
      return extendStatics(d2, b2);
    };
    return function(d2, b2) {
      if (typeof b2 !== "function" && b2 !== null)
        throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
      extendStatics(d2, b2);
      function __() {
        this.constructor = d2;
      }
      d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
    };
  }();
  var __assign = node$1 && node$1.__assign || function() {
    __assign = Object.assign || function(t) {
      for (var s2, i2 = 1, n = arguments.length; i2 < n; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2))
          t[p2] = s2[p2];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  Object.defineProperty(node$1, "__esModule", { value: true });
  node$1.cloneNode = node$1.hasChildren = node$1.isDocument = node$1.isDirective = node$1.isComment = node$1.isText = node$1.isCDATA = node$1.isTag = node$1.Element = node$1.Document = node$1.CDATA = node$1.NodeWithChildren = node$1.ProcessingInstruction = node$1.Comment = node$1.Text = node$1.DataNode = node$1.Node = void 0;
  var domelementtype_1 = /* @__PURE__ */ requireLib$5();
  var Node = (
    /** @class */
    function() {
      function Node2() {
        this.parent = null;
        this.prev = null;
        this.next = null;
        this.startIndex = null;
        this.endIndex = null;
      }
      Object.defineProperty(Node2.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.parent;
        },
        set: function(parent) {
          this.parent = parent;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Node2.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.prev;
        },
        set: function(prev) {
          this.prev = prev;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Node2.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.next;
        },
        set: function(next) {
          this.next = next;
        },
        enumerable: false,
        configurable: true
      });
      Node2.prototype.cloneNode = function(recursive) {
        if (recursive === void 0) {
          recursive = false;
        }
        return cloneNode(this, recursive);
      };
      return Node2;
    }()
  );
  node$1.Node = Node;
  var DataNode = (
    /** @class */
    function(_super) {
      __extends(DataNode2, _super);
      function DataNode2(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
      }
      Object.defineProperty(DataNode2.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.data;
        },
        set: function(data) {
          this.data = data;
        },
        enumerable: false,
        configurable: true
      });
      return DataNode2;
    }(Node)
  );
  node$1.DataNode = DataNode;
  var Text = (
    /** @class */
    function(_super) {
      __extends(Text2, _super);
      function Text2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Text;
        return _this;
      }
      Object.defineProperty(Text2.prototype, "nodeType", {
        get: function() {
          return 3;
        },
        enumerable: false,
        configurable: true
      });
      return Text2;
    }(DataNode)
  );
  node$1.Text = Text;
  var Comment = (
    /** @class */
    function(_super) {
      __extends(Comment2, _super);
      function Comment2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Comment;
        return _this;
      }
      Object.defineProperty(Comment2.prototype, "nodeType", {
        get: function() {
          return 8;
        },
        enumerable: false,
        configurable: true
      });
      return Comment2;
    }(DataNode)
  );
  node$1.Comment = Comment;
  var ProcessingInstruction = (
    /** @class */
    function(_super) {
      __extends(ProcessingInstruction2, _super);
      function ProcessingInstruction2(name, data) {
        var _this = _super.call(this, data) || this;
        _this.name = name;
        _this.type = domelementtype_1.ElementType.Directive;
        return _this;
      }
      Object.defineProperty(ProcessingInstruction2.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: false,
        configurable: true
      });
      return ProcessingInstruction2;
    }(DataNode)
  );
  node$1.ProcessingInstruction = ProcessingInstruction;
  var NodeWithChildren = (
    /** @class */
    function(_super) {
      __extends(NodeWithChildren2, _super);
      function NodeWithChildren2(children) {
        var _this = _super.call(this) || this;
        _this.children = children;
        return _this;
      }
      Object.defineProperty(NodeWithChildren2.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function() {
          var _a;
          return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(NodeWithChildren2.prototype, "lastChild", {
        /** Last child of the node. */
        get: function() {
          return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(NodeWithChildren2.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.children;
        },
        set: function(children) {
          this.children = children;
        },
        enumerable: false,
        configurable: true
      });
      return NodeWithChildren2;
    }(Node)
  );
  node$1.NodeWithChildren = NodeWithChildren;
  var CDATA = (
    /** @class */
    function(_super) {
      __extends(CDATA2, _super);
      function CDATA2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.CDATA;
        return _this;
      }
      Object.defineProperty(CDATA2.prototype, "nodeType", {
        get: function() {
          return 4;
        },
        enumerable: false,
        configurable: true
      });
      return CDATA2;
    }(NodeWithChildren)
  );
  node$1.CDATA = CDATA;
  var Document = (
    /** @class */
    function(_super) {
      __extends(Document2, _super);
      function Document2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = domelementtype_1.ElementType.Root;
        return _this;
      }
      Object.defineProperty(Document2.prototype, "nodeType", {
        get: function() {
          return 9;
        },
        enumerable: false,
        configurable: true
      });
      return Document2;
    }(NodeWithChildren)
  );
  node$1.Document = Document;
  var Element2 = (
    /** @class */
    function(_super) {
      __extends(Element3, _super);
      function Element3(name, attribs, children, type) {
        if (children === void 0) {
          children = [];
        }
        if (type === void 0) {
          type = name === "script" ? domelementtype_1.ElementType.Script : name === "style" ? domelementtype_1.ElementType.Style : domelementtype_1.ElementType.Tag;
        }
        var _this = _super.call(this, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
      }
      Object.defineProperty(Element3.prototype, "nodeType", {
        get: function() {
          return 1;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Element3.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function() {
          return this.name;
        },
        set: function(name) {
          this.name = name;
        },
        enumerable: false,
        configurable: true
      });
      Object.defineProperty(Element3.prototype, "attributes", {
        get: function() {
          var _this = this;
          return Object.keys(this.attribs).map(function(name) {
            var _a, _b;
            return {
              name,
              value: _this.attribs[name],
              namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
              prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
          });
        },
        enumerable: false,
        configurable: true
      });
      return Element3;
    }(NodeWithChildren)
  );
  node$1.Element = Element2;
  function isTag(node2) {
    return (0, domelementtype_1.isTag)(node2);
  }
  node$1.isTag = isTag;
  function isCDATA(node2) {
    return node2.type === domelementtype_1.ElementType.CDATA;
  }
  node$1.isCDATA = isCDATA;
  function isText(node2) {
    return node2.type === domelementtype_1.ElementType.Text;
  }
  node$1.isText = isText;
  function isComment(node2) {
    return node2.type === domelementtype_1.ElementType.Comment;
  }
  node$1.isComment = isComment;
  function isDirective(node2) {
    return node2.type === domelementtype_1.ElementType.Directive;
  }
  node$1.isDirective = isDirective;
  function isDocument(node2) {
    return node2.type === domelementtype_1.ElementType.Root;
  }
  node$1.isDocument = isDocument;
  function hasChildren(node2) {
    return Object.prototype.hasOwnProperty.call(node2, "children");
  }
  node$1.hasChildren = hasChildren;
  function cloneNode(node2, recursive) {
    if (recursive === void 0) {
      recursive = false;
    }
    var result2;
    if (isText(node2)) {
      result2 = new Text(node2.data);
    } else if (isComment(node2)) {
      result2 = new Comment(node2.data);
    } else if (isTag(node2)) {
      var children = recursive ? cloneChildren(node2.children) : [];
      var clone_1 = new Element2(node2.name, __assign({}, node2.attribs), children);
      children.forEach(function(child) {
        return child.parent = clone_1;
      });
      if (node2.namespace != null) {
        clone_1.namespace = node2.namespace;
      }
      if (node2["x-attribsNamespace"]) {
        clone_1["x-attribsNamespace"] = __assign({}, node2["x-attribsNamespace"]);
      }
      if (node2["x-attribsPrefix"]) {
        clone_1["x-attribsPrefix"] = __assign({}, node2["x-attribsPrefix"]);
      }
      result2 = clone_1;
    } else if (isCDATA(node2)) {
      var children = recursive ? cloneChildren(node2.children) : [];
      var clone_2 = new CDATA(children);
      children.forEach(function(child) {
        return child.parent = clone_2;
      });
      result2 = clone_2;
    } else if (isDocument(node2)) {
      var children = recursive ? cloneChildren(node2.children) : [];
      var clone_3 = new Document(children);
      children.forEach(function(child) {
        return child.parent = clone_3;
      });
      if (node2["x-mode"]) {
        clone_3["x-mode"] = node2["x-mode"];
      }
      result2 = clone_3;
    } else if (isDirective(node2)) {
      var instruction = new ProcessingInstruction(node2.name, node2.data);
      if (node2["x-name"] != null) {
        instruction["x-name"] = node2["x-name"];
        instruction["x-publicId"] = node2["x-publicId"];
        instruction["x-systemId"] = node2["x-systemId"];
      }
      result2 = instruction;
    } else {
      throw new Error("Not implemented yet: ".concat(node2.type));
    }
    result2.startIndex = node2.startIndex;
    result2.endIndex = node2.endIndex;
    if (node2.sourceCodeLocation != null) {
      result2.sourceCodeLocation = node2.sourceCodeLocation;
    }
    return result2;
  }
  node$1.cloneNode = cloneNode;
  function cloneChildren(childs) {
    var children = childs.map(function(child) {
      return cloneNode(child, true);
    });
    for (var i2 = 1; i2 < children.length; i2++) {
      children[i2].prev = children[i2 - 1];
      children[i2 - 1].next = children[i2];
    }
    return children;
  }
  return node$1;
}
var hasRequiredLib$4;
function requireLib$4() {
  if (hasRequiredLib$4) return lib$4;
  hasRequiredLib$4 = 1;
  (function(exports) {
    var __createBinding = lib$4 && lib$4.__createBinding || (Object.create ? function(o, m2, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m2, k);
      if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m2[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m2, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m2[k];
    });
    var __exportStar = lib$4 && lib$4.__exportStar || function(m2, exports2) {
      for (var p2 in m2) if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p2)) __createBinding(exports2, m2, p2);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DomHandler = void 0;
    var domelementtype_1 = /* @__PURE__ */ requireLib$5();
    var node_js_1 = /* @__PURE__ */ requireNode$1();
    __exportStar(/* @__PURE__ */ requireNode$1(), exports);
    var defaultOpts = {
      withStartIndices: false,
      withEndIndices: false,
      xmlMode: false
    };
    var DomHandler = (
      /** @class */
      function() {
        function DomHandler2(callback, options, elementCB) {
          this.dom = [];
          this.root = new node_js_1.Document(this.dom);
          this.done = false;
          this.tagStack = [this.root];
          this.lastNode = null;
          this.parser = null;
          if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
          }
          if (typeof callback === "object") {
            options = callback;
            callback = void 0;
          }
          this.callback = callback !== null && callback !== void 0 ? callback : null;
          this.options = options !== null && options !== void 0 ? options : defaultOpts;
          this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
        }
        DomHandler2.prototype.onparserinit = function(parser2) {
          this.parser = parser2;
        };
        DomHandler2.prototype.onreset = function() {
          this.dom = [];
          this.root = new node_js_1.Document(this.dom);
          this.done = false;
          this.tagStack = [this.root];
          this.lastNode = null;
          this.parser = null;
        };
        DomHandler2.prototype.onend = function() {
          if (this.done)
            return;
          this.done = true;
          this.parser = null;
          this.handleCallback(null);
        };
        DomHandler2.prototype.onerror = function(error) {
          this.handleCallback(error);
        };
        DomHandler2.prototype.onclosetag = function() {
          this.lastNode = null;
          var elem = this.tagStack.pop();
          if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
          }
          if (this.elementCB)
            this.elementCB(elem);
        };
        DomHandler2.prototype.onopentag = function(name, attribs) {
          var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : void 0;
          var element = new node_js_1.Element(name, attribs, void 0, type);
          this.addNode(element);
          this.tagStack.push(element);
        };
        DomHandler2.prototype.ontext = function(data) {
          var lastNode = this.lastNode;
          if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) {
              lastNode.endIndex = this.parser.endIndex;
            }
          } else {
            var node2 = new node_js_1.Text(data);
            this.addNode(node2);
            this.lastNode = node2;
          }
        };
        DomHandler2.prototype.oncomment = function(data) {
          if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
          }
          var node2 = new node_js_1.Comment(data);
          this.addNode(node2);
          this.lastNode = node2;
        };
        DomHandler2.prototype.oncommentend = function() {
          this.lastNode = null;
        };
        DomHandler2.prototype.oncdatastart = function() {
          var text = new node_js_1.Text("");
          var node2 = new node_js_1.CDATA([text]);
          this.addNode(node2);
          text.parent = node2;
          this.lastNode = text;
        };
        DomHandler2.prototype.oncdataend = function() {
          this.lastNode = null;
        };
        DomHandler2.prototype.onprocessinginstruction = function(name, data) {
          var node2 = new node_js_1.ProcessingInstruction(name, data);
          this.addNode(node2);
        };
        DomHandler2.prototype.handleCallback = function(error) {
          if (typeof this.callback === "function") {
            this.callback(error, this.dom);
          } else if (error) {
            throw error;
          }
        };
        DomHandler2.prototype.addNode = function(node2) {
          var parent = this.tagStack[this.tagStack.length - 1];
          var previousSibling = parent.children[parent.children.length - 1];
          if (this.options.withStartIndices) {
            node2.startIndex = this.parser.startIndex;
          }
          if (this.options.withEndIndices) {
            node2.endIndex = this.parser.endIndex;
          }
          parent.children.push(node2);
          if (previousSibling) {
            node2.prev = previousSibling;
            previousSibling.next = node2;
          }
          node2.parent = parent;
          this.lastNode = null;
        };
        return DomHandler2;
      }()
    );
    exports.DomHandler = DomHandler;
    exports.default = DomHandler;
  })(lib$4);
  return lib$4;
}
var lib$2 = {};
var stringify = {};
var lib$1 = {};
var lib = {};
var encode = {};
var encodeHtml = {};
var hasRequiredEncodeHtml;
function requireEncodeHtml() {
  if (hasRequiredEncodeHtml) return encodeHtml;
  hasRequiredEncodeHtml = 1;
  Object.defineProperty(encodeHtml, "__esModule", { value: true });
  function restoreDiff(arr) {
    for (var i2 = 1; i2 < arr.length; i2++) {
      arr[i2][0] += arr[i2 - 1][0] + 1;
    }
    return arr;
  }
  encodeHtml.default = new Map(/* @__PURE__ */ restoreDiff([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ restoreDiff([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ restoreDiff([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
  return encodeHtml;
}
var _escape = {};
var hasRequired_escape;
function require_escape() {
  if (hasRequired_escape) return _escape;
  hasRequired_escape = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.getCodePoint = exports.xmlReplacer = void 0;
    exports.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
    var xmlCodeMap = /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [39, "&apos;"],
      [60, "&lt;"],
      [62, "&gt;"]
    ]);
    exports.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? function(str, index) {
      return str.codePointAt(index);
    } : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(c2, index) {
        return (c2.charCodeAt(index) & 64512) === 55296 ? (c2.charCodeAt(index) - 55296) * 1024 + c2.charCodeAt(index + 1) - 56320 + 65536 : c2.charCodeAt(index);
      }
    );
    function encodeXML(str) {
      var ret = "";
      var lastIdx = 0;
      var match;
      while ((match = exports.xmlReplacer.exec(str)) !== null) {
        var i2 = match.index;
        var char = str.charCodeAt(i2);
        var next = xmlCodeMap.get(char);
        if (next !== void 0) {
          ret += str.substring(lastIdx, i2) + next;
          lastIdx = i2 + 1;
        } else {
          ret += "".concat(str.substring(lastIdx, i2), "&#x").concat((0, exports.getCodePoint)(str, i2).toString(16), ";");
          lastIdx = exports.xmlReplacer.lastIndex += Number((char & 64512) === 55296);
        }
      }
      return ret + str.substr(lastIdx);
    }
    exports.encodeXML = encodeXML;
    exports.escape = encodeXML;
    function getEscaper(regex, map) {
      return function escape(data) {
        var match;
        var lastIdx = 0;
        var result2 = "";
        while (match = regex.exec(data)) {
          if (lastIdx !== match.index) {
            result2 += data.substring(lastIdx, match.index);
          }
          result2 += map.get(match[0].charCodeAt(0));
          lastIdx = match.index + 1;
        }
        return result2 + data.substring(lastIdx);
      };
    }
    exports.escapeUTF8 = getEscaper(/[&<>'"]/g, xmlCodeMap);
    exports.escapeAttribute = getEscaper(/["&\u00A0]/g, /* @__PURE__ */ new Map([
      [34, "&quot;"],
      [38, "&amp;"],
      [160, "&nbsp;"]
    ]));
    exports.escapeText = getEscaper(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
      [38, "&amp;"],
      [60, "&lt;"],
      [62, "&gt;"],
      [160, "&nbsp;"]
    ]));
  })(_escape);
  return _escape;
}
var hasRequiredEncode;
function requireEncode() {
  if (hasRequiredEncode) return encode;
  hasRequiredEncode = 1;
  var __importDefault = encode && encode.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
  };
  Object.defineProperty(encode, "__esModule", { value: true });
  encode.encodeNonAsciiHTML = encode.encodeHTML = void 0;
  var encode_html_js_1 = __importDefault(/* @__PURE__ */ requireEncodeHtml());
  var escape_js_1 = /* @__PURE__ */ require_escape();
  var htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
  function encodeHTML(data) {
    return encodeHTMLTrieRe(htmlReplacer, data);
  }
  encode.encodeHTML = encodeHTML;
  function encodeNonAsciiHTML(data) {
    return encodeHTMLTrieRe(escape_js_1.xmlReplacer, data);
  }
  encode.encodeNonAsciiHTML = encodeNonAsciiHTML;
  function encodeHTMLTrieRe(regExp, str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while ((match = regExp.exec(str)) !== null) {
      var i2 = match.index;
      ret += str.substring(lastIdx, i2);
      var char = str.charCodeAt(i2);
      var next = encode_html_js_1.default.get(char);
      if (typeof next === "object") {
        if (i2 + 1 < str.length) {
          var nextChar = str.charCodeAt(i2 + 1);
          var value = typeof next.n === "number" ? next.n === nextChar ? next.o : void 0 : next.n.get(nextChar);
          if (value !== void 0) {
            ret += value;
            lastIdx = regExp.lastIndex += 1;
            continue;
          }
        }
        next = next.v;
      }
      if (next !== void 0) {
        ret += next;
        lastIdx = i2 + 1;
      } else {
        var cp = (0, escape_js_1.getCodePoint)(str, i2);
        ret += "&#x".concat(cp.toString(16), ";");
        lastIdx = regExp.lastIndex += Number(cp !== char);
      }
    }
    return ret + str.substr(lastIdx);
  }
  return encode;
}
var hasRequiredLib$3;
function requireLib$3() {
  if (hasRequiredLib$3) return lib;
  hasRequiredLib$3 = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLAttribute = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.DecodingMode = exports.EntityDecoder = exports.encodeHTML5 = exports.encodeHTML4 = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.escapeText = exports.escapeAttribute = exports.escapeUTF8 = exports.escape = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = exports.EncodingMode = exports.EntityLevel = void 0;
    var decode_js_1 = /* @__PURE__ */ requireDecode();
    var encode_js_1 = /* @__PURE__ */ requireEncode();
    var escape_js_1 = /* @__PURE__ */ require_escape();
    var EntityLevel;
    (function(EntityLevel2) {
      EntityLevel2[EntityLevel2["XML"] = 0] = "XML";
      EntityLevel2[EntityLevel2["HTML"] = 1] = "HTML";
    })(EntityLevel = exports.EntityLevel || (exports.EntityLevel = {}));
    var EncodingMode;
    (function(EncodingMode2) {
      EncodingMode2[EncodingMode2["UTF8"] = 0] = "UTF8";
      EncodingMode2[EncodingMode2["ASCII"] = 1] = "ASCII";
      EncodingMode2[EncodingMode2["Extensive"] = 2] = "Extensive";
      EncodingMode2[EncodingMode2["Attribute"] = 3] = "Attribute";
      EncodingMode2[EncodingMode2["Text"] = 4] = "Text";
    })(EncodingMode = exports.EncodingMode || (exports.EncodingMode = {}));
    function decode2(data, options) {
      if (options === void 0) {
        options = EntityLevel.XML;
      }
      var level = typeof options === "number" ? options : options.level;
      if (level === EntityLevel.HTML) {
        var mode = typeof options === "object" ? options.mode : void 0;
        return (0, decode_js_1.decodeHTML)(data, mode);
      }
      return (0, decode_js_1.decodeXML)(data);
    }
    exports.decode = decode2;
    function decodeStrict(data, options) {
      var _a;
      if (options === void 0) {
        options = EntityLevel.XML;
      }
      var opts = typeof options === "number" ? { level: options } : options;
      (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = decode_js_1.DecodingMode.Strict;
      return decode2(data, opts);
    }
    exports.decodeStrict = decodeStrict;
    function encode2(data, options) {
      if (options === void 0) {
        options = EntityLevel.XML;
      }
      var opts = typeof options === "number" ? { level: options } : options;
      if (opts.mode === EncodingMode.UTF8)
        return (0, escape_js_1.escapeUTF8)(data);
      if (opts.mode === EncodingMode.Attribute)
        return (0, escape_js_1.escapeAttribute)(data);
      if (opts.mode === EncodingMode.Text)
        return (0, escape_js_1.escapeText)(data);
      if (opts.level === EntityLevel.HTML) {
        if (opts.mode === EncodingMode.ASCII) {
          return (0, encode_js_1.encodeNonAsciiHTML)(data);
        }
        return (0, encode_js_1.encodeHTML)(data);
      }
      return (0, escape_js_1.encodeXML)(data);
    }
    exports.encode = encode2;
    var escape_js_2 = /* @__PURE__ */ require_escape();
    Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function() {
      return escape_js_2.encodeXML;
    } });
    Object.defineProperty(exports, "escape", { enumerable: true, get: function() {
      return escape_js_2.escape;
    } });
    Object.defineProperty(exports, "escapeUTF8", { enumerable: true, get: function() {
      return escape_js_2.escapeUTF8;
    } });
    Object.defineProperty(exports, "escapeAttribute", { enumerable: true, get: function() {
      return escape_js_2.escapeAttribute;
    } });
    Object.defineProperty(exports, "escapeText", { enumerable: true, get: function() {
      return escape_js_2.escapeText;
    } });
    var encode_js_2 = /* @__PURE__ */ requireEncode();
    Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function() {
      return encode_js_2.encodeHTML;
    } });
    Object.defineProperty(exports, "encodeNonAsciiHTML", { enumerable: true, get: function() {
      return encode_js_2.encodeNonAsciiHTML;
    } });
    Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function() {
      return encode_js_2.encodeHTML;
    } });
    Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function() {
      return encode_js_2.encodeHTML;
    } });
    var decode_js_2 = /* @__PURE__ */ requireDecode();
    Object.defineProperty(exports, "EntityDecoder", { enumerable: true, get: function() {
      return decode_js_2.EntityDecoder;
    } });
    Object.defineProperty(exports, "DecodingMode", { enumerable: true, get: function() {
      return decode_js_2.DecodingMode;
    } });
    Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function() {
      return decode_js_2.decodeXML;
    } });
    Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function() {
      return decode_js_2.decodeHTML;
    } });
    Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function() {
      return decode_js_2.decodeHTMLStrict;
    } });
    Object.defineProperty(exports, "decodeHTMLAttribute", { enumerable: true, get: function() {
      return decode_js_2.decodeHTMLAttribute;
    } });
    Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function() {
      return decode_js_2.decodeHTML;
    } });
    Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function() {
      return decode_js_2.decodeHTML;
    } });
    Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function() {
      return decode_js_2.decodeHTMLStrict;
    } });
    Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function() {
      return decode_js_2.decodeHTMLStrict;
    } });
    Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function() {
      return decode_js_2.decodeXML;
    } });
  })(lib);
  return lib;
}
var foreignNames = {};
var hasRequiredForeignNames;
function requireForeignNames() {
  if (hasRequiredForeignNames) return foreignNames;
  hasRequiredForeignNames = 1;
  Object.defineProperty(foreignNames, "__esModule", { value: true });
  foreignNames.attributeNames = foreignNames.elementNames = void 0;
  foreignNames.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
  ].map(function(val) {
    return [val.toLowerCase(), val];
  }));
  foreignNames.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
  ].map(function(val) {
    return [val.toLowerCase(), val];
  }));
  return foreignNames;
}
var hasRequiredLib$2;
function requireLib$2() {
  if (hasRequiredLib$2) return lib$1;
  hasRequiredLib$2 = 1;
  var __assign = lib$1 && lib$1.__assign || function() {
    __assign = Object.assign || function(t) {
      for (var s2, i2 = 1, n = arguments.length; i2 < n; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2))
          t[p2] = s2[p2];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __createBinding = lib$1 && lib$1.__createBinding || (Object.create ? function(o, m2, k, k2) {
    if (k2 === void 0) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m2, k);
    if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m2[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m2, k, k2) {
    if (k2 === void 0) k2 = k;
    o[k2] = m2[k];
  });
  var __setModuleDefault = lib$1 && lib$1.__setModuleDefault || (Object.create ? function(o, v2) {
    Object.defineProperty(o, "default", { enumerable: true, value: v2 });
  } : function(o, v2) {
    o["default"] = v2;
  });
  var __importStar = lib$1 && lib$1.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result2 = {};
    if (mod != null) {
      for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result2, mod, k);
    }
    __setModuleDefault(result2, mod);
    return result2;
  };
  Object.defineProperty(lib$1, "__esModule", { value: true });
  lib$1.render = void 0;
  var ElementType = __importStar(/* @__PURE__ */ requireLib$5());
  var entities_1 = /* @__PURE__ */ requireLib$3();
  var foreignNames_js_1 = /* @__PURE__ */ requireForeignNames();
  var unencodedElements = /* @__PURE__ */ new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
  ]);
  function replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
  }
  function formatAttributes(attributes, opts) {
    var _a;
    if (!attributes)
      return;
    var encode2 = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? entities_1.encodeXML : entities_1.escapeAttribute;
    return Object.keys(attributes).map(function(key) {
      var _a2, _b;
      var value = (_a2 = attributes[key]) !== null && _a2 !== void 0 ? _a2 : "";
      if (opts.xmlMode === "foreign") {
        key = (_b = foreignNames_js_1.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
      }
      if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
        return key;
      }
      return "".concat(key, '="').concat(encode2(value), '"');
    }).join(" ");
  }
  var singleTag = /* @__PURE__ */ new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ]);
  function render2(node2, options) {
    if (options === void 0) {
      options = {};
    }
    var nodes = "length" in node2 ? node2 : [node2];
    var output = "";
    for (var i2 = 0; i2 < nodes.length; i2++) {
      output += renderNode(nodes[i2], options);
    }
    return output;
  }
  lib$1.render = render2;
  lib$1.default = render2;
  function renderNode(node2, options) {
    switch (node2.type) {
      case ElementType.Root:
        return render2(node2.children, options);
      // @ts-expect-error We don't use `Doctype` yet
      case ElementType.Doctype:
      case ElementType.Directive:
        return renderDirective(node2);
      case ElementType.Comment:
        return renderComment(node2);
      case ElementType.CDATA:
        return renderCdata(node2);
      case ElementType.Script:
      case ElementType.Style:
      case ElementType.Tag:
        return renderTag(node2, options);
      case ElementType.Text:
        return renderText(node2, options);
    }
  }
  var foreignModeIntegrationPoints = /* @__PURE__ */ new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
  ]);
  var foreignElements = /* @__PURE__ */ new Set(["svg", "math"]);
  function renderTag(elem, opts) {
    var _a;
    if (opts.xmlMode === "foreign") {
      elem.name = (_a = foreignNames_js_1.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
      if (elem.parent && foreignModeIntegrationPoints.has(elem.parent.name)) {
        opts = __assign(__assign({}, opts), { xmlMode: false });
      }
    }
    if (!opts.xmlMode && foreignElements.has(elem.name)) {
      opts = __assign(__assign({}, opts), { xmlMode: "foreign" });
    }
    var tag = "<".concat(elem.name);
    var attribs = formatAttributes(elem.attribs, opts);
    if (attribs) {
      tag += " ".concat(attribs);
    }
    if (elem.children.length === 0 && (opts.xmlMode ? (
      // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
      opts.selfClosingTags !== false
    ) : (
      // User explicitly asked for self-closing tags, even in HTML mode
      opts.selfClosingTags && singleTag.has(elem.name)
    ))) {
      if (!opts.xmlMode)
        tag += " ";
      tag += "/>";
    } else {
      tag += ">";
      if (elem.children.length > 0) {
        tag += render2(elem.children, opts);
      }
      if (opts.xmlMode || !singleTag.has(elem.name)) {
        tag += "</".concat(elem.name, ">");
      }
    }
    return tag;
  }
  function renderDirective(elem) {
    return "<".concat(elem.data, ">");
  }
  function renderText(elem, opts) {
    var _a;
    var data = elem.data || "";
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && unencodedElements.has(elem.parent.name))) {
      data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, entities_1.encodeXML)(data) : (0, entities_1.escapeText)(data);
    }
    return data;
  }
  function renderCdata(elem) {
    return "<![CDATA[".concat(elem.children[0].data, "]]>");
  }
  function renderComment(elem) {
    return "<!--".concat(elem.data, "-->");
  }
  return lib$1;
}
var hasRequiredStringify$1;
function requireStringify$1() {
  if (hasRequiredStringify$1) return stringify;
  hasRequiredStringify$1 = 1;
  var __importDefault = stringify && stringify.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
  };
  Object.defineProperty(stringify, "__esModule", { value: true });
  stringify.getOuterHTML = getOuterHTML;
  stringify.getInnerHTML = getInnerHTML;
  stringify.getText = getText;
  stringify.textContent = textContent;
  stringify.innerText = innerText;
  var domhandler_1 = /* @__PURE__ */ requireLib$4();
  var dom_serializer_1 = __importDefault(/* @__PURE__ */ requireLib$2());
  var domelementtype_1 = /* @__PURE__ */ requireLib$5();
  function getOuterHTML(node2, options) {
    return (0, dom_serializer_1.default)(node2, options);
  }
  function getInnerHTML(node2, options) {
    return (0, domhandler_1.hasChildren)(node2) ? node2.children.map(function(node3) {
      return getOuterHTML(node3, options);
    }).join("") : "";
  }
  function getText(node2) {
    if (Array.isArray(node2))
      return node2.map(getText).join("");
    if ((0, domhandler_1.isTag)(node2))
      return node2.name === "br" ? "\n" : getText(node2.children);
    if ((0, domhandler_1.isCDATA)(node2))
      return getText(node2.children);
    if ((0, domhandler_1.isText)(node2))
      return node2.data;
    return "";
  }
  function textContent(node2) {
    if (Array.isArray(node2))
      return node2.map(textContent).join("");
    if ((0, domhandler_1.hasChildren)(node2) && !(0, domhandler_1.isComment)(node2)) {
      return textContent(node2.children);
    }
    if ((0, domhandler_1.isText)(node2))
      return node2.data;
    return "";
  }
  function innerText(node2) {
    if (Array.isArray(node2))
      return node2.map(innerText).join("");
    if ((0, domhandler_1.hasChildren)(node2) && (node2.type === domelementtype_1.ElementType.Tag || (0, domhandler_1.isCDATA)(node2))) {
      return innerText(node2.children);
    }
    if ((0, domhandler_1.isText)(node2))
      return node2.data;
    return "";
  }
  return stringify;
}
var traversal = {};
var hasRequiredTraversal;
function requireTraversal() {
  if (hasRequiredTraversal) return traversal;
  hasRequiredTraversal = 1;
  Object.defineProperty(traversal, "__esModule", { value: true });
  traversal.getChildren = getChildren;
  traversal.getParent = getParent;
  traversal.getSiblings = getSiblings;
  traversal.getAttributeValue = getAttributeValue;
  traversal.hasAttrib = hasAttrib;
  traversal.getName = getName;
  traversal.nextElementSibling = nextElementSibling;
  traversal.prevElementSibling = prevElementSibling;
  var domhandler_1 = /* @__PURE__ */ requireLib$4();
  function getChildren(elem) {
    return (0, domhandler_1.hasChildren)(elem) ? elem.children : [];
  }
  function getParent(elem) {
    return elem.parent || null;
  }
  function getSiblings(elem) {
    var _a, _b;
    var parent = getParent(elem);
    if (parent != null)
      return getChildren(parent);
    var siblings = [elem];
    var prev = elem.prev, next = elem.next;
    while (prev != null) {
      siblings.unshift(prev);
      _a = prev, prev = _a.prev;
    }
    while (next != null) {
      siblings.push(next);
      _b = next, next = _b.next;
    }
    return siblings;
  }
  function getAttributeValue(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
  }
  function hasAttrib(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
  }
  function getName(elem) {
    return elem.name;
  }
  function nextElementSibling(elem) {
    var _a;
    var next = elem.next;
    while (next !== null && !(0, domhandler_1.isTag)(next))
      _a = next, next = _a.next;
    return next;
  }
  function prevElementSibling(elem) {
    var _a;
    var prev = elem.prev;
    while (prev !== null && !(0, domhandler_1.isTag)(prev))
      _a = prev, prev = _a.prev;
    return prev;
  }
  return traversal;
}
var manipulation = {};
var hasRequiredManipulation;
function requireManipulation() {
  if (hasRequiredManipulation) return manipulation;
  hasRequiredManipulation = 1;
  Object.defineProperty(manipulation, "__esModule", { value: true });
  manipulation.removeElement = removeElement;
  manipulation.replaceElement = replaceElement;
  manipulation.appendChild = appendChild;
  manipulation.append = append;
  manipulation.prependChild = prependChild;
  manipulation.prepend = prepend;
  function removeElement(elem) {
    if (elem.prev)
      elem.prev.next = elem.next;
    if (elem.next)
      elem.next.prev = elem.prev;
    if (elem.parent) {
      var childs = elem.parent.children;
      var childsIndex = childs.lastIndexOf(elem);
      if (childsIndex >= 0) {
        childs.splice(childsIndex, 1);
      }
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
  }
  function replaceElement(elem, replacement) {
    var prev = replacement.prev = elem.prev;
    if (prev) {
      prev.next = replacement;
    }
    var next = replacement.next = elem.next;
    if (next) {
      next.prev = replacement;
    }
    var parent = replacement.parent = elem.parent;
    if (parent) {
      var childs = parent.children;
      childs[childs.lastIndexOf(elem)] = replacement;
      elem.parent = null;
    }
  }
  function appendChild(parent, child) {
    removeElement(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
      var sibling = parent.children[parent.children.length - 2];
      sibling.next = child;
      child.prev = sibling;
    } else {
      child.prev = null;
    }
  }
  function append(elem, next) {
    removeElement(next);
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
      currNext.prev = next;
      if (parent) {
        var childs = parent.children;
        childs.splice(childs.lastIndexOf(currNext), 0, next);
      }
    } else if (parent) {
      parent.children.push(next);
    }
  }
  function prependChild(parent, child) {
    removeElement(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
      var sibling = parent.children[1];
      sibling.prev = child;
      child.next = sibling;
    } else {
      child.next = null;
    }
  }
  function prepend(elem, prev) {
    removeElement(prev);
    var parent = elem.parent;
    if (parent) {
      var childs = parent.children;
      childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) {
      elem.prev.next = prev;
    }
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
  }
  return manipulation;
}
var querying = {};
var hasRequiredQuerying;
function requireQuerying() {
  if (hasRequiredQuerying) return querying;
  hasRequiredQuerying = 1;
  Object.defineProperty(querying, "__esModule", { value: true });
  querying.filter = filter;
  querying.find = find;
  querying.findOneChild = findOneChild;
  querying.findOne = findOne;
  querying.existsOne = existsOne;
  querying.findAll = findAll;
  var domhandler_1 = /* @__PURE__ */ requireLib$4();
  function filter(test, node2, recurse, limit) {
    if (recurse === void 0) {
      recurse = true;
    }
    if (limit === void 0) {
      limit = Infinity;
    }
    return find(test, Array.isArray(node2) ? node2 : [node2], recurse, limit);
  }
  function find(test, nodes, recurse, limit) {
    var result2 = [];
    var nodeStack = [Array.isArray(nodes) ? nodes : [nodes]];
    var indexStack = [0];
    for (; ; ) {
      if (indexStack[0] >= nodeStack[0].length) {
        if (indexStack.length === 1) {
          return result2;
        }
        nodeStack.shift();
        indexStack.shift();
        continue;
      }
      var elem = nodeStack[0][indexStack[0]++];
      if (test(elem)) {
        result2.push(elem);
        if (--limit <= 0)
          return result2;
      }
      if (recurse && (0, domhandler_1.hasChildren)(elem) && elem.children.length > 0) {
        indexStack.unshift(0);
        nodeStack.unshift(elem.children);
      }
    }
  }
  function findOneChild(test, nodes) {
    return nodes.find(test);
  }
  function findOne(test, nodes, recurse) {
    if (recurse === void 0) {
      recurse = true;
    }
    var searchedNodes = Array.isArray(nodes) ? nodes : [nodes];
    for (var i2 = 0; i2 < searchedNodes.length; i2++) {
      var node2 = searchedNodes[i2];
      if ((0, domhandler_1.isTag)(node2) && test(node2)) {
        return node2;
      }
      if (recurse && (0, domhandler_1.hasChildren)(node2) && node2.children.length > 0) {
        var found = findOne(test, node2.children, true);
        if (found)
          return found;
      }
    }
    return null;
  }
  function existsOne(test, nodes) {
    return (Array.isArray(nodes) ? nodes : [nodes]).some(function(node2) {
      return (0, domhandler_1.isTag)(node2) && test(node2) || (0, domhandler_1.hasChildren)(node2) && existsOne(test, node2.children);
    });
  }
  function findAll(test, nodes) {
    var result2 = [];
    var nodeStack = [Array.isArray(nodes) ? nodes : [nodes]];
    var indexStack = [0];
    for (; ; ) {
      if (indexStack[0] >= nodeStack[0].length) {
        if (nodeStack.length === 1) {
          return result2;
        }
        nodeStack.shift();
        indexStack.shift();
        continue;
      }
      var elem = nodeStack[0][indexStack[0]++];
      if ((0, domhandler_1.isTag)(elem) && test(elem))
        result2.push(elem);
      if ((0, domhandler_1.hasChildren)(elem) && elem.children.length > 0) {
        indexStack.unshift(0);
        nodeStack.unshift(elem.children);
      }
    }
  }
  return querying;
}
var legacy = {};
var hasRequiredLegacy;
function requireLegacy() {
  if (hasRequiredLegacy) return legacy;
  hasRequiredLegacy = 1;
  Object.defineProperty(legacy, "__esModule", { value: true });
  legacy.testElement = testElement;
  legacy.getElements = getElements;
  legacy.getElementById = getElementById;
  legacy.getElementsByTagName = getElementsByTagName;
  legacy.getElementsByClassName = getElementsByClassName;
  legacy.getElementsByTagType = getElementsByTagType;
  var domhandler_1 = /* @__PURE__ */ requireLib$4();
  var querying_js_1 = /* @__PURE__ */ requireQuerying();
  var Checks = {
    tag_name: function(name) {
      if (typeof name === "function") {
        return function(elem) {
          return (0, domhandler_1.isTag)(elem) && name(elem.name);
        };
      } else if (name === "*") {
        return domhandler_1.isTag;
      }
      return function(elem) {
        return (0, domhandler_1.isTag)(elem) && elem.name === name;
      };
    },
    tag_type: function(type) {
      if (typeof type === "function") {
        return function(elem) {
          return type(elem.type);
        };
      }
      return function(elem) {
        return elem.type === type;
      };
    },
    tag_contains: function(data) {
      if (typeof data === "function") {
        return function(elem) {
          return (0, domhandler_1.isText)(elem) && data(elem.data);
        };
      }
      return function(elem) {
        return (0, domhandler_1.isText)(elem) && elem.data === data;
      };
    }
  };
  function getAttribCheck(attrib, value) {
    if (typeof value === "function") {
      return function(elem) {
        return (0, domhandler_1.isTag)(elem) && value(elem.attribs[attrib]);
      };
    }
    return function(elem) {
      return (0, domhandler_1.isTag)(elem) && elem.attribs[attrib] === value;
    };
  }
  function combineFuncs(a2, b2) {
    return function(elem) {
      return a2(elem) || b2(elem);
    };
  }
  function compileTest(options) {
    var funcs = Object.keys(options).map(function(key) {
      var value = options[key];
      return Object.prototype.hasOwnProperty.call(Checks, key) ? Checks[key](value) : getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
  }
  function testElement(options, node2) {
    var test = compileTest(options);
    return test ? test(node2) : true;
  }
  function getElements(options, nodes, recurse, limit) {
    if (limit === void 0) {
      limit = Infinity;
    }
    var test = compileTest(options);
    return test ? (0, querying_js_1.filter)(test, nodes, recurse, limit) : [];
  }
  function getElementById(id, nodes, recurse) {
    if (recurse === void 0) {
      recurse = true;
    }
    if (!Array.isArray(nodes))
      nodes = [nodes];
    return (0, querying_js_1.findOne)(getAttribCheck("id", id), nodes, recurse);
  }
  function getElementsByTagName(tagName, nodes, recurse, limit) {
    if (recurse === void 0) {
      recurse = true;
    }
    if (limit === void 0) {
      limit = Infinity;
    }
    return (0, querying_js_1.filter)(Checks["tag_name"](tagName), nodes, recurse, limit);
  }
  function getElementsByClassName(className, nodes, recurse, limit) {
    if (recurse === void 0) {
      recurse = true;
    }
    if (limit === void 0) {
      limit = Infinity;
    }
    return (0, querying_js_1.filter)(getAttribCheck("class", className), nodes, recurse, limit);
  }
  function getElementsByTagType(type, nodes, recurse, limit) {
    if (recurse === void 0) {
      recurse = true;
    }
    if (limit === void 0) {
      limit = Infinity;
    }
    return (0, querying_js_1.filter)(Checks["tag_type"](type), nodes, recurse, limit);
  }
  return legacy;
}
var helpers = {};
var hasRequiredHelpers;
function requireHelpers() {
  if (hasRequiredHelpers) return helpers;
  hasRequiredHelpers = 1;
  Object.defineProperty(helpers, "__esModule", { value: true });
  helpers.DocumentPosition = void 0;
  helpers.removeSubsets = removeSubsets;
  helpers.compareDocumentPosition = compareDocumentPosition;
  helpers.uniqueSort = uniqueSort;
  var domhandler_1 = /* @__PURE__ */ requireLib$4();
  function removeSubsets(nodes) {
    var idx = nodes.length;
    while (--idx >= 0) {
      var node2 = nodes[idx];
      if (idx > 0 && nodes.lastIndexOf(node2, idx - 1) >= 0) {
        nodes.splice(idx, 1);
        continue;
      }
      for (var ancestor = node2.parent; ancestor; ancestor = ancestor.parent) {
        if (nodes.includes(ancestor)) {
          nodes.splice(idx, 1);
          break;
        }
      }
    }
    return nodes;
  }
  var DocumentPosition;
  (function(DocumentPosition2) {
    DocumentPosition2[DocumentPosition2["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition2[DocumentPosition2["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition2[DocumentPosition2["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition2[DocumentPosition2["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition2[DocumentPosition2["CONTAINED_BY"] = 16] = "CONTAINED_BY";
  })(DocumentPosition || (helpers.DocumentPosition = DocumentPosition = {}));
  function compareDocumentPosition(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) {
      return 0;
    }
    var current = (0, domhandler_1.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while (current) {
      aParents.unshift(current);
      current = current.parent;
    }
    current = (0, domhandler_1.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while (current) {
      bParents.unshift(current);
      current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while (idx < maxIdx && aParents[idx] === bParents[idx]) {
      idx++;
    }
    if (idx === 0) {
      return DocumentPosition.DISCONNECTED;
    }
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
      if (sharedParent === nodeB) {
        return DocumentPosition.FOLLOWING | DocumentPosition.CONTAINED_BY;
      }
      return DocumentPosition.FOLLOWING;
    }
    if (sharedParent === nodeA) {
      return DocumentPosition.PRECEDING | DocumentPosition.CONTAINS;
    }
    return DocumentPosition.PRECEDING;
  }
  function uniqueSort(nodes) {
    nodes = nodes.filter(function(node2, i2, arr) {
      return !arr.includes(node2, i2 + 1);
    });
    nodes.sort(function(a2, b2) {
      var relative = compareDocumentPosition(a2, b2);
      if (relative & DocumentPosition.PRECEDING) {
        return -1;
      } else if (relative & DocumentPosition.FOLLOWING) {
        return 1;
      }
      return 0;
    });
    return nodes;
  }
  return helpers;
}
var feeds = {};
var hasRequiredFeeds;
function requireFeeds() {
  if (hasRequiredFeeds) return feeds;
  hasRequiredFeeds = 1;
  Object.defineProperty(feeds, "__esModule", { value: true });
  feeds.getFeed = getFeed;
  var stringify_js_1 = /* @__PURE__ */ requireStringify$1();
  var legacy_js_1 = /* @__PURE__ */ requireLegacy();
  function getFeed(doc) {
    var feedRoot = getOneElement(isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? getAtomFeed(feedRoot) : getRssFeed(feedRoot);
  }
  function getAtomFeed(feedRoot) {
    var _a;
    var childs = feedRoot.children;
    var feed = {
      type: "atom",
      items: (0, legacy_js_1.getElementsByTagName)("entry", childs).map(function(item) {
        var _a2;
        var children = item.children;
        var entry = { media: getMediaElements(children) };
        addConditionally(entry, "id", "id", children);
        addConditionally(entry, "title", "title", children);
        var href2 = (_a2 = getOneElement("link", children)) === null || _a2 === void 0 ? void 0 : _a2.attribs["href"];
        if (href2) {
          entry.link = href2;
        }
        var description = fetch("summary", children) || fetch("content", children);
        if (description) {
          entry.description = description;
        }
        var pubDate = fetch("updated", children);
        if (pubDate) {
          entry.pubDate = new Date(pubDate);
        }
        return entry;
      })
    };
    addConditionally(feed, "id", "id", childs);
    addConditionally(feed, "title", "title", childs);
    var href = (_a = getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) {
      feed.link = href;
    }
    addConditionally(feed, "description", "subtitle", childs);
    var updated = fetch("updated", childs);
    if (updated) {
      feed.updated = new Date(updated);
    }
    addConditionally(feed, "author", "email", childs, true);
    return feed;
  }
  function getRssFeed(feedRoot) {
    var _a, _b;
    var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    var feed = {
      type: feedRoot.name.substr(0, 3),
      id: "",
      items: (0, legacy_js_1.getElementsByTagName)("item", feedRoot.children).map(function(item) {
        var children = item.children;
        var entry = { media: getMediaElements(children) };
        addConditionally(entry, "id", "guid", children);
        addConditionally(entry, "title", "title", children);
        addConditionally(entry, "link", "link", children);
        addConditionally(entry, "description", "description", children);
        var pubDate = fetch("pubDate", children) || fetch("dc:date", children);
        if (pubDate)
          entry.pubDate = new Date(pubDate);
        return entry;
      })
    };
    addConditionally(feed, "title", "title", childs);
    addConditionally(feed, "link", "link", childs);
    addConditionally(feed, "description", "description", childs);
    var updated = fetch("lastBuildDate", childs);
    if (updated) {
      feed.updated = new Date(updated);
    }
    addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
  }
  var MEDIA_KEYS_STRING = ["url", "type", "lang"];
  var MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
  ];
  function getMediaElements(where) {
    return (0, legacy_js_1.getElementsByTagName)("media:content", where).map(function(elem) {
      var attribs = elem.attribs;
      var media = {
        medium: attribs["medium"],
        isDefault: !!attribs["isDefault"]
      };
      for (var _i = 0, MEDIA_KEYS_STRING_1 = MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++) {
        var attrib = MEDIA_KEYS_STRING_1[_i];
        if (attribs[attrib]) {
          media[attrib] = attribs[attrib];
        }
      }
      for (var _a = 0, MEDIA_KEYS_INT_1 = MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++) {
        var attrib = MEDIA_KEYS_INT_1[_a];
        if (attribs[attrib]) {
          media[attrib] = parseInt(attribs[attrib], 10);
        }
      }
      if (attribs["expression"]) {
        media.expression = attribs["expression"];
      }
      return media;
    });
  }
  function getOneElement(tagName, node2) {
    return (0, legacy_js_1.getElementsByTagName)(tagName, node2, true, 1)[0];
  }
  function fetch(tagName, where, recurse) {
    if (recurse === void 0) {
      recurse = false;
    }
    return (0, stringify_js_1.textContent)((0, legacy_js_1.getElementsByTagName)(tagName, where, recurse, 1)).trim();
  }
  function addConditionally(obj, prop, tagName, where, recurse) {
    if (recurse === void 0) {
      recurse = false;
    }
    var val = fetch(tagName, where, recurse);
    if (val)
      obj[prop] = val;
  }
  function isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
  }
  return feeds;
}
var hasRequiredLib$1;
function requireLib$1() {
  if (hasRequiredLib$1) return lib$2;
  hasRequiredLib$1 = 1;
  (function(exports) {
    var __createBinding = lib$2 && lib$2.__createBinding || (Object.create ? function(o, m2, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m2, k);
      if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m2[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m2, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m2[k];
    });
    var __exportStar = lib$2 && lib$2.__exportStar || function(m2, exports2) {
      for (var p2 in m2) if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p2)) __createBinding(exports2, m2, p2);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.hasChildren = exports.isDocument = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = void 0;
    __exportStar(/* @__PURE__ */ requireStringify$1(), exports);
    __exportStar(/* @__PURE__ */ requireTraversal(), exports);
    __exportStar(/* @__PURE__ */ requireManipulation(), exports);
    __exportStar(/* @__PURE__ */ requireQuerying(), exports);
    __exportStar(/* @__PURE__ */ requireLegacy(), exports);
    __exportStar(/* @__PURE__ */ requireHelpers(), exports);
    __exportStar(/* @__PURE__ */ requireFeeds(), exports);
    var domhandler_1 = /* @__PURE__ */ requireLib$4();
    Object.defineProperty(exports, "isTag", { enumerable: true, get: function() {
      return domhandler_1.isTag;
    } });
    Object.defineProperty(exports, "isCDATA", { enumerable: true, get: function() {
      return domhandler_1.isCDATA;
    } });
    Object.defineProperty(exports, "isText", { enumerable: true, get: function() {
      return domhandler_1.isText;
    } });
    Object.defineProperty(exports, "isComment", { enumerable: true, get: function() {
      return domhandler_1.isComment;
    } });
    Object.defineProperty(exports, "isDocument", { enumerable: true, get: function() {
      return domhandler_1.isDocument;
    } });
    Object.defineProperty(exports, "hasChildren", { enumerable: true, get: function() {
      return domhandler_1.hasChildren;
    } });
  })(lib$2);
  return lib$2;
}
var hasRequiredLib;
function requireLib() {
  if (hasRequiredLib) return lib$5;
  hasRequiredLib = 1;
  (function(exports) {
    var __createBinding = lib$5 && lib$5.__createBinding || (Object.create ? function(o, m2, k, k2) {
      if (k2 === void 0) k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m2, k);
      if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m2[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m2, k, k2) {
      if (k2 === void 0) k2 = k;
      o[k2] = m2[k];
    });
    var __setModuleDefault = lib$5 && lib$5.__setModuleDefault || (Object.create ? function(o, v2) {
      Object.defineProperty(o, "default", { enumerable: true, value: v2 });
    } : function(o, v2) {
      o["default"] = v2;
    });
    var __importStar = lib$5 && lib$5.__importStar || function(mod) {
      if (mod && mod.__esModule) return mod;
      var result2 = {};
      if (mod != null) {
        for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result2, mod, k);
      }
      __setModuleDefault(result2, mod);
      return result2;
    };
    var __importDefault = lib$5 && lib$5.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DomUtils = exports.parseFeed = exports.getFeed = exports.ElementType = exports.Tokenizer = exports.createDomStream = exports.parseDOM = exports.parseDocument = exports.DefaultHandler = exports.DomHandler = exports.Parser = void 0;
    var Parser_js_1 = /* @__PURE__ */ requireParser$1();
    var Parser_js_2 = /* @__PURE__ */ requireParser$1();
    Object.defineProperty(exports, "Parser", { enumerable: true, get: function() {
      return Parser_js_2.Parser;
    } });
    var domhandler_1 = /* @__PURE__ */ requireLib$4();
    var domhandler_2 = /* @__PURE__ */ requireLib$4();
    Object.defineProperty(exports, "DomHandler", { enumerable: true, get: function() {
      return domhandler_2.DomHandler;
    } });
    Object.defineProperty(exports, "DefaultHandler", { enumerable: true, get: function() {
      return domhandler_2.DomHandler;
    } });
    function parseDocument(data, options) {
      var handler = new domhandler_1.DomHandler(void 0, options);
      new Parser_js_1.Parser(handler, options).end(data);
      return handler.root;
    }
    exports.parseDocument = parseDocument;
    function parseDOM(data, options) {
      return parseDocument(data, options).children;
    }
    exports.parseDOM = parseDOM;
    function createDomStream(callback, options, elementCallback) {
      var handler = new domhandler_1.DomHandler(callback, options, elementCallback);
      return new Parser_js_1.Parser(handler, options);
    }
    exports.createDomStream = createDomStream;
    var Tokenizer_js_1 = /* @__PURE__ */ requireTokenizer();
    Object.defineProperty(exports, "Tokenizer", { enumerable: true, get: function() {
      return __importDefault(Tokenizer_js_1).default;
    } });
    exports.ElementType = __importStar(/* @__PURE__ */ requireLib$5());
    var domutils_1 = /* @__PURE__ */ requireLib$1();
    var domutils_2 = /* @__PURE__ */ requireLib$1();
    Object.defineProperty(exports, "getFeed", { enumerable: true, get: function() {
      return domutils_2.getFeed;
    } });
    var parseFeedDefaultOptions = { xmlMode: true };
    function parseFeed(feed, options) {
      if (options === void 0) {
        options = parseFeedDefaultOptions;
      }
      return (0, domutils_1.getFeed)(parseDOM(feed, options));
    }
    exports.parseFeed = parseFeed;
    exports.DomUtils = __importStar(/* @__PURE__ */ requireLib$1());
  })(lib$5);
  return lib$5;
}
var escapeStringRegexp;
var hasRequiredEscapeStringRegexp;
function requireEscapeStringRegexp() {
  if (hasRequiredEscapeStringRegexp) return escapeStringRegexp;
  hasRequiredEscapeStringRegexp = 1;
  escapeStringRegexp = (string) => {
    if (typeof string !== "string") {
      throw new TypeError("Expected a string");
    }
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
  };
  return escapeStringRegexp;
}
var isPlainObject = {};
var hasRequiredIsPlainObject;
function requireIsPlainObject() {
  if (hasRequiredIsPlainObject) return isPlainObject;
  hasRequiredIsPlainObject = 1;
  Object.defineProperty(isPlainObject, "__esModule", { value: true });
  /*!
   * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
   *
   * Copyright (c) 2014-2017, Jon Schlinkert.
   * Released under the MIT License.
   */
  function isObject(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
  }
  function isPlainObject$1(o) {
    var ctor, prot;
    if (isObject(o) === false) return false;
    ctor = o.constructor;
    if (ctor === void 0) return true;
    prot = ctor.prototype;
    if (isObject(prot) === false) return false;
    if (prot.hasOwnProperty("isPrototypeOf") === false) {
      return false;
    }
    return true;
  }
  isPlainObject.isPlainObject = isPlainObject$1;
  return isPlainObject;
}
var cjs;
var hasRequiredCjs;
function requireCjs() {
  if (hasRequiredCjs) return cjs;
  hasRequiredCjs = 1;
  var isMergeableObject = function isMergeableObject2(value) {
    return isNonNullObject(value) && !isSpecial(value);
  };
  function isNonNullObject(value) {
    return !!value && typeof value === "object";
  }
  function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
  }
  var canUseSymbol = typeof Symbol === "function" && Symbol.for;
  var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
  function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
  }
  function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
  }
  function cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
  }
  function defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
      return cloneUnlessOtherwiseSpecified(element, options);
    });
  }
  function getMergeFunction(key, options) {
    if (!options.customMerge) {
      return deepmerge;
    }
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : deepmerge;
  }
  function getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
      return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
  }
  function getKeys(target) {
    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
  }
  function propertyIsOnObject(object, property) {
    try {
      return property in object;
    } catch (_2) {
      return false;
    }
  }
  function propertyIsUnsafe(target, key) {
    return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
  }
  function mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) {
      getKeys(target).forEach(function(key) {
        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
      });
    }
    getKeys(source).forEach(function(key) {
      if (propertyIsUnsafe(target, key)) {
        return;
      }
      if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
        destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
      } else {
        destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
      }
    });
    return destination;
  }
  function deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) {
      return cloneUnlessOtherwiseSpecified(source, options);
    } else if (sourceIsArray) {
      return options.arrayMerge(target, source, options);
    } else {
      return mergeObject(target, source, options);
    }
  }
  deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) {
      throw new Error("first argument should be an array");
    }
    return array.reduce(function(prev, next) {
      return deepmerge(prev, next, options);
    }, {});
  };
  var deepmerge_1 = deepmerge;
  cjs = deepmerge_1;
  return cjs;
}
var parseSrcset$1 = { exports: {} };
var parseSrcset = parseSrcset$1.exports;
var hasRequiredParseSrcset;
function requireParseSrcset() {
  if (hasRequiredParseSrcset) return parseSrcset$1.exports;
  hasRequiredParseSrcset = 1;
  (function(module) {
    (function(root2, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        root2.parseSrcset = factory();
      }
    })(parseSrcset, function() {
      return function(input2) {
        function isSpace(c3) {
          return c3 === " " || // space
          c3 === "	" || // horizontal tab
          c3 === "\n" || // new line
          c3 === "\f" || // form feed
          c3 === "\r";
        }
        function collectCharacters(regEx) {
          var chars, match = regEx.exec(input2.substring(pos));
          if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
          }
        }
        var inputLength = input2.length, regexLeadingSpaces = /^[ \t\n\r\u000c]+/, regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/, regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/, regexTrailingCommas = /[,]+$/, regexNonNegativeInteger = /^\d+$/, regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, url, descriptors, currentDescriptor, state, c2, pos = 0, candidates = [];
        while (true) {
          collectCharacters(regexLeadingCommasOrSpaces);
          if (pos >= inputLength) {
            return candidates;
          }
          url = collectCharacters(regexLeadingNotSpaces);
          descriptors = [];
          if (url.slice(-1) === ",") {
            url = url.replace(regexTrailingCommas, "");
            parseDescriptors();
          } else {
            tokenize2();
          }
        }
        function tokenize2() {
          collectCharacters(regexLeadingSpaces);
          currentDescriptor = "";
          state = "in descriptor";
          while (true) {
            c2 = input2.charAt(pos);
            if (state === "in descriptor") {
              if (isSpace(c2)) {
                if (currentDescriptor) {
                  descriptors.push(currentDescriptor);
                  currentDescriptor = "";
                  state = "after descriptor";
                }
              } else if (c2 === ",") {
                pos += 1;
                if (currentDescriptor) {
                  descriptors.push(currentDescriptor);
                }
                parseDescriptors();
                return;
              } else if (c2 === "(") {
                currentDescriptor = currentDescriptor + c2;
                state = "in parens";
              } else if (c2 === "") {
                if (currentDescriptor) {
                  descriptors.push(currentDescriptor);
                }
                parseDescriptors();
                return;
              } else {
                currentDescriptor = currentDescriptor + c2;
              }
            } else if (state === "in parens") {
              if (c2 === ")") {
                currentDescriptor = currentDescriptor + c2;
                state = "in descriptor";
              } else if (c2 === "") {
                descriptors.push(currentDescriptor);
                parseDescriptors();
                return;
              } else {
                currentDescriptor = currentDescriptor + c2;
              }
            } else if (state === "after descriptor") {
              if (isSpace(c2)) ;
              else if (c2 === "") {
                parseDescriptors();
                return;
              } else {
                state = "in descriptor";
                pos -= 1;
              }
            }
            pos += 1;
          }
        }
        function parseDescriptors() {
          var pError = false, w2, d2, h, i2, candidate = {}, desc, lastChar, value, intVal, floatVal;
          for (i2 = 0; i2 < descriptors.length; i2++) {
            desc = descriptors[i2];
            lastChar = desc[desc.length - 1];
            value = desc.substring(0, desc.length - 1);
            intVal = parseInt(value, 10);
            floatVal = parseFloat(value);
            if (regexNonNegativeInteger.test(value) && lastChar === "w") {
              if (w2 || d2) {
                pError = true;
              }
              if (intVal === 0) {
                pError = true;
              } else {
                w2 = intVal;
              }
            } else if (regexFloatingPoint.test(value) && lastChar === "x") {
              if (w2 || d2 || h) {
                pError = true;
              }
              if (floatVal < 0) {
                pError = true;
              } else {
                d2 = floatVal;
              }
            } else if (regexNonNegativeInteger.test(value) && lastChar === "h") {
              if (h || d2) {
                pError = true;
              }
              if (intVal === 0) {
                pError = true;
              } else {
                h = intVal;
              }
            } else {
              pError = true;
            }
          }
          if (!pError) {
            candidate.url = url;
            if (w2) {
              candidate.w = w2;
            }
            if (d2) {
              candidate.d = d2;
            }
            if (h) {
              candidate.h = h;
            }
            candidates.push(candidate);
          } else if (console && console.log) {
            console.log("Invalid srcset descriptor found in '" + input2 + "' at '" + desc + "'.");
          }
        }
      };
    });
  })(parseSrcset$1);
  return parseSrcset$1.exports;
}
var picocolors_browser = { exports: {} };
var hasRequiredPicocolors_browser;
function requirePicocolors_browser() {
  if (hasRequiredPicocolors_browser) return picocolors_browser.exports;
  hasRequiredPicocolors_browser = 1;
  var x = String;
  var create = function() {
    return { isColorSupported: false, reset: x, bold: x, dim: x, italic: x, underline: x, inverse: x, hidden: x, strikethrough: x, black: x, red: x, green: x, yellow: x, blue: x, magenta: x, cyan: x, white: x, gray: x, bgBlack: x, bgRed: x, bgGreen: x, bgYellow: x, bgBlue: x, bgMagenta: x, bgCyan: x, bgWhite: x, blackBright: x, redBright: x, greenBright: x, yellowBright: x, blueBright: x, magentaBright: x, cyanBright: x, whiteBright: x, bgBlackBright: x, bgRedBright: x, bgGreenBright: x, bgYellowBright: x, bgBlueBright: x, bgMagentaBright: x, bgCyanBright: x, bgWhiteBright: x };
  };
  picocolors_browser.exports = create();
  picocolors_browser.exports.createColors = create;
  return picocolors_browser.exports;
}
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var cssSyntaxError;
var hasRequiredCssSyntaxError;
function requireCssSyntaxError() {
  if (hasRequiredCssSyntaxError) return cssSyntaxError;
  hasRequiredCssSyntaxError = 1;
  let pico = /* @__PURE__ */ requirePicocolors_browser();
  let terminalHighlight = require$$2;
  class CssSyntaxError extends Error {
    constructor(message, line, column, source, file, plugin) {
      super(message);
      this.name = "CssSyntaxError";
      this.reason = message;
      if (file) {
        this.file = file;
      }
      if (source) {
        this.source = source;
      }
      if (plugin) {
        this.plugin = plugin;
      }
      if (typeof line !== "undefined" && typeof column !== "undefined") {
        if (typeof line === "number") {
          this.line = line;
          this.column = column;
        } else {
          this.line = line.line;
          this.column = line.column;
          this.endLine = column.line;
          this.endColumn = column.column;
        }
      }
      this.setMessage();
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, CssSyntaxError);
      }
    }
    setMessage() {
      this.message = this.plugin ? this.plugin + ": " : "";
      this.message += this.file ? this.file : "<css input>";
      if (typeof this.line !== "undefined") {
        this.message += ":" + this.line + ":" + this.column;
      }
      this.message += ": " + this.reason;
    }
    showSourceCode(color) {
      if (!this.source) return "";
      let css3 = this.source;
      if (color == null) color = pico.isColorSupported;
      let aside = (text) => text;
      let mark = (text) => text;
      let highlight = (text) => text;
      if (color) {
        let { bold, gray, red } = pico.createColors(true);
        mark = (text) => bold(red(text));
        aside = (text) => gray(text);
        if (terminalHighlight) {
          highlight = (text) => terminalHighlight(text);
        }
      }
      let lines = css3.split(/\r?\n/);
      let start = Math.max(this.line - 3, 0);
      let end = Math.min(this.line + 2, lines.length);
      let maxWidth = String(end).length;
      return lines.slice(start, end).map((line, index) => {
        let number = start + 1 + index;
        let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
        if (number === this.line) {
          if (line.length > 160) {
            let padding = 20;
            let subLineStart = Math.max(0, this.column - padding);
            let subLineEnd = Math.max(
              this.column + padding,
              this.endColumn + padding
            );
            let subLine = line.slice(subLineStart, subLineEnd);
            let spacing2 = aside(gutter.replace(/\d/g, " ")) + line.slice(0, Math.min(this.column - 1, padding - 1)).replace(/[^\t]/g, " ");
            return mark(">") + aside(gutter) + highlight(subLine) + "\n " + spacing2 + mark("^");
          }
          let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
          return mark(">") + aside(gutter) + highlight(line) + "\n " + spacing + mark("^");
        }
        return " " + aside(gutter) + highlight(line);
      }).join("\n");
    }
    toString() {
      let code = this.showSourceCode();
      if (code) {
        code = "\n\n" + code + "\n";
      }
      return this.name + ": " + this.message + code;
    }
  }
  cssSyntaxError = CssSyntaxError;
  CssSyntaxError.default = CssSyntaxError;
  return cssSyntaxError;
}
var stringifier;
var hasRequiredStringifier;
function requireStringifier() {
  if (hasRequiredStringifier) return stringifier;
  hasRequiredStringifier = 1;
  const DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
  };
  function capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
  }
  class Stringifier {
    constructor(builder) {
      this.builder = builder;
    }
    atrule(node2, semicolon) {
      let name = "@" + node2.name;
      let params = node2.params ? this.rawValue(node2, "params") : "";
      if (typeof node2.raws.afterName !== "undefined") {
        name += node2.raws.afterName;
      } else if (params) {
        name += " ";
      }
      if (node2.nodes) {
        this.block(node2, name + params);
      } else {
        let end = (node2.raws.between || "") + (semicolon ? ";" : "");
        this.builder(name + params + end, node2);
      }
    }
    beforeAfter(node2, detect) {
      let value;
      if (node2.type === "decl") {
        value = this.raw(node2, null, "beforeDecl");
      } else if (node2.type === "comment") {
        value = this.raw(node2, null, "beforeComment");
      } else if (detect === "before") {
        value = this.raw(node2, null, "beforeRule");
      } else {
        value = this.raw(node2, null, "beforeClose");
      }
      let buf = node2.parent;
      let depth = 0;
      while (buf && buf.type !== "root") {
        depth += 1;
        buf = buf.parent;
      }
      if (value.includes("\n")) {
        let indent = this.raw(node2, null, "indent");
        if (indent.length) {
          for (let step = 0; step < depth; step++) value += indent;
        }
      }
      return value;
    }
    block(node2, start) {
      let between = this.raw(node2, "between", "beforeOpen");
      this.builder(start + between + "{", node2, "start");
      let after;
      if (node2.nodes && node2.nodes.length) {
        this.body(node2);
        after = this.raw(node2, "after");
      } else {
        after = this.raw(node2, "after", "emptyBody");
      }
      if (after) this.builder(after);
      this.builder("}", node2, "end");
    }
    body(node2) {
      let last = node2.nodes.length - 1;
      while (last > 0) {
        if (node2.nodes[last].type !== "comment") break;
        last -= 1;
      }
      let semicolon = this.raw(node2, "semicolon");
      for (let i2 = 0; i2 < node2.nodes.length; i2++) {
        let child = node2.nodes[i2];
        let before = this.raw(child, "before");
        if (before) this.builder(before);
        this.stringify(child, last !== i2 || semicolon);
      }
    }
    comment(node2) {
      let left = this.raw(node2, "left", "commentLeft");
      let right = this.raw(node2, "right", "commentRight");
      this.builder("/*" + left + node2.text + right + "*/", node2);
    }
    decl(node2, semicolon) {
      let between = this.raw(node2, "between", "colon");
      let string = node2.prop + between + this.rawValue(node2, "value");
      if (node2.important) {
        string += node2.raws.important || " !important";
      }
      if (semicolon) string += ";";
      this.builder(string, node2);
    }
    document(node2) {
      this.body(node2);
    }
    raw(node2, own, detect) {
      let value;
      if (!detect) detect = own;
      if (own) {
        value = node2.raws[own];
        if (typeof value !== "undefined") return value;
      }
      let parent = node2.parent;
      if (detect === "before") {
        if (!parent || parent.type === "root" && parent.first === node2) {
          return "";
        }
        if (parent && parent.type === "document") {
          return "";
        }
      }
      if (!parent) return DEFAULT_RAW[detect];
      let root2 = node2.root();
      if (!root2.rawCache) root2.rawCache = {};
      if (typeof root2.rawCache[detect] !== "undefined") {
        return root2.rawCache[detect];
      }
      if (detect === "before" || detect === "after") {
        return this.beforeAfter(node2, detect);
      } else {
        let method = "raw" + capitalize(detect);
        if (this[method]) {
          value = this[method](root2, node2);
        } else {
          root2.walk((i2) => {
            value = i2.raws[own];
            if (typeof value !== "undefined") return false;
          });
        }
      }
      if (typeof value === "undefined") value = DEFAULT_RAW[detect];
      root2.rawCache[detect] = value;
      return value;
    }
    rawBeforeClose(root2) {
      let value;
      root2.walk((i2) => {
        if (i2.nodes && i2.nodes.length > 0) {
          if (typeof i2.raws.after !== "undefined") {
            value = i2.raws.after;
            if (value.includes("\n")) {
              value = value.replace(/[^\n]+$/, "");
            }
            return false;
          }
        }
      });
      if (value) value = value.replace(/\S/g, "");
      return value;
    }
    rawBeforeComment(root2, node2) {
      let value;
      root2.walkComments((i2) => {
        if (typeof i2.raws.before !== "undefined") {
          value = i2.raws.before;
          if (value.includes("\n")) {
            value = value.replace(/[^\n]+$/, "");
          }
          return false;
        }
      });
      if (typeof value === "undefined") {
        value = this.raw(node2, null, "beforeDecl");
      } else if (value) {
        value = value.replace(/\S/g, "");
      }
      return value;
    }
    rawBeforeDecl(root2, node2) {
      let value;
      root2.walkDecls((i2) => {
        if (typeof i2.raws.before !== "undefined") {
          value = i2.raws.before;
          if (value.includes("\n")) {
            value = value.replace(/[^\n]+$/, "");
          }
          return false;
        }
      });
      if (typeof value === "undefined") {
        value = this.raw(node2, null, "beforeRule");
      } else if (value) {
        value = value.replace(/\S/g, "");
      }
      return value;
    }
    rawBeforeOpen(root2) {
      let value;
      root2.walk((i2) => {
        if (i2.type !== "decl") {
          value = i2.raws.between;
          if (typeof value !== "undefined") return false;
        }
      });
      return value;
    }
    rawBeforeRule(root2) {
      let value;
      root2.walk((i2) => {
        if (i2.nodes && (i2.parent !== root2 || root2.first !== i2)) {
          if (typeof i2.raws.before !== "undefined") {
            value = i2.raws.before;
            if (value.includes("\n")) {
              value = value.replace(/[^\n]+$/, "");
            }
            return false;
          }
        }
      });
      if (value) value = value.replace(/\S/g, "");
      return value;
    }
    rawColon(root2) {
      let value;
      root2.walkDecls((i2) => {
        if (typeof i2.raws.between !== "undefined") {
          value = i2.raws.between.replace(/[^\s:]/g, "");
          return false;
        }
      });
      return value;
    }
    rawEmptyBody(root2) {
      let value;
      root2.walk((i2) => {
        if (i2.nodes && i2.nodes.length === 0) {
          value = i2.raws.after;
          if (typeof value !== "undefined") return false;
        }
      });
      return value;
    }
    rawIndent(root2) {
      if (root2.raws.indent) return root2.raws.indent;
      let value;
      root2.walk((i2) => {
        let p2 = i2.parent;
        if (p2 && p2 !== root2 && p2.parent && p2.parent === root2) {
          if (typeof i2.raws.before !== "undefined") {
            let parts = i2.raws.before.split("\n");
            value = parts[parts.length - 1];
            value = value.replace(/\S/g, "");
            return false;
          }
        }
      });
      return value;
    }
    rawSemicolon(root2) {
      let value;
      root2.walk((i2) => {
        if (i2.nodes && i2.nodes.length && i2.last.type === "decl") {
          value = i2.raws.semicolon;
          if (typeof value !== "undefined") return false;
        }
      });
      return value;
    }
    rawValue(node2, prop) {
      let value = node2[prop];
      let raw = node2.raws[prop];
      if (raw && raw.value === value) {
        return raw.raw;
      }
      return value;
    }
    root(node2) {
      this.body(node2);
      if (node2.raws.after) this.builder(node2.raws.after);
    }
    rule(node2) {
      this.block(node2, this.rawValue(node2, "selector"));
      if (node2.raws.ownSemicolon) {
        this.builder(node2.raws.ownSemicolon, node2, "end");
      }
    }
    stringify(node2, semicolon) {
      if (!this[node2.type]) {
        throw new Error(
          "Unknown AST node type " + node2.type + ". Maybe you need to change PostCSS stringifier."
        );
      }
      this[node2.type](node2, semicolon);
    }
  }
  stringifier = Stringifier;
  Stringifier.default = Stringifier;
  return stringifier;
}
var stringify_1;
var hasRequiredStringify;
function requireStringify() {
  if (hasRequiredStringify) return stringify_1;
  hasRequiredStringify = 1;
  let Stringifier = requireStringifier();
  function stringify2(node2, builder) {
    let str = new Stringifier(builder);
    str.stringify(node2);
  }
  stringify_1 = stringify2;
  stringify2.default = stringify2;
  return stringify_1;
}
var symbols = {};
var hasRequiredSymbols;
function requireSymbols() {
  if (hasRequiredSymbols) return symbols;
  hasRequiredSymbols = 1;
  symbols.isClean = Symbol("isClean");
  symbols.my = Symbol("my");
  return symbols;
}
var node;
var hasRequiredNode;
function requireNode() {
  if (hasRequiredNode) return node;
  hasRequiredNode = 1;
  let CssSyntaxError = requireCssSyntaxError();
  let Stringifier = requireStringifier();
  let stringify2 = requireStringify();
  let { isClean, my } = requireSymbols();
  function cloneNode(obj, parent) {
    let cloned = new obj.constructor();
    for (let i2 in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, i2)) {
        continue;
      }
      if (i2 === "proxyCache") continue;
      let value = obj[i2];
      let type = typeof value;
      if (i2 === "parent" && type === "object") {
        if (parent) cloned[i2] = parent;
      } else if (i2 === "source") {
        cloned[i2] = value;
      } else if (Array.isArray(value)) {
        cloned[i2] = value.map((j) => cloneNode(j, cloned));
      } else {
        if (type === "object" && value !== null) value = cloneNode(value);
        cloned[i2] = value;
      }
    }
    return cloned;
  }
  function sourceOffset(inputCSS, position) {
    if (position && typeof position.offset !== "undefined") {
      return position.offset;
    }
    let column = 1;
    let line = 1;
    let offset = 0;
    for (let i2 = 0; i2 < inputCSS.length; i2++) {
      if (line === position.line && column === position.column) {
        offset = i2;
        break;
      }
      if (inputCSS[i2] === "\n") {
        column = 1;
        line += 1;
      } else {
        column += 1;
      }
    }
    return offset;
  }
  class Node {
    get proxyOf() {
      return this;
    }
    constructor(defaults = {}) {
      this.raws = {};
      this[isClean] = false;
      this[my] = true;
      for (let name in defaults) {
        if (name === "nodes") {
          this.nodes = [];
          for (let node2 of defaults[name]) {
            if (typeof node2.clone === "function") {
              this.append(node2.clone());
            } else {
              this.append(node2);
            }
          }
        } else {
          this[name] = defaults[name];
        }
      }
    }
    addToError(error) {
      error.postcssNode = this;
      if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
        let s2 = this.source;
        error.stack = error.stack.replace(
          /\n\s{4}at /,
          `$&${s2.input.from}:${s2.start.line}:${s2.start.column}$&`
        );
      }
      return error;
    }
    after(add) {
      this.parent.insertAfter(this, add);
      return this;
    }
    assign(overrides = {}) {
      for (let name in overrides) {
        this[name] = overrides[name];
      }
      return this;
    }
    before(add) {
      this.parent.insertBefore(this, add);
      return this;
    }
    cleanRaws(keepBetween) {
      delete this.raws.before;
      delete this.raws.after;
      if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
      let cloned = cloneNode(this);
      for (let name in overrides) {
        cloned[name] = overrides[name];
      }
      return cloned;
    }
    cloneAfter(overrides = {}) {
      let cloned = this.clone(overrides);
      this.parent.insertAfter(this, cloned);
      return cloned;
    }
    cloneBefore(overrides = {}) {
      let cloned = this.clone(overrides);
      this.parent.insertBefore(this, cloned);
      return cloned;
    }
    error(message, opts = {}) {
      if (this.source) {
        let { end, start } = this.rangeBy(opts);
        return this.source.input.error(
          message,
          { column: start.column, line: start.line },
          { column: end.column, line: end.line },
          opts
        );
      }
      return new CssSyntaxError(message);
    }
    getProxyProcessor() {
      return {
        get(node2, prop) {
          if (prop === "proxyOf") {
            return node2;
          } else if (prop === "root") {
            return () => node2.root().toProxy();
          } else {
            return node2[prop];
          }
        },
        set(node2, prop, value) {
          if (node2[prop] === value) return true;
          node2[prop] = value;
          if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */
          prop === "text") {
            node2.markDirty();
          }
          return true;
        }
      };
    }
    /* c8 ignore next 3 */
    markClean() {
      this[isClean] = true;
    }
    markDirty() {
      if (this[isClean]) {
        this[isClean] = false;
        let next = this;
        while (next = next.parent) {
          next[isClean] = false;
        }
      }
    }
    next() {
      if (!this.parent) return void 0;
      let index = this.parent.index(this);
      return this.parent.nodes[index + 1];
    }
    positionBy(opts = {}) {
      let pos = this.source.start;
      if (opts.index) {
        pos = this.positionInside(opts.index);
      } else if (opts.word) {
        let inputString = "document" in this.source.input ? this.source.input.document : this.source.input.css;
        let stringRepresentation = inputString.slice(
          sourceOffset(inputString, this.source.start),
          sourceOffset(inputString, this.source.end)
        );
        let index = stringRepresentation.indexOf(opts.word);
        if (index !== -1) pos = this.positionInside(index);
      }
      return pos;
    }
    positionInside(index) {
      let column = this.source.start.column;
      let line = this.source.start.line;
      let inputString = "document" in this.source.input ? this.source.input.document : this.source.input.css;
      let offset = sourceOffset(inputString, this.source.start);
      let end = offset + index;
      for (let i2 = offset; i2 < end; i2++) {
        if (inputString[i2] === "\n") {
          column = 1;
          line += 1;
        } else {
          column += 1;
        }
      }
      return { column, line, offset: end };
    }
    prev() {
      if (!this.parent) return void 0;
      let index = this.parent.index(this);
      return this.parent.nodes[index - 1];
    }
    rangeBy(opts = {}) {
      let inputString = "document" in this.source.input ? this.source.input.document : this.source.input.css;
      let start = {
        column: this.source.start.column,
        line: this.source.start.line,
        offset: sourceOffset(inputString, this.source.start)
      };
      let end = this.source.end ? {
        column: this.source.end.column + 1,
        line: this.source.end.line,
        offset: typeof this.source.end.offset === "number" ? (
          // `source.end.offset` is exclusive, so we don't need to add 1
          this.source.end.offset
        ) : (
          // Since line/column in this.source.end is inclusive,
          // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
          // So, we add 1 to convert it to exclusive.
          sourceOffset(inputString, this.source.end) + 1
        )
      } : {
        column: start.column + 1,
        line: start.line,
        offset: start.offset + 1
      };
      if (opts.word) {
        let stringRepresentation = inputString.slice(
          sourceOffset(inputString, this.source.start),
          sourceOffset(inputString, this.source.end)
        );
        let index = stringRepresentation.indexOf(opts.word);
        if (index !== -1) {
          start = this.positionInside(index);
          end = this.positionInside(index + opts.word.length);
        }
      } else {
        if (opts.start) {
          start = {
            column: opts.start.column,
            line: opts.start.line,
            offset: sourceOffset(inputString, opts.start)
          };
        } else if (opts.index) {
          start = this.positionInside(opts.index);
        }
        if (opts.end) {
          end = {
            column: opts.end.column,
            line: opts.end.line,
            offset: sourceOffset(inputString, opts.end)
          };
        } else if (typeof opts.endIndex === "number") {
          end = this.positionInside(opts.endIndex);
        } else if (opts.index) {
          end = this.positionInside(opts.index + 1);
        }
      }
      if (end.line < start.line || end.line === start.line && end.column <= start.column) {
        end = {
          column: start.column + 1,
          line: start.line,
          offset: start.offset + 1
        };
      }
      return { end, start };
    }
    raw(prop, defaultType) {
      let str = new Stringifier();
      return str.raw(this, prop, defaultType);
    }
    remove() {
      if (this.parent) {
        this.parent.removeChild(this);
      }
      this.parent = void 0;
      return this;
    }
    replaceWith(...nodes) {
      if (this.parent) {
        let bookmark = this;
        let foundSelf = false;
        for (let node2 of nodes) {
          if (node2 === this) {
            foundSelf = true;
          } else if (foundSelf) {
            this.parent.insertAfter(bookmark, node2);
            bookmark = node2;
          } else {
            this.parent.insertBefore(bookmark, node2);
          }
        }
        if (!foundSelf) {
          this.remove();
        }
      }
      return this;
    }
    root() {
      let result2 = this;
      while (result2.parent && result2.parent.type !== "document") {
        result2 = result2.parent;
      }
      return result2;
    }
    toJSON(_2, inputs) {
      let fixed = {};
      let emitInputs = inputs == null;
      inputs = inputs || /* @__PURE__ */ new Map();
      let inputsNextIndex = 0;
      for (let name in this) {
        if (!Object.prototype.hasOwnProperty.call(this, name)) {
          continue;
        }
        if (name === "parent" || name === "proxyCache") continue;
        let value = this[name];
        if (Array.isArray(value)) {
          fixed[name] = value.map((i2) => {
            if (typeof i2 === "object" && i2.toJSON) {
              return i2.toJSON(null, inputs);
            } else {
              return i2;
            }
          });
        } else if (typeof value === "object" && value.toJSON) {
          fixed[name] = value.toJSON(null, inputs);
        } else if (name === "source") {
          if (value == null) continue;
          let inputId = inputs.get(value.input);
          if (inputId == null) {
            inputId = inputsNextIndex;
            inputs.set(value.input, inputsNextIndex);
            inputsNextIndex++;
          }
          fixed[name] = {
            end: value.end,
            inputId,
            start: value.start
          };
        } else {
          fixed[name] = value;
        }
      }
      if (emitInputs) {
        fixed.inputs = [...inputs.keys()].map((input2) => input2.toJSON());
      }
      return fixed;
    }
    toProxy() {
      if (!this.proxyCache) {
        this.proxyCache = new Proxy(this, this.getProxyProcessor());
      }
      return this.proxyCache;
    }
    toString(stringifier2 = stringify2) {
      if (stringifier2.stringify) stringifier2 = stringifier2.stringify;
      let result2 = "";
      stringifier2(this, (i2) => {
        result2 += i2;
      });
      return result2;
    }
    warn(result2, text, opts = {}) {
      let data = { node: this };
      for (let i2 in opts) data[i2] = opts[i2];
      return result2.warn(text, data);
    }
  }
  node = Node;
  Node.default = Node;
  return node;
}
var comment;
var hasRequiredComment;
function requireComment() {
  if (hasRequiredComment) return comment;
  hasRequiredComment = 1;
  let Node = requireNode();
  class Comment extends Node {
    constructor(defaults) {
      super(defaults);
      this.type = "comment";
    }
  }
  comment = Comment;
  Comment.default = Comment;
  return comment;
}
var declaration;
var hasRequiredDeclaration;
function requireDeclaration() {
  if (hasRequiredDeclaration) return declaration;
  hasRequiredDeclaration = 1;
  let Node = requireNode();
  class Declaration extends Node {
    get variable() {
      return this.prop.startsWith("--") || this.prop[0] === "$";
    }
    constructor(defaults) {
      if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") {
        defaults = { ...defaults, value: String(defaults.value) };
      }
      super(defaults);
      this.type = "decl";
    }
  }
  declaration = Declaration;
  Declaration.default = Declaration;
  return declaration;
}
var container;
var hasRequiredContainer;
function requireContainer() {
  if (hasRequiredContainer) return container;
  hasRequiredContainer = 1;
  let Comment = requireComment();
  let Declaration = requireDeclaration();
  let Node = requireNode();
  let { isClean, my } = requireSymbols();
  let AtRule, parse, Root, Rule;
  function cleanSource(nodes) {
    return nodes.map((i2) => {
      if (i2.nodes) i2.nodes = cleanSource(i2.nodes);
      delete i2.source;
      return i2;
    });
  }
  function markTreeDirty(node2) {
    node2[isClean] = false;
    if (node2.proxyOf.nodes) {
      for (let i2 of node2.proxyOf.nodes) {
        markTreeDirty(i2);
      }
    }
  }
  class Container extends Node {
    get first() {
      if (!this.proxyOf.nodes) return void 0;
      return this.proxyOf.nodes[0];
    }
    get last() {
      if (!this.proxyOf.nodes) return void 0;
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
    append(...children) {
      for (let child of children) {
        let nodes = this.normalize(child, this.last);
        for (let node2 of nodes) this.proxyOf.nodes.push(node2);
      }
      this.markDirty();
      return this;
    }
    cleanRaws(keepBetween) {
      super.cleanRaws(keepBetween);
      if (this.nodes) {
        for (let node2 of this.nodes) node2.cleanRaws(keepBetween);
      }
    }
    each(callback) {
      if (!this.proxyOf.nodes) return void 0;
      let iterator = this.getIterator();
      let index, result2;
      while (this.indexes[iterator] < this.proxyOf.nodes.length) {
        index = this.indexes[iterator];
        result2 = callback(this.proxyOf.nodes[index], index);
        if (result2 === false) break;
        this.indexes[iterator] += 1;
      }
      delete this.indexes[iterator];
      return result2;
    }
    every(condition) {
      return this.nodes.every(condition);
    }
    getIterator() {
      if (!this.lastEach) this.lastEach = 0;
      if (!this.indexes) this.indexes = {};
      this.lastEach += 1;
      let iterator = this.lastEach;
      this.indexes[iterator] = 0;
      return iterator;
    }
    getProxyProcessor() {
      return {
        get(node2, prop) {
          if (prop === "proxyOf") {
            return node2;
          } else if (!node2[prop]) {
            return node2[prop];
          } else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) {
            return (...args) => {
              return node2[prop](
                ...args.map((i2) => {
                  if (typeof i2 === "function") {
                    return (child, index) => i2(child.toProxy(), index);
                  } else {
                    return i2;
                  }
                })
              );
            };
          } else if (prop === "every" || prop === "some") {
            return (cb) => {
              return node2[prop](
                (child, ...other) => cb(child.toProxy(), ...other)
              );
            };
          } else if (prop === "root") {
            return () => node2.root().toProxy();
          } else if (prop === "nodes") {
            return node2.nodes.map((i2) => i2.toProxy());
          } else if (prop === "first" || prop === "last") {
            return node2[prop].toProxy();
          } else {
            return node2[prop];
          }
        },
        set(node2, prop, value) {
          if (node2[prop] === value) return true;
          node2[prop] = value;
          if (prop === "name" || prop === "params" || prop === "selector") {
            node2.markDirty();
          }
          return true;
        }
      };
    }
    index(child) {
      if (typeof child === "number") return child;
      if (child.proxyOf) child = child.proxyOf;
      return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
      let existIndex = this.index(exist);
      let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
      existIndex = this.index(exist);
      for (let node2 of nodes) this.proxyOf.nodes.splice(existIndex + 1, 0, node2);
      let index;
      for (let id in this.indexes) {
        index = this.indexes[id];
        if (existIndex < index) {
          this.indexes[id] = index + nodes.length;
        }
      }
      this.markDirty();
      return this;
    }
    insertBefore(exist, add) {
      let existIndex = this.index(exist);
      let type = existIndex === 0 ? "prepend" : false;
      let nodes = this.normalize(
        add,
        this.proxyOf.nodes[existIndex],
        type
      ).reverse();
      existIndex = this.index(exist);
      for (let node2 of nodes) this.proxyOf.nodes.splice(existIndex, 0, node2);
      let index;
      for (let id in this.indexes) {
        index = this.indexes[id];
        if (existIndex <= index) {
          this.indexes[id] = index + nodes.length;
        }
      }
      this.markDirty();
      return this;
    }
    normalize(nodes, sample) {
      if (typeof nodes === "string") {
        nodes = cleanSource(parse(nodes).nodes);
      } else if (typeof nodes === "undefined") {
        nodes = [];
      } else if (Array.isArray(nodes)) {
        nodes = nodes.slice(0);
        for (let i2 of nodes) {
          if (i2.parent) i2.parent.removeChild(i2, "ignore");
        }
      } else if (nodes.type === "root" && this.type !== "document") {
        nodes = nodes.nodes.slice(0);
        for (let i2 of nodes) {
          if (i2.parent) i2.parent.removeChild(i2, "ignore");
        }
      } else if (nodes.type) {
        nodes = [nodes];
      } else if (nodes.prop) {
        if (typeof nodes.value === "undefined") {
          throw new Error("Value field is missed in node creation");
        } else if (typeof nodes.value !== "string") {
          nodes.value = String(nodes.value);
        }
        nodes = [new Declaration(nodes)];
      } else if (nodes.selector || nodes.selectors) {
        nodes = [new Rule(nodes)];
      } else if (nodes.name) {
        nodes = [new AtRule(nodes)];
      } else if (nodes.text) {
        nodes = [new Comment(nodes)];
      } else {
        throw new Error("Unknown node type in node creation");
      }
      let processed = nodes.map((i2) => {
        if (!i2[my]) Container.rebuild(i2);
        i2 = i2.proxyOf;
        if (i2.parent) i2.parent.removeChild(i2);
        if (i2[isClean]) markTreeDirty(i2);
        if (!i2.raws) i2.raws = {};
        if (typeof i2.raws.before === "undefined") {
          if (sample && typeof sample.raws.before !== "undefined") {
            i2.raws.before = sample.raws.before.replace(/\S/g, "");
          }
        }
        i2.parent = this.proxyOf;
        return i2;
      });
      return processed;
    }
    prepend(...children) {
      children = children.reverse();
      for (let child of children) {
        let nodes = this.normalize(child, this.first, "prepend").reverse();
        for (let node2 of nodes) this.proxyOf.nodes.unshift(node2);
        for (let id in this.indexes) {
          this.indexes[id] = this.indexes[id] + nodes.length;
        }
      }
      this.markDirty();
      return this;
    }
    push(child) {
      child.parent = this;
      this.proxyOf.nodes.push(child);
      return this;
    }
    removeAll() {
      for (let node2 of this.proxyOf.nodes) node2.parent = void 0;
      this.proxyOf.nodes = [];
      this.markDirty();
      return this;
    }
    removeChild(child) {
      child = this.index(child);
      this.proxyOf.nodes[child].parent = void 0;
      this.proxyOf.nodes.splice(child, 1);
      let index;
      for (let id in this.indexes) {
        index = this.indexes[id];
        if (index >= child) {
          this.indexes[id] = index - 1;
        }
      }
      this.markDirty();
      return this;
    }
    replaceValues(pattern, opts, callback) {
      if (!callback) {
        callback = opts;
        opts = {};
      }
      this.walkDecls((decl) => {
        if (opts.props && !opts.props.includes(decl.prop)) return;
        if (opts.fast && !decl.value.includes(opts.fast)) return;
        decl.value = decl.value.replace(pattern, callback);
      });
      this.markDirty();
      return this;
    }
    some(condition) {
      return this.nodes.some(condition);
    }
    walk(callback) {
      return this.each((child, i2) => {
        let result2;
        try {
          result2 = callback(child, i2);
        } catch (e) {
          throw child.addToError(e);
        }
        if (result2 !== false && child.walk) {
          result2 = child.walk(callback);
        }
        return result2;
      });
    }
    walkAtRules(name, callback) {
      if (!callback) {
        callback = name;
        return this.walk((child, i2) => {
          if (child.type === "atrule") {
            return callback(child, i2);
          }
        });
      }
      if (name instanceof RegExp) {
        return this.walk((child, i2) => {
          if (child.type === "atrule" && name.test(child.name)) {
            return callback(child, i2);
          }
        });
      }
      return this.walk((child, i2) => {
        if (child.type === "atrule" && child.name === name) {
          return callback(child, i2);
        }
      });
    }
    walkComments(callback) {
      return this.walk((child, i2) => {
        if (child.type === "comment") {
          return callback(child, i2);
        }
      });
    }
    walkDecls(prop, callback) {
      if (!callback) {
        callback = prop;
        return this.walk((child, i2) => {
          if (child.type === "decl") {
            return callback(child, i2);
          }
        });
      }
      if (prop instanceof RegExp) {
        return this.walk((child, i2) => {
          if (child.type === "decl" && prop.test(child.prop)) {
            return callback(child, i2);
          }
        });
      }
      return this.walk((child, i2) => {
        if (child.type === "decl" && child.prop === prop) {
          return callback(child, i2);
        }
      });
    }
    walkRules(selector, callback) {
      if (!callback) {
        callback = selector;
        return this.walk((child, i2) => {
          if (child.type === "rule") {
            return callback(child, i2);
          }
        });
      }
      if (selector instanceof RegExp) {
        return this.walk((child, i2) => {
          if (child.type === "rule" && selector.test(child.selector)) {
            return callback(child, i2);
          }
        });
      }
      return this.walk((child, i2) => {
        if (child.type === "rule" && child.selector === selector) {
          return callback(child, i2);
        }
      });
    }
  }
  Container.registerParse = (dependant) => {
    parse = dependant;
  };
  Container.registerRule = (dependant) => {
    Rule = dependant;
  };
  Container.registerAtRule = (dependant) => {
    AtRule = dependant;
  };
  Container.registerRoot = (dependant) => {
    Root = dependant;
  };
  container = Container;
  Container.default = Container;
  Container.rebuild = (node2) => {
    if (node2.type === "atrule") {
      Object.setPrototypeOf(node2, AtRule.prototype);
    } else if (node2.type === "rule") {
      Object.setPrototypeOf(node2, Rule.prototype);
    } else if (node2.type === "decl") {
      Object.setPrototypeOf(node2, Declaration.prototype);
    } else if (node2.type === "comment") {
      Object.setPrototypeOf(node2, Comment.prototype);
    } else if (node2.type === "root") {
      Object.setPrototypeOf(node2, Root.prototype);
    }
    node2[my] = true;
    if (node2.nodes) {
      node2.nodes.forEach((child) => {
        Container.rebuild(child);
      });
    }
  };
  return container;
}
var atRule;
var hasRequiredAtRule;
function requireAtRule() {
  if (hasRequiredAtRule) return atRule;
  hasRequiredAtRule = 1;
  let Container = requireContainer();
  class AtRule extends Container {
    constructor(defaults) {
      super(defaults);
      this.type = "atrule";
    }
    append(...children) {
      if (!this.proxyOf.nodes) this.nodes = [];
      return super.append(...children);
    }
    prepend(...children) {
      if (!this.proxyOf.nodes) this.nodes = [];
      return super.prepend(...children);
    }
  }
  atRule = AtRule;
  AtRule.default = AtRule;
  Container.registerAtRule(AtRule);
  return atRule;
}
var document$1;
var hasRequiredDocument;
function requireDocument() {
  if (hasRequiredDocument) return document$1;
  hasRequiredDocument = 1;
  let Container = requireContainer();
  let LazyResult, Processor;
  class Document extends Container {
    constructor(defaults) {
      super({ type: "document", ...defaults });
      if (!this.nodes) {
        this.nodes = [];
      }
    }
    toResult(opts = {}) {
      let lazy = new LazyResult(new Processor(), this, opts);
      return lazy.stringify();
    }
  }
  Document.registerLazyResult = (dependant) => {
    LazyResult = dependant;
  };
  Document.registerProcessor = (dependant) => {
    Processor = dependant;
  };
  document$1 = Document;
  Document.default = Document;
  return document$1;
}
var nonSecure;
var hasRequiredNonSecure;
function requireNonSecure() {
  if (hasRequiredNonSecure) return nonSecure;
  hasRequiredNonSecure = 1;
  let urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
  let customAlphabet = (alphabet, defaultSize = 21) => {
    return (size = defaultSize) => {
      let id = "";
      let i2 = size | 0;
      while (i2--) {
        id += alphabet[Math.random() * alphabet.length | 0];
      }
      return id;
    };
  };
  let nanoid = (size = 21) => {
    let id = "";
    let i2 = size | 0;
    while (i2--) {
      id += urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
  };
  nonSecure = { nanoid, customAlphabet };
  return nonSecure;
}
var previousMap;
var hasRequiredPreviousMap;
function requirePreviousMap() {
  if (hasRequiredPreviousMap) return previousMap;
  hasRequiredPreviousMap = 1;
  let { existsSync, readFileSync } = require$$2;
  let { dirname, join } = require$$2;
  let { SourceMapConsumer, SourceMapGenerator } = require$$2;
  function fromBase64(str) {
    if (Buffer) {
      return Buffer.from(str, "base64").toString();
    } else {
      return window.atob(str);
    }
  }
  class PreviousMap {
    constructor(css3, opts) {
      if (opts.map === false) return;
      this.loadAnnotation(css3);
      this.inline = this.startWith(this.annotation, "data:");
      let prev = opts.map ? opts.map.prev : void 0;
      let text = this.loadMap(opts.from, prev);
      if (!this.mapFile && opts.from) {
        this.mapFile = opts.from;
      }
      if (this.mapFile) this.root = dirname(this.mapFile);
      if (text) this.text = text;
    }
    consumer() {
      if (!this.consumerCache) {
        this.consumerCache = new SourceMapConsumer(this.text);
      }
      return this.consumerCache;
    }
    decodeInline(text) {
      let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
      let baseUri = /^data:application\/json;base64,/;
      let charsetUri = /^data:application\/json;charset=utf-?8,/;
      let uri = /^data:application\/json,/;
      let uriMatch = text.match(charsetUri) || text.match(uri);
      if (uriMatch) {
        return decodeURIComponent(text.substr(uriMatch[0].length));
      }
      let baseUriMatch = text.match(baseCharsetUri) || text.match(baseUri);
      if (baseUriMatch) {
        return fromBase64(text.substr(baseUriMatch[0].length));
      }
      let encoding = text.match(/data:application\/json;([^,]+),/)[1];
      throw new Error("Unsupported source map encoding " + encoding);
    }
    getAnnotationURL(sourceMapString) {
      return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(map) {
      if (typeof map !== "object") return false;
      return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    }
    loadAnnotation(css3) {
      let comments = css3.match(/\/\*\s*# sourceMappingURL=/g);
      if (!comments) return;
      let start = css3.lastIndexOf(comments.pop());
      let end = css3.indexOf("*/", start);
      if (start > -1 && end > -1) {
        this.annotation = this.getAnnotationURL(css3.substring(start, end));
      }
    }
    loadFile(path) {
      this.root = dirname(path);
      if (existsSync(path)) {
        this.mapFile = path;
        return readFileSync(path, "utf-8").toString().trim();
      }
    }
    loadMap(file, prev) {
      if (prev === false) return false;
      if (prev) {
        if (typeof prev === "string") {
          return prev;
        } else if (typeof prev === "function") {
          let prevPath = prev(file);
          if (prevPath) {
            let map = this.loadFile(prevPath);
            if (!map) {
              throw new Error(
                "Unable to load previous source map: " + prevPath.toString()
              );
            }
            return map;
          }
        } else if (prev instanceof SourceMapConsumer) {
          return SourceMapGenerator.fromSourceMap(prev).toString();
        } else if (prev instanceof SourceMapGenerator) {
          return prev.toString();
        } else if (this.isMap(prev)) {
          return JSON.stringify(prev);
        } else {
          throw new Error(
            "Unsupported previous source map format: " + prev.toString()
          );
        }
      } else if (this.inline) {
        return this.decodeInline(this.annotation);
      } else if (this.annotation) {
        let map = this.annotation;
        if (file) map = join(dirname(file), map);
        return this.loadFile(map);
      }
    }
    startWith(string, start) {
      if (!string) return false;
      return string.substr(0, start.length) === start;
    }
    withContent() {
      return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
  }
  previousMap = PreviousMap;
  PreviousMap.default = PreviousMap;
  return previousMap;
}
var input;
var hasRequiredInput;
function requireInput() {
  if (hasRequiredInput) return input;
  hasRequiredInput = 1;
  let { nanoid } = /* @__PURE__ */ requireNonSecure();
  let { isAbsolute, resolve } = require$$2;
  let { SourceMapConsumer, SourceMapGenerator } = require$$2;
  let { fileURLToPath, pathToFileURL } = require$$2;
  let CssSyntaxError = requireCssSyntaxError();
  let PreviousMap = requirePreviousMap();
  let terminalHighlight = require$$2;
  let lineToIndexCache = Symbol("lineToIndexCache");
  let sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
  let pathAvailable = Boolean(resolve && isAbsolute);
  function getLineToIndex(input2) {
    if (input2[lineToIndexCache]) return input2[lineToIndexCache];
    let lines = input2.css.split("\n");
    let lineToIndex = new Array(lines.length);
    let prevIndex = 0;
    for (let i2 = 0, l2 = lines.length; i2 < l2; i2++) {
      lineToIndex[i2] = prevIndex;
      prevIndex += lines[i2].length + 1;
    }
    input2[lineToIndexCache] = lineToIndex;
    return lineToIndex;
  }
  class Input {
    get from() {
      return this.file || this.id;
    }
    constructor(css3, opts = {}) {
      if (css3 === null || typeof css3 === "undefined" || typeof css3 === "object" && !css3.toString) {
        throw new Error(`PostCSS received ${css3} instead of CSS string`);
      }
      this.css = css3.toString();
      if (this.css[0] === "\uFEFF" || this.css[0] === "￾") {
        this.hasBOM = true;
        this.css = this.css.slice(1);
      } else {
        this.hasBOM = false;
      }
      this.document = this.css;
      if (opts.document) this.document = opts.document.toString();
      if (opts.from) {
        if (!pathAvailable || /^\w+:\/\//.test(opts.from) || isAbsolute(opts.from)) {
          this.file = opts.from;
        } else {
          this.file = resolve(opts.from);
        }
      }
      if (pathAvailable && sourceMapAvailable) {
        let map = new PreviousMap(this.css, opts);
        if (map.text) {
          this.map = map;
          let file = map.consumer().file;
          if (!this.file && file) this.file = this.mapResolve(file);
        }
      }
      if (!this.file) {
        this.id = "<input css " + nanoid(6) + ">";
      }
      if (this.map) this.map.file = this.from;
    }
    error(message, line, column, opts = {}) {
      let endColumn, endLine, endOffset, offset, result2;
      if (line && typeof line === "object") {
        let start = line;
        let end = column;
        if (typeof start.offset === "number") {
          offset = start.offset;
          let pos = this.fromOffset(offset);
          line = pos.line;
          column = pos.col;
        } else {
          line = start.line;
          column = start.column;
          offset = this.fromLineAndColumn(line, column);
        }
        if (typeof end.offset === "number") {
          endOffset = end.offset;
          let pos = this.fromOffset(endOffset);
          endLine = pos.line;
          endColumn = pos.col;
        } else {
          endLine = end.line;
          endColumn = end.column;
          endOffset = this.fromLineAndColumn(end.line, end.column);
        }
      } else if (!column) {
        offset = line;
        let pos = this.fromOffset(offset);
        line = pos.line;
        column = pos.col;
      } else {
        offset = this.fromLineAndColumn(line, column);
      }
      let origin = this.origin(line, column, endLine, endColumn);
      if (origin) {
        result2 = new CssSyntaxError(
          message,
          origin.endLine === void 0 ? origin.line : { column: origin.column, line: origin.line },
          origin.endLine === void 0 ? origin.column : { column: origin.endColumn, line: origin.endLine },
          origin.source,
          origin.file,
          opts.plugin
        );
      } else {
        result2 = new CssSyntaxError(
          message,
          endLine === void 0 ? line : { column, line },
          endLine === void 0 ? column : { column: endColumn, line: endLine },
          this.css,
          this.file,
          opts.plugin
        );
      }
      result2.input = { column, endColumn, endLine, endOffset, line, offset, source: this.css };
      if (this.file) {
        if (pathToFileURL) {
          result2.input.url = pathToFileURL(this.file).toString();
        }
        result2.input.file = this.file;
      }
      return result2;
    }
    fromLineAndColumn(line, column) {
      let lineToIndex = getLineToIndex(this);
      let index = lineToIndex[line - 1];
      return index + column - 1;
    }
    fromOffset(offset) {
      let lineToIndex = getLineToIndex(this);
      let lastLine = lineToIndex[lineToIndex.length - 1];
      let min = 0;
      if (offset >= lastLine) {
        min = lineToIndex.length - 1;
      } else {
        let max = lineToIndex.length - 2;
        let mid;
        while (min < max) {
          mid = min + (max - min >> 1);
          if (offset < lineToIndex[mid]) {
            max = mid - 1;
          } else if (offset >= lineToIndex[mid + 1]) {
            min = mid + 1;
          } else {
            min = mid;
            break;
          }
        }
      }
      return {
        col: offset - lineToIndex[min] + 1,
        line: min + 1
      };
    }
    mapResolve(file) {
      if (/^\w+:\/\//.test(file)) {
        return file;
      }
      return resolve(this.map.consumer().sourceRoot || this.map.root || ".", file);
    }
    origin(line, column, endLine, endColumn) {
      if (!this.map) return false;
      let consumer = this.map.consumer();
      let from = consumer.originalPositionFor({ column, line });
      if (!from.source) return false;
      let to;
      if (typeof endLine === "number") {
        to = consumer.originalPositionFor({ column: endColumn, line: endLine });
      }
      let fromUrl;
      if (isAbsolute(from.source)) {
        fromUrl = pathToFileURL(from.source);
      } else {
        fromUrl = new URL(
          from.source,
          this.map.consumer().sourceRoot || pathToFileURL(this.map.mapFile)
        );
      }
      let result2 = {
        column: from.column,
        endColumn: to && to.column,
        endLine: to && to.line,
        line: from.line,
        url: fromUrl.toString()
      };
      if (fromUrl.protocol === "file:") {
        if (fileURLToPath) {
          result2.file = fileURLToPath(fromUrl);
        } else {
          throw new Error(`file: protocol is not available in this PostCSS build`);
        }
      }
      let source = consumer.sourceContentFor(from.source);
      if (source) result2.source = source;
      return result2;
    }
    toJSON() {
      let json = {};
      for (let name of ["hasBOM", "css", "file", "id"]) {
        if (this[name] != null) {
          json[name] = this[name];
        }
      }
      if (this.map) {
        json.map = { ...this.map };
        if (json.map.consumerCache) {
          json.map.consumerCache = void 0;
        }
      }
      return json;
    }
  }
  input = Input;
  Input.default = Input;
  if (terminalHighlight && terminalHighlight.registerInput) {
    terminalHighlight.registerInput(Input);
  }
  return input;
}
var root;
var hasRequiredRoot;
function requireRoot() {
  if (hasRequiredRoot) return root;
  hasRequiredRoot = 1;
  let Container = requireContainer();
  let LazyResult, Processor;
  class Root extends Container {
    constructor(defaults) {
      super(defaults);
      this.type = "root";
      if (!this.nodes) this.nodes = [];
    }
    normalize(child, sample, type) {
      let nodes = super.normalize(child);
      if (sample) {
        if (type === "prepend") {
          if (this.nodes.length > 1) {
            sample.raws.before = this.nodes[1].raws.before;
          } else {
            delete sample.raws.before;
          }
        } else if (this.first !== sample) {
          for (let node2 of nodes) {
            node2.raws.before = sample.raws.before;
          }
        }
      }
      return nodes;
    }
    removeChild(child, ignore) {
      let index = this.index(child);
      if (!ignore && index === 0 && this.nodes.length > 1) {
        this.nodes[1].raws.before = this.nodes[index].raws.before;
      }
      return super.removeChild(child);
    }
    toResult(opts = {}) {
      let lazy = new LazyResult(new Processor(), this, opts);
      return lazy.stringify();
    }
  }
  Root.registerLazyResult = (dependant) => {
    LazyResult = dependant;
  };
  Root.registerProcessor = (dependant) => {
    Processor = dependant;
  };
  root = Root;
  Root.default = Root;
  Container.registerRoot(Root);
  return root;
}
var list_1;
var hasRequiredList;
function requireList() {
  if (hasRequiredList) return list_1;
  hasRequiredList = 1;
  let list = {
    comma(string) {
      return list.split(string, [","], true);
    },
    space(string) {
      let spaces = [" ", "\n", "	"];
      return list.split(string, spaces);
    },
    split(string, separators, last) {
      let array = [];
      let current = "";
      let split = false;
      let func = 0;
      let inQuote = false;
      let prevQuote = "";
      let escape = false;
      for (let letter of string) {
        if (escape) {
          escape = false;
        } else if (letter === "\\") {
          escape = true;
        } else if (inQuote) {
          if (letter === prevQuote) {
            inQuote = false;
          }
        } else if (letter === '"' || letter === "'") {
          inQuote = true;
          prevQuote = letter;
        } else if (letter === "(") {
          func += 1;
        } else if (letter === ")") {
          if (func > 0) func -= 1;
        } else if (func === 0) {
          if (separators.includes(letter)) split = true;
        }
        if (split) {
          if (current !== "") array.push(current.trim());
          current = "";
          split = false;
        } else {
          current += letter;
        }
      }
      if (last || current !== "") array.push(current.trim());
      return array;
    }
  };
  list_1 = list;
  list.default = list;
  return list_1;
}
var rule;
var hasRequiredRule;
function requireRule() {
  if (hasRequiredRule) return rule;
  hasRequiredRule = 1;
  let Container = requireContainer();
  let list = requireList();
  class Rule extends Container {
    get selectors() {
      return list.comma(this.selector);
    }
    set selectors(values) {
      let match = this.selector ? this.selector.match(/,\s*/) : null;
      let sep = match ? match[0] : "," + this.raw("between", "beforeOpen");
      this.selector = values.join(sep);
    }
    constructor(defaults) {
      super(defaults);
      this.type = "rule";
      if (!this.nodes) this.nodes = [];
    }
  }
  rule = Rule;
  Rule.default = Rule;
  Container.registerRule(Rule);
  return rule;
}
var fromJSON_1;
var hasRequiredFromJSON;
function requireFromJSON() {
  if (hasRequiredFromJSON) return fromJSON_1;
  hasRequiredFromJSON = 1;
  let AtRule = requireAtRule();
  let Comment = requireComment();
  let Declaration = requireDeclaration();
  let Input = requireInput();
  let PreviousMap = requirePreviousMap();
  let Root = requireRoot();
  let Rule = requireRule();
  function fromJSON(json, inputs) {
    if (Array.isArray(json)) return json.map((n) => fromJSON(n));
    let { inputs: ownInputs, ...defaults } = json;
    if (ownInputs) {
      inputs = [];
      for (let input2 of ownInputs) {
        let inputHydrated = { ...input2, __proto__: Input.prototype };
        if (inputHydrated.map) {
          inputHydrated.map = {
            ...inputHydrated.map,
            __proto__: PreviousMap.prototype
          };
        }
        inputs.push(inputHydrated);
      }
    }
    if (defaults.nodes) {
      defaults.nodes = json.nodes.map((n) => fromJSON(n, inputs));
    }
    if (defaults.source) {
      let { inputId, ...source } = defaults.source;
      defaults.source = source;
      if (inputId != null) {
        defaults.source.input = inputs[inputId];
      }
    }
    if (defaults.type === "root") {
      return new Root(defaults);
    } else if (defaults.type === "decl") {
      return new Declaration(defaults);
    } else if (defaults.type === "rule") {
      return new Rule(defaults);
    } else if (defaults.type === "comment") {
      return new Comment(defaults);
    } else if (defaults.type === "atrule") {
      return new AtRule(defaults);
    } else {
      throw new Error("Unknown node type: " + json.type);
    }
  }
  fromJSON_1 = fromJSON;
  fromJSON.default = fromJSON;
  return fromJSON_1;
}
var mapGenerator;
var hasRequiredMapGenerator;
function requireMapGenerator() {
  if (hasRequiredMapGenerator) return mapGenerator;
  hasRequiredMapGenerator = 1;
  let { dirname, relative, resolve, sep } = require$$2;
  let { SourceMapConsumer, SourceMapGenerator } = require$$2;
  let { pathToFileURL } = require$$2;
  let Input = requireInput();
  let sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
  let pathAvailable = Boolean(dirname && resolve && relative && sep);
  class MapGenerator {
    constructor(stringify2, root2, opts, cssString) {
      this.stringify = stringify2;
      this.mapOpts = opts.map || {};
      this.root = root2;
      this.opts = opts;
      this.css = cssString;
      this.originalCSS = cssString;
      this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
      this.memoizedFileURLs = /* @__PURE__ */ new Map();
      this.memoizedPaths = /* @__PURE__ */ new Map();
      this.memoizedURLs = /* @__PURE__ */ new Map();
    }
    addAnnotation() {
      let content;
      if (this.isInline()) {
        content = "data:application/json;base64," + this.toBase64(this.map.toString());
      } else if (typeof this.mapOpts.annotation === "string") {
        content = this.mapOpts.annotation;
      } else if (typeof this.mapOpts.annotation === "function") {
        content = this.mapOpts.annotation(this.opts.to, this.root);
      } else {
        content = this.outputFile() + ".map";
      }
      let eol = "\n";
      if (this.css.includes("\r\n")) eol = "\r\n";
      this.css += eol + "/*# sourceMappingURL=" + content + " */";
    }
    applyPrevMaps() {
      for (let prev of this.previous()) {
        let from = this.toUrl(this.path(prev.file));
        let root2 = prev.root || dirname(prev.file);
        let map;
        if (this.mapOpts.sourcesContent === false) {
          map = new SourceMapConsumer(prev.text);
          if (map.sourcesContent) {
            map.sourcesContent = null;
          }
        } else {
          map = prev.consumer();
        }
        this.map.applySourceMap(map, from, this.toUrl(this.path(root2)));
      }
    }
    clearAnnotation() {
      if (this.mapOpts.annotation === false) return;
      if (this.root) {
        let node2;
        for (let i2 = this.root.nodes.length - 1; i2 >= 0; i2--) {
          node2 = this.root.nodes[i2];
          if (node2.type !== "comment") continue;
          if (node2.text.startsWith("# sourceMappingURL=")) {
            this.root.removeChild(i2);
          }
        }
      } else if (this.css) {
        this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, "");
      }
    }
    generate() {
      this.clearAnnotation();
      if (pathAvailable && sourceMapAvailable && this.isMap()) {
        return this.generateMap();
      } else {
        let result2 = "";
        this.stringify(this.root, (i2) => {
          result2 += i2;
        });
        return [result2];
      }
    }
    generateMap() {
      if (this.root) {
        this.generateString();
      } else if (this.previous().length === 1) {
        let prev = this.previous()[0].consumer();
        prev.file = this.outputFile();
        this.map = SourceMapGenerator.fromSourceMap(prev, {
          ignoreInvalidMapping: true
        });
      } else {
        this.map = new SourceMapGenerator({
          file: this.outputFile(),
          ignoreInvalidMapping: true
        });
        this.map.addMapping({
          generated: { column: 0, line: 1 },
          original: { column: 0, line: 1 },
          source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
        });
      }
      if (this.isSourcesContent()) this.setSourcesContent();
      if (this.root && this.previous().length > 0) this.applyPrevMaps();
      if (this.isAnnotation()) this.addAnnotation();
      if (this.isInline()) {
        return [this.css];
      } else {
        return [this.css, this.map];
      }
    }
    generateString() {
      this.css = "";
      this.map = new SourceMapGenerator({
        file: this.outputFile(),
        ignoreInvalidMapping: true
      });
      let line = 1;
      let column = 1;
      let noSource = "<no source>";
      let mapping = {
        generated: { column: 0, line: 0 },
        original: { column: 0, line: 0 },
        source: ""
      };
      let last, lines;
      this.stringify(this.root, (str, node2, type) => {
        this.css += str;
        if (node2 && type !== "end") {
          mapping.generated.line = line;
          mapping.generated.column = column - 1;
          if (node2.source && node2.source.start) {
            mapping.source = this.sourcePath(node2);
            mapping.original.line = node2.source.start.line;
            mapping.original.column = node2.source.start.column - 1;
            this.map.addMapping(mapping);
          } else {
            mapping.source = noSource;
            mapping.original.line = 1;
            mapping.original.column = 0;
            this.map.addMapping(mapping);
          }
        }
        lines = str.match(/\n/g);
        if (lines) {
          line += lines.length;
          last = str.lastIndexOf("\n");
          column = str.length - last;
        } else {
          column += str.length;
        }
        if (node2 && type !== "start") {
          let p2 = node2.parent || { raws: {} };
          let childless = node2.type === "decl" || node2.type === "atrule" && !node2.nodes;
          if (!childless || node2 !== p2.last || p2.raws.semicolon) {
            if (node2.source && node2.source.end) {
              mapping.source = this.sourcePath(node2);
              mapping.original.line = node2.source.end.line;
              mapping.original.column = node2.source.end.column - 1;
              mapping.generated.line = line;
              mapping.generated.column = column - 2;
              this.map.addMapping(mapping);
            } else {
              mapping.source = noSource;
              mapping.original.line = 1;
              mapping.original.column = 0;
              mapping.generated.line = line;
              mapping.generated.column = column - 1;
              this.map.addMapping(mapping);
            }
          }
        }
      });
    }
    isAnnotation() {
      if (this.isInline()) {
        return true;
      }
      if (typeof this.mapOpts.annotation !== "undefined") {
        return this.mapOpts.annotation;
      }
      if (this.previous().length) {
        return this.previous().some((i2) => i2.annotation);
      }
      return true;
    }
    isInline() {
      if (typeof this.mapOpts.inline !== "undefined") {
        return this.mapOpts.inline;
      }
      let annotation = this.mapOpts.annotation;
      if (typeof annotation !== "undefined" && annotation !== true) {
        return false;
      }
      if (this.previous().length) {
        return this.previous().some((i2) => i2.inline);
      }
      return true;
    }
    isMap() {
      if (typeof this.opts.map !== "undefined") {
        return !!this.opts.map;
      }
      return this.previous().length > 0;
    }
    isSourcesContent() {
      if (typeof this.mapOpts.sourcesContent !== "undefined") {
        return this.mapOpts.sourcesContent;
      }
      if (this.previous().length) {
        return this.previous().some((i2) => i2.withContent());
      }
      return true;
    }
    outputFile() {
      if (this.opts.to) {
        return this.path(this.opts.to);
      } else if (this.opts.from) {
        return this.path(this.opts.from);
      } else {
        return "to.css";
      }
    }
    path(file) {
      if (this.mapOpts.absolute) return file;
      if (file.charCodeAt(0) === 60) return file;
      if (/^\w+:\/\//.test(file)) return file;
      let cached = this.memoizedPaths.get(file);
      if (cached) return cached;
      let from = this.opts.to ? dirname(this.opts.to) : ".";
      if (typeof this.mapOpts.annotation === "string") {
        from = dirname(resolve(from, this.mapOpts.annotation));
      }
      let path = relative(from, file);
      this.memoizedPaths.set(file, path);
      return path;
    }
    previous() {
      if (!this.previousMaps) {
        this.previousMaps = [];
        if (this.root) {
          this.root.walk((node2) => {
            if (node2.source && node2.source.input.map) {
              let map = node2.source.input.map;
              if (!this.previousMaps.includes(map)) {
                this.previousMaps.push(map);
              }
            }
          });
        } else {
          let input2 = new Input(this.originalCSS, this.opts);
          if (input2.map) this.previousMaps.push(input2.map);
        }
      }
      return this.previousMaps;
    }
    setSourcesContent() {
      let already = {};
      if (this.root) {
        this.root.walk((node2) => {
          if (node2.source) {
            let from = node2.source.input.from;
            if (from && !already[from]) {
              already[from] = true;
              let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
              this.map.setSourceContent(fromUrl, node2.source.input.css);
            }
          }
        });
      } else if (this.css) {
        let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
        this.map.setSourceContent(from, this.css);
      }
    }
    sourcePath(node2) {
      if (this.mapOpts.from) {
        return this.toUrl(this.mapOpts.from);
      } else if (this.usesFileUrls) {
        return this.toFileUrl(node2.source.input.from);
      } else {
        return this.toUrl(this.path(node2.source.input.from));
      }
    }
    toBase64(str) {
      if (Buffer) {
        return Buffer.from(str).toString("base64");
      } else {
        return window.btoa(unescape(encodeURIComponent(str)));
      }
    }
    toFileUrl(path) {
      let cached = this.memoizedFileURLs.get(path);
      if (cached) return cached;
      if (pathToFileURL) {
        let fileURL = pathToFileURL(path).toString();
        this.memoizedFileURLs.set(path, fileURL);
        return fileURL;
      } else {
        throw new Error(
          "`map.absolute` option is not available in this PostCSS build"
        );
      }
    }
    toUrl(path) {
      let cached = this.memoizedURLs.get(path);
      if (cached) return cached;
      if (sep === "\\") {
        path = path.replace(/\\/g, "/");
      }
      let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
      this.memoizedURLs.set(path, url);
      return url;
    }
  }
  mapGenerator = MapGenerator;
  return mapGenerator;
}
var tokenize;
var hasRequiredTokenize;
function requireTokenize() {
  if (hasRequiredTokenize) return tokenize;
  hasRequiredTokenize = 1;
  const SINGLE_QUOTE = "'".charCodeAt(0);
  const DOUBLE_QUOTE = '"'.charCodeAt(0);
  const BACKSLASH = "\\".charCodeAt(0);
  const SLASH = "/".charCodeAt(0);
  const NEWLINE = "\n".charCodeAt(0);
  const SPACE = " ".charCodeAt(0);
  const FEED = "\f".charCodeAt(0);
  const TAB = "	".charCodeAt(0);
  const CR = "\r".charCodeAt(0);
  const OPEN_SQUARE = "[".charCodeAt(0);
  const CLOSE_SQUARE = "]".charCodeAt(0);
  const OPEN_PARENTHESES = "(".charCodeAt(0);
  const CLOSE_PARENTHESES = ")".charCodeAt(0);
  const OPEN_CURLY = "{".charCodeAt(0);
  const CLOSE_CURLY = "}".charCodeAt(0);
  const SEMICOLON = ";".charCodeAt(0);
  const ASTERISK = "*".charCodeAt(0);
  const COLON = ":".charCodeAt(0);
  const AT = "@".charCodeAt(0);
  const RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
  const RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
  const RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
  const RE_HEX_ESCAPE = /[\da-f]/i;
  tokenize = function tokenizer(input2, options = {}) {
    let css3 = input2.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, content, escape, next, quote;
    let currentToken, escaped, escapePos, n, prev;
    let length = css3.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
      return pos;
    }
    function unclosed(what) {
      throw input2.error("Unclosed " + what, pos);
    }
    function endOfFile() {
      return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
      if (returned.length) return returned.pop();
      if (pos >= length) return;
      let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
      code = css3.charCodeAt(pos);
      switch (code) {
        case NEWLINE:
        case SPACE:
        case TAB:
        case CR:
        case FEED: {
          next = pos;
          do {
            next += 1;
            code = css3.charCodeAt(next);
          } while (code === SPACE || code === NEWLINE || code === TAB || code === CR || code === FEED);
          currentToken = ["space", css3.slice(pos, next)];
          pos = next - 1;
          break;
        }
        case OPEN_SQUARE:
        case CLOSE_SQUARE:
        case OPEN_CURLY:
        case CLOSE_CURLY:
        case COLON:
        case SEMICOLON:
        case CLOSE_PARENTHESES: {
          let controlChar = String.fromCharCode(code);
          currentToken = [controlChar, controlChar, pos];
          break;
        }
        case OPEN_PARENTHESES: {
          prev = buffer.length ? buffer.pop()[1] : "";
          n = css3.charCodeAt(pos + 1);
          if (prev === "url" && n !== SINGLE_QUOTE && n !== DOUBLE_QUOTE && n !== SPACE && n !== NEWLINE && n !== TAB && n !== FEED && n !== CR) {
            next = pos;
            do {
              escaped = false;
              next = css3.indexOf(")", next + 1);
              if (next === -1) {
                if (ignore || ignoreUnclosed) {
                  next = pos;
                  break;
                } else {
                  unclosed("bracket");
                }
              }
              escapePos = next;
              while (css3.charCodeAt(escapePos - 1) === BACKSLASH) {
                escapePos -= 1;
                escaped = !escaped;
              }
            } while (escaped);
            currentToken = ["brackets", css3.slice(pos, next + 1), pos, next];
            pos = next;
          } else {
            next = css3.indexOf(")", pos + 1);
            content = css3.slice(pos, next + 1);
            if (next === -1 || RE_BAD_BRACKET.test(content)) {
              currentToken = ["(", "(", pos];
            } else {
              currentToken = ["brackets", content, pos, next];
              pos = next;
            }
          }
          break;
        }
        case SINGLE_QUOTE:
        case DOUBLE_QUOTE: {
          quote = code === SINGLE_QUOTE ? "'" : '"';
          next = pos;
          do {
            escaped = false;
            next = css3.indexOf(quote, next + 1);
            if (next === -1) {
              if (ignore || ignoreUnclosed) {
                next = pos + 1;
                break;
              } else {
                unclosed("string");
              }
            }
            escapePos = next;
            while (css3.charCodeAt(escapePos - 1) === BACKSLASH) {
              escapePos -= 1;
              escaped = !escaped;
            }
          } while (escaped);
          currentToken = ["string", css3.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }
        case AT: {
          RE_AT_END.lastIndex = pos + 1;
          RE_AT_END.test(css3);
          if (RE_AT_END.lastIndex === 0) {
            next = css3.length - 1;
          } else {
            next = RE_AT_END.lastIndex - 2;
          }
          currentToken = ["at-word", css3.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }
        case BACKSLASH: {
          next = pos;
          escape = true;
          while (css3.charCodeAt(next + 1) === BACKSLASH) {
            next += 1;
            escape = !escape;
          }
          code = css3.charCodeAt(next + 1);
          if (escape && code !== SLASH && code !== SPACE && code !== NEWLINE && code !== TAB && code !== CR && code !== FEED) {
            next += 1;
            if (RE_HEX_ESCAPE.test(css3.charAt(next))) {
              while (RE_HEX_ESCAPE.test(css3.charAt(next + 1))) {
                next += 1;
              }
              if (css3.charCodeAt(next + 1) === SPACE) {
                next += 1;
              }
            }
          }
          currentToken = ["word", css3.slice(pos, next + 1), pos, next];
          pos = next;
          break;
        }
        default: {
          if (code === SLASH && css3.charCodeAt(pos + 1) === ASTERISK) {
            next = css3.indexOf("*/", pos + 2) + 1;
            if (next === 0) {
              if (ignore || ignoreUnclosed) {
                next = css3.length;
              } else {
                unclosed("comment");
              }
            }
            currentToken = ["comment", css3.slice(pos, next + 1), pos, next];
            pos = next;
          } else {
            RE_WORD_END.lastIndex = pos + 1;
            RE_WORD_END.test(css3);
            if (RE_WORD_END.lastIndex === 0) {
              next = css3.length - 1;
            } else {
              next = RE_WORD_END.lastIndex - 2;
            }
            currentToken = ["word", css3.slice(pos, next + 1), pos, next];
            buffer.push(currentToken);
            pos = next;
          }
          break;
        }
      }
      pos++;
      return currentToken;
    }
    function back(token) {
      returned.push(token);
    }
    return {
      back,
      endOfFile,
      nextToken,
      position
    };
  };
  return tokenize;
}
var parser;
var hasRequiredParser;
function requireParser() {
  if (hasRequiredParser) return parser;
  hasRequiredParser = 1;
  let AtRule = requireAtRule();
  let Comment = requireComment();
  let Declaration = requireDeclaration();
  let Root = requireRoot();
  let Rule = requireRule();
  let tokenizer = requireTokenize();
  const SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
  };
  function findLastWithPosition(tokens) {
    for (let i2 = tokens.length - 1; i2 >= 0; i2--) {
      let token = tokens[i2];
      let pos = token[3] || token[2];
      if (pos) return pos;
    }
  }
  class Parser2 {
    constructor(input2) {
      this.input = input2;
      this.root = new Root();
      this.current = this.root;
      this.spaces = "";
      this.semicolon = false;
      this.createTokenizer();
      this.root.source = { input: input2, start: { column: 1, line: 1, offset: 0 } };
    }
    atrule(token) {
      let node2 = new AtRule();
      node2.name = token[1].slice(1);
      if (node2.name === "") {
        this.unnamedAtrule(node2, token);
      }
      this.init(node2, token[2]);
      let type;
      let prev;
      let shift;
      let last = false;
      let open = false;
      let params = [];
      let brackets = [];
      while (!this.tokenizer.endOfFile()) {
        token = this.tokenizer.nextToken();
        type = token[0];
        if (type === "(" || type === "[") {
          brackets.push(type === "(" ? ")" : "]");
        } else if (type === "{" && brackets.length > 0) {
          brackets.push("}");
        } else if (type === brackets[brackets.length - 1]) {
          brackets.pop();
        }
        if (brackets.length === 0) {
          if (type === ";") {
            node2.source.end = this.getPosition(token[2]);
            node2.source.end.offset++;
            this.semicolon = true;
            break;
          } else if (type === "{") {
            open = true;
            break;
          } else if (type === "}") {
            if (params.length > 0) {
              shift = params.length - 1;
              prev = params[shift];
              while (prev && prev[0] === "space") {
                prev = params[--shift];
              }
              if (prev) {
                node2.source.end = this.getPosition(prev[3] || prev[2]);
                node2.source.end.offset++;
              }
            }
            this.end(token);
            break;
          } else {
            params.push(token);
          }
        } else {
          params.push(token);
        }
        if (this.tokenizer.endOfFile()) {
          last = true;
          break;
        }
      }
      node2.raws.between = this.spacesAndCommentsFromEnd(params);
      if (params.length) {
        node2.raws.afterName = this.spacesAndCommentsFromStart(params);
        this.raw(node2, "params", params);
        if (last) {
          token = params[params.length - 1];
          node2.source.end = this.getPosition(token[3] || token[2]);
          node2.source.end.offset++;
          this.spaces = node2.raws.between;
          node2.raws.between = "";
        }
      } else {
        node2.raws.afterName = "";
        node2.params = "";
      }
      if (open) {
        node2.nodes = [];
        this.current = node2;
      }
    }
    checkMissedSemicolon(tokens) {
      let colon = this.colon(tokens);
      if (colon === false) return;
      let founded = 0;
      let token;
      for (let j = colon - 1; j >= 0; j--) {
        token = tokens[j];
        if (token[0] !== "space") {
          founded += 1;
          if (founded === 2) break;
        }
      }
      throw this.input.error(
        "Missed semicolon",
        token[0] === "word" ? token[3] + 1 : token[2]
      );
    }
    colon(tokens) {
      let brackets = 0;
      let prev, token, type;
      for (let [i2, element] of tokens.entries()) {
        token = element;
        type = token[0];
        if (type === "(") {
          brackets += 1;
        }
        if (type === ")") {
          brackets -= 1;
        }
        if (brackets === 0 && type === ":") {
          if (!prev) {
            this.doubleColon(token);
          } else if (prev[0] === "word" && prev[1] === "progid") {
            continue;
          } else {
            return i2;
          }
        }
        prev = token;
      }
      return false;
    }
    comment(token) {
      let node2 = new Comment();
      this.init(node2, token[2]);
      node2.source.end = this.getPosition(token[3] || token[2]);
      node2.source.end.offset++;
      let text = token[1].slice(2, -2);
      if (/^\s*$/.test(text)) {
        node2.text = "";
        node2.raws.left = text;
        node2.raws.right = "";
      } else {
        let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
        node2.text = match[2];
        node2.raws.left = match[1];
        node2.raws.right = match[3];
      }
    }
    createTokenizer() {
      this.tokenizer = tokenizer(this.input);
    }
    decl(tokens, customProperty) {
      let node2 = new Declaration();
      this.init(node2, tokens[0][2]);
      let last = tokens[tokens.length - 1];
      if (last[0] === ";") {
        this.semicolon = true;
        tokens.pop();
      }
      node2.source.end = this.getPosition(
        last[3] || last[2] || findLastWithPosition(tokens)
      );
      node2.source.end.offset++;
      while (tokens[0][0] !== "word") {
        if (tokens.length === 1) this.unknownWord(tokens);
        node2.raws.before += tokens.shift()[1];
      }
      node2.source.start = this.getPosition(tokens[0][2]);
      node2.prop = "";
      while (tokens.length) {
        let type = tokens[0][0];
        if (type === ":" || type === "space" || type === "comment") {
          break;
        }
        node2.prop += tokens.shift()[1];
      }
      node2.raws.between = "";
      let token;
      while (tokens.length) {
        token = tokens.shift();
        if (token[0] === ":") {
          node2.raws.between += token[1];
          break;
        } else {
          if (token[0] === "word" && /\w/.test(token[1])) {
            this.unknownWord([token]);
          }
          node2.raws.between += token[1];
        }
      }
      if (node2.prop[0] === "_" || node2.prop[0] === "*") {
        node2.raws.before += node2.prop[0];
        node2.prop = node2.prop.slice(1);
      }
      let firstSpaces = [];
      let next;
      while (tokens.length) {
        next = tokens[0][0];
        if (next !== "space" && next !== "comment") break;
        firstSpaces.push(tokens.shift());
      }
      this.precheckMissedSemicolon(tokens);
      for (let i2 = tokens.length - 1; i2 >= 0; i2--) {
        token = tokens[i2];
        if (token[1].toLowerCase() === "!important") {
          node2.important = true;
          let string = this.stringFrom(tokens, i2);
          string = this.spacesFromEnd(tokens) + string;
          if (string !== " !important") node2.raws.important = string;
          break;
        } else if (token[1].toLowerCase() === "important") {
          let cache = tokens.slice(0);
          let str = "";
          for (let j = i2; j > 0; j--) {
            let type = cache[j][0];
            if (str.trim().startsWith("!") && type !== "space") {
              break;
            }
            str = cache.pop()[1] + str;
          }
          if (str.trim().startsWith("!")) {
            node2.important = true;
            node2.raws.important = str;
            tokens = cache;
          }
        }
        if (token[0] !== "space" && token[0] !== "comment") {
          break;
        }
      }
      let hasWord = tokens.some((i2) => i2[0] !== "space" && i2[0] !== "comment");
      if (hasWord) {
        node2.raws.between += firstSpaces.map((i2) => i2[1]).join("");
        firstSpaces = [];
      }
      this.raw(node2, "value", firstSpaces.concat(tokens), customProperty);
      if (node2.value.includes(":") && !customProperty) {
        this.checkMissedSemicolon(tokens);
      }
    }
    doubleColon(token) {
      throw this.input.error(
        "Double colon",
        { offset: token[2] },
        { offset: token[2] + token[1].length }
      );
    }
    emptyRule(token) {
      let node2 = new Rule();
      this.init(node2, token[2]);
      node2.selector = "";
      node2.raws.between = "";
      this.current = node2;
    }
    end(token) {
      if (this.current.nodes && this.current.nodes.length) {
        this.current.raws.semicolon = this.semicolon;
      }
      this.semicolon = false;
      this.current.raws.after = (this.current.raws.after || "") + this.spaces;
      this.spaces = "";
      if (this.current.parent) {
        this.current.source.end = this.getPosition(token[2]);
        this.current.source.end.offset++;
        this.current = this.current.parent;
      } else {
        this.unexpectedClose(token);
      }
    }
    endFile() {
      if (this.current.parent) this.unclosedBlock();
      if (this.current.nodes && this.current.nodes.length) {
        this.current.raws.semicolon = this.semicolon;
      }
      this.current.raws.after = (this.current.raws.after || "") + this.spaces;
      this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(token) {
      this.spaces += token[1];
      if (this.current.nodes) {
        let prev = this.current.nodes[this.current.nodes.length - 1];
        if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
          prev.raws.ownSemicolon = this.spaces;
          this.spaces = "";
          prev.source.end = this.getPosition(token[2]);
          prev.source.end.offset += prev.raws.ownSemicolon.length;
        }
      }
    }
    // Helpers
    getPosition(offset) {
      let pos = this.input.fromOffset(offset);
      return {
        column: pos.col,
        line: pos.line,
        offset
      };
    }
    init(node2, offset) {
      this.current.push(node2);
      node2.source = {
        input: this.input,
        start: this.getPosition(offset)
      };
      node2.raws.before = this.spaces;
      this.spaces = "";
      if (node2.type !== "comment") this.semicolon = false;
    }
    other(start) {
      let end = false;
      let type = null;
      let colon = false;
      let bracket = null;
      let brackets = [];
      let customProperty = start[1].startsWith("--");
      let tokens = [];
      let token = start;
      while (token) {
        type = token[0];
        tokens.push(token);
        if (type === "(" || type === "[") {
          if (!bracket) bracket = token;
          brackets.push(type === "(" ? ")" : "]");
        } else if (customProperty && colon && type === "{") {
          if (!bracket) bracket = token;
          brackets.push("}");
        } else if (brackets.length === 0) {
          if (type === ";") {
            if (colon) {
              this.decl(tokens, customProperty);
              return;
            } else {
              break;
            }
          } else if (type === "{") {
            this.rule(tokens);
            return;
          } else if (type === "}") {
            this.tokenizer.back(tokens.pop());
            end = true;
            break;
          } else if (type === ":") {
            colon = true;
          }
        } else if (type === brackets[brackets.length - 1]) {
          brackets.pop();
          if (brackets.length === 0) bracket = null;
        }
        token = this.tokenizer.nextToken();
      }
      if (this.tokenizer.endOfFile()) end = true;
      if (brackets.length > 0) this.unclosedBracket(bracket);
      if (end && colon) {
        if (!customProperty) {
          while (tokens.length) {
            token = tokens[tokens.length - 1][0];
            if (token !== "space" && token !== "comment") break;
            this.tokenizer.back(tokens.pop());
          }
        }
        this.decl(tokens, customProperty);
      } else {
        this.unknownWord(tokens);
      }
    }
    parse() {
      let token;
      while (!this.tokenizer.endOfFile()) {
        token = this.tokenizer.nextToken();
        switch (token[0]) {
          case "space":
            this.spaces += token[1];
            break;
          case ";":
            this.freeSemicolon(token);
            break;
          case "}":
            this.end(token);
            break;
          case "comment":
            this.comment(token);
            break;
          case "at-word":
            this.atrule(token);
            break;
          case "{":
            this.emptyRule(token);
            break;
          default:
            this.other(token);
            break;
        }
      }
      this.endFile();
    }
    precheckMissedSemicolon() {
    }
    raw(node2, prop, tokens, customProperty) {
      let token, type;
      let length = tokens.length;
      let value = "";
      let clean = true;
      let next, prev;
      for (let i2 = 0; i2 < length; i2 += 1) {
        token = tokens[i2];
        type = token[0];
        if (type === "space" && i2 === length - 1 && !customProperty) {
          clean = false;
        } else if (type === "comment") {
          prev = tokens[i2 - 1] ? tokens[i2 - 1][0] : "empty";
          next = tokens[i2 + 1] ? tokens[i2 + 1][0] : "empty";
          if (!SAFE_COMMENT_NEIGHBOR[prev] && !SAFE_COMMENT_NEIGHBOR[next]) {
            if (value.slice(-1) === ",") {
              clean = false;
            } else {
              value += token[1];
            }
          } else {
            clean = false;
          }
        } else {
          value += token[1];
        }
      }
      if (!clean) {
        let raw = tokens.reduce((all, i2) => all + i2[1], "");
        node2.raws[prop] = { raw, value };
      }
      node2[prop] = value;
    }
    rule(tokens) {
      tokens.pop();
      let node2 = new Rule();
      this.init(node2, tokens[0][2]);
      node2.raws.between = this.spacesAndCommentsFromEnd(tokens);
      this.raw(node2, "selector", tokens);
      this.current = node2;
    }
    spacesAndCommentsFromEnd(tokens) {
      let lastTokenType;
      let spaces = "";
      while (tokens.length) {
        lastTokenType = tokens[tokens.length - 1][0];
        if (lastTokenType !== "space" && lastTokenType !== "comment") break;
        spaces = tokens.pop()[1] + spaces;
      }
      return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
      let next;
      let spaces = "";
      while (tokens.length) {
        next = tokens[0][0];
        if (next !== "space" && next !== "comment") break;
        spaces += tokens.shift()[1];
      }
      return spaces;
    }
    spacesFromEnd(tokens) {
      let lastTokenType;
      let spaces = "";
      while (tokens.length) {
        lastTokenType = tokens[tokens.length - 1][0];
        if (lastTokenType !== "space") break;
        spaces = tokens.pop()[1] + spaces;
      }
      return spaces;
    }
    stringFrom(tokens, from) {
      let result2 = "";
      for (let i2 = from; i2 < tokens.length; i2++) {
        result2 += tokens[i2][1];
      }
      tokens.splice(from, tokens.length - from);
      return result2;
    }
    unclosedBlock() {
      let pos = this.current.source.start;
      throw this.input.error("Unclosed block", pos.line, pos.column);
    }
    unclosedBracket(bracket) {
      throw this.input.error(
        "Unclosed bracket",
        { offset: bracket[2] },
        { offset: bracket[2] + 1 }
      );
    }
    unexpectedClose(token) {
      throw this.input.error(
        "Unexpected }",
        { offset: token[2] },
        { offset: token[2] + 1 }
      );
    }
    unknownWord(tokens) {
      throw this.input.error(
        "Unknown word " + tokens[0][1],
        { offset: tokens[0][2] },
        { offset: tokens[0][2] + tokens[0][1].length }
      );
    }
    unnamedAtrule(node2, token) {
      throw this.input.error(
        "At-rule without name",
        { offset: token[2] },
        { offset: token[2] + token[1].length }
      );
    }
  }
  parser = Parser2;
  return parser;
}
var parse_1;
var hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse_1;
  hasRequiredParse = 1;
  let Container = requireContainer();
  let Input = requireInput();
  let Parser2 = requireParser();
  function parse(css3, opts) {
    let input2 = new Input(css3, opts);
    let parser2 = new Parser2(input2);
    try {
      parser2.parse();
    } catch (e) {
      if (process.env.NODE_ENV !== "production") {
        if (e.name === "CssSyntaxError" && opts && opts.from) {
          if (/\.scss$/i.test(opts.from)) {
            e.message += "\nYou tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser";
          } else if (/\.sass/i.test(opts.from)) {
            e.message += "\nYou tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser";
          } else if (/\.less$/i.test(opts.from)) {
            e.message += "\nYou tried to parse Less with the standard CSS parser; try again with the postcss-less parser";
          }
        }
      }
      throw e;
    }
    return parser2.root;
  }
  parse_1 = parse;
  parse.default = parse;
  Container.registerParse(parse);
  return parse_1;
}
var warning;
var hasRequiredWarning;
function requireWarning() {
  if (hasRequiredWarning) return warning;
  hasRequiredWarning = 1;
  class Warning {
    constructor(text, opts = {}) {
      this.type = "warning";
      this.text = text;
      if (opts.node && opts.node.source) {
        let range = opts.node.rangeBy(opts);
        this.line = range.start.line;
        this.column = range.start.column;
        this.endLine = range.end.line;
        this.endColumn = range.end.column;
      }
      for (let opt in opts) this[opt] = opts[opt];
    }
    toString() {
      if (this.node) {
        return this.node.error(this.text, {
          index: this.index,
          plugin: this.plugin,
          word: this.word
        }).message;
      }
      if (this.plugin) {
        return this.plugin + ": " + this.text;
      }
      return this.text;
    }
  }
  warning = Warning;
  Warning.default = Warning;
  return warning;
}
var result;
var hasRequiredResult;
function requireResult() {
  if (hasRequiredResult) return result;
  hasRequiredResult = 1;
  let Warning = requireWarning();
  class Result {
    get content() {
      return this.css;
    }
    constructor(processor2, root2, opts) {
      this.processor = processor2;
      this.messages = [];
      this.root = root2;
      this.opts = opts;
      this.css = "";
      this.map = void 0;
    }
    toString() {
      return this.css;
    }
    warn(text, opts = {}) {
      if (!opts.plugin) {
        if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
          opts.plugin = this.lastPlugin.postcssPlugin;
        }
      }
      let warning2 = new Warning(text, opts);
      this.messages.push(warning2);
      return warning2;
    }
    warnings() {
      return this.messages.filter((i2) => i2.type === "warning");
    }
  }
  result = Result;
  Result.default = Result;
  return result;
}
var warnOnce;
var hasRequiredWarnOnce;
function requireWarnOnce() {
  if (hasRequiredWarnOnce) return warnOnce;
  hasRequiredWarnOnce = 1;
  let printed = {};
  warnOnce = function warnOnce2(message) {
    if (printed[message]) return;
    printed[message] = true;
    if (typeof console !== "undefined" && console.warn) {
      console.warn(message);
    }
  };
  return warnOnce;
}
var lazyResult;
var hasRequiredLazyResult;
function requireLazyResult() {
  if (hasRequiredLazyResult) return lazyResult;
  hasRequiredLazyResult = 1;
  let Container = requireContainer();
  let Document = requireDocument();
  let MapGenerator = requireMapGenerator();
  let parse = requireParse();
  let Result = requireResult();
  let Root = requireRoot();
  let stringify2 = requireStringify();
  let { isClean, my } = requireSymbols();
  let warnOnce2 = requireWarnOnce();
  const TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
  };
  const PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
  };
  const NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
  };
  const CHILDREN = 0;
  function isPromise(obj) {
    return typeof obj === "object" && typeof obj.then === "function";
  }
  function getEvents(node2) {
    let key = false;
    let type = TYPE_TO_CLASS_NAME[node2.type];
    if (node2.type === "decl") {
      key = node2.prop.toLowerCase();
    } else if (node2.type === "atrule") {
      key = node2.name.toLowerCase();
    }
    if (key && node2.append) {
      return [
        type,
        type + "-" + key,
        CHILDREN,
        type + "Exit",
        type + "Exit-" + key
      ];
    } else if (key) {
      return [type, type + "-" + key, type + "Exit", type + "Exit-" + key];
    } else if (node2.append) {
      return [type, CHILDREN, type + "Exit"];
    } else {
      return [type, type + "Exit"];
    }
  }
  function toStack(node2) {
    let events;
    if (node2.type === "document") {
      events = ["Document", CHILDREN, "DocumentExit"];
    } else if (node2.type === "root") {
      events = ["Root", CHILDREN, "RootExit"];
    } else {
      events = getEvents(node2);
    }
    return {
      eventIndex: 0,
      events,
      iterator: 0,
      node: node2,
      visitorIndex: 0,
      visitors: []
    };
  }
  function cleanMarks(node2) {
    node2[isClean] = false;
    if (node2.nodes) node2.nodes.forEach((i2) => cleanMarks(i2));
    return node2;
  }
  let postcss = {};
  class LazyResult {
    get content() {
      return this.stringify().content;
    }
    get css() {
      return this.stringify().css;
    }
    get map() {
      return this.stringify().map;
    }
    get messages() {
      return this.sync().messages;
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      return this.sync().root;
    }
    get [Symbol.toStringTag]() {
      return "LazyResult";
    }
    constructor(processor2, css3, opts) {
      this.stringified = false;
      this.processed = false;
      let root2;
      if (typeof css3 === "object" && css3 !== null && (css3.type === "root" || css3.type === "document")) {
        root2 = cleanMarks(css3);
      } else if (css3 instanceof LazyResult || css3 instanceof Result) {
        root2 = cleanMarks(css3.root);
        if (css3.map) {
          if (typeof opts.map === "undefined") opts.map = {};
          if (!opts.map.inline) opts.map.inline = false;
          opts.map.prev = css3.map;
        }
      } else {
        let parser2 = parse;
        if (opts.syntax) parser2 = opts.syntax.parse;
        if (opts.parser) parser2 = opts.parser;
        if (parser2.parse) parser2 = parser2.parse;
        try {
          root2 = parser2(css3, opts);
        } catch (error) {
          this.processed = true;
          this.error = error;
        }
        if (root2 && !root2[my]) {
          Container.rebuild(root2);
        }
      }
      this.result = new Result(processor2, root2, opts);
      this.helpers = { ...postcss, postcss, result: this.result };
      this.plugins = this.processor.plugins.map((plugin) => {
        if (typeof plugin === "object" && plugin.prepare) {
          return { ...plugin, ...plugin.prepare(this.result) };
        } else {
          return plugin;
        }
      });
    }
    async() {
      if (this.error) return Promise.reject(this.error);
      if (this.processed) return Promise.resolve(this.result);
      if (!this.processing) {
        this.processing = this.runAsync();
      }
      return this.processing;
    }
    catch(onRejected) {
      return this.async().catch(onRejected);
    }
    finally(onFinally) {
      return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
      throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(error, node2) {
      let plugin = this.result.lastPlugin;
      try {
        if (node2) node2.addToError(error);
        this.error = error;
        if (error.name === "CssSyntaxError" && !error.plugin) {
          error.plugin = plugin.postcssPlugin;
          error.setMessage();
        } else if (plugin.postcssVersion) {
          if (process.env.NODE_ENV !== "production") {
            let pluginName = plugin.postcssPlugin;
            let pluginVer = plugin.postcssVersion;
            let runtimeVer = this.result.processor.version;
            let a2 = pluginVer.split(".");
            let b2 = runtimeVer.split(".");
            if (a2[0] !== b2[0] || parseInt(a2[1]) > parseInt(b2[1])) {
              console.error(
                "Unknown error from PostCSS plugin. Your current PostCSS version is " + runtimeVer + ", but " + pluginName + " uses " + pluginVer + ". Perhaps this is the source of the error below."
              );
            }
          }
        }
      } catch (err) {
        if (console && console.error) console.error(err);
      }
      return error;
    }
    prepareVisitors() {
      this.listeners = {};
      let add = (plugin, type, cb) => {
        if (!this.listeners[type]) this.listeners[type] = [];
        this.listeners[type].push([plugin, cb]);
      };
      for (let plugin of this.plugins) {
        if (typeof plugin === "object") {
          for (let event in plugin) {
            if (!PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) {
              throw new Error(
                `Unknown event ${event} in ${plugin.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
              );
            }
            if (!NOT_VISITORS[event]) {
              if (typeof plugin[event] === "object") {
                for (let filter in plugin[event]) {
                  if (filter === "*") {
                    add(plugin, event, plugin[event][filter]);
                  } else {
                    add(
                      plugin,
                      event + "-" + filter.toLowerCase(),
                      plugin[event][filter]
                    );
                  }
                }
              } else if (typeof plugin[event] === "function") {
                add(plugin, event, plugin[event]);
              }
            }
          }
        }
      }
      this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
      this.plugin = 0;
      for (let i2 = 0; i2 < this.plugins.length; i2++) {
        let plugin = this.plugins[i2];
        let promise = this.runOnRoot(plugin);
        if (isPromise(promise)) {
          try {
            await promise;
          } catch (error) {
            throw this.handleError(error);
          }
        }
      }
      this.prepareVisitors();
      if (this.hasListener) {
        let root2 = this.result.root;
        while (!root2[isClean]) {
          root2[isClean] = true;
          let stack = [toStack(root2)];
          while (stack.length > 0) {
            let promise = this.visitTick(stack);
            if (isPromise(promise)) {
              try {
                await promise;
              } catch (e) {
                let node2 = stack[stack.length - 1].node;
                throw this.handleError(e, node2);
              }
            }
          }
        }
        if (this.listeners.OnceExit) {
          for (let [plugin, visitor] of this.listeners.OnceExit) {
            this.result.lastPlugin = plugin;
            try {
              if (root2.type === "document") {
                let roots = root2.nodes.map(
                  (subRoot) => visitor(subRoot, this.helpers)
                );
                await Promise.all(roots);
              } else {
                await visitor(root2, this.helpers);
              }
            } catch (e) {
              throw this.handleError(e);
            }
          }
        }
      }
      this.processed = true;
      return this.stringify();
    }
    runOnRoot(plugin) {
      this.result.lastPlugin = plugin;
      try {
        if (typeof plugin === "object" && plugin.Once) {
          if (this.result.root.type === "document") {
            let roots = this.result.root.nodes.map(
              (root2) => plugin.Once(root2, this.helpers)
            );
            if (isPromise(roots[0])) {
              return Promise.all(roots);
            }
            return roots;
          }
          return plugin.Once(this.result.root, this.helpers);
        } else if (typeof plugin === "function") {
          return plugin(this.result.root, this.result);
        }
      } catch (error) {
        throw this.handleError(error);
      }
    }
    stringify() {
      if (this.error) throw this.error;
      if (this.stringified) return this.result;
      this.stringified = true;
      this.sync();
      let opts = this.result.opts;
      let str = stringify2;
      if (opts.syntax) str = opts.syntax.stringify;
      if (opts.stringifier) str = opts.stringifier;
      if (str.stringify) str = str.stringify;
      let map = new MapGenerator(str, this.result.root, this.result.opts);
      let data = map.generate();
      this.result.css = data[0];
      this.result.map = data[1];
      return this.result;
    }
    sync() {
      if (this.error) throw this.error;
      if (this.processed) return this.result;
      this.processed = true;
      if (this.processing) {
        throw this.getAsyncError();
      }
      for (let plugin of this.plugins) {
        let promise = this.runOnRoot(plugin);
        if (isPromise(promise)) {
          throw this.getAsyncError();
        }
      }
      this.prepareVisitors();
      if (this.hasListener) {
        let root2 = this.result.root;
        while (!root2[isClean]) {
          root2[isClean] = true;
          this.walkSync(root2);
        }
        if (this.listeners.OnceExit) {
          if (root2.type === "document") {
            for (let subRoot of root2.nodes) {
              this.visitSync(this.listeners.OnceExit, subRoot);
            }
          } else {
            this.visitSync(this.listeners.OnceExit, root2);
          }
        }
      }
      return this.result;
    }
    then(onFulfilled, onRejected) {
      if (process.env.NODE_ENV !== "production") {
        if (!("from" in this.opts)) {
          warnOnce2(
            "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
          );
        }
      }
      return this.async().then(onFulfilled, onRejected);
    }
    toString() {
      return this.css;
    }
    visitSync(visitors, node2) {
      for (let [plugin, visitor] of visitors) {
        this.result.lastPlugin = plugin;
        let promise;
        try {
          promise = visitor(node2, this.helpers);
        } catch (e) {
          throw this.handleError(e, node2.proxyOf);
        }
        if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
          return true;
        }
        if (isPromise(promise)) {
          throw this.getAsyncError();
        }
      }
    }
    visitTick(stack) {
      let visit = stack[stack.length - 1];
      let { node: node2, visitors } = visit;
      if (node2.type !== "root" && node2.type !== "document" && !node2.parent) {
        stack.pop();
        return;
      }
      if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
        let [plugin, visitor] = visitors[visit.visitorIndex];
        visit.visitorIndex += 1;
        if (visit.visitorIndex === visitors.length) {
          visit.visitors = [];
          visit.visitorIndex = 0;
        }
        this.result.lastPlugin = plugin;
        try {
          return visitor(node2.toProxy(), this.helpers);
        } catch (e) {
          throw this.handleError(e, node2);
        }
      }
      if (visit.iterator !== 0) {
        let iterator = visit.iterator;
        let child;
        while (child = node2.nodes[node2.indexes[iterator]]) {
          node2.indexes[iterator] += 1;
          if (!child[isClean]) {
            child[isClean] = true;
            stack.push(toStack(child));
            return;
          }
        }
        visit.iterator = 0;
        delete node2.indexes[iterator];
      }
      let events = visit.events;
      while (visit.eventIndex < events.length) {
        let event = events[visit.eventIndex];
        visit.eventIndex += 1;
        if (event === CHILDREN) {
          if (node2.nodes && node2.nodes.length) {
            node2[isClean] = true;
            visit.iterator = node2.getIterator();
          }
          return;
        } else if (this.listeners[event]) {
          visit.visitors = this.listeners[event];
          return;
        }
      }
      stack.pop();
    }
    walkSync(node2) {
      node2[isClean] = true;
      let events = getEvents(node2);
      for (let event of events) {
        if (event === CHILDREN) {
          if (node2.nodes) {
            node2.each((child) => {
              if (!child[isClean]) this.walkSync(child);
            });
          }
        } else {
          let visitors = this.listeners[event];
          if (visitors) {
            if (this.visitSync(visitors, node2.toProxy())) return;
          }
        }
      }
    }
    warnings() {
      return this.sync().warnings();
    }
  }
  LazyResult.registerPostcss = (dependant) => {
    postcss = dependant;
  };
  lazyResult = LazyResult;
  LazyResult.default = LazyResult;
  Root.registerLazyResult(LazyResult);
  Document.registerLazyResult(LazyResult);
  return lazyResult;
}
var noWorkResult;
var hasRequiredNoWorkResult;
function requireNoWorkResult() {
  if (hasRequiredNoWorkResult) return noWorkResult;
  hasRequiredNoWorkResult = 1;
  let MapGenerator = requireMapGenerator();
  let parse = requireParse();
  const Result = requireResult();
  let stringify2 = requireStringify();
  let warnOnce2 = requireWarnOnce();
  class NoWorkResult {
    get content() {
      return this.result.css;
    }
    get css() {
      return this.result.css;
    }
    get map() {
      return this.result.map;
    }
    get messages() {
      return [];
    }
    get opts() {
      return this.result.opts;
    }
    get processor() {
      return this.result.processor;
    }
    get root() {
      if (this._root) {
        return this._root;
      }
      let root2;
      let parser2 = parse;
      try {
        root2 = parser2(this._css, this._opts);
      } catch (error) {
        this.error = error;
      }
      if (this.error) {
        throw this.error;
      } else {
        this._root = root2;
        return root2;
      }
    }
    get [Symbol.toStringTag]() {
      return "NoWorkResult";
    }
    constructor(processor2, css3, opts) {
      css3 = css3.toString();
      this.stringified = false;
      this._processor = processor2;
      this._css = css3;
      this._opts = opts;
      this._map = void 0;
      let root2;
      let str = stringify2;
      this.result = new Result(this._processor, root2, this._opts);
      this.result.css = css3;
      let self = this;
      Object.defineProperty(this.result, "root", {
        get() {
          return self.root;
        }
      });
      let map = new MapGenerator(str, root2, this._opts, css3);
      if (map.isMap()) {
        let [generatedCSS, generatedMap] = map.generate();
        if (generatedCSS) {
          this.result.css = generatedCSS;
        }
        if (generatedMap) {
          this.result.map = generatedMap;
        }
      } else {
        map.clearAnnotation();
        this.result.css = map.css;
      }
    }
    async() {
      if (this.error) return Promise.reject(this.error);
      return Promise.resolve(this.result);
    }
    catch(onRejected) {
      return this.async().catch(onRejected);
    }
    finally(onFinally) {
      return this.async().then(onFinally, onFinally);
    }
    sync() {
      if (this.error) throw this.error;
      return this.result;
    }
    then(onFulfilled, onRejected) {
      if (process.env.NODE_ENV !== "production") {
        if (!("from" in this._opts)) {
          warnOnce2(
            "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
          );
        }
      }
      return this.async().then(onFulfilled, onRejected);
    }
    toString() {
      return this._css;
    }
    warnings() {
      return [];
    }
  }
  noWorkResult = NoWorkResult;
  NoWorkResult.default = NoWorkResult;
  return noWorkResult;
}
var processor;
var hasRequiredProcessor;
function requireProcessor() {
  if (hasRequiredProcessor) return processor;
  hasRequiredProcessor = 1;
  let Document = requireDocument();
  let LazyResult = requireLazyResult();
  let NoWorkResult = requireNoWorkResult();
  let Root = requireRoot();
  class Processor {
    constructor(plugins = []) {
      this.version = "8.5.6";
      this.plugins = this.normalize(plugins);
    }
    normalize(plugins) {
      let normalized = [];
      for (let i2 of plugins) {
        if (i2.postcss === true) {
          i2 = i2();
        } else if (i2.postcss) {
          i2 = i2.postcss;
        }
        if (typeof i2 === "object" && Array.isArray(i2.plugins)) {
          normalized = normalized.concat(i2.plugins);
        } else if (typeof i2 === "object" && i2.postcssPlugin) {
          normalized.push(i2);
        } else if (typeof i2 === "function") {
          normalized.push(i2);
        } else if (typeof i2 === "object" && (i2.parse || i2.stringify)) {
          if (process.env.NODE_ENV !== "production") {
            throw new Error(
              "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
            );
          }
        } else {
          throw new Error(i2 + " is not a PostCSS plugin");
        }
      }
      return normalized;
    }
    process(css3, opts = {}) {
      if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) {
        return new NoWorkResult(this, css3, opts);
      } else {
        return new LazyResult(this, css3, opts);
      }
    }
    use(plugin) {
      this.plugins = this.plugins.concat(this.normalize([plugin]));
      return this;
    }
  }
  processor = Processor;
  Processor.default = Processor;
  Root.registerProcessor(Processor);
  Document.registerProcessor(Processor);
  return processor;
}
var postcss_1;
var hasRequiredPostcss;
function requirePostcss() {
  if (hasRequiredPostcss) return postcss_1;
  hasRequiredPostcss = 1;
  let AtRule = requireAtRule();
  let Comment = requireComment();
  let Container = requireContainer();
  let CssSyntaxError = requireCssSyntaxError();
  let Declaration = requireDeclaration();
  let Document = requireDocument();
  let fromJSON = requireFromJSON();
  let Input = requireInput();
  let LazyResult = requireLazyResult();
  let list = requireList();
  let Node = requireNode();
  let parse = requireParse();
  let Processor = requireProcessor();
  let Result = requireResult();
  let Root = requireRoot();
  let Rule = requireRule();
  let stringify2 = requireStringify();
  let Warning = requireWarning();
  function postcss(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) {
      plugins = plugins[0];
    }
    return new Processor(plugins);
  }
  postcss.plugin = function plugin(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
      if (console && console.warn && !warningPrinted) {
        warningPrinted = true;
        console.warn(
          name + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration"
        );
        if (process.env.LANG && process.env.LANG.startsWith("cn")) {
          console.warn(
            name + ": 里面 postcss.plugin 被弃用. 迁移指南:\nhttps://www.w3ctech.com/topic/2226"
          );
        }
      }
      let transformer = initializer(...args);
      transformer.postcssPlugin = name;
      transformer.postcssVersion = new Processor().version;
      return transformer;
    }
    let cache;
    Object.defineProperty(creator, "postcss", {
      get() {
        if (!cache) cache = creator();
        return cache;
      }
    });
    creator.process = function(css3, processOpts, pluginOpts) {
      return postcss([creator(pluginOpts)]).process(css3, processOpts);
    };
    return creator;
  };
  postcss.stringify = stringify2;
  postcss.parse = parse;
  postcss.fromJSON = fromJSON;
  postcss.list = list;
  postcss.comment = (defaults) => new Comment(defaults);
  postcss.atRule = (defaults) => new AtRule(defaults);
  postcss.decl = (defaults) => new Declaration(defaults);
  postcss.rule = (defaults) => new Rule(defaults);
  postcss.root = (defaults) => new Root(defaults);
  postcss.document = (defaults) => new Document(defaults);
  postcss.CssSyntaxError = CssSyntaxError;
  postcss.Declaration = Declaration;
  postcss.Container = Container;
  postcss.Processor = Processor;
  postcss.Document = Document;
  postcss.Comment = Comment;
  postcss.Warning = Warning;
  postcss.AtRule = AtRule;
  postcss.Result = Result;
  postcss.Input = Input;
  postcss.Rule = Rule;
  postcss.Root = Root;
  postcss.Node = Node;
  LazyResult.registerPostcss(postcss);
  postcss_1 = postcss;
  postcss.default = postcss;
  return postcss_1;
}
var sanitizeHtml_1;
var hasRequiredSanitizeHtml;
function requireSanitizeHtml() {
  if (hasRequiredSanitizeHtml) return sanitizeHtml_1;
  hasRequiredSanitizeHtml = 1;
  const htmlparser = /* @__PURE__ */ requireLib();
  const escapeStringRegexp2 = requireEscapeStringRegexp();
  const { isPlainObject: isPlainObject2 } = requireIsPlainObject();
  const deepmerge = requireCjs();
  const parseSrcset2 = requireParseSrcset();
  const { parse: postcssParse } = requirePostcss();
  const mediaTags = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
  ];
  const vulnerableTags = ["script", "style"];
  function each(obj, cb) {
    if (obj) {
      Object.keys(obj).forEach(function(key) {
        cb(obj[key], key);
      });
    }
  }
  function has(obj, key) {
    return {}.hasOwnProperty.call(obj, key);
  }
  function filter(a2, cb) {
    const n = [];
    each(a2, function(v2) {
      if (cb(v2)) {
        n.push(v2);
      }
    });
    return n;
  }
  function isEmptyObject(obj) {
    for (const key in obj) {
      if (has(obj, key)) {
        return false;
      }
    }
    return true;
  }
  function stringifySrcset(parsedSrcset) {
    return parsedSrcset.map(function(part) {
      if (!part.url) {
        throw new Error("URL missing");
      }
      return part.url + (part.w ? ` ${part.w}w` : "") + (part.h ? ` ${part.h}h` : "") + (part.d ? ` ${part.d}x` : "");
    }).join(", ");
  }
  sanitizeHtml_1 = sanitizeHtml2;
  const VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;
  function sanitizeHtml2(html, options, _recursing) {
    if (html == null) {
      return "";
    }
    if (typeof html === "number") {
      html = html.toString();
    }
    let result2 = "";
    let tempResult = "";
    function Frame(tag, attribs) {
      const that = this;
      this.tag = tag;
      this.attribs = attribs || {};
      this.tagPosition = result2.length;
      this.text = "";
      this.openingTagLength = 0;
      this.mediaChildren = [];
      this.updateParentNodeText = function() {
        if (stack.length) {
          const parentFrame = stack[stack.length - 1];
          parentFrame.text += that.text;
        }
      };
      this.updateParentNodeMediaChildren = function() {
        if (stack.length && mediaTags.includes(this.tag)) {
          const parentFrame = stack[stack.length - 1];
          parentFrame.mediaChildren.push(this.tag);
        }
      };
    }
    options = Object.assign({}, sanitizeHtml2.defaults, options);
    options.parser = Object.assign({}, htmlParserDefaults, options.parser);
    const tagAllowed = function(name) {
      return options.allowedTags === false || (options.allowedTags || []).indexOf(name) > -1;
    };
    vulnerableTags.forEach(function(tag) {
      if (tagAllowed(tag) && !options.allowVulnerableTags) {
        console.warn(`

⚠️ Your \`allowedTags\` option includes, \`${tag}\`, which is inherently
vulnerable to XSS attacks. Please remove it from \`allowedTags\`.
Or, to disable this warning, add the \`allowVulnerableTags\` option
and ensure you are accounting for this risk.

`);
      }
    });
    const nonTextTagsArray = options.nonTextTags || [
      "script",
      "style",
      "textarea",
      "option"
    ];
    let allowedAttributesMap;
    let allowedAttributesGlobMap;
    if (options.allowedAttributes) {
      allowedAttributesMap = {};
      allowedAttributesGlobMap = {};
      each(options.allowedAttributes, function(attributes, tag) {
        allowedAttributesMap[tag] = [];
        const globRegex = [];
        attributes.forEach(function(obj) {
          if (typeof obj === "string" && obj.indexOf("*") >= 0) {
            globRegex.push(escapeStringRegexp2(obj).replace(/\\\*/g, ".*"));
          } else {
            allowedAttributesMap[tag].push(obj);
          }
        });
        if (globRegex.length) {
          allowedAttributesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
        }
      });
    }
    const allowedClassesMap = {};
    const allowedClassesGlobMap = {};
    const allowedClassesRegexMap = {};
    each(options.allowedClasses, function(classes2, tag) {
      if (allowedAttributesMap) {
        if (!has(allowedAttributesMap, tag)) {
          allowedAttributesMap[tag] = [];
        }
        allowedAttributesMap[tag].push("class");
      }
      allowedClassesMap[tag] = classes2;
      if (Array.isArray(classes2)) {
        const globRegex = [];
        allowedClassesMap[tag] = [];
        allowedClassesRegexMap[tag] = [];
        classes2.forEach(function(obj) {
          if (typeof obj === "string" && obj.indexOf("*") >= 0) {
            globRegex.push(escapeStringRegexp2(obj).replace(/\\\*/g, ".*"));
          } else if (obj instanceof RegExp) {
            allowedClassesRegexMap[tag].push(obj);
          } else {
            allowedClassesMap[tag].push(obj);
          }
        });
        if (globRegex.length) {
          allowedClassesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
        }
      }
    });
    const transformTagsMap = {};
    let transformTagsAll;
    each(options.transformTags, function(transform, tag) {
      let transFun;
      if (typeof transform === "function") {
        transFun = transform;
      } else if (typeof transform === "string") {
        transFun = sanitizeHtml2.simpleTransform(transform);
      }
      if (tag === "*") {
        transformTagsAll = transFun;
      } else {
        transformTagsMap[tag] = transFun;
      }
    });
    let depth;
    let stack;
    let skipMap;
    let transformMap;
    let skipText;
    let skipTextDepth;
    let addedText = false;
    initializeState();
    const parser2 = new htmlparser.Parser({
      onopentag: function(name, attribs) {
        if (options.onOpenTag) {
          options.onOpenTag(name, attribs);
        }
        if (options.enforceHtmlBoundary && name === "html") {
          initializeState();
        }
        if (skipText) {
          skipTextDepth++;
          return;
        }
        const frame = new Frame(name, attribs);
        stack.push(frame);
        let skip = false;
        const hasText = !!frame.text;
        let transformedTag;
        if (has(transformTagsMap, name)) {
          transformedTag = transformTagsMap[name](name, attribs);
          frame.attribs = attribs = transformedTag.attribs;
          if (transformedTag.text !== void 0) {
            frame.innerText = transformedTag.text;
          }
          if (name !== transformedTag.tagName) {
            frame.name = name = transformedTag.tagName;
            transformMap[depth] = transformedTag.tagName;
          }
        }
        if (transformTagsAll) {
          transformedTag = transformTagsAll(name, attribs);
          frame.attribs = attribs = transformedTag.attribs;
          if (name !== transformedTag.tagName) {
            frame.name = name = transformedTag.tagName;
            transformMap[depth] = transformedTag.tagName;
          }
        }
        if (!tagAllowed(name) || options.disallowedTagsMode === "recursiveEscape" && !isEmptyObject(skipMap) || options.nestingLimit != null && depth >= options.nestingLimit) {
          skip = true;
          skipMap[depth] = true;
          if (options.disallowedTagsMode === "discard" || options.disallowedTagsMode === "completelyDiscard") {
            if (nonTextTagsArray.indexOf(name) !== -1) {
              skipText = true;
              skipTextDepth = 1;
            }
          }
        }
        depth++;
        if (skip) {
          if (options.disallowedTagsMode === "discard" || options.disallowedTagsMode === "completelyDiscard") {
            if (frame.innerText && !hasText) {
              const escaped = escapeHtml(frame.innerText);
              if (options.textFilter) {
                result2 += options.textFilter(escaped, name);
              } else {
                result2 += escaped;
              }
              addedText = true;
            }
            return;
          }
          tempResult = result2;
          result2 = "";
        }
        result2 += "<" + name;
        if (name === "script") {
          if (options.allowedScriptHostnames || options.allowedScriptDomains) {
            frame.innerText = "";
          }
        }
        const isBeingEscaped = skip && (options.disallowedTagsMode === "escape" || options.disallowedTagsMode === "recursiveEscape");
        const shouldPreserveEscapedAttributes = isBeingEscaped && options.preserveEscapedAttributes;
        if (shouldPreserveEscapedAttributes) {
          each(attribs, function(value, a2) {
            result2 += " " + a2 + '="' + escapeHtml(value || "", true) + '"';
          });
        } else if (!allowedAttributesMap || has(allowedAttributesMap, name) || allowedAttributesMap["*"]) {
          each(attribs, function(value, a2) {
            if (!VALID_HTML_ATTRIBUTE_NAME.test(a2)) {
              delete frame.attribs[a2];
              return;
            }
            if (value === "" && !options.allowedEmptyAttributes.includes(a2) && (options.nonBooleanAttributes.includes(a2) || options.nonBooleanAttributes.includes("*"))) {
              delete frame.attribs[a2];
              return;
            }
            let passedAllowedAttributesMapCheck = false;
            if (!allowedAttributesMap || has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a2) !== -1 || allowedAttributesMap["*"] && allowedAttributesMap["*"].indexOf(a2) !== -1 || has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a2) || allowedAttributesGlobMap["*"] && allowedAttributesGlobMap["*"].test(a2)) {
              passedAllowedAttributesMapCheck = true;
            } else if (allowedAttributesMap && allowedAttributesMap[name]) {
              for (const o of allowedAttributesMap[name]) {
                if (isPlainObject2(o) && o.name && o.name === a2) {
                  passedAllowedAttributesMapCheck = true;
                  let newValue = "";
                  if (o.multiple === true) {
                    const splitStrArray = value.split(" ");
                    for (const s2 of splitStrArray) {
                      if (o.values.indexOf(s2) !== -1) {
                        if (newValue === "") {
                          newValue = s2;
                        } else {
                          newValue += " " + s2;
                        }
                      }
                    }
                  } else if (o.values.indexOf(value) >= 0) {
                    newValue = value;
                  }
                  value = newValue;
                }
              }
            }
            if (passedAllowedAttributesMapCheck) {
              if (options.allowedSchemesAppliedToAttributes.indexOf(a2) !== -1) {
                if (naughtyHref(name, value)) {
                  delete frame.attribs[a2];
                  return;
                }
              }
              if (name === "script" && a2 === "src") {
                let allowed = true;
                try {
                  const parsed = parseUrl(value);
                  if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                    const allowedHostname = (options.allowedScriptHostnames || []).find(function(hostname) {
                      return hostname === parsed.url.hostname;
                    });
                    const allowedDomain = (options.allowedScriptDomains || []).find(function(domain) {
                      return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                    });
                    allowed = allowedHostname || allowedDomain;
                  }
                } catch (e) {
                  allowed = false;
                }
                if (!allowed) {
                  delete frame.attribs[a2];
                  return;
                }
              }
              if (name === "iframe" && a2 === "src") {
                let allowed = true;
                try {
                  const parsed = parseUrl(value);
                  if (parsed.isRelativeUrl) {
                    allowed = has(options, "allowIframeRelativeUrls") ? options.allowIframeRelativeUrls : !options.allowedIframeHostnames && !options.allowedIframeDomains;
                  } else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
                    const allowedHostname = (options.allowedIframeHostnames || []).find(function(hostname) {
                      return hostname === parsed.url.hostname;
                    });
                    const allowedDomain = (options.allowedIframeDomains || []).find(function(domain) {
                      return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                    });
                    allowed = allowedHostname || allowedDomain;
                  }
                } catch (e) {
                  allowed = false;
                }
                if (!allowed) {
                  delete frame.attribs[a2];
                  return;
                }
              }
              if (a2 === "srcset") {
                try {
                  let parsed = parseSrcset2(value);
                  parsed.forEach(function(value2) {
                    if (naughtyHref("srcset", value2.url)) {
                      value2.evil = true;
                    }
                  });
                  parsed = filter(parsed, function(v2) {
                    return !v2.evil;
                  });
                  if (!parsed.length) {
                    delete frame.attribs[a2];
                    return;
                  } else {
                    value = stringifySrcset(filter(parsed, function(v2) {
                      return !v2.evil;
                    }));
                    frame.attribs[a2] = value;
                  }
                } catch (e) {
                  delete frame.attribs[a2];
                  return;
                }
              }
              if (a2 === "class") {
                const allowedSpecificClasses = allowedClassesMap[name];
                const allowedWildcardClasses = allowedClassesMap["*"];
                const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
                const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
                const allowedWildcardClassesRegex = allowedClassesRegexMap["*"];
                const allowedWildcardClassesGlob = allowedClassesGlobMap["*"];
                const allowedClassesGlobs = [
                  allowedSpecificClassesGlob,
                  allowedWildcardClassesGlob
                ].concat(allowedSpecificClassesRegex, allowedWildcardClassesRegex).filter(function(t) {
                  return t;
                });
                if (allowedSpecificClasses && allowedWildcardClasses) {
                  value = filterClasses(value, deepmerge(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
                } else {
                  value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
                }
                if (!value.length) {
                  delete frame.attribs[a2];
                  return;
                }
              }
              if (a2 === "style") {
                if (options.parseStyleAttributes) {
                  try {
                    const abstractSyntaxTree = postcssParse(name + " {" + value + "}", { map: false });
                    const filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);
                    value = stringifyStyleAttributes(filteredAST);
                    if (value.length === 0) {
                      delete frame.attribs[a2];
                      return;
                    }
                  } catch (e) {
                    if (typeof window !== "undefined") {
                      console.warn('Failed to parse "' + name + " {" + value + `}", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547`);
                    }
                    delete frame.attribs[a2];
                    return;
                  }
                } else if (options.allowedStyles) {
                  throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
                }
              }
              result2 += " " + a2;
              if (value && value.length) {
                result2 += '="' + escapeHtml(value, true) + '"';
              } else if (options.allowedEmptyAttributes.includes(a2)) {
                result2 += '=""';
              }
            } else {
              delete frame.attribs[a2];
            }
          });
        }
        if (options.selfClosing.indexOf(name) !== -1) {
          result2 += " />";
        } else {
          result2 += ">";
          if (frame.innerText && !hasText && !options.textFilter) {
            result2 += escapeHtml(frame.innerText);
            addedText = true;
          }
        }
        if (skip) {
          result2 = tempResult + escapeHtml(result2);
          tempResult = "";
        }
        frame.openingTagLength = result2.length - frame.tagPosition;
      },
      ontext: function(text) {
        if (skipText) {
          return;
        }
        const lastFrame = stack[stack.length - 1];
        let tag;
        if (lastFrame) {
          tag = lastFrame.tag;
          text = lastFrame.innerText !== void 0 ? lastFrame.innerText : text;
        }
        if (options.disallowedTagsMode === "completelyDiscard" && !tagAllowed(tag)) {
          text = "";
        } else if ((options.disallowedTagsMode === "discard" || options.disallowedTagsMode === "completelyDiscard") && (tag === "script" || tag === "style")) {
          result2 += text;
        } else if (!addedText) {
          const escaped = escapeHtml(text, false);
          if (options.textFilter) {
            result2 += options.textFilter(escaped, tag);
          } else {
            result2 += escaped;
          }
        }
        if (stack.length) {
          const frame = stack[stack.length - 1];
          frame.text += text;
        }
      },
      onclosetag: function(name, isImplied) {
        if (options.onCloseTag) {
          options.onCloseTag(name, isImplied);
        }
        if (skipText) {
          skipTextDepth--;
          if (!skipTextDepth) {
            skipText = false;
          } else {
            return;
          }
        }
        const frame = stack.pop();
        if (!frame) {
          return;
        }
        if (frame.tag !== name) {
          stack.push(frame);
          return;
        }
        skipText = options.enforceHtmlBoundary ? name === "html" : false;
        depth--;
        const skip = skipMap[depth];
        if (skip) {
          delete skipMap[depth];
          if (options.disallowedTagsMode === "discard" || options.disallowedTagsMode === "completelyDiscard") {
            frame.updateParentNodeText();
            return;
          }
          tempResult = result2;
          result2 = "";
        }
        if (transformMap[depth]) {
          name = transformMap[depth];
          delete transformMap[depth];
        }
        if (options.exclusiveFilter) {
          const filterResult = options.exclusiveFilter(frame);
          if (filterResult === "excludeTag") {
            if (skip) {
              result2 = tempResult;
              tempResult = "";
            }
            result2 = result2.substring(0, frame.tagPosition) + result2.substring(frame.tagPosition + frame.openingTagLength);
            return;
          } else if (filterResult) {
            result2 = result2.substring(0, frame.tagPosition);
            return;
          }
        }
        frame.updateParentNodeMediaChildren();
        frame.updateParentNodeText();
        if (
          // Already output />
          options.selfClosing.indexOf(name) !== -1 || // Escaped tag, closing tag is implied
          isImplied && !tagAllowed(name) && ["escape", "recursiveEscape"].indexOf(options.disallowedTagsMode) >= 0
        ) {
          if (skip) {
            result2 = tempResult;
            tempResult = "";
          }
          return;
        }
        result2 += "</" + name + ">";
        if (skip) {
          result2 = tempResult + escapeHtml(result2);
          tempResult = "";
        }
        addedText = false;
      }
    }, options.parser);
    parser2.write(html);
    parser2.end();
    return result2;
    function initializeState() {
      result2 = "";
      depth = 0;
      stack = [];
      skipMap = {};
      transformMap = {};
      skipText = false;
      skipTextDepth = 0;
    }
    function escapeHtml(s2, quote) {
      if (typeof s2 !== "string") {
        s2 = s2 + "";
      }
      if (options.parser.decodeEntities) {
        s2 = s2.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        if (quote) {
          s2 = s2.replace(/"/g, "&quot;");
        }
      }
      s2 = s2.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      if (quote) {
        s2 = s2.replace(/"/g, "&quot;");
      }
      return s2;
    }
    function naughtyHref(name, href) {
      href = href.replace(/[\x00-\x20]+/g, "");
      while (true) {
        const firstIndex = href.indexOf("<!--");
        if (firstIndex === -1) {
          break;
        }
        const lastIndex = href.indexOf("-->", firstIndex + 4);
        if (lastIndex === -1) {
          break;
        }
        href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
      }
      const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
      if (!matches) {
        if (href.match(/^[/\\]{2}/)) {
          return !options.allowProtocolRelative;
        }
        return false;
      }
      const scheme = matches[1].toLowerCase();
      if (has(options.allowedSchemesByTag, name)) {
        return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
      }
      return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
    }
    function parseUrl(value) {
      value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//");
      if (value.startsWith("relative:")) {
        throw new Error("relative: exploit attempt");
      }
      let base = "relative://relative-site";
      for (let i2 = 0; i2 < 100; i2++) {
        base += `/${i2}`;
      }
      const parsed = new URL(value, base);
      const isRelativeUrl = parsed && parsed.hostname === "relative-site" && parsed.protocol === "relative:";
      return {
        isRelativeUrl,
        url: parsed
      };
    }
    function filterCss(abstractSyntaxTree, allowedStyles) {
      if (!allowedStyles) {
        return abstractSyntaxTree;
      }
      const astRules = abstractSyntaxTree.nodes[0];
      let selectedRule;
      if (allowedStyles[astRules.selector] && allowedStyles["*"]) {
        selectedRule = deepmerge(
          allowedStyles[astRules.selector],
          allowedStyles["*"]
        );
      } else {
        selectedRule = allowedStyles[astRules.selector] || allowedStyles["*"];
      }
      if (selectedRule) {
        abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
      }
      return abstractSyntaxTree;
    }
    function stringifyStyleAttributes(filteredAST) {
      return filteredAST.nodes[0].nodes.reduce(function(extractedAttributes, attrObject) {
        extractedAttributes.push(
          `${attrObject.prop}:${attrObject.value}${attrObject.important ? " !important" : ""}`
        );
        return extractedAttributes;
      }, []).join(";");
    }
    function filterDeclarations(selectedRule) {
      return function(allowedDeclarationsList, attributeObject) {
        if (has(selectedRule, attributeObject.prop)) {
          const matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
            return regularExpression.test(attributeObject.value);
          });
          if (matchesRegex) {
            allowedDeclarationsList.push(attributeObject);
          }
        }
        return allowedDeclarationsList;
      };
    }
    function filterClasses(classes2, allowed, allowedGlobs) {
      if (!allowed) {
        return classes2;
      }
      classes2 = classes2.split(/\s+/);
      return classes2.filter(function(clss) {
        return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
          return glob.test(clss);
        });
      }).join(" ");
    }
  }
  const htmlParserDefaults = {
    decodeEntities: true
  };
  sanitizeHtml2.defaults = {
    allowedTags: [
      // Sections derived from MDN element categories and limited to the more
      // benign categories.
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
      // Content sectioning
      "address",
      "article",
      "aside",
      "footer",
      "header",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hgroup",
      "main",
      "nav",
      "section",
      // Text content
      "blockquote",
      "dd",
      "div",
      "dl",
      "dt",
      "figcaption",
      "figure",
      "hr",
      "li",
      "menu",
      "ol",
      "p",
      "pre",
      "ul",
      // Inline text semantics
      "a",
      "abbr",
      "b",
      "bdi",
      "bdo",
      "br",
      "cite",
      "code",
      "data",
      "dfn",
      "em",
      "i",
      "kbd",
      "mark",
      "q",
      "rb",
      "rp",
      "rt",
      "rtc",
      "ruby",
      "s",
      "samp",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "time",
      "u",
      "var",
      "wbr",
      // Table content
      "caption",
      "col",
      "colgroup",
      "table",
      "tbody",
      "td",
      "tfoot",
      "th",
      "thead",
      "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
      "abbr",
      "accept",
      "accept-charset",
      "accesskey",
      "action",
      "allow",
      "alt",
      "as",
      "autocapitalize",
      "autocomplete",
      "blocking",
      "charset",
      "cite",
      "class",
      "color",
      "cols",
      "colspan",
      "content",
      "contenteditable",
      "coords",
      "crossorigin",
      "data",
      "datetime",
      "decoding",
      "dir",
      "dirname",
      "download",
      "draggable",
      "enctype",
      "enterkeyhint",
      "fetchpriority",
      "for",
      "form",
      "formaction",
      "formenctype",
      "formmethod",
      "formtarget",
      "headers",
      "height",
      "hidden",
      "high",
      "href",
      "hreflang",
      "http-equiv",
      "id",
      "imagesizes",
      "imagesrcset",
      "inputmode",
      "integrity",
      "is",
      "itemid",
      "itemprop",
      "itemref",
      "itemtype",
      "kind",
      "label",
      "lang",
      "list",
      "loading",
      "low",
      "max",
      "maxlength",
      "media",
      "method",
      "min",
      "minlength",
      "name",
      "nonce",
      "optimum",
      "pattern",
      "ping",
      "placeholder",
      "popover",
      "popovertarget",
      "popovertargetaction",
      "poster",
      "preload",
      "referrerpolicy",
      "rel",
      "rows",
      "rowspan",
      "sandbox",
      "scope",
      "shape",
      "size",
      "sizes",
      "slot",
      "span",
      "spellcheck",
      "src",
      "srcdoc",
      "srclang",
      "srcset",
      "start",
      "step",
      "style",
      "tabindex",
      "target",
      "title",
      "translate",
      "type",
      "usemap",
      "value",
      "width",
      "wrap",
      // Event handlers
      "onauxclick",
      "onafterprint",
      "onbeforematch",
      "onbeforeprint",
      "onbeforeunload",
      "onbeforetoggle",
      "onblur",
      "oncancel",
      "oncanplay",
      "oncanplaythrough",
      "onchange",
      "onclick",
      "onclose",
      "oncontextlost",
      "oncontextmenu",
      "oncontextrestored",
      "oncopy",
      "oncuechange",
      "oncut",
      "ondblclick",
      "ondrag",
      "ondragend",
      "ondragenter",
      "ondragleave",
      "ondragover",
      "ondragstart",
      "ondrop",
      "ondurationchange",
      "onemptied",
      "onended",
      "onerror",
      "onfocus",
      "onformdata",
      "onhashchange",
      "oninput",
      "oninvalid",
      "onkeydown",
      "onkeypress",
      "onkeyup",
      "onlanguagechange",
      "onload",
      "onloadeddata",
      "onloadedmetadata",
      "onloadstart",
      "onmessage",
      "onmessageerror",
      "onmousedown",
      "onmouseenter",
      "onmouseleave",
      "onmousemove",
      "onmouseout",
      "onmouseover",
      "onmouseup",
      "onoffline",
      "ononline",
      "onpagehide",
      "onpageshow",
      "onpaste",
      "onpause",
      "onplay",
      "onplaying",
      "onpopstate",
      "onprogress",
      "onratechange",
      "onreset",
      "onresize",
      "onrejectionhandled",
      "onscroll",
      "onscrollend",
      "onsecuritypolicyviolation",
      "onseeked",
      "onseeking",
      "onselect",
      "onslotchange",
      "onstalled",
      "onstorage",
      "onsubmit",
      "onsuspend",
      "ontimeupdate",
      "ontoggle",
      "onunhandledrejection",
      "onunload",
      "onvolumechange",
      "onwaiting",
      "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: ["href", "name", "target"],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
    },
    allowedEmptyAttributes: [
      "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
    // URL schemes we permit
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false,
    parseStyleAttributes: true,
    preserveEscapedAttributes: false
  };
  sanitizeHtml2.simpleTransform = function(newTagName, newAttribs, merge) {
    merge = merge === void 0 ? true : merge;
    newAttribs = newAttribs || {};
    return function(tagName, attribs) {
      let attrib;
      if (merge) {
        for (attrib in newAttribs) {
          attribs[attrib] = newAttribs[attrib];
        }
      } else {
        attribs = newAttribs;
      }
      return {
        tagName: newTagName,
        attribs
      };
    };
  };
  return sanitizeHtml_1;
}
var sanitizeHtmlExports = /* @__PURE__ */ requireSanitizeHtml();
const sanitizeHtml = /* @__PURE__ */ getDefaultExportFromCjs(sanitizeHtmlExports);
const _sfc_main$m = defineComponent({
  name: "DpsFormCheckboxGroup",
  components: {
    DpsFormCheckbox
  },
  props: {
    /**
     * The unique identifier for the checkbox group (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * modelValue of the checkbox group.
     * @default undefined
     */
    modelValue: {
      type: Array,
      required: false,
      default: void 0
    },
    /**
     * Name attribute of the checkboxes.
     * @default undefined
     */
    name: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Label for the checkbox group.
     * @default undefined
     */
    label: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Whether the label should be visually hidden.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Array of checkbox data to be displayed.
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Key to use for the checkbox values.
     * @default "value"
     */
    optionValue: {
      type: String,
      required: false,
      default: "value"
    },
    /**
     * Key to use for the checkbox labels.
     * @default "label"
     */
    optionLabel: {
      type: String,
      required: false,
      default: "label"
    },
    /**
     * Disables the checkbox group.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Checkboxes displayed in line.
     * @default false
     */
    inline: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Truncates the labels.
     * @default false
     */
    truncate: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Size of the checkboxes.
     * @default undefined
     */
    size: {
      type: String,
      required: false,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when one of the values changes.
     * @event module:DpsFormCheckboxGroup#update:modelValue
     */
    "update:modelValue"
  ],
  data() {
    return {
      selected: void 0
    };
  },
  computed: {
    mappedOptions() {
      const intermediateOptions = [];
      this.options.forEach((elem) => {
        let option = {};
        if (typeof elem !== "object") {
          option[this.optionValue] = elem;
          option[this.optionLabel] = elem;
        } else {
          option = JSON.parse(JSON.stringify(elem));
        }
        intermediateOptions.push(option);
      });
      return intermediateOptions;
    },
    uniqueId() {
      return this.id ? this.id : getUniqueId("dps-form-checkbox-group-");
    }
  },
  created() {
    this.selected = this.modelValue;
  },
  methods: {
    handleChange(value) {
      this.selected = value;
      this.$emit("update:modelValue", value);
    },
    getLabelContent(option) {
      const value = option[this.optionLabel];
      if (typeof value === "string") {
        return sanitizeHtml(value);
      }
      return value.toString();
    }
  }
});
const _hoisted_1$j = ["id"];
const _hoisted_2$f = { class: "dps-input-wrapper" };
const _hoisted_3$e = ["innerHTML"];
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpsFormCheckbox = resolveComponent("DpsFormCheckbox");
  return openBlock(), createElementBlock("fieldset", {
    id: _ctx.uniqueId,
    class: normalizeClass(["dps-form-checkbox-group", { "dps-form-checkbox-group--inline": _ctx.inline }])
  }, [
    _ctx.label ? (openBlock(), createElementBlock("legend", {
      key: 0,
      class: normalizeClass(["dps-label", { "visually-hidden": _ctx.hideLabel }])
    }, toDisplayString(_ctx.label), 3)) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_2$f, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.mappedOptions, (option, index) => {
        return openBlock(), createBlock(_component_DpsFormCheckbox, {
          id: _ctx.uniqueId + "-option-" + index,
          key: "option-" + index,
          name: _ctx.name,
          value: option[_ctx.optionValue],
          disabled: _ctx.disabled || option.disabled,
          readonly: option.readonly,
          error: option.error,
          block: !_ctx.inline,
          truncate: _ctx.truncate,
          tooltip: option.tooltip,
          size: _ctx.size,
          "model-value": _ctx.selected,
          "onUpdate:modelValue": _ctx.handleChange
        }, {
          default: withCtx(() => [
            createElementVNode("span", {
              innerHTML: _ctx.getLabelContent(option)
            }, null, 8, _hoisted_3$e)
          ]),
          _: 2
        }, 1032, ["id", "name", "value", "disabled", "readonly", "error", "block", "truncate", "tooltip", "size", "model-value", "onUpdate:modelValue"]);
      }), 128))
    ])
  ], 10, _hoisted_1$j);
}
const DpsFormCheckboxGroup = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$l]]);
const _sfc_main$l = defineComponent({
  name: "DpsFormGroup",
  props: {
    /**
     * Unique ID for the component (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Description text shown under the content.
     * @default undefined
     */
    description: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Label for the group.
     * @default undefined
     */
    label: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * ID of the element the label is for.
     * @default undefined
     */
    labelFor: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Whether the label should be visually hidden.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Text shown on success.
     * @default undefined
     */
    successFeedback: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Text shown on error.
     * @default undefined
     */
    errorFeedback: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Whether the input is valid or not.
     * `undefined` if the state is neutral.
     * @default undefined
     */
    valid: {
      type: Boolean,
      required: false,
      default: void 0
    },
    /**
     * Whether the group is disabled.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    uniqueId() {
      return this.id ? this.id : getUniqueId("dps-form-group-");
    },
    hasError() {
      return this.valid === false;
    },
    hasSuccess() {
      return this.valid === true;
    },
    ariaDescribedby() {
      const arr = [];
      if (this.description) {
        arr.push(this.uniqueId + "__description");
      }
      if (this.successFeedback && this.hasSuccess) {
        arr.push(this.uniqueId + "__success-feedback");
      }
      if (this.errorFeedback && this.hasError) {
        arr.push(this.uniqueId + "__error-feedback");
      }
      if (arr.length) {
        return arr.join(" ");
      }
      return void 0;
    }
  }
});
const _hoisted_1$i = ["id", "aria-invalid"];
const _hoisted_2$e = ["id", "for"];
const _hoisted_3$d = ["id"];
const _hoisted_4$8 = ["id"];
const _hoisted_5$6 = ["id"];
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    id: _ctx.uniqueId,
    class: normalizeClass(["dps-form-group", {
      "dps-form-group--disabled": _ctx.disabled
    }]),
    role: "group",
    "aria-invalid": _ctx.hasError ? "true" : void 0
  }, [
    _ctx.label ? (openBlock(), createElementBlock("label", {
      key: 0,
      id: _ctx.uniqueId + "__label",
      for: _ctx.labelFor,
      class: normalizeClass(["dps-form-group__label", { "visually-hidden": _ctx.hideLabel }])
    }, toDisplayString(_ctx.label), 11, _hoisted_2$e)) : createCommentVNode("", true),
    createElementVNode("div", null, [
      renderSlot(_ctx.$slots, "default", {
        slotProps: {
          success: _ctx.hasSuccess,
          error: _ctx.hasError,
          disabled: _ctx.disabled,
          description: _ctx.description,
          ariaDescribedby: _ctx.ariaDescribedby
        }
      }),
      _ctx.errorFeedback ? withDirectives((openBlock(), createElementBlock("div", {
        key: 0,
        id: _ctx.uniqueId + "__error-feedback",
        tabindex: "-1",
        "aria-live": "assertive",
        class: "dps-form-group__feedback dps-form-group__feedback--error"
      }, toDisplayString(_ctx.errorFeedback), 9, _hoisted_3$d)), [
        [vShow, _ctx.hasError]
      ]) : createCommentVNode("", true),
      _ctx.successFeedback ? withDirectives((openBlock(), createElementBlock("div", {
        key: 1,
        id: _ctx.uniqueId + "__success-feedback",
        tabindex: "-1",
        "aria-live": "assertive",
        class: "dps-form-group__feedback dps-form-group__feedback--success"
      }, toDisplayString(_ctx.successFeedback), 9, _hoisted_4$8)), [
        [vShow, _ctx.hasSuccess]
      ]) : createCommentVNode("", true),
      _ctx.description ? (openBlock(), createElementBlock("div", {
        key: 2,
        id: _ctx.uniqueId + "__description",
        tabindex: "-1",
        class: "dps-form-group__description"
      }, toDisplayString(_ctx.description), 9, _hoisted_5$6)) : createCommentVNode("", true)
    ])
  ], 10, _hoisted_1$i);
}
const DpsFormGroup = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$k]]);
const _sfc_main$k = defineComponent({
  name: "DpsFormInput",
  inheritAttrs: false,
  props: {
    /**
     * Unique ID of the input field.
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * ModelValue of the input.
     * @default undefined
     */
    modelValue: {
      type: [String, Number],
      required: false,
      default: void 0
    },
    /**
     * Icon displayed at the end of the input field.
     * @default undefined
     */
    icon: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Placeholder text.
     * @default undefined
     */
    placeholder: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Title attribute of the input.
     * @default undefined
     */
    title: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Makes the field readonly.
     * @default false
     */
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Disables the field.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * The maximum string length that the user can enter.
     * @default -1
     */
    maxlength: {
      type: Number,
      required: false,
      default: -1
    },
    /**
     * The type of the input field.
     * @default "text"
     */
    type: {
      type: String,
      required: false,
      default: "text"
    },
    /**
     * The step attribute specifying the granularity number values have to
     * adhere to.
     * @default 1
     */
    step: {
      type: Number,
      required: false,
      default: 1
    },
    /**
     * The minimum value to accept for this input.
     * @default undefined
     */
    min: {
      type: Number,
      required: false,
      default: void 0
    },
    /**
     * The maximum value to accept for this input.
     * @default undefined
     */
    max: {
      type: Number,
      required: false,
      default: void 0
    },
    /**
     * Pattern the value must match to be valid.
     * @default undefined
     */
    pattern: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Required field.
     * @default false
     */
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Aria label for the input.
     * @default undefined
     */
    ariaLabel: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * ID of the element that labels the input.
     * @default undefined
     */
    ariaLabelledby: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * ID of the element that describes the input.
     * @default undefined
     */
    ariaDescribedby: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Vertical size of the input field.
     * @default undefined
     */
    size: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Displays the success state.
     * @default false
     */
    success: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Displays the error state.
     * @default false
     */
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * For styling the node element
     * (fallthough attributes are added to the native form element)
     * @default ""
     */
    class: {
      type: String,
      required: false,
      default: ""
    }
  },
  emits: [
    /**
     * Emitted when the value changes.
     * @event module:DpsFormInput#update:modelValue
     */
    "update:modelValue",
    /**
     * Emitted on keyup.
     * @event module:DpsFormInput#keyup
     */
    "keyup",
    /**
     * Emitted on keydown.
     * @event module:DpsFormInput#keydown
     */
    "keydown",
    /**
     * Emitted on blur.
     * @event module:DpsFormInput#blur
     */
    "blur",
    /**
     * Emitted on focus.
     * @event module:DpsFormInput#focus
     */
    "focus"
  ],
  computed: {
    outerClass() {
      return this.class;
    },
    iconName() {
      if (this.icon) {
        return this.icon;
      }
      if (this.error) {
        return "error";
      } else if (this.success) {
        return "success";
      }
      return void 0;
    },
    showSearchCancelButton() {
      return this.type === "search" && typeof this.modelValue === "string" && this.modelValue?.length > 0;
    }
  },
  methods: {
    focus() {
      const input2 = this.$refs.input;
      input2.focus();
    },
    cancelSearch() {
      this.$emit("update:modelValue", "");
      this.focus();
    },
    handleInput(event) {
      const target = event.target;
      const value = target.value;
      this.$emit("update:modelValue", value);
    }
  }
});
const _hoisted_1$h = ["id", "value", "type", "step", "min", "max", "placeholder", "title", "pattern", "required", "readonly", "disabled", "maxlength", "aria-label", "aria-describedby", "aria-labelledby"];
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["dps-form-input dps-input-wrapper", {
      "dps-form-input--success": _ctx.success,
      "dps-form-input--error": _ctx.error,
      [_ctx.outerClass]: true
    }])
  }, [
    createElementVNode("input", mergeProps(_ctx.$attrs, {
      id: _ctx.id,
      ref: "input",
      value: _ctx.modelValue,
      class: ["dps-input", {
        "dps-input--success": _ctx.success,
        "dps-input--error": _ctx.error,
        "dps-input--size-sm": _ctx.size === "sm",
        "dps-input--icon": _ctx.iconName
      }],
      type: _ctx.type,
      step: _ctx.type === "number" ? _ctx.step : void 0,
      min: _ctx.type === "number" ? _ctx.min : void 0,
      max: _ctx.type === "number" ? _ctx.max : void 0,
      placeholder: _ctx.placeholder,
      title: _ctx.title,
      pattern: _ctx.pattern,
      required: _ctx.required,
      readonly: _ctx.readonly,
      disabled: _ctx.disabled,
      maxlength: _ctx.maxlength,
      "aria-label": _ctx.ariaLabel,
      "aria-describedby": _ctx.ariaDescribedby,
      "aria-labelledby": _ctx.ariaLabelledby,
      onKeyup: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("keyup", $event), ["stop"])),
      onKeydown: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.$emit("keydown", $event), ["stop"])),
      onBlur: _cache[2] || (_cache[2] = withModifiers(($event) => _ctx.$emit("blur", $event), ["stop"])),
      onFocus: _cache[3] || (_cache[3] = withModifiers(($event) => _ctx.$emit("focus", $event), ["stop"])),
      onInput: _cache[4] || (_cache[4] = (...args) => _ctx.handleInput && _ctx.handleInput(...args))
    }), null, 16, _hoisted_1$h),
    _ctx.showSearchCancelButton ? (openBlock(), createElementBlock("button", {
      key: 0,
      type: "button",
      class: "dps-form-input__search-cancel-button dps-icon dps-icon--close",
      title: "Eingabe zurücksetzen",
      onClick: _cache[5] || (_cache[5] = (...args) => _ctx.cancelSearch && _ctx.cancelSearch(...args))
    })) : _ctx.iconName ? (openBlock(), createElementBlock("span", {
      key: 1,
      class: normalizeClass(["dps-icon", "dps-icon--" + _ctx.iconName])
    }, null, 2)) : createCommentVNode("", true)
  ], 2);
}
const DpsFormInput = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$j]]);
const _sfc_main$j = defineComponent({
  name: "DpsFormRadio",
  props: {
    /**
     * Unique ID for the radio (optional)
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * ModelValue of the radio.
     * @default undefined
     */
    modelValue: {
      type: [String, Boolean, Number],
      required: false,
      default: void 0
    },
    /**
     * Name attribute of the radio input.
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Value of the radio input.
     */
    value: {
      type: [String, Boolean, Number],
      required: true
    },
    /**
     * Disables the radio input.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Displays the component as a block.
     * @default false
     */
    block: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Truncates the label.
     * @default false
     */
    truncate: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Hides the label.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when the selected value changes.
     * @event module:DpsFormRadio#update:modelValue
     */
    "update:modelValue"
  ],
  computed: {
    uniqueId() {
      return this.id ? this.id : getUniqueId("dps-form-radio-");
    },
    isChecked() {
      return this.modelValue === this.value;
    }
  },
  methods: {
    handleChange(event) {
      const target = event.target;
      const value = target.value;
      this.$emit("update:modelValue", value);
    }
  }
});
const _hoisted_1$g = ["id", "name", "value", "checked", "disabled", "readonly"];
const _hoisted_2$d = ["for"];
const _hoisted_3$c = {
  key: 0,
  class: "sr-only"
};
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["dps-form-radio dps-input-wrapper", { "dps-form-radio--block": _ctx.block || _ctx.truncate }])
  }, [
    createElementVNode("input", {
      id: _ctx.uniqueId,
      class: normalizeClass(["dps-form-radio__input dps-radio", { "dps-radio--error": _ctx.error }]),
      type: "radio",
      name: _ctx.name,
      value: _ctx.value,
      checked: _ctx.isChecked,
      disabled: _ctx.disabled || _ctx.readonly,
      readonly: _ctx.readonly,
      onChange: _cache[0] || (_cache[0] = (...args) => _ctx.handleChange && _ctx.handleChange(...args))
    }, null, 42, _hoisted_1$g),
    createElementVNode("label", {
      for: _ctx.uniqueId,
      class: normalizeClass(["dps-form-radio__label dps-label", {
        "dps-form-radio__label--input-only": _ctx.hideLabel,
        "dps-text--ellipse": _ctx.truncate
      }])
    }, [
      _ctx.hideLabel ? (openBlock(), createElementBlock("span", _hoisted_3$c, [
        renderSlot(_ctx.$slots, "default")
      ])) : renderSlot(_ctx.$slots, "default", { key: 1 })
    ], 10, _hoisted_2$d)
  ], 2);
}
const DpsFormRadio = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$i]]);
const _sfc_main$i = defineComponent({
  name: "DpsFormRadioGroup",
  components: {
    DpsFormRadio
  },
  props: {
    /**
     * The unique identifier for the radio group (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * ModelValue of the radio group.
     * @default undefined
     */
    modelValue: {
      type: [String, Boolean, Number],
      required: false,
      default: void 0
    },
    /**
     * Name of the radio inputs.
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Label for the radio group.
     * @default undefined
     */
    label: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Whether the label should be visually hidden.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Array of options to be displayed.
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Which key to use for the option value.
     * @default "value"
     */
    optionValue: {
      type: String,
      required: false,
      default: "value"
    },
    /**
     * Which key to use for the option label.
     * @default "label"
     */
    optionLabel: {
      type: String,
      required: false,
      default: "label"
    },
    /**
     * Whether the radio group should be disabled.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Whether the radio inputs should be displayed in line.
     * @default false
     */
    inline: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Whether the labels should be truncated.
     * @default false
     */
    truncate: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when the selected value changes.
     * @event module:DpsFormRadioGroup#update:modelValue
     */
    "update:modelValue"
  ],
  data() {
    return {
      selected: void 0
    };
  },
  computed: {
    mappedOptions() {
      const intermediateOptions = [];
      this.options.forEach((elem) => {
        let option = {};
        if (typeof elem !== "object") {
          option[this.optionValue] = elem;
          option[this.optionLabel] = elem;
        } else {
          option = JSON.parse(JSON.stringify(elem));
        }
        intermediateOptions.push(option);
      });
      return intermediateOptions;
    },
    uniqueId() {
      return this.id ? this.id : getUniqueId("dps-form-radio-group-");
    }
  },
  watch: {
    modelValue(value) {
      this.selected = value;
    }
  },
  created() {
    this.selected = this.modelValue;
  },
  methods: {
    handleChange(event) {
      this.$emit("update:modelValue", event);
    },
    getLabelContent(option) {
      const value = option[this.optionLabel];
      if (typeof value === "string") {
        return sanitizeHtml(value);
      }
      return value.toString();
    }
  }
});
const _hoisted_1$f = ["id"];
const _hoisted_2$c = { class: "dps-input-wrapper" };
const _hoisted_3$b = ["innerHTML"];
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpsFormRadio = resolveComponent("DpsFormRadio");
  return openBlock(), createElementBlock("fieldset", {
    id: _ctx.uniqueId,
    class: normalizeClass(["dps-form-radio-group", { "dps-form-radio-group--inline": _ctx.inline }])
  }, [
    _ctx.label ? (openBlock(), createElementBlock("legend", {
      key: 0,
      class: normalizeClass(["dps-label", { "visually-hidden": _ctx.hideLabel }])
    }, toDisplayString(_ctx.label), 3)) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_2$c, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.mappedOptions, (option, index) => {
        return openBlock(), createBlock(_component_DpsFormRadio, {
          id: _ctx.uniqueId + "-option-" + index,
          key: "option-" + index,
          name: _ctx.name,
          value: option[_ctx.optionValue],
          disabled: _ctx.disabled || option.disabled,
          readonly: option.readonly,
          error: option.error,
          block: !_ctx.inline,
          truncate: _ctx.truncate,
          "model-value": _ctx.selected,
          "onUpdate:modelValue": _ctx.handleChange
        }, {
          default: withCtx(() => [
            createElementVNode("span", {
              innerHTML: _ctx.getLabelContent(option)
            }, null, 8, _hoisted_3$b)
          ]),
          _: 2
        }, 1032, ["id", "name", "value", "disabled", "readonly", "error", "block", "truncate", "model-value", "onUpdate:modelValue"]);
      }), 128))
    ])
  ], 10, _hoisted_1$f);
}
const DpsFormRadioGroup = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$h]]);
function isEmpty(opt) {
  if (opt === 0) return false;
  if (Array.isArray(opt) && opt.length === 0) return true;
  return !opt;
}
function not(fun) {
  return (...params) => !fun(...params);
}
function includes(str, query) {
  if (str === void 0) str = "undefined";
  if (str === null) str = "null";
  if (str === false) str = "false";
  const text = str.toString().toLowerCase();
  return text.indexOf(query.trim()) !== -1;
}
function stripGroups(options) {
  return options.filter((option) => !option.$isLabel);
}
function flattenOptions(values, label) {
  return (options) => options.reduce((prev, curr) => {
    if (curr[values] && curr[values].length) {
      prev.push({
        $groupLabel: curr[label],
        $isLabel: true
      });
      return prev.concat(curr[values]);
    }
    return prev;
  }, []);
}
const flow = (...fns) => (x) => fns.reduce((v2, f) => f(v2), x);
var multiselectMixin = {
  data() {
    return {
      search: "",
      isOpen: false,
      preferredOpenDirection: "below",
      optimizedHeight: this.maxHeight
    };
  },
  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: true
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: true
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: false
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: "Select option"
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: true
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: false
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default(option, label) {
        if (isEmpty(option)) return "";
        return label ? option[label] : option;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: false
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
    */
    tagPlaceholder: {
      type: String,
      default: "Press enter to create a tag"
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
    */
    tagPosition: {
      type: String,
      default: "top"
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
    */
    max: {
      type: [Number, Boolean],
      default: false
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
    */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
    */
    optionsLimit: {
      type: Number,
      default: 1e3
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
    */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
    */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: false
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
    */
    blockKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
    */
    preserveSearch: {
      type: Boolean,
      default: false
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
    */
    preselectFirst: {
      type: Boolean,
      default: false
    },
    /**
     * Prevent autofocus
     * @default false
     * @type {Boolean}
     */
    preventAutofocus: {
      type: Boolean,
      default: false
    },
    /**
     * Allows a custom function for sorting search/filtered results.
     * @default null
     * @type {Function}
     */
    filteringSortFunc: {
      type: Function,
      default: null
    }
  },
  mounted() {
    if (!this.multiple && this.max) {
      console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false.");
    }
    if (this.preselectFirst && !this.internalValue.length && this.options.length) {
      this.select(this.filteredOptions[0]);
    }
  },
  computed: {
    internalValue() {
      return this.modelValue || this.modelValue === 0 ? Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue] : [];
    },
    filteredOptions() {
      const search = this.search || "";
      const normalizedSearch = search.toLowerCase().trim();
      let options = this.options.concat();
      if (this.internalSearch) {
        options = this.groupValues ? this.filterAndFlat(options, normalizedSearch, this.label) : this.filterOptions(options, normalizedSearch, this.label, this.customLabel);
      } else {
        options = this.groupValues ? flattenOptions(this.groupValues, this.groupLabel)(options) : options;
      }
      options = this.hideSelected ? options.filter(not(this.isSelected)) : options;
      if (this.taggable && normalizedSearch.length && !this.isExistingOption(normalizedSearch)) {
        if (this.tagPosition === "bottom") {
          options.push({ isTag: true, label: search });
        } else {
          options.unshift({ isTag: true, label: search });
        }
      }
      return options.slice(0, this.optionsLimit);
    },
    valueKeys() {
      if (this.trackBy) {
        return this.internalValue.map((element) => element[this.trackBy]);
      } else {
        return this.internalValue;
      }
    },
    optionKeys() {
      const options = this.groupValues ? this.flatAndStrip(this.options) : this.options;
      return options.map((element) => this.customLabel(element, this.label).toString().toLowerCase());
    },
    currentOptionLabel() {
      return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
    }
  },
  watch: {
    internalValue: {
      handler() {
        if (this.resetAfter && this.internalValue.length) {
          this.search = "";
          this.$emit("update:modelValue", this.multiple ? [] : null);
        }
      },
      deep: true
    },
    search() {
      this.$emit("search-change", this.search);
    }
  },
  emits: ["open", "search-change", "close", "select", "update:modelValue", "remove", "tag"],
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },
    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @return {Array} returns a filtered and flat options list
     */
    filterAndFlat(options, search, label) {
      return flow(
        this.filterGroups(search, label, this.groupValues, this.groupLabel, this.customLabel),
        flattenOptions(this.groupValues, this.groupLabel)
      )(options);
    },
    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @return {Array} returns a flat options list without group labels
     */
    flatAndStrip(options) {
      return flow(
        flattenOptions(this.groupValues, this.groupLabel),
        stripGroups
      )(options);
    },
    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch(query) {
      this.search = query;
    },
    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @return {Boolean} returns true if element is available
     */
    isExistingOption(query) {
      return !this.options ? false : this.optionKeys.indexOf(query) > -1;
    },
    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected(option) {
      const opt = this.trackBy ? option[this.trackBy] : option;
      return this.valueKeys.indexOf(opt) > -1;
    },
    /**
     * Finds out if the given option is disabled
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is disabled
     */
    isOptionDisabled(option) {
      return !!option.$isDisabled;
    },
    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel(option) {
      if (isEmpty(option)) return "";
      if (option.isTag) return option.label;
      if (option.$isLabel) return option.$groupLabel;
      const label = this.customLabel(option, this.label);
      if (isEmpty(label)) return "";
      return label;
    },
    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select(option, key) {
      if (option.$isLabel && this.groupSelect) {
        this.selectGroup(option);
        return;
      }
      if (this.blockKeys.indexOf(key) !== -1 || this.disabled || option.$isDisabled || option.$isLabel) return;
      if (this.max && this.multiple && this.internalValue.length === this.max) return;
      if (key === "Tab" && !this.pointerDirty) return;
      if (option.isTag) {
        this.$emit("tag", option.label, this.id);
        this.search = "";
        if (this.closeOnSelect && !this.multiple) this.deactivate();
      } else {
        const isSelected = this.isSelected(option);
        if (isSelected) {
          if (key !== "Tab") this.removeElement(option);
          return;
        }
        if (this.multiple) {
          this.$emit("update:modelValue", this.internalValue.concat([option]));
        } else {
          this.$emit("update:modelValue", option);
        }
        this.$emit("select", option, this.id);
        if (this.clearOnSelect) this.search = "";
      }
      if (this.closeOnSelect) this.deactivate();
    },
    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup(selectedGroup) {
      const group = this.options.find((option) => {
        return option[this.groupLabel] === selectedGroup.$groupLabel;
      });
      if (!group) return;
      if (this.wholeGroupSelected(group)) {
        this.$emit("remove", group[this.groupValues], this.id);
        const groupValues = this.trackBy ? group[this.groupValues].map((val) => val[this.trackBy]) : group[this.groupValues];
        const newValue = this.internalValue.filter(
          (option) => groupValues.indexOf(this.trackBy ? option[this.trackBy] : option) === -1
        );
        this.$emit("update:modelValue", newValue);
      } else {
        const optionsToAdd = group[this.groupValues].filter(
          (option) => !(this.isOptionDisabled(option) || this.isSelected(option))
        );
        if (this.max) {
          optionsToAdd.splice(this.max - this.internalValue.length);
        }
        this.$emit("select", optionsToAdd, this.id);
        this.$emit(
          "update:modelValue",
          this.internalValue.concat(optionsToAdd)
        );
      }
      if (this.closeOnSelect) this.deactivate();
    },
    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected(group) {
      return group[this.groupValues].every(
        (option) => this.isSelected(option) || this.isOptionDisabled(option)
      );
    },
    /**
     * Helper to identify if all values in a group are disabled
     *
     * @param {Object} group to check for disabled values
     */
    wholeGroupDisabled(group) {
      return group[this.groupValues].every(this.isOptionDisabled);
    },
    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @return {type}        description
     */
    removeElement(option, shouldClose = true) {
      if (this.disabled) return;
      if (option.$isDisabled) return;
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }
      const index = typeof option === "object" ? this.valueKeys.indexOf(option[this.trackBy]) : this.valueKeys.indexOf(option);
      if (this.multiple) {
        const newValue = this.internalValue.slice(0, index).concat(this.internalValue.slice(index + 1));
        this.$emit("update:modelValue", newValue);
      } else {
        this.$emit("update:modelValue", null);
      }
      this.$emit("remove", option, this.id);
      if (this.closeOnSelect && shouldClose) this.deactivate();
    },
    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement() {
      if (this.blockKeys.indexOf("Delete") !== -1) return;
      if (this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length) {
        this.removeElement(this.internalValue[this.internalValue.length - 1], false);
      }
    },
    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate() {
      if (this.isOpen || this.disabled) return;
      this.adjustPosition();
      if (this.groupValues && this.pointer === 0 && this.filteredOptions.length) {
        this.pointer = 1;
      }
      this.isOpen = true;
      if (this.searchable) {
        if (!this.preserveSearch) this.search = "";
        if (!this.preventAutofocus) this.$nextTick(() => this.$refs.search && this.$refs.search.focus());
      } else if (!this.preventAutofocus) {
        if (typeof this.$el !== "undefined") this.$el.focus();
      }
      this.$emit("open", this.id);
    },
    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate() {
      if (!this.isOpen) return;
      this.isOpen = false;
      if (this.searchable) {
        if (this.$refs.search !== null && typeof this.$refs.search !== "undefined") this.$refs.search.blur();
      } else {
        if (typeof this.$el !== "undefined") this.$el.blur();
      }
      if (!this.preserveSearch) this.search = "";
      this.$emit("close", this.getValue(), this.id);
    },
    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },
    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition() {
      if (typeof window === "undefined") return;
      const spaceAbove = this.$el.getBoundingClientRect().top;
      const spaceBelow = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      const hasEnoughSpaceBelow = spaceBelow > this.maxHeight;
      if (hasEnoughSpaceBelow || spaceBelow > spaceAbove || this.openDirection === "below" || this.openDirection === "bottom") {
        this.preferredOpenDirection = "below";
        this.optimizedHeight = Math.min(spaceBelow - 40, this.maxHeight);
      } else {
        this.preferredOpenDirection = "above";
        this.optimizedHeight = Math.min(spaceAbove - 40, this.maxHeight);
      }
    },
    /**
     * Filters and sorts the options ready for selection
     * @param {Array} options
     * @param {String} search
     * @param {String} label
     * @param {Function} customLabel
     * @returns {Array}
     */
    filterOptions(options, search, label, customLabel) {
      return search ? options.filter((option) => includes(customLabel(option, label), search)).sort((a2, b2) => {
        if (typeof this.filteringSortFunc === "function") {
          return this.filteringSortFunc(a2, b2);
        }
        return customLabel(a2, label).length - customLabel(b2, label).length;
      }) : options;
    },
    /**
     *
     * @param {String} search
     * @param {String} label
     * @param {String} values
     * @param {String} groupLabel
     * @param {function} customLabel
     * @returns {function(*): *}
     */
    filterGroups(search, label, values, groupLabel, customLabel) {
      return (groups) => groups.map((group) => {
        if (!group[values]) {
          console.warn("Options passed to vue-multiselect do not contain groups, despite the config.");
          return [];
        }
        const groupOptions = this.filterOptions(group[values], search, label, customLabel);
        return groupOptions.length ? {
          [groupLabel]: group[groupLabel],
          [values]: groupOptions
        } : [];
      });
    }
  }
};
var pointerMixin = {
  data() {
    return {
      pointer: 0,
      pointerDirty: false
    };
  },
  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: true
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions() {
      this.pointerAdjust();
    },
    isOpen() {
      this.pointerDirty = false;
    },
    pointer() {
      this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
    }
  },
  methods: {
    optionHighlight(index, option) {
      return {
        "multiselect__option--highlight": index === this.pointer && this.showPointer,
        "multiselect__option--selected": this.isSelected(option)
      };
    },
    groupHighlight(index, selectedGroup) {
      if (!this.groupSelect) {
        return [
          "multiselect__option--disabled",
          { "multiselect__option--group": selectedGroup.$isLabel }
        ];
      }
      const group = this.options.find((option) => {
        return option[this.groupLabel] === selectedGroup.$groupLabel;
      });
      return group && !this.wholeGroupDisabled(group) ? [
        "multiselect__option--group",
        { "multiselect__option--highlight": index === this.pointer && this.showPointer },
        { "multiselect__option--group-selected": this.wholeGroupSelected(group) }
      ] : "multiselect__option--disabled";
    },
    addPointerElement({ key } = "Enter") {
      if (this.filteredOptions.length > 0) {
        this.select(this.filteredOptions[this.pointer], key);
      }
      this.pointerReset();
    },
    pointerForward() {
      if (this.pointer < this.filteredOptions.length - 1) {
        this.pointer++;
        if (this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight) {
          this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight;
        }
        if (this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect) this.pointerForward();
      }
      this.pointerDirty = true;
    },
    pointerBackward() {
      if (this.pointer > 0) {
        this.pointer--;
        if (this.$refs.list.scrollTop >= this.pointerPosition) {
          this.$refs.list.scrollTop = this.pointerPosition;
        }
        if (this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect) this.pointerBackward();
      } else {
        if (this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect) this.pointerForward();
      }
      this.pointerDirty = true;
    },
    pointerReset() {
      if (!this.closeOnSelect) return;
      this.pointer = 0;
      if (this.$refs.list) {
        this.$refs.list.scrollTop = 0;
      }
    },
    pointerAdjust() {
      if (this.pointer >= this.filteredOptions.length - 1) {
        this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0;
      }
      if (this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect) {
        this.pointerForward();
      }
    },
    pointerSet(index) {
      this.pointer = index;
      this.pointerDirty = true;
    }
  }
};
var script = {
  name: "vue-multiselect",
  mixins: [multiselectMixin, pointerMixin],
  compatConfig: {
    MODE: 3,
    ATTR_ENUMERATED_COERCION: false
  },
  props: {
    /**
       * name attribute to match optional label element
       * @default ''
       * @type {String}
       */
    name: {
      type: String,
      default: ""
    },
    /**
       * Presets the selected options value.
       * @type {Object||Array||String||Integer}
       */
    modelValue: {
      type: null,
      default() {
        return [];
      }
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectLabel: {
      type: String,
      default: "Press enter to select"
    },
    /**
       * String to show when pointing to an option
       * @default 'Press enter to select'
       * @type {String}
       */
    selectGroupLabel: {
      type: String,
      default: "Press enter to select group"
    },
    /**
       * String to show next to selected option
       * @default 'Selected'
       * @type {String}
       */
    selectedLabel: {
      type: String,
      default: "Selected"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectLabel: {
      type: String,
      default: "Press enter to remove"
    },
    /**
       * String to show when pointing to an already selected option
       * @default 'Press enter to remove'
       * @type {String}
       */
    deselectGroupLabel: {
      type: String,
      default: "Press enter to deselect group"
    },
    /**
       * Decide whether to show pointer labels
       * @default true
       * @type {Boolean}
       */
    showLabels: {
      type: Boolean,
      default: true
    },
    /**
       * Limit the display of selected options. The rest will be hidden within the limitText string.
       * @default 99999
       * @type {Integer}
       */
    limit: {
      type: Number,
      default: 99999
    },
    /**
       * Sets maxHeight style value of the dropdown
       * @default 300
       * @type {Integer}
       */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
       * Function that process the message shown when selected
       * elements pass the defined limit.
       * @default 'and * more'
       * @param {Int} count Number of elements more than limit
       * @type {Function}
       */
    limitText: {
      type: Function,
      default: (count) => `and ${count} more`
    },
    /**
       * Set true to trigger the loading spinner.
       * @default False
       * @type {Boolean}
       */
    loading: {
      type: Boolean,
      default: false
    },
    /**
       * Disables the multiselect if true.
       * @default false
       * @type {Boolean}
       */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Enables search input's spellcheck if true.
     * @default false
     * @type {Boolean}
     */
    spellcheck: {
      type: Boolean,
      default: false
    },
    /**
       * Fixed opening direction
       * @default ''
       * @type {String}
       */
    openDirection: {
      type: String,
      default: ""
    },
    /**
       * Shows slot with message about empty options
       * @default true
       * @type {Boolean}
       */
    showNoOptions: {
      type: Boolean,
      default: true
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    },
    /**
     * Adds Required attribute to the input element when there is no value selected
     * @default false
     * @type {Boolean}
     */
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasOptionGroup() {
      return this.groupValues && this.groupLabel && this.groupSelect;
    },
    isSingleLabelVisible() {
      return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText() {
      return this.showLabels ? this.deselectLabel : "";
    },
    deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : "";
    },
    selectLabelText() {
      return this.showLabels ? this.selectLabel : "";
    },
    selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : "";
    },
    selectedLabelText() {
      return this.showLabels ? this.selectedLabel : "";
    },
    inputStyle() {
      if (this.searchable || this.multiple && this.modelValue && this.modelValue.length) {
        return this.isOpen ? { width: "100%" } : { width: "0", position: "absolute", padding: "0" };
      }
      return "";
    },
    contentStyle() {
      return this.options.length ? { display: "inline-block" } : { display: "block" };
    },
    isAbove() {
      if (this.openDirection === "above" || this.openDirection === "top") {
        return true;
      } else if (this.openDirection === "below" || this.openDirection === "bottom") {
        return false;
      } else {
        return this.preferredOpenDirection === "above";
      }
    },
    showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : true);
    },
    isRequired() {
      if (this.required === false) {
        return false;
      }
      return this.internalValue.length <= 0;
    }
  }
};
const _hoisted_1$e = ["tabindex", "aria-expanded", "aria-owns", "aria-activedescendant"];
const _hoisted_2$b = {
  ref: "tags",
  class: "multiselect__tags"
};
const _hoisted_3$a = { class: "multiselect__tags-wrap" };
const _hoisted_4$7 = ["textContent"];
const _hoisted_5$5 = ["onKeypress", "onMousedown"];
const _hoisted_6$5 = ["textContent"];
const _hoisted_7$3 = { class: "multiselect__spinner" };
const _hoisted_8$1 = ["name", "id", "spellcheck", "placeholder", "required", "value", "disabled", "tabindex", "aria-label", "aria-controls"];
const _hoisted_9$1 = ["id", "aria-multiselectable"];
const _hoisted_10$1 = { key: 0 };
const _hoisted_11$1 = { class: "multiselect__option" };
const _hoisted_12$1 = ["aria-selected", "id", "role"];
const _hoisted_13 = ["onClick", "onMouseenter", "data-select", "data-selected", "data-deselect"];
const _hoisted_14 = ["data-select", "data-deselect", "onMouseenter", "onMousedown"];
const _hoisted_15 = { class: "multiselect__option" };
const _hoisted_16 = { class: "multiselect__option" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    tabindex: _ctx.searchable ? -1 : $props.tabindex,
    class: normalizeClass([{ "multiselect--active": _ctx.isOpen, "multiselect--disabled": $props.disabled, "multiselect--above": $options.isAbove, "multiselect--has-options-group": $options.hasOptionGroup }, "multiselect"]),
    onFocus: _cache[14] || (_cache[14] = ($event) => _ctx.activate()),
    onBlur: _cache[15] || (_cache[15] = ($event) => _ctx.searchable ? false : _ctx.deactivate()),
    onKeydown: [
      _cache[16] || (_cache[16] = withKeys(withModifiers(($event) => _ctx.pointerForward(), ["self", "prevent"]), ["down"])),
      _cache[17] || (_cache[17] = withKeys(withModifiers(($event) => _ctx.pointerBackward(), ["self", "prevent"]), ["up"]))
    ],
    onKeypress: _cache[18] || (_cache[18] = withKeys(withModifiers(($event) => _ctx.addPointerElement($event), ["stop", "self"]), ["enter", "tab"])),
    onKeyup: _cache[19] || (_cache[19] = withKeys(($event) => _ctx.deactivate(), ["esc"])),
    role: "combobox",
    "aria-expanded": _ctx.isOpen,
    "aria-owns": "listbox-" + _ctx.id,
    "aria-activedescendant": _ctx.isOpen && _ctx.pointer !== null ? _ctx.id + "-" + _ctx.pointer : null
  }, [
    renderSlot(_ctx.$slots, "caret", { toggle: _ctx.toggle }, () => [
      createElementVNode(
        "div",
        {
          onMousedown: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.toggle(), ["prevent", "stop"])),
          class: "multiselect__select"
        },
        null,
        32
        /* NEED_HYDRATION */
      )
    ]),
    renderSlot(_ctx.$slots, "clear", { search: _ctx.search }),
    createElementVNode(
      "div",
      _hoisted_2$b,
      [
        renderSlot(_ctx.$slots, "selection", {
          search: _ctx.search,
          remove: _ctx.removeElement,
          values: $options.visibleValues,
          isOpen: _ctx.isOpen
        }, () => [
          withDirectives(createElementVNode(
            "div",
            _hoisted_3$a,
            [
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList($options.visibleValues, (option, index) => {
                  return renderSlot(_ctx.$slots, "tag", {
                    option,
                    search: _ctx.search,
                    remove: _ctx.removeElement
                  }, () => [
                    (openBlock(), createElementBlock(
                      "span",
                      {
                        class: "multiselect__tag",
                        key: index,
                        onMousedown: _cache[1] || (_cache[1] = withModifiers(() => {
                        }, ["prevent"]))
                      },
                      [
                        createElementVNode("span", {
                          textContent: toDisplayString(_ctx.getOptionLabel(option))
                        }, null, 8, _hoisted_4$7),
                        createElementVNode("i", {
                          tabindex: "1",
                          onKeypress: withKeys(withModifiers(($event) => _ctx.removeElement(option), ["prevent"]), ["enter"]),
                          onMousedown: withModifiers(($event) => _ctx.removeElement(option), ["prevent"]),
                          class: "multiselect__tag-icon"
                        }, null, 40, _hoisted_5$5)
                      ],
                      32
                      /* NEED_HYDRATION */
                    ))
                  ]);
                }),
                256
                /* UNKEYED_FRAGMENT */
              ))
            ],
            512
            /* NEED_PATCH */
          ), [
            [vShow, $options.visibleValues.length > 0]
          ]),
          _ctx.internalValue && _ctx.internalValue.length > $props.limit ? renderSlot(_ctx.$slots, "limit", { key: 0 }, () => [
            createElementVNode("strong", {
              class: "multiselect__strong",
              textContent: toDisplayString($props.limitText(_ctx.internalValue.length - $props.limit))
            }, null, 8, _hoisted_6$5)
          ]) : createCommentVNode("v-if", true)
        ]),
        createVNode(Transition, { name: "multiselect__loading" }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "loading", {}, () => [
              withDirectives(createElementVNode(
                "div",
                _hoisted_7$3,
                null,
                512
                /* NEED_PATCH */
              ), [
                [vShow, $props.loading]
              ])
            ])
          ]),
          _: 3
          /* FORWARDED */
        }),
        _ctx.searchable ? (openBlock(), createElementBlock("input", {
          key: 0,
          ref: "search",
          name: $props.name,
          id: _ctx.id,
          type: "text",
          autocomplete: "off",
          spellcheck: $props.spellcheck,
          placeholder: _ctx.placeholder,
          required: $options.isRequired,
          style: normalizeStyle($options.inputStyle),
          value: _ctx.search,
          disabled: $props.disabled,
          tabindex: $props.tabindex,
          "aria-label": $props.name + "-searchbox",
          onInput: _cache[2] || (_cache[2] = ($event) => _ctx.updateSearch($event.target.value)),
          onFocus: _cache[3] || (_cache[3] = withModifiers(($event) => _ctx.activate(), ["prevent"])),
          onBlur: _cache[4] || (_cache[4] = withModifiers(($event) => _ctx.deactivate(), ["prevent"])),
          onKeyup: _cache[5] || (_cache[5] = withKeys(($event) => _ctx.deactivate(), ["esc"])),
          onKeydown: [
            _cache[6] || (_cache[6] = withKeys(withModifiers(($event) => _ctx.pointerForward(), ["prevent"]), ["down"])),
            _cache[7] || (_cache[7] = withKeys(withModifiers(($event) => _ctx.pointerBackward(), ["prevent"]), ["up"])),
            _cache[9] || (_cache[9] = withKeys(withModifiers(($event) => _ctx.removeLastElement(), ["stop"]), ["delete"]))
          ],
          onKeypress: _cache[8] || (_cache[8] = withKeys(withModifiers(($event) => _ctx.addPointerElement($event), ["prevent", "stop", "self"]), ["enter"])),
          class: "multiselect__input",
          "aria-controls": "listbox-" + _ctx.id
        }, null, 44, _hoisted_8$1)) : createCommentVNode("v-if", true),
        $options.isSingleLabelVisible ? (openBlock(), createElementBlock(
          "span",
          {
            key: 1,
            class: "multiselect__single",
            onMousedown: _cache[10] || (_cache[10] = withModifiers((...args) => _ctx.toggle && _ctx.toggle(...args), ["prevent"]))
          },
          [
            renderSlot(_ctx.$slots, "singleLabel", { option: $options.singleValue }, () => [
              createTextVNode(
                toDisplayString(_ctx.currentOptionLabel),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : createCommentVNode("v-if", true),
        $options.isPlaceholderVisible ? (openBlock(), createElementBlock(
          "span",
          {
            key: 2,
            class: "multiselect__placeholder",
            onMousedown: _cache[11] || (_cache[11] = withModifiers((...args) => _ctx.toggle && _ctx.toggle(...args), ["prevent"]))
          },
          [
            renderSlot(_ctx.$slots, "placeholder", {}, () => [
              createTextVNode(
                toDisplayString(_ctx.placeholder),
                1
                /* TEXT */
              )
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : createCommentVNode("v-if", true)
      ],
      512
      /* NEED_PATCH */
    ),
    createVNode(Transition, {
      name: "multiselect",
      persisted: ""
    }, {
      default: withCtx(() => [
        withDirectives(createElementVNode(
          "div",
          {
            class: "multiselect__content-wrapper",
            onFocus: _cache[12] || (_cache[12] = (...args) => _ctx.activate && _ctx.activate(...args)),
            tabindex: "-1",
            onMousedown: _cache[13] || (_cache[13] = withModifiers(() => {
            }, ["prevent"])),
            style: normalizeStyle({ maxHeight: _ctx.optimizedHeight + "px" }),
            ref: "list"
          },
          [
            createElementVNode("ul", {
              class: "multiselect__content",
              style: normalizeStyle($options.contentStyle),
              role: "listbox",
              id: "listbox-" + _ctx.id,
              "aria-multiselectable": _ctx.multiple
            }, [
              renderSlot(_ctx.$slots, "beforeList"),
              _ctx.multiple && _ctx.max === _ctx.internalValue.length ? (openBlock(), createElementBlock("li", _hoisted_10$1, [
                createElementVNode("span", _hoisted_11$1, [
                  renderSlot(_ctx.$slots, "maxElements", {}, () => [
                    createTextVNode(
                      "Maximum of " + toDisplayString(_ctx.max) + " options selected. First remove a selected option to select another.",
                      1
                      /* TEXT */
                    )
                  ])
                ])
              ])) : createCommentVNode("v-if", true),
              !_ctx.max || _ctx.internalValue.length < _ctx.max ? (openBlock(true), createElementBlock(
                Fragment,
                { key: 1 },
                renderList(_ctx.filteredOptions, (option, index) => {
                  return openBlock(), createElementBlock("li", {
                    class: "multiselect__element",
                    key: index,
                    "aria-selected": _ctx.isSelected(option),
                    id: _ctx.id + "-" + index,
                    role: !(option && (option.$isLabel || option.$isDisabled)) ? "option" : null
                  }, [
                    !(option && (option.$isLabel || option.$isDisabled)) ? (openBlock(), createElementBlock("span", {
                      key: 0,
                      class: normalizeClass([_ctx.optionHighlight(index, option), "multiselect__option"]),
                      onClick: withModifiers(($event) => _ctx.select(option), ["stop"]),
                      onMouseenter: withModifiers(($event) => _ctx.pointerSet(index), ["self"]),
                      "data-select": option && option.isTag ? _ctx.tagPlaceholder : $options.selectLabelText,
                      "data-selected": $options.selectedLabelText,
                      "data-deselect": $options.deselectLabelText
                    }, [
                      renderSlot(_ctx.$slots, "option", {
                        option,
                        search: _ctx.search,
                        index
                      }, () => [
                        createElementVNode(
                          "span",
                          null,
                          toDisplayString(_ctx.getOptionLabel(option)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, _hoisted_13)) : createCommentVNode("v-if", true),
                    option && (option.$isLabel || option.$isDisabled) ? (openBlock(), createElementBlock("span", {
                      key: 1,
                      "data-select": _ctx.groupSelect && $options.selectGroupLabelText,
                      "data-deselect": _ctx.groupSelect && $options.deselectGroupLabelText,
                      class: normalizeClass([_ctx.groupHighlight(index, option), "multiselect__option"]),
                      onMouseenter: withModifiers(($event) => _ctx.groupSelect && _ctx.pointerSet(index), ["self"]),
                      onMousedown: withModifiers(($event) => _ctx.selectGroup(option), ["prevent"])
                    }, [
                      renderSlot(_ctx.$slots, "option", {
                        option,
                        search: _ctx.search,
                        index
                      }, () => [
                        createElementVNode(
                          "span",
                          null,
                          toDisplayString(_ctx.getOptionLabel(option)),
                          1
                          /* TEXT */
                        )
                      ])
                    ], 42, _hoisted_14)) : createCommentVNode("v-if", true)
                  ], 8, _hoisted_12$1);
                }),
                128
                /* KEYED_FRAGMENT */
              )) : createCommentVNode("v-if", true),
              withDirectives(createElementVNode(
                "li",
                null,
                [
                  createElementVNode("span", _hoisted_15, [
                    renderSlot(_ctx.$slots, "noResult", { search: _ctx.search }, () => [
                      _cache[20] || (_cache[20] = createTextVNode("No elements found. Consider changing the search query."))
                    ])
                  ])
                ],
                512
                /* NEED_PATCH */
              ), [
                [vShow, $props.showNoResults && (_ctx.filteredOptions.length === 0 && _ctx.search && !$props.loading)]
              ]),
              withDirectives(createElementVNode(
                "li",
                null,
                [
                  createElementVNode("span", _hoisted_16, [
                    renderSlot(_ctx.$slots, "noOptions", {}, () => [
                      _cache[21] || (_cache[21] = createTextVNode("List is empty."))
                    ])
                  ])
                ],
                512
                /* NEED_PATCH */
              ), [
                [vShow, $props.showNoOptions && ((_ctx.options.length === 0 || $options.hasOptionGroup === true && _ctx.filteredOptions.length === 0) && !_ctx.search && !$props.loading)]
              ]),
              renderSlot(_ctx.$slots, "afterList")
            ], 12, _hoisted_9$1)
          ],
          36
          /* STYLE, NEED_HYDRATION */
        ), [
          [vShow, _ctx.isOpen]
        ])
      ]),
      _: 3
      /* FORWARDED */
    })
  ], 42, _hoisted_1$e);
}
script.render = render;
const _sfc_main$h = defineComponent({
  name: "DpsFormSelect",
  components: { DpsFilterButton, Multiselect: script },
  props: {
    /**
     * Unique ID of the select (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Size of the select.
     * @default undefined
     */
    size: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Style variant of the select.
     * @default undefined
     */
    variant: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Hides tags for selected elements (only for multiple).
     * @default false
     */
    hideTags: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * ModelValue for the select.
     * @default undefined
     */
    modelValue: {
      type: [String, Number, Array, Object],
      required: false,
      default: void 0
    },
    /**
     * Key for the label text in the option object.
     * @default "label"
     */
    optionLabel: {
      type: String,
      required: false,
      default: "label"
    },
    /**
     * Key for the value in the option object.
     * @default "value"
     */
    optionValue: {
      type: String,
      required: false,
      default: "value"
    },
    /**
     * Makes the select readonly.
     * @default false
     */
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Requires a value to be selected.
     * @default false
     */
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Title attribute of the select.
     * @default props.placeholder
     */
    title: {
      type: String,
      required: false,
      default(props) {
        return props.placeholder;
      }
    },
    /**
     * Label for the select.
     * @default undefined
     */
    label: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Icon placed before the select in the simple variant.
     * @default undefined
     */
    icon: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Success state of the select.
     * @default false
     */
    success: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Error state of the select.
     * @default false
     */
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Aligns the dropdown left or right.
     * @default "start"
     */
    align: {
      type: String,
      required: false,
      default: "start"
    },
    // -----------------------
    // Vue-Multiselect
    // -----------------------
    /**
     * Array of available options: Objects, Strings or Integers. If array of objects, visible label will default to option.label.
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Clear the search input after `select()`. Use only when multiple is true.
     * @default true
     */
    clearOnSelect: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     */
    closeOnSelect: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Enable/disable the multiselect.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Number of allowed selected options.
     * @default undefined
     */
    max: {
      type: Number,
      required: false,
      default: void 0
    },
    /**
     * Equivalent to the multiple attribute on a `<select>` input.
     * @default false
     */
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Fixed opening direction (instead of auto). Options are "above"/"top" or "below"/"bottom"
     * @default ""
     */
    openDirection: {
      type: String,
      required: false,
      default: ""
    },
    /**
     * Equivalent to the placeholder attribute on a `<select>` input.
     * @default "Bitte wählen"
     */
    placeholder: {
      type: String,
      required: false,
      default: "Bitte wählen"
    },
    /**
     * Selects the first option if initial value is empty
     * @default false
     */
    preselectFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * If set to true, will preserve the search query when opening/closing the component.
     * @default false
     */
    preserveSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Add / removes search input.
     * @default false
     */
    searchable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when a value gets selected.
     */
    "select",
    /**
     * Emitted after removing an option.
     */
    "remove",
    /**
     * Emitted after the search query changes.
     */
    "search-change",
    /**
     * Emitted after user attempts to add a tag.
     */
    "tag",
    /**
     * Emitted when the dropdown opens. Useful for detecting when touched.
     */
    "open",
    /**
     * Emitted when the dropdown closes.
     */
    "close",
    /**
     * Emitted after this.modelValue changes.
     */
    "update:modelValue"
  ],
  data() {
    return {
      selected: void 0,
      multiselectEl: null,
      isDropdownOpen: false
    };
  },
  computed: {
    uniqueId() {
      return this.id ? this.id : getUniqueId("dps-form-select-");
    },
    multiselectOptions() {
      const options = [];
      for (const option of this.options) {
        if (typeof option !== "object") {
          const fixedOption = {};
          fixedOption[this.optionValue] = option;
          fixedOption[this.optionLabel] = option;
          options.push(fixedOption);
        } else {
          options.push(option);
        }
      }
      return options;
    }
  },
  watch: {
    modelValue(newValue) {
      this.selected = newValue;
    },
    selected(newValue, oldValue) {
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.$emit("update:modelValue", newValue);
      }
    }
  },
  mounted() {
    const multiselect = this.$refs.multiselect;
    this.multiselectEl = multiselect?.$el;
    this.improveMultiselectAccessibility();
    this.improveElementAccessibility();
    this.improveContentAccessibility();
  },
  created() {
    this.selected = this.modelValue;
  },
  methods: {
    handleMouseDown(event) {
      const root2 = this.multiselectEl;
      const content = root2.querySelector(".multiselect__content");
      const searchInput = root2.querySelector(
        ".multiselect__input"
      );
      const target = event.target;
      const isOpen = this.isDropdownOpen;
      const ms = this.$refs.multiselect;
      if (searchInput && searchInput.contains(target)) return;
      if (content && content.contains(target)) return;
      if (root2.contains(target)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (isOpen) {
          ms.deactivate();
          this.isDropdownOpen = false;
        } else {
          ms.activate();
          this.isDropdownOpen = true;
        }
        return;
      }
    },
    improveMultiselectAccessibility() {
      this.multiselectEl?.setAttribute("aria-expanded", "false");
      this.multiselectEl?.setAttribute(
        "aria-controls",
        "listbox-" + this.uniqueId
      );
    },
    improveContentAccessibility() {
      const content = this.multiselectEl?.querySelector(
        ".multiselect__content"
      );
      if (content) {
        content.ariaLabel = "Auswahlliste";
      }
    },
    improveElementAccessibility() {
      const options = this.multiselectEl?.querySelectorAll(
        ".multiselect__option"
      );
      if (options) {
        for (const option of Array.from(options)) {
          const parentEl = option.parentElement;
          if (parentEl?.classList.contains("multiselect__element")) {
            if (option.classList.contains("multiselect__option--selected")) {
              parentEl.ariaSelected = "true";
            } else {
              parentEl.ariaSelected = "false";
            }
          }
        }
      }
      const emptyItems = this.multiselectEl?.querySelectorAll(
        ".multiselect__content > li:not(.multiselect__element)"
      );
      if (emptyItems) {
        for (const emptyItem of Array.from(emptyItems)) {
          emptyItem.role = "option";
        }
      }
      const searchInput = this.multiselectEl?.querySelector(
        ".multiselect__input"
      );
      if (searchInput) {
        searchInput.placeholder = "Suchbegriff ...";
      }
    },
    handleSelect(event) {
      this.$emit("select", event);
      this.$nextTick(() => {
        this.improveElementAccessibility();
      });
    },
    handleRemove(event) {
      this.$emit("remove", event);
      this.$nextTick(() => {
        this.improveElementAccessibility();
      });
    },
    handleOpen(event) {
      this.isDropdownOpen = true;
      this.$emit("open", event);
      this.multiselectEl?.setAttribute("aria-expanded", "true");
      this.$nextTick(() => {
        this.setSearchInputWidth();
      });
    },
    handleClose(event) {
      this.isDropdownOpen = false;
      this.$emit("close", event);
      this.multiselectEl?.setAttribute("aria-expanded", "false");
    },
    handleTag(event) {
      this.$emit("tag", event);
    },
    handleSearchChange(event) {
      this.$emit("search-change", event);
    },
    setSearchInputWidth() {
      const paddingInline = 12;
      const searchInput = this.multiselectEl?.querySelector(
        ".multiselect__input"
      );
      const contentWrapper = this.multiselectEl?.querySelector(
        ".multiselect__content"
      );
      if (searchInput && contentWrapper) {
        const width = contentWrapper.offsetWidth;
        searchInput.style.setProperty("--width", width - paddingInline + "px");
      }
    }
  }
});
const _hoisted_1$d = {
  key: 0,
  class: "multiselect__option-checkbox"
};
const _hoisted_2$a = { class: "multiselect__option-label" };
const _hoisted_3$9 = {
  key: 2,
  class: "multiselect__option-checkbox"
};
const _hoisted_4$6 = {
  key: 0,
  class: "multiselect__single multiselect__single--label"
};
const _hoisted_5$4 = {
  key: 1,
  class: "multiselect__placeholder multiselect__placeholder--label"
};
const _hoisted_6$4 = {
  key: 1,
  class: "multiselect__tags-wrap"
};
const _hoisted_7$2 = {
  key: 1,
  class: "multiselect__single multiselect__single--label"
};
const _hoisted_8 = {
  key: 2,
  class: "multiselect__placeholder multiselect__placeholder--label"
};
const _hoisted_9 = {
  key: 3,
  class: "multiselect__placeholder multiselect__placeholder--label"
};
const _hoisted_10 = { class: "multiselect__option-results" };
const _hoisted_11 = { class: "multiselect__option-results" };
const _hoisted_12 = { class: "multiselect__option-results" };
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpsFilterButton = resolveComponent("DpsFilterButton");
  const _component_Multiselect = resolveComponent("Multiselect");
  return openBlock(), createBlock(_component_Multiselect, {
    id: _ctx.uniqueId,
    ref: "multiselect",
    modelValue: _ctx.selected,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.selected = $event),
    class: normalizeClass(["dps-form-select", {
      "dps-form-select--readonly": _ctx.readonly,
      "dps-form-select--multiple": _ctx.multiple,
      "dps-form-select--searchable": _ctx.searchable,
      "dps-form-select--labelled": _ctx.label,
      "dps-form-select--filter": _ctx.variant === "filter",
      "dps-form-select--simple": _ctx.variant === "simple",
      "dps-form-select--size-sm": _ctx.size === "sm",
      "dps-form-select--success": _ctx.success,
      "dps-form-select--error": _ctx.error,
      "dps-form-select--align-end": _ctx.align === "end"
    }]),
    options: _ctx.multiselectOptions,
    "allow-empty": !_ctx.required,
    "clear-on-select": _ctx.clearOnSelect,
    "close-on-select": _ctx.closeOnSelect,
    disabled: _ctx.disabled || _ctx.readonly,
    label: _ctx.optionLabel,
    max: _ctx.max,
    multiple: _ctx.multiple,
    "open-direction": _ctx.openDirection,
    placeholder: _ctx.placeholder,
    "preselect-first": _ctx.preselectFirst,
    "preserve-search": _ctx.preserveSearch,
    searchable: _ctx.searchable,
    "track-by": _ctx.optionValue,
    title: _ctx.title,
    onMousedownCapture: _ctx.handleMouseDown,
    onClose: _ctx.handleClose,
    onOpen: _ctx.handleOpen,
    onRemove: _ctx.handleRemove,
    onSearchChange: _ctx.handleSearchChange,
    onSelect: _ctx.handleSelect,
    onTag: _ctx.handleTag
  }, createSlots({
    option: withCtx((props) => [
      _ctx.multiple ? (openBlock(), createElementBlock("span", _hoisted_1$d, _cache[1] || (_cache[1] = [
        createElementVNode("span", { class: "dps-icon dps-icon--success" }, null, -1)
      ]))) : createCommentVNode("", true),
      props.option.icon ? (openBlock(), createElementBlock("span", {
        key: 1,
        class: normalizeClass(["multiselect__option-icon dps-icon", "dps-icon--" + props.option.icon])
      }, null, 2)) : createCommentVNode("", true),
      createElementVNode("span", _hoisted_2$a, [
        renderSlot(_ctx.$slots, "option", normalizeProps(guardReactiveProps(props)), () => [
          createTextVNode(toDisplayString(props.option[_ctx.optionLabel]), 1)
        ])
      ]),
      !_ctx.multiple ? (openBlock(), createElementBlock("span", _hoisted_3$9, _cache[2] || (_cache[2] = [
        createElementVNode("span", { class: "dps-icon dps-icon--success" }, null, -1)
      ]))) : createCommentVNode("", true)
    ]),
    tag: withCtx((props) => [
      createVNode(_component_DpsFilterButton, {
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        onClick: ($event) => props.remove(props.option)
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "tag", normalizeProps(guardReactiveProps(props)), () => [
            createTextVNode(toDisplayString(props.option[_ctx.optionLabel]), 1)
          ])
        ]),
        _: 2
      }, 1032, ["disabled", "readonly", "onClick"])
    ]),
    noOptions: withCtx(() => [
      createElementVNode("span", _hoisted_10, [
        renderSlot(_ctx.$slots, "noOptions", {}, () => [
          _cache[3] || (_cache[3] = createTextVNode("Keine Elemente"))
        ])
      ])
    ]),
    noResult: withCtx(() => [
      createElementVNode("span", _hoisted_11, [
        renderSlot(_ctx.$slots, "noResult", {}, () => [
          _cache[4] || (_cache[4] = createTextVNode(" Es wurden keine Elemente gefunden. "))
        ])
      ])
    ]),
    maxElements: withCtx(() => [
      createElementVNode("span", _hoisted_12, [
        renderSlot(_ctx.$slots, "maxElements", {}, () => [
          _cache[5] || (_cache[5] = createTextVNode(" Maximale Anzahl von Elementen erreicht. Bitte zuerst ein Element abwählen bevor Sie eine erneute Auswahl treffen. "))
        ])
      ])
    ]),
    _: 2
  }, [
    _ctx.multiple ? {
      name: "selection",
      fn: withCtx((props) => [
        props.values.length === 0 || _ctx.hideTags ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          _ctx.label ? (openBlock(), createElementBlock("div", _hoisted_4$6, toDisplayString(_ctx.label), 1)) : (openBlock(), createElementBlock("div", _hoisted_5$4, [
            renderSlot(_ctx.$slots, "selection", normalizeProps(guardReactiveProps(props)), () => [
              createTextVNode(toDisplayString(_ctx.placeholder), 1)
            ])
          ]))
        ], 64)) : (openBlock(), createElementBlock("div", _hoisted_6$4, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(props.values, (option, index) => {
            return openBlock(), createBlock(_component_DpsFilterButton, {
              key: "option-" + index,
              disabled: _ctx.disabled,
              readonly: _ctx.readonly,
              onClick: ($event) => props.remove(option)
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "selection", mergeProps({ ref_for: true }, props, { option }), () => [
                  createTextVNode(toDisplayString(option[_ctx.optionLabel]), 1)
                ])
              ]),
              _: 2
            }, 1032, ["disabled", "readonly", "onClick"]);
          }), 128))
        ]))
      ]),
      key: "0"
    } : {
      name: "selection",
      fn: withCtx((props) => [
        _ctx.variant === "simple" && _ctx.icon ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(["dps-icon dps-icon--" + _ctx.icon])
        }, null, 2)) : createCommentVNode("", true),
        _ctx.label ? (openBlock(), createElementBlock("div", _hoisted_7$2, toDisplayString(_ctx.label), 1)) : createCommentVNode("", true),
        _ctx.modelValue && typeof _ctx.modelValue === "object" && !Array.isArray(_ctx.modelValue) && _ctx.modelValue[_ctx.optionLabel] ? (openBlock(), createElementBlock("div", _hoisted_8, [
          renderSlot(_ctx.$slots, "selection", normalizeProps(guardReactiveProps(props)), () => [
            createTextVNode(toDisplayString(_ctx.modelValue[_ctx.optionLabel]), 1)
          ])
        ])) : (openBlock(), createElementBlock("div", _hoisted_9, [
          renderSlot(_ctx.$slots, "selection", normalizeProps(guardReactiveProps(props)), () => [
            createTextVNode(toDisplayString(_ctx.placeholder), 1)
          ])
        ]))
      ]),
      key: "1"
    },
    _ctx.$slots["beforeList"] ? {
      name: "beforeList",
      fn: withCtx(() => [
        renderSlot(_ctx.$slots, "beforeList")
      ]),
      key: "2"
    } : void 0,
    _ctx.$slots["afterList"] ? {
      name: "afterList",
      fn: withCtx(() => [
        renderSlot(_ctx.$slots, "afterList")
      ]),
      key: "3"
    } : void 0
  ]), 1032, ["id", "modelValue", "class", "options", "allow-empty", "clear-on-select", "close-on-select", "disabled", "label", "max", "multiple", "open-direction", "placeholder", "preselect-first", "preserve-search", "searchable", "track-by", "title", "onMousedownCapture", "onClose", "onOpen", "onRemove", "onSearchChange", "onSelect", "onTag"]);
}
const DpsFormSelect = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$g]]);
const _sfc_main$g = defineComponent({
  name: "DpsFormTextarea",
  props: {
    /**
     * ModelValue of the textarea.
     * @default undefined
     */
    modelValue: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Sets whether the textarea is resizable, and if so, in which directions.
     * @default false
     */
    resizable: {
      type: [Boolean, String],
      required: false,
      default: false
    },
    /**
     * Success state of the textarea.
     * @default false
     */
    success: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Error state of the textarea.
     * @default false
     */
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * The number of visible text lines.
     * @default 3
     */
    rows: {
      type: Number,
      required: false,
      default: 3
    },
    /**
     * Makes the textarea readonly.
     * @default false
     */
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Disables the textarea.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when the value changes.
     */
    "update:modelValue"
  ],
  watch: {
    modelValue() {
      this.$nextTick(() => {
        if (this.resizable === "auto") {
          this.resize();
        }
      });
    }
  },
  mounted() {
    if (this.resizable === "auto") {
      this.resize();
    }
  },
  methods: {
    handleInput(event) {
      const target = event.target;
      const value = target.value;
      this.$emit("update:modelValue", value);
      if (this.resizable === "auto") {
        this.$nextTick(this.resize);
      }
    },
    /**
     * Resize the textarea to fit its content when in `auto` mode.
     */
    resize() {
      if (this.$refs.textarea) {
        const textareaEl = this.$refs.textarea;
        textareaEl.style.height = "auto";
        textareaEl.style.height = textareaEl.scrollHeight + "px";
      }
    }
  }
});
const _hoisted_1$c = ["value", "rows", "readonly", "disabled"];
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("textarea", {
    ref: "textarea",
    class: normalizeClass(["dps-form-textarea dps-textarea", {
      "dps-form-textarea--resize": _ctx.resizable === true,
      "dps-form-textarea--resize-v": _ctx.resizable === "vertical",
      "dps-form-textarea--resize-h": _ctx.resizable === "horizontal",
      "dps-form-textarea--resize-a": _ctx.resizable === "auto",
      "dps-form-textarea--success": _ctx.success,
      "dps-form-textarea--error": _ctx.error
    }]),
    value: _ctx.modelValue,
    rows: _ctx.rows,
    readonly: _ctx.readonly,
    disabled: _ctx.disabled,
    onInput: _cache[0] || (_cache[0] = (...args) => _ctx.handleInput && _ctx.handleInput(...args))
  }, null, 42, _hoisted_1$c);
}
const DpsFormTextarea = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$f]]);
const _sfc_main$f = defineComponent({
  name: "DpsLink",
  props: {
    /**
     * The URL that the hyperlink points to.
     */
    href: {
      type: String,
      required: true
    },
    /**
     * Icon to be displayed in front of the link text.
     * Can be set to 'false' when using external links to
     * hide the icon.
     * @default undefined
     */
    icon: {
      type: [String, Boolean],
      required: false,
      default: void 0
    },
    /**
     * The relationship of the linked URL as space-separated
     * link types. "noopener noreferrer" gets set automatically
     * when "external" is true.
     * @default undefined
     */
    rel: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Where to display the linked URL,
     * as the name for a browsing context.
     * Gets set to "_blank" automatically when "external" is true.
     * @default undefined
     */
    target: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Whether the link is an external link.
     * @default false
     */
    external: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * How to format the link (telephone or email formatting).
     * @default undefined
     */
    format: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Whether the link should be a slightly darker blue.
     * @default false
     */
    darker: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when the link is clicked.
     */
    "click"
  ],
  computed: {
    hrefAttribute() {
      if (this.format === "telephone") {
        const href = this.href.replaceAll(" ", "").replaceAll("-", "").replaceAll("/", "").replaceAll("(", "").replaceAll(")", "");
        return "tel:" + href;
      } else if (this.format === "email") {
        return "mailto:" + this.href.replaceAll(" ", "");
      }
      return this.href;
    },
    relAttribute() {
      if (this.rel) {
        return this.rel;
      }
      if (this.external) {
        return "noopener noreferrer";
      }
      return void 0;
    },
    targetAttribute() {
      if (this.target) {
        return this.target;
      }
      if (this.external) {
        return "_blank";
      }
      return void 0;
    },
    iconName() {
      if (this.icon !== false) {
        if (this.icon && typeof this.icon === "string") {
          return this.icon;
        }
        if (this.external) {
          return "external-link";
        }
      }
      return void 0;
    }
  }
});
const _hoisted_1$b = ["href", "rel", "target"];
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("a", {
    class: normalizeClass(["dps-link", {
      "dps-link--icon": _ctx.iconName,
      "dps-link--darker": _ctx.darker
    }]),
    href: _ctx.hrefAttribute,
    rel: _ctx.relAttribute,
    target: _ctx.targetAttribute,
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, [
    _ctx.iconName ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      createElementVNode("span", {
        class: normalizeClass(["dps-icon", "dps-icon--" + _ctx.iconName])
      }, null, 2),
      createElementVNode("span", null, [
        renderSlot(_ctx.$slots, "default")
      ])
    ], 64)) : renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 10, _hoisted_1$b);
}
const DpsLink = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$e]]);
const _sfc_main$e = defineComponent({
  name: "DpsSortSelect",
  components: { DpsFormSelect },
  props: {
    /**
     * Unique ID of the select (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Array of options to be displayed.
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * ModelValue of the select.
     */
    modelValue: {
      type: String,
      required: true
    },
    /**
     * Title attribute of the select.
     * @default "Sortierung anpassen"
     */
    title: {
      type: String,
      default: "Sortierung anpassen",
      required: false
    },
    /**
     * Disables the select.
     * @default false
     */
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: [
    /**
     * Emitted when the selected value changes.
     */
    "update:modelValue"
  ],
  data() {
    return {
      selected: void 0
    };
  },
  computed: {
    uniqueId() {
      return this.id ? this.id : getUniqueId("dps-sort-select-");
    }
  },
  watch: {
    modelValue() {
      this.setSelectedOption();
    }
  },
  created() {
    this.setSelectedOption();
  },
  methods: {
    setSelectedOption() {
      let defaultValue = this.options[0];
      for (const option of this.options) {
        if (option.value === this.modelValue) {
          defaultValue = option;
        }
      }
      this.selected = defaultValue;
    },
    handleChange(payload) {
      this.$emit("update:modelValue", payload.value);
    }
  }
});
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpsFormSelect = resolveComponent("DpsFormSelect");
  return openBlock(), createBlock(_component_DpsFormSelect, {
    id: _ctx.uniqueId,
    class: normalizeClass(["dps-sort-select", { "dps-sort-select--disabled": _ctx.disabled }]),
    "model-value": _ctx.selected,
    options: _ctx.options,
    disabled: _ctx.disabled,
    title: _ctx.title,
    required: "",
    "onUpdate:modelValue": _ctx.handleChange
  }, null, 8, ["id", "class", "model-value", "options", "disabled", "title", "onUpdate:modelValue"]);
}
const DpsSortSelect = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$d]]);
const _sfc_main$d = defineComponent({
  name: "DpsAlert",
  props: {
    /**
     * The variant determines the color and icon of the alert.
     * @default undefined
     */
    variant: {
      type: String,
      default: void 0,
      required: false
    },
    /**
     * Headline of the alert.
     * @default undefined
     */
    heading: {
      type: String,
      default: void 0,
      required: false
    },
    /**
     * Hides the icon.
     * @default false
     */
    hideIcon: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    variantIcon() {
      const icons = {
        info: "feedback-info",
        warning: "error",
        success: "feedback-success",
        error: "error"
      };
      return icons[this.variant ?? "info"];
    }
  },
  methods: {
    sanitizeHtml
  }
});
const _hoisted_1$a = {
  key: 0,
  class: "dps-alert__icon-wrapper"
};
const _hoisted_2$9 = { class: "dps-alert__content-wrapper" };
const _hoisted_3$8 = ["innerHTML"];
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["dps-alert", { ["dps-alert--" + _ctx.variant]: _ctx.variant }])
  }, [
    !_ctx.hideIcon ? (openBlock(), createElementBlock("div", _hoisted_1$a, [
      createElementVNode("span", {
        class: normalizeClass(["dps-icon", "dps-icon--" + _ctx.variantIcon])
      }, null, 2)
    ])) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_2$9, [
      _ctx.heading ? (openBlock(), createElementBlock("header", {
        key: 0,
        class: "dps-alert__content-header",
        innerHTML: _ctx.sanitizeHtml(_ctx.heading)
      }, null, 8, _hoisted_3$8)) : createCommentVNode("", true),
      renderSlot(_ctx.$slots, "default")
    ])
  ], 2);
}
const DpsAlert = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$c]]);
const _sfc_main$c = defineComponent({
  name: "DpsInputGroup",
  props: {
    /**
     * Whether there should be no gap between the
     * elements.
     */
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    }
  }
});
const _hoisted_1$9 = {
  key: 0,
  class: "dps-input-group__content dps-input-group__content--prepend"
};
const _hoisted_2$8 = { class: "dps-input-group__content dps-input-group__content--default" };
const _hoisted_3$7 = {
  key: 1,
  class: "dps-input-group__content dps-input-group__content--append"
};
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    role: "group",
    class: normalizeClass(["dps-input-group", { "dps-input-group--collapsed": _ctx.collapsed }])
  }, [
    _ctx.$slots.prepend ? (openBlock(), createElementBlock("div", _hoisted_1$9, [
      renderSlot(_ctx.$slots, "prepend")
    ])) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_2$8, [
      renderSlot(_ctx.$slots, "default")
    ]),
    _ctx.$slots.append ? (openBlock(), createElementBlock("div", _hoisted_3$7, [
      renderSlot(_ctx.$slots, "append")
    ])) : createCommentVNode("", true)
  ], 2);
}
const DpsInputGroup = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$b]]);
const _sfc_main$b = defineComponent({
  name: "DpsFormFile",
  props: {
    /**
     * The unique identifier for the input (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * ModelValue of the input.
     * With inputs of type file, normally this is uni-directional.
     * However, you can clear the file input's selected files by setting the modelValue to either null
     * (for single mode) or an empty array [] (for multiple mode).
     * @default null
     */
    modelValue: {
      type: [File, Array, null],
      required: false,
      default: null
    },
    /**
     * Which file formats to accept.
     * Can be either file extension or mime-type or mixed
     * e.g. '.pdf', 'application/pdf' or '.pdf, application/pdf'
     * @default ""
     */
    accept: {
      type: String,
      required: false,
      default: ""
    },
    /**
     * Allows selecting multiple files at once.
     * @default false
     */
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Disables the component.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Title for the search button.
     * Defaults to "Datei auswählen" if no title is set.
     * @default undefined
     */
    title: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Changes the state to error.
     * @default false
     */
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Required attribute of the input.
     * @default false
     */
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when the file selection changes.
     * @event module:DpsFormFile#update:modelValue
     */
    "update:modelValue"
  ],
  data() {
    return {
      uniqID: this.id ?? getUniqueId("dps-form-file-")
    };
  },
  computed: {
    fileSearchTitle() {
      return this.title ?? `Datei${this.multiple ? "en" : ""} auswählen`;
    }
  },
  watch: {
    modelValue: {
      handler(value) {
        if (!value || this.multiple && !value.length) {
          this.$refs.fileInput.value = "";
        }
      }
    }
  },
  methods: {
    getUniqueId,
    handleSelectionChange() {
      const files = this.$refs.fileInput.files;
      if (files.length === 0)
        this.$emit("update:modelValue", this.multiple ? [] : null);
      else
        this.$emit(
          "update:modelValue",
          this.multiple ? Array.from(files) : files[0]
        );
    },
    resetSelection() {
      this.$refs.fileInput.value = "";
      this.$emit("update:modelValue", this.multiple ? [] : null);
    }
  }
});
const _hoisted_1$8 = ["for", "title"];
const _hoisted_2$7 = { class: "sr-only" };
const _hoisted_3$6 = ["id", "accept", "required", "multiple", "disabled"];
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["dps-form-file", {
      "dps-form-file--selected": _ctx.multiple && Array.isArray(_ctx.modelValue) ? _ctx.modelValue.length : _ctx.modelValue,
      "dps-form-file--disabled": _ctx.disabled,
      "dps-form-file--error": _ctx.error
    }])
  }, [
    createElementVNode("label", {
      for: _ctx.uniqID,
      title: _ctx.fileSearchTitle
    }, [
      _cache[3] || (_cache[3] = createElementVNode("span", {
        class: "dps-icon dps-icon--search",
        "aria-hidden": "true"
      }, null, -1)),
      createElementVNode("span", _hoisted_2$7, toDisplayString(_ctx.fileSearchTitle), 1)
    ], 8, _hoisted_1$8),
    createElementVNode("input", {
      id: _ctx.uniqID,
      ref: "fileInput",
      type: "file",
      class: "dps-form-file__input",
      accept: _ctx.accept,
      required: _ctx.required,
      multiple: _ctx.multiple ? true : void 0,
      disabled: _ctx.disabled,
      onChange: _cache[0] || (_cache[0] = (...args) => _ctx.handleSelectionChange && _ctx.handleSelectionChange(...args)),
      onCancel: _cache[1] || (_cache[1] = (...args) => _ctx.resetSelection && _ctx.resetSelection(...args)),
      onClick: _cache[2] || (_cache[2] = (event) => event.target.value = "")
    }, null, 40, _hoisted_3$6)
  ], 2);
}
const DpsFormFile = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$a]]);
const _sfc_main$a = {
  name: "DpsPagination",
  components: {
    DpsFormGroup,
    DpsButton,
    DpsFormSelect
  },
  props: {
    /**
     * Total Number of Elements
     * @required
     */
    numberOfElements: {
      type: Number,
      required: true
    },
    /**
     * Label of pagination menu for accessibilty ("aria-label")
     * @default undefined
     */
    ariaLabel: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * ID of the HTML element the pagination is controlling for accessibility ("aria-controls")
     * @default undefined
     */
    ariaContentId: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Configure select options for "elements per page"
     * @default [25, 50, 100]
     */
    elementsPerPageOptions: {
      type: Array,
      required: false,
      default() {
        return [25, 50, 100];
      }
    },
    /**
     * Configure maximum number of page buttons in pagination
     * @default 5
     */
    numberOfPageNumbers: {
      type: Number,
      required: false,
      default: 5
    },
    /**
     * Set number of pages as prop if the calculation should not be handled automatically (e.g. for serverside pagination). A note for migration: Was "pagesFromServer"
     * @default null
     */
    numberOfPagesAsProp: {
      type: Number,
      required: false,
      default: null
    },
    /**
     * Set current page as prop (e.g. for serverside pagination)
     * @default null
     */
    currentPageAsProp: {
      type: Number,
      required: false,
      default: void 0
    },
    /**
     * Set default option for "elements per page". If not set the first option will be selected. This is useful e.g. when resetting the page size to default on removing filters.
     */
    elementsPerPageAsProp: {
      type: Number,
      required: false,
      default: void 0
    }
  },
  emits: [
    /**
     * Emitted when the pagination is updated
     * @event module:DpsPagination#shownElements
     */
    "updatePagination"
    // TODO fix naming
  ],
  data() {
    return {
      elementsPerPage: this.elementsPerPageAsProp ? {
        value: this.elementsPerPageAsProp,
        label: this.elementsPerPageAsProp
      } : {
        value: this.elementsPerPageOptions[0],
        label: this.elementsPerPageOptions[0]
      },
      currentPage: this.currentPageAsProp ?? 1,
      paginationButtons: []
    };
  },
  computed: {
    uniqueId() {
      return getUniqueId("dps-pagination-");
    },
    /**
     * Number of Pages
     * @return {number}
     */
    numberOfPages() {
      return this.numberOfPagesAsProp ?? Math.ceil(this.numberOfElements / this.elementsPerPage.value);
    },
    /**
     * calculates Page Numbers to be shown on the buttons,
     * shows all if numberOfPages is smaller than numberOfPageNumbers
     * @return {number|*[]}
     */
    shownPageNumbers() {
      if (this.numberOfPages <= this.numberOfPageNumbers) {
        return this.numberOfPages;
      } else {
        let numberNextPages = Math.ceil(this.numberOfPageNumbers / 2);
        const numberPrevPages = Math.floor(this.numberOfPageNumbers / 2);
        const sPages = [];
        for (let i2 = -numberPrevPages; i2 < numberNextPages; i2++) {
          if (this.currentPage + i2 > 0 && this.currentPage + i2 <= this.numberOfPages) {
            sPages.push(this.currentPage + i2);
          } else if (this.currentPage + numberNextPages <= this.numberOfPages) {
            numberNextPages++;
          }
        }
        return sPages;
      }
    },
    /**
     * calculates which elements will be shown on the current page
     * @return {object} {elementsPerPage: default.elementsPerPageAsProp, start: (number|number), end: number, currentPage: number}
     */
    shownElements() {
      const calculateStart = (this.currentPage - 1) * this.elementsPerPage.value;
      const start = calculateStart ?? 0;
      const end = start + this.elementsPerPage.value < this.numberOfElements ? start + this.elementsPerPage.value - 1 : this.numberOfElements - 1;
      return {
        start,
        end,
        elementsPerPage: this.elementsPerPage.value,
        currentPage: this.currentPage
      };
    }
  },
  watch: {
    elementsPerPage() {
      this.currentPage = 1;
      this.$emit("updatePagination", this.shownElements);
    },
    currentPage() {
      this.$nextTick(() => {
        this.updatePaginationButtons();
        this.paginationButtons.forEach((btnElem) => {
          btnElem.removeEventListener("keydown", this.onPageButtonKeydown);
          btnElem.addEventListener("keydown", this.onPageButtonKeydown);
        });
      });
    },
    currentPageAsProp() {
      if (this.currentPageAsProp) {
        this.currentPage = this.currentPageAsProp;
        this.$emit("updatePagination", this.shownElements);
      }
    }
  },
  async mounted() {
    this.updatePaginationButtons();
    this.paginationButtons.forEach((btnElem) => {
      btnElem.addEventListener("keydown", this.onPageButtonKeydown);
    });
  },
  beforeUnmount() {
    this.paginationButtons.forEach((btnElem) => {
      btnElem.removeEventListener("keydown", this.onPageButtonKeydown);
    });
  },
  methods: {
    onPageButtonKeydown(ev) {
      const { key, currentTarget } = ev;
      let index = this.paginationButtons.indexOf(currentTarget);
      let newElem = void 0;
      switch (key) {
        case "Left":
        case "ArrowLeft":
          index = index > 0 ? index - 1 : this.paginationButtons.length - 1;
          newElem = this.paginationButtons[index];
          this.setFocusToPaginationItem(newElem);
          break;
        case "Right":
        case "ArrowRight":
          index = index < this.paginationButtons.length - 1 ? index + 1 : 0;
          newElem = this.paginationButtons[index];
          this.setFocusToPaginationItem(newElem);
          break;
        case " ":
        case "Enter":
          currentTarget.click();
          break;
      }
    },
    isPrintableCharacter(str) {
      return str.length === 1 && str.match(/\S/);
    },
    updatePaginationButtons() {
      this.paginationButtons = this.$refs.paginationMenu ? Array.from(
        this.$refs.paginationMenu.getElementsByTagName("button")
      ).filter((elem) => !elem.disabled) : [];
    },
    setFocusToPaginationItem(newElem) {
      this.paginationButtons.forEach((btnElem) => {
        btnElem.tabIndex = -1;
      });
      newElem.tabIndex = 0;
      newElem.focus();
    },
    /**
     * updates value of current page
     * @param {Number|String} page number of page or inc/dec
     * @return void
     */
    updatePage(page) {
      if (page === "inc") {
        if (this.currentPage < this.numberOfPages) {
          this.currentPage++;
        }
      } else if (page === "dec") {
        if (this.currentPage > 1) {
          this.currentPage--;
        }
      } else {
        this.currentPage = page;
      }
      this.$emit("updatePagination", this.shownElements);
    }
  }
};
const _hoisted_1$7 = { class: "dps-pagination" };
const _hoisted_2$6 = ["aria-label"];
const _hoisted_3$5 = { role: "presentation" };
const _hoisted_4$5 = { role: "presentation" };
const _hoisted_5$3 = { role: "presentation" };
const _hoisted_6$3 = { role: "presentation" };
const _hoisted_7$1 = { class: "dps-pagination__select-container" };
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpsButton = resolveComponent("DpsButton");
  const _component_DpsFormSelect = resolveComponent("DpsFormSelect");
  const _component_DpsFormGroup = resolveComponent("DpsFormGroup");
  return openBlock(), createElementBlock("div", _hoisted_1$7, [
    createElementVNode("ul", {
      ref: "paginationMenu",
      role: "menubar",
      "aria-label": $props.ariaLabel ?? "Paginierung",
      class: "dps-pagination__buttons"
    }, [
      createElementVNode("li", _hoisted_3$5, [
        createVNode(_component_DpsButton, {
          role: "menuitem",
          "aria-controls": $props.ariaContentId,
          title: "erste Seite",
          "aria-label": "erste Seite",
          "aria-disabled": $data.currentPage === 1 || $options.numberOfPages === 0,
          disabled: $data.currentPage === 1 || $options.numberOfPages === 0,
          tabindex: "-1",
          variant: "secondary",
          icon: "chevron-left-double-small",
          squared: "",
          size: "lg",
          onClick: _cache[0] || (_cache[0] = ($event) => $options.updatePage(1))
        }, null, 8, ["aria-controls", "aria-disabled", "disabled"])
      ]),
      createElementVNode("li", _hoisted_4$5, [
        createVNode(_component_DpsButton, {
          role: "menuitem",
          "aria-controls": $props.ariaContentId,
          title: "Seite zurück",
          "aria-label": "Seite zurück",
          "aria-disabled": $data.currentPage === 1 || $options.numberOfPages === 0,
          disabled: $data.currentPage === 1 || $options.numberOfPages === 0,
          tabindex: "-1",
          variant: "secondary",
          icon: "chevron-left-small",
          squared: "",
          size: "lg",
          onClick: _cache[1] || (_cache[1] = ($event) => $options.updatePage("dec"))
        }, null, 8, ["aria-controls", "aria-disabled", "disabled"])
      ]),
      (openBlock(true), createElementBlock(Fragment, null, renderList($options.shownPageNumbers, (page) => {
        return openBlock(), createElementBlock("li", {
          key: page,
          ref_for: true,
          ref: "paginationItem",
          role: "presentation"
        }, [
          createVNode(_component_DpsButton, {
            role: "menuitemradio",
            "aria-controls": $props.ariaContentId,
            title: `Seite ${page}`,
            "aria-label": `Seite ${page}`,
            "aria-checked": page === $data.currentPage,
            "aria-posinset": page,
            "aria-setsize": $options.numberOfPages,
            tabindex: page === $data.currentPage ? "0" : "-1",
            class: normalizeClass(page === $data.currentPage ? "active" : ""),
            variant: "secondary",
            squared: "",
            size: "lg",
            onClick: ($event) => $options.updatePage(page)
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(page), 1)
            ]),
            _: 2
          }, 1032, ["aria-controls", "title", "aria-label", "aria-checked", "aria-posinset", "aria-setsize", "tabindex", "class", "onClick"])
        ]);
      }), 128)),
      createElementVNode("li", _hoisted_5$3, [
        createVNode(_component_DpsButton, {
          role: "menuitem",
          "aria-controls": $props.ariaContentId,
          title: "nächste Seite",
          "aria-label": "nächste Seite",
          "aria-disabled": $data.currentPage === $options.numberOfPages || $options.numberOfPages === 0,
          disabled: $data.currentPage === $options.numberOfPages || $options.numberOfPages === 0,
          tabindex: "-1",
          variant: "secondary",
          icon: "chevron-right-small",
          squared: "",
          size: "lg",
          onClick: _cache[2] || (_cache[2] = ($event) => $options.updatePage("inc"))
        }, null, 8, ["aria-controls", "aria-disabled", "disabled"])
      ]),
      createElementVNode("li", _hoisted_6$3, [
        createVNode(_component_DpsButton, {
          role: "menuitem",
          "aria-controls": $props.ariaContentId,
          title: "letzte Seite",
          "aria-label": "letzte Seite",
          "aria-disabled": $data.currentPage === $options.numberOfPages || $options.numberOfPages === 0,
          disabled: $data.currentPage === $options.numberOfPages || $options.numberOfPages === 0,
          tabindex: "-1",
          variant: "secondary",
          icon: "chevron-right-double-small",
          squared: "",
          size: "lg",
          onClick: _cache[3] || (_cache[3] = ($event) => $options.updatePage($options.numberOfPages))
        }, null, 8, ["aria-controls", "aria-disabled", "disabled"])
      ])
    ], 8, _hoisted_2$6),
    createElementVNode("div", _hoisted_7$1, [
      createVNode(_component_DpsFormGroup, {
        label: "Treffer pro Seite",
        "label-for": "pagination-select-" + $options.uniqueId
      }, {
        default: withCtx(() => [
          createVNode(_component_DpsFormSelect, {
            id: "pagination-select-" + $options.uniqueId,
            modelValue: $data.elementsPerPage,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => $data.elementsPerPage = $event),
            "aria-label": "Treffer pro Seite",
            options: $props.elementsPerPageOptions,
            required: "",
            title: "Treffer pro Seite"
          }, null, 8, ["id", "modelValue", "options"])
        ]),
        _: 1
      }, 8, ["label-for"])
    ])
  ]);
}
const DpsPagination = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$9]]);
const _sfc_main$9 = {
  name: "DpsFormToggle",
  props: {
    /**
     * The unique identifier for the input element.
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * The current value of the toggle switch (on/off).
     * @default false
     */
    modelValue: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * The title attribute for the input element, shown as a tooltip on hover.
     * @default undefined
     */
    title: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Disables the toggle switch when set to true.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * An ARIA label for accessibility, describing the input element.
     * @default undefined
     */
    ariaLabel: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * ID of an element that labels the input element.
     * @default undefined
     */
    ariaLabelledby: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * ID of an element that describes the input element.
     * @default undefined
     */
    ariaDescribedby: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Hides the label.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * The size of the component.
     * @default undefined
     */
    size: {
      type: String,
      required: false,
      default: "md"
    }
  },
  emits: [
    /**
     * Emitted when the toggle switch's value changes.
     * @event update:modelValue
     * @type { boolean }
     */
    "update:modelValue"
  ],
  computed: {
    uniqueId() {
      return this.id ? this.id : getUniqueId("dps-form-toggle-");
    }
  },
  methods: {
    handleChange(event) {
      const target = event.target;
      this.$emit("update:modelValue", target.checked);
    }
  }
};
const _hoisted_1$6 = ["for", "title"];
const _hoisted_2$5 = ["id", "checked", "disabled", "aria-label", "aria-describedby", "aria-labelledby"];
const _hoisted_3$4 = {
  key: 0,
  class: "dps-form-toggle__label sr-only"
};
const _hoisted_4$4 = {
  key: 1,
  class: "dps-form-toggle__label"
};
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["dps-form-toggle dps-input-wrapper", [
      "dps-form-toggle--size-" + $props.size,
      { "dps-form-toggle--disabled": $props.disabled }
    ]])
  }, [
    createElementVNode("label", {
      for: $options.uniqueId,
      title: $props.title,
      class: "dps-form-toggle__container"
    }, [
      createElementVNode("input", {
        id: $options.uniqueId,
        ref: "input",
        class: "dps-toggle",
        type: "checkbox",
        checked: $props.modelValue,
        disabled: $props.disabled,
        "aria-label": $props.ariaLabel,
        "aria-describedby": $props.ariaDescribedby,
        "aria-labelledby": $props.ariaLabelledby,
        onChange: _cache[0] || (_cache[0] = (...args) => $options.handleChange && $options.handleChange(...args))
      }, null, 40, _hoisted_2$5),
      _cache[1] || (_cache[1] = createElementVNode("span", { class: "dps-form-toggle__slider" }, null, -1)),
      $props.hideLabel ? (openBlock(), createElementBlock("span", _hoisted_3$4, [
        renderSlot(_ctx.$slots, "default")
      ])) : (openBlock(), createElementBlock("span", _hoisted_4$4, [
        renderSlot(_ctx.$slots, "default")
      ]))
    ], 8, _hoisted_1$6)
  ], 2);
}
const DpsFormToggle = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$8]]);
const _sfc_main$8 = defineComponent({
  name: "DpsLogoutAlert",
  components: { DpsButton, DpsAlert },
  props: {
    /**
     * Defines when the current session expires (UNIX timestamp in seconds)
     */
    expirationTime: {
      type: Number,
      required: true
    },
    /**
     * Defines how many minutes before the logout the alert should be visible
     * @default 3
     */
    threshold: {
      type: Number,
      default: 3,
      required: false
    }
  },
  emits: [
    /**
     * Emitted when the user clicks the "Neu anmelden" button
     */
    "click"
  ],
  data() {
    return {
      interval: null,
      minutesToLogout: null
    };
  },
  computed: {
    showLogoutAlert() {
      return this.minutesToLogout <= this.threshold;
    }
  },
  watch: {
    expirationTime() {
      this.startInterval();
    }
  },
  created() {
    this.startInterval();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    startInterval() {
      this.setMinutesToLogout();
      clearInterval(this.interval);
      if (this.minutesToLogout > 0) {
        this.interval = setInterval(this.setMinutesToLogout, 1e3);
      }
    },
    setMinutesToLogout() {
      const expirationTime = this.expirationTime * 1e3;
      const currentTime = Date.now();
      const timeRemaining = expirationTime - currentTime;
      this.minutesToLogout = Math.ceil(timeRemaining / 1e3 / 60);
      if (this.minutesToLogout <= 0) {
        clearInterval(this.interval);
      }
    },
    handleClick() {
      this.$emit("click");
    }
  }
});
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpsButton = resolveComponent("DpsButton");
  const _component_DpsAlert = resolveComponent("DpsAlert");
  return _ctx.showLogoutAlert ? (openBlock(), createBlock(_component_DpsAlert, {
    key: 0,
    variant: "info",
    class: "dps-logout-alert"
  }, {
    default: withCtx(() => [
      createElementVNode("div", null, [
        _cache[1] || (_cache[1] = createElementVNode("b", null, "Hinweis:", -1)),
        _cache[2] || (_cache[2] = createTextVNode(" Aus Sicherheitsgründen werden Sie in ")),
        createElementVNode("b", null, [
          _ctx.minutesToLogout > 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(toDisplayString(_ctx.minutesToLogout) + " " + toDisplayString(_ctx.minutesToLogout === 1 ? "Minute" : "Minuten"), 1)
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode("Kürze")
          ], 64)),
          _cache[0] || (_cache[0] = createTextVNode(" automatisch ausgeloggt. "))
        ]),
        _cache[3] || (_cache[3] = createTextVNode(" Bitte melden Sie sich anschließend erneut an. "))
      ]),
      createVNode(_component_DpsButton, {
        class: "dps-logout-alert__logout-button",
        variant: "secondary",
        size: "sm",
        onClick: _ctx.handleClick
      }, {
        default: withCtx(() => _cache[4] || (_cache[4] = [
          createTextVNode(" Neu anmelden ")
        ])),
        _: 1,
        __: [4]
      }, 8, ["onClick"])
    ]),
    _: 1
  })) : createCommentVNode("", true);
}
const DpsLogoutAlert = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$7]]);
var locale = {
  months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
  monthsShort: ["Jan", "Feb", "März", "Apr", "Mai", "Juni", "Juli", "Aug", "Sep", "Okt", "Nov", "Dez"],
  weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
  weekdaysShort: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  weekdaysMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  firstDayOfWeek: 1,
  firstWeekContainsDate: 4
};
const lang = {
  formatLocale: locale,
  yearFormat: "YYYY",
  monthFormat: "MMM",
  monthBeforeYear: true
};
DatePicker.locale("de", lang);
const _sfc_main$7 = {
  name: "DpsFormDatepicker",
  components: {
    DpsFormCheckbox,
    DpsButton,
    DatePickerNext: DatePicker
  },
  inheritAttrs: false,
  props: {
    /**
     * Sets the initial date in the format `YYYY-MM-DD`.
     * Example: `2024-10-02`.
     */
    initialDate: {
      type: String,
      default: ""
    },
    /**
     * Enables the checkbox next to the date picker.
     */
    hasCheckbox: {
      type: Boolean,
      default: false
    },
    /**
     * Sets the initial state of the checkbox.
     */
    isCheckboxChecked: {
      type: Boolean,
      default: false
    },
    /**
     * Title for the checkbox.
     */
    checkboxTitle: {
      type: String,
      default: ""
    },
    /**
     * An array of dates that should be grayed out.
     * Can either be an array of dates or an array of objects containing a "from" and "to" date and an optional title.
     * Example: `[new Date(2024, 9, 15)]` or `[{from: "01.02.2025", to: "10.02.2025", title: "Beispieltermin"}]`.
     */
    dateBlackList: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Watch for external updates.
     */
    watchForExternalUpdates: {
      type: Boolean,
      default: false
    },
    /**
     * Sets the start and end dates for the range.
     * Example: `{ beginn: new Date(), ende: new Date() }`.
     */
    zeitraum: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * Disables the date picker when true.
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Disables the date picker with readonly styles
     * @default false
     */
    readonly: {
      type: Boolean,
      default: false,
      required: false
    },
    /**
     * Placeholder text for the input field.
     */
    placeholder: {
      type: String,
      default: "TT.MM.JJJJ"
    },
    /**
     * Enables range selection mode.
     */
    range: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Allows the date picker to be cleared when set to true.
     */
    clearable: {
      type: Boolean,
      default: true
    },
    /**
     * Enables manual input in the date field when set to true.
     */
    editable: {
      type: Boolean,
      default: true
    },
    /**
     * For styling the node element
     * (fallthough attributes are added to the native form element)
     * @default ""
     */
    class: {
      type: String,
      required: false,
      default: ""
    }
  },
  emits: [
    /**
     * Emitted when the selected date value changes.
     * @event date-picker-value
     */
    "date-picker-value",
    /**
     * Emitted when the checkbox state changes.
     * @event is-checkbox-checked
     */
    "is-checkbox-checked",
    /**
     * Emitted when the date picker is opened.
     * @event date-picker-opened
     */
    "date-picker-opened",
    /**
     * Emitted when a date is selected.
     * @event pick-element
     */
    "pick-element",
    /**
     * Emitted when the date range is updated.
     * @event update-range
     */
    "update-range",
    /**
     * Emitted when the duration is updated.
     * @event update-termindauer
     */
    "update-termindauer",
    /**
     * Emitted when the start or end dates are changed.
     * @event start-end
     */
    "start-end"
  ],
  data() {
    return {
      KEY_ARROW_RIGHT: "ArrowRight",
      KEY_ARROW_LEFT: "ArrowLeft",
      KEY_ARROW_UP: "ArrowUp",
      KEY_ARROW_DOWN: "ArrowDown",
      KEY_ENTER: "Enter",
      KEY_ESCAPE: "Escape",
      KEY_TAB: "Tab",
      defaultDate: this.getDefaultDate(),
      dauer: null,
      dateBlackListFinal: [],
      startDate: this.zeitraum && this.zeitraum.beginn ? moment(this.zeitraum.beginn).format("DD.MM.YYYY") : "",
      endDate: this.zeitraum && this.zeitraum.ende ? moment(this.zeitraum.ende).format("DD.MM.YYYY") : "",
      datepicker: null,
      datepickerPopup: null,
      cssClasses: {
        popup: "mx-datepicker-popup",
        header: "mx-calendar-header",
        calendarContent: "mx-calendar-content",
        rows: "tr.mx-date-row:not(.d-none)",
        firstRow: "mx-date-row:first-of-type",
        lastRow: "mx-date-row:last-of-type",
        cellsInCurrentMonth: "td.cell:not(.not-current-month)",
        hidden: "d-none",
        blackDate: "black-date",
        dayView: "mx-calendar-panel-date",
        monthView: "mx-calendar-panel-month",
        yearView: "mx-calendar-panel-year"
      },
      heights: {
        contentHeightSm: 225,
        contentHeightMd: 268,
        contentHeightLg: 308
      },
      isOpenDatepicker: false,
      isChecked: false
    };
  },
  computed: {
    outerClass() {
      return this.class;
    }
  },
  watch: {
    initialDate: {
      deep: true,
      handler(newInitialDate) {
        if (this.watchForExternalUpdates) {
          this.defaultDate = newInitialDate ? new Date(newInitialDate) : "";
        }
      }
    },
    zeitraum: {
      deep: true,
      handler(value) {
        if (value) {
          this.startDate = value.beginn ? moment(value.beginn).format("DD.MM.YYYY") : "";
          this.endDate = value.ende ? moment(value.ende).format("DD.MM.YYYY") : "";
          this.defaultDate = this.getDefaultDate();
        }
      }
    },
    defaultDate: {
      deep: true,
      handler(value) {
        if (this.range) {
          this.startDate = value[0] ? moment(value[0]).format("DD.MM.YYYY") : "";
          this.endDate = value[1] ? moment(value[1]).format("DD.MM.YYYY") : "";
          if (!value.length) {
            this.updateRange();
            this.$emit("update-termindauer", "", "", 0);
          }
        }
      }
    }
  },
  mounted() {
    this.datepicker = this.$refs.datepicker;
    this.isChecked = this.isCheckboxChecked;
    this.calculateFinalBlacklist();
    if (this.range) {
      this.calcDateDifference();
    } else {
      this.defaultDate = new Date(this.initialDate);
    }
  },
  methods: {
    /**
     * Handles the behavior when confirm button is clicked
     * Ensures popup doesn't reopen immediately after closing
     */
    handleConfirm() {
      this.isOpenDatepicker = false;
      this.$nextTick(() => {
        this.$refs.datepicker.getElementsByTagName("input")[0].blur();
      });
    },
    /**
     * Toggles the datepicker open state.
     * Can be used for both click and keyup.enter events.
     * @returns {void}
     */
    toggleDatepicker() {
      if (!this.isOpenDatepicker) {
        this.isOpenDatepicker = true;
        this.$nextTick(() => {
          this.handleOpen();
        });
      }
    },
    /**
     * returns valid moment date or null
     * @param   {string} dateString string to parse
     * @returns {moment.Moment} date or null
     */
    getMomentDate(dateString) {
      if (dateString) {
        return moment(dateString, "DD.MM.YYYY");
      }
      return null;
    },
    /**
     * calculates the duration between dates
     * @param {Array} datesArr selected date as Array or empty
     * @returns {void}
     */
    calcDateDifference(datesArr = []) {
      if (datesArr.length < 2 || datesArr.some((date) => date === null)) return;
      const startMoment = this.getMomentDate(datesArr[0]);
      const endMoment = this.getMomentDate(datesArr[1]);
      this.dauer = endMoment.diff(startMoment, "days") || 0;
      this.$emit("start-end", {
        beginn: startMoment.format("YYYY-MM-DD"),
        ende: endMoment.format("YYYY-MM-DD")
      });
      this.$emit("update-termindauer", startMoment, endMoment, this.dauer);
    },
    /**
     * Check if the date changed in the datepicker range
     * @returns {void}
     */
    updateRange() {
      let beginn = "";
      let ende = "";
      if (this.startDate && this.endDate) {
        const startMoment = this.getMomentDate(this.startDate);
        const endMoment = this.getMomentDate(this.endDate);
        this.dauer = endMoment.diff(startMoment, "days") || 0;
        beginn = startMoment.format("YYYY-MM-DD");
        ende = endMoment.format("YYYY-MM-DD");
      }
      this.$emit("update-range", {
        beginn,
        ende,
        dauer: this.dauer
      });
    },
    /**
     * function to get the defaultDate from zeitraum
     * @return {object}
     */
    getDefaultDate() {
      if (this.range) {
        return this.zeitraum?.beginn && this.zeitraum?.ende ? [
          new Date(moment(this.zeitraum.beginn).format("MM.DD.YYYY")),
          new Date(moment(this.zeitraum.ende).format("MM.DD.YYYY"))
        ] : [];
      } else {
        return this.initialDate ? new Date(this.initialDate) : "";
      }
    },
    /**
     * Moves focus to a different cell in the datepicker based on the given offset.
     * @param {number} dayOffset - The number of days to move the focus by.
     * @param {HTMLElement} currentPanel - The currently active panel containing the date cells (day, month, or year view).
     * @returns {void}
     */
    moveFocus(dayOffset, currentPanel) {
      if (!currentPanel) return;
      const dateCells = Array.from(currentPanel.querySelectorAll(".cell"));
      if (dateCells.length === 0) return;
      const focusedElement = document.activeElement;
      const focusedIndex = dateCells.findIndex(
        (cell) => cell === focusedElement
      );
      if (focusedIndex === -1) {
        this.setFocusOnCell(dateCells[0]);
        return;
      }
      const newIndex = focusedIndex + dayOffset;
      if (newIndex >= 0 && newIndex < dateCells.length) {
        this.updateFocus(dateCells[focusedIndex], dateCells[newIndex]);
      }
    },
    /**
     * Sets focus on a specific cell in the datepicker.
     * @param {HTMLElement} cell - The cell to focus.
     * @returns {void}
     */
    setFocusOnCell(cell) {
      const allCells = this.datepickerPopup.querySelectorAll(".cell");
      allCells.forEach((c2) => c2.classList.remove("focused"));
      cell.tabIndex = 0;
      cell.classList.add("focused");
      cell.focus();
    },
    /**
     * Updates focus by removing focus from the old cell and applying it to the new cell.
     * @param {HTMLElement} oldCell - The previously focused cell.
     * @param {HTMLElement} newCell - The new cell to focus on.
     * @returns {void}
     */
    updateFocus(oldCell, newCell) {
      if (oldCell) {
        oldCell.classList.remove("focused");
        oldCell.tabIndex = -1;
      }
      if (newCell) {
        this.setFocusOnCell(newCell);
      }
    },
    /**
     * Handles keydown events for navigating within the datepicker panels.
     *
     * This function manages navigation within day, month, and year views based on
     * arrow keys, handles the "Enter" key to simulate clicks, and ensures focus trapping
     * within the datepicker. It also manages specific transitions when navigating between
     * different calendar panels in range view.
     *
     * @param {KeyboardEvent} event - The keyboard event object containing information about the key pressed.
     *
     * @returns {void}
     */
    handleKeydown(event) {
      const focusedElement = document.activeElement;
      const isDayView = !!focusedElement.closest(".mx-calendar-panel-date");
      const isMonthView = !!focusedElement.closest(".mx-calendar-panel-month");
      const isYearView = !!focusedElement.closest(".mx-calendar-panel-year");
      const currentPanel = isDayView ? focusedElement.closest(".mx-calendar-panel-date") : isMonthView ? focusedElement.closest(".mx-calendar-panel-month") : isYearView ? focusedElement.closest(".mx-calendar-panel-year") : null;
      const keyMoveMapping = {
        [this.KEY_ARROW_RIGHT]: isDayView || isMonthView || isYearView ? 1 : 0,
        [this.KEY_ARROW_LEFT]: isDayView || isMonthView || isYearView ? -1 : 0,
        [this.KEY_ARROW_UP]: isDayView ? -7 : isMonthView ? -3 : isYearView ? -2 : 0,
        [this.KEY_ARROW_DOWN]: isDayView ? 7 : isMonthView ? 3 : isYearView ? 2 : 0
      };
      if (event.key === this.KEY_ARROW_UP || event.key === this.KEY_ARROW_DOWN) {
        event.preventDefault();
      }
      const moveStep = keyMoveMapping[event.key] || 0;
      if (moveStep !== 0 && currentPanel) {
        const direction = event.key === this.KEY_ARROW_RIGHT ? "right" : event.key === this.KEY_ARROW_LEFT ? "left" : event.key === this.KEY_ARROW_UP ? "up" : event.key === this.KEY_ARROW_DOWN ? "down" : null;
        if (isDayView && direction) {
          this.handleDayViewBoundaryMove(moveStep, currentPanel, direction);
        } else {
          this.moveFocus(moveStep, currentPanel);
        }
      }
      if (event.key === this.KEY_ENTER) {
        this.handleEnterKey(event);
      }
      if (event.key === this.KEY_ESCAPE) {
        this.isOpenDatepicker = false;
        this.resetFocusToCurrentDatepickerInput();
      }
      this.trapFocus(event);
    },
    /**
     * Handles focus movement in the day view, including crossing boundaries between calendar panels.
     * @param {number} moveStep - The number of steps to move the focus by (positive for forward, negative for backward).
     * @param {HTMLElement} currentPanel - The currently active panel (day view) containing the date cells.
     * @param {string} direction - The direction of movement (e.g., 'left', 'right', 'up', 'down').
     * @returns {void}
     */
    handleDayViewBoundaryMove(moveStep, currentPanel, direction) {
      const dateCells = Array.from(
        currentPanel.querySelectorAll(".cell:not(.not-current-month)")
      );
      if (dateCells.length === 0) return;
      const focusedElement = document.activeElement;
      const focusedIndex = dateCells.findIndex(
        (cell) => cell === focusedElement
      );
      if (focusedIndex === -1) {
        this.setFocusOnCell(dateCells[0]);
        return;
      }
      const newIndex = focusedIndex + moveStep;
      switch (direction) {
        case "down":
        case "up":
          if (newIndex >= 0 && newIndex < dateCells.length) {
            this.updateFocus(dateCells[focusedIndex], dateCells[newIndex]);
          }
          break;
        case "right":
          if (newIndex >= dateCells.length) {
            const nextCalendar = currentPanel.nextElementSibling;
            if (nextCalendar) {
              const nextDateCells = Array.from(
                nextCalendar.querySelectorAll(".cell:not(.not-current-month)")
              );
              if (nextDateCells.length > 0) {
                this.setFocusOnCell(nextDateCells[0]);
              }
            }
          } else {
            this.updateFocus(dateCells[focusedIndex], dateCells[newIndex]);
          }
          break;
        case "left":
          if (newIndex < 0) {
            const previousCalendar = currentPanel.previousElementSibling;
            if (previousCalendar) {
              const previousDateCells = Array.from(
                previousCalendar.querySelectorAll(
                  ".cell:not(.not-current-month)"
                )
              );
              if (previousDateCells.length > 0) {
                this.setFocusOnCell(
                  previousDateCells[previousDateCells.length - 1]
                );
              }
            }
          } else {
            this.updateFocus(dateCells[focusedIndex], dateCells[newIndex]);
          }
          break;
      }
    },
    /**
     * Handles the behavior when the "Enter" key is pressed.
     * @param {KeyboardEvent} event - The keyboard event object.
     * @returns {void}
     */
    handleEnterKey(event) {
      event.target.click();
      this.$nextTick(() => {
        const isYearView = document.querySelector(".mx-calendar-panel-year");
        const isMonthView = document.querySelector(".mx-calendar-panel-month");
        const activeCell = isYearView ? isYearView.querySelector("td.cell.active") : isMonthView ? isMonthView.querySelector("td.cell.active") : null;
        if (activeCell) {
          activeCell.setAttribute("tabindex", "0");
          activeCell.focus();
        }
      });
    },
    /**
     * Sets up an event listener for the datepicker popup.
     * @returns {void}
     */
    setPopupEventListener() {
      this.$nextTick(() => {
        if (this.datepickerPopup) {
          this.datepickerPopup.addEventListener("keydown", this.handleKeydown);
        }
      });
    },
    /**
     * Checks and sets the focus on either 'today' or 'active' cell after the DOM updates.
     * @returns {void}
     */
    checkAndSetCellFocus() {
      this.$nextTick(() => {
        if (!this.datepickerPopup) return;
        const yearPanels = this.datepickerPopup.querySelectorAll(
          ".mx-calendar-panel-year"
        );
        const monthPanels = this.datepickerPopup.querySelectorAll(
          ".mx-calendar-panel-month"
        );
        const dayPanels = this.datepickerPopup.querySelectorAll(
          ".mx-calendar-panel-date"
        );
        if (yearPanels.length) {
          const leftYearPanel = yearPanels[0];
          const activeYearCell = leftYearPanel.querySelector("td.cell.active") || leftYearPanel.querySelector("td.cell");
          if (activeYearCell) {
            this.setFocusOnCell(activeYearCell);
          }
          return;
        }
        if (monthPanels.length) {
          const leftMonthPanel = monthPanels[0];
          const activeMonthCell = leftMonthPanel.querySelector("td.cell.active") || leftMonthPanel.querySelector("td.cell");
          if (activeMonthCell) {
            this.setFocusOnCell(activeMonthCell);
          }
          return;
        }
        if (dayPanels.length) {
          const leftDayPanel = dayPanels[0];
          const activeDayCell = leftDayPanel.querySelector(".cell.active") || leftDayPanel.querySelector(".cell.today") || leftDayPanel.querySelector(".cell:not(.not-current-month)");
          if (activeDayCell) {
            this.setFocusOnCell(activeDayCell);
          }
        }
      });
    },
    /**
     * Traps focus within the datepicker popup for improved accessibility.
     * @param {KeyboardEvent} event - The keyboard event object.
     * @returns {void}
     */
    trapFocus(event) {
      const focusableElements = this.getFocusableElements();
      if (focusableElements.length === 0) {
        return;
      }
      const [firstElement, lastElement] = [
        focusableElements[0],
        focusableElements[focusableElements.length - 1]
      ];
      if (event.key === this.KEY_TAB) {
        this.handleTabNavigation(event, firstElement, lastElement);
      }
    },
    /**
     * Retrieves all focusable elements inside the datepickerPopup.
     * @returns {HTMLElement[]} Array of focusable elements.
     */
    getFocusableElements() {
      const allFocusableElements = this.datepickerPopup.querySelectorAll(
        'input, a, .mx-calendar-panel-month button, .mx-calendar-panel-year button, .mx-calendar-panel-date button:not(.mx-btn-icon-double-left), [tabindex]:not([tabindex="-1"]), .mx-datepicker-footer button'
      );
      return Array.from(allFocusableElements).filter((element) => {
        const style2 = window.getComputedStyle(element);
        return element.offsetWidth > 0 && element.offsetHeight > 0 && style2.visibility !== "hidden" && style2.display !== "none";
      });
    },
    /**
     * Handles Tab and Shift+Tab navigation for focus trapping.
     * @param {KeyboardEvent} event - The keyboard event object.
     * @param {HTMLElement} firstElement - The first focusable element.
     * @param {HTMLElement} lastElement - The last focusable element.
     * @returns {void}
     */
    handleTabNavigation(event, firstElement, lastElement) {
      const isShiftTab = event.shiftKey;
      if (isShiftTab && document.activeElement === firstElement) {
        lastElement.focus();
        event.preventDefault();
      } else if (!isShiftTab && document.activeElement === lastElement) {
        firstElement.focus();
        event.preventDefault();
      }
    },
    /**
     * Resets the focus back to the current datepicker input element.
     * @returns {void}
     */
    resetFocusToCurrentDatepickerInput() {
      this.$nextTick(() => {
        this.$refs.datepicker.getElementsByTagName("input")[0].select();
      });
    },
    /**
     * Improves the accessibility of navigation buttons in the datepicker.
     * Sets titles for previous, next, month, and year buttons for better understanding and accessibility.
     * @returns {void}
     */
    improveNavigationButtonAccessibility() {
      this.$nextTick(() => {
        if (!this.datepickerPopup) return;
        const buttonTitles = {
          ".mx-calendar-header .mx-btn-icon-left, .mx-calendar-header .mx-btn-icon-double-left": "Zurück",
          ".mx-calendar-header .mx-btn-icon-right, .mx-calendar-header .mx-btn-icon-double-right": "Weiter",
          ".mx-calendar-header .mx-btn-current-month": "Monat",
          ".mx-calendar-header .mx-btn-current-year": "Jahr"
        };
        Object.entries(buttonTitles).forEach(([selector, title]) => {
          const buttons = this.datepickerPopup.querySelectorAll(selector);
          buttons.forEach((button) => {
            button.title = title;
          });
        });
      });
    },
    /**
     * Sets titles to each cell in the datepicker.
     * The title is set to the text content of the cell for better accessibility.
     * @returns {void}
     */
    setCellTitles() {
      this.$nextTick(() => {
        if (!this.datepickerPopup) return;
        const cells = this.datepickerPopup.querySelectorAll(
          ".mx-calendar-panel-month .mx-calendar-content .cell, .mx-calendar-panel-year .mx-calendar-content .cell"
        );
        cells.forEach((cell) => {
          cell.title = cell.textContent.trim();
        });
      });
    },
    /**
     * run functions to customize the datepicker
     * @returns {void}
     */
    customizeDatePicker() {
      this.setDateBlacklist();
      this.hideRowsNotInCurrentMonth();
    },
    /**
     * Sets CSS classes and titles for black and white days based on the provided lists.
     * @param {Array} dateList - The list of dates to process.
     * @returns {void}
     */
    async setDateList(dateList) {
      await this.selectDatepickerPopup();
      if (!this.datepickerPopup) return;
      const calendarContents = this.datepickerPopup.querySelectorAll(
        `.${this.cssClasses.calendarContent}`
      );
      if (!calendarContents) return;
      calendarContents.forEach((calendarContent) => {
        const blackDateCells = calendarContent.querySelectorAll(
          `.${this.cssClasses.blackDate}`
        );
        blackDateCells.forEach((cell) => {
          cell.classList.remove(this.cssClasses.blackDate);
          cell.removeAttribute("data-tooltip");
        });
      });
      dateList.forEach((date) => {
        const localDate = date instanceof Date ? moment(date) : date.date;
        const formattedDate = localDate.format("YYYY-MM-DD");
        calendarContents.forEach((calendarContent) => {
          const dateCell = calendarContent.querySelector(
            `.cell[title='${formattedDate}']`
          );
          if (dateCell) {
            this.addDateClass(dateCell, date.title || "");
          }
        });
      });
    },
    /**
     * Adds the specified CSS class and updates attributes for the date cell.
     * @param {Element} dateCell - The cell element for the date.
     * @param {string} zusatz - Additional label for the date (if available).
     * @returns {void}
     */
    addDateClass(dateCell, zusatz) {
      dateCell.classList.add(this.cssClasses.blackDate);
      const dateTitle = zusatz || "";
      if (dateTitle) {
        dateCell.setAttribute("aria-label", dateCell.getAttribute("title"));
        dateCell.setAttribute("title", dateTitle);
      }
    },
    async setDateBlacklist() {
      this.setDateList(this.dateBlackListFinal);
    },
    /**
     * Hide first or last row if all days in the calendar row are in the new month
     * @returns {void}
     */
    async hideRowsNotInCurrentMonth() {
      await this.selectDatepickerPopup();
      if (!this.datepickerPopup) return;
      const popupContent = this.datepickerPopup.querySelectorAll(
        `.${this.cssClasses.calendarContent}`
      );
      for (const panel of popupContent) {
        const rows = panel.querySelectorAll("tr.mx-date-row");
        for (const row of rows) {
          const cellsInRowInCurrentMonth = row.querySelectorAll(
            this.cssClasses.cellsInCurrentMonth
          );
          const shouldShowRow = cellsInRowInCurrentMonth.length > 0;
          row.classList.toggle(this.cssClasses.hidden, !shouldShowRow);
        }
        const finalVisibleRows = panel.querySelectorAll(
          `tr.mx-date-row:not(.${this.cssClasses.hidden})`
        );
        const visibleCount = finalVisibleRows.length;
        if (visibleCount === 0) {
          panel.style.setProperty("--mx-content-height", "0px");
        } else if (visibleCount < 5) {
          panel.style.setProperty(
            "--mx-content-height",
            this.heights.contentHeightSm + "px"
          );
        } else if (visibleCount === 5) {
          panel.style.setProperty(
            "--mx-content-height",
            this.heights.contentHeightMd + "px"
          );
        } else {
          panel.style.setProperty(
            "--mx-content-height",
            this.heights.contentHeightLg + "px"
          );
        }
      }
    },
    /**
     * select popup element and customize the datepicker
     * @returns {void}
     */
    async handleOpen() {
      this.isChecked = this.isCheckboxChecked;
      await this.selectDatepickerPopup();
      if (this.datepickerPopup) {
        this.customizeDatePicker();
        this.improveNavigationButtonAccessibility();
        this.setCellTitles();
        this.checkAndSetCellFocus();
        this.setPopupEventListener();
        this.$emit("date-picker-opened");
      }
    },
    handleClose() {
      this.datepickerPopup.removeEventListener("keydown", this.handleKeydown);
      this.updateRange();
      this.isOpenDatepicker = false;
      this.resetFocusToCurrentDatepickerInput();
    },
    /**
     * function to handle the calendar change event. customize the popup element.
     * @returns {void}
     */
    handleCalendarChange() {
      this.customizeDatePicker();
      this.improveNavigationButtonAccessibility();
      this.setCellTitles();
      this.$nextTick(() => {
        this.hideRowsNotInCurrentMonth();
      });
    },
    /**
     * function to select the popup element of the datepicker after it was opened
     * @returns {Promise}
     */
    selectDatepickerPopup() {
      return new Promise((resolve, reject) => {
        if (this.datepickerPopup) resolve();
        this.$nextTick(() => {
          this.datepickerPopup = document.querySelector(
            `.${this.cssClasses.popup}`
          );
          if (this.datepickerPopup) resolve();
          reject();
        });
      });
    },
    updateCheckbox(value) {
      this.$emit("is-checkbox-checked", value);
    },
    /**
     * function to handle the change event. set the start date and emits the date-picker-value event.
     * @emits date-picker-value
     * @returns {void}
     */
    handleChange(selectedDates) {
      if (!selectedDates) {
        this.$emit("date-picker-value", null);
        return;
      }
      const formatDate = (date) => moment(date, moment.ISO_8601, true).isValid() ? moment(date).format("DD.MM.YYYY") : moment(date, "DD.MM.YYYY").format("DD.MM.YYYY");
      if (!this.range) {
        const formattedDate = formatDate(selectedDates);
        this.$emit("date-picker-value", formattedDate);
      } else {
        if (selectedDates.length < 1 || selectedDates[0] === null) {
          this.startDate = "";
          this.endDate = "";
        } else {
          this.startDate = formatDate(selectedDates[0]);
          this.endDate = this.startDate;
          if (selectedDates.length >= 2 && selectedDates[1] !== null) {
            this.endDate = formatDate(selectedDates[1]);
            this.calcDateDifference(selectedDates);
          }
        }
      }
      this.handleConfirm();
      this.$nextTick(() => {
        this.checkAndSetCellFocus();
        this.resetFocusToCurrentDatepickerInput();
      });
    },
    handlePanelChange() {
      this.$nextTick(() => {
        this.improveNavigationButtonAccessibility();
        this.setCellTitles();
        this.checkAndSetCellFocus();
        this.setPopupEventListener();
      });
    },
    /**
     * creates a list of all blacklisted dates and the corresponding titles.
     */
    calculateFinalBlacklist() {
      if (!Array.isArray(this.dateBlackList)) {
        this.dateBlackListFinal = [];
      } else if (this.dateBlackList[0] instanceof Date) {
        this.dateBlackListFinal = this.dateBlackList;
      } else {
        this.dateBlackList.forEach((date) => {
          if (date.to && date.from) {
            const fromDate = moment(date.from);
            const toDate = moment(date.to);
            const diff = toDate.diff(fromDate, "days");
            for (let i2 = 0; i2 <= diff; i2++) {
              this.dateBlackListFinal.push({
                date: moment(date.from).add(i2, "days"),
                title: date.title
              });
            }
          }
        });
      }
    }
  }
};
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpsFormCheckbox = resolveComponent("DpsFormCheckbox");
  const _component_DpsButton = resolveComponent("DpsButton");
  const _component_DatePickerNext = resolveComponent("DatePickerNext");
  return openBlock(), createBlock(_component_DatePickerNext, {
    ref: "datepicker",
    value: $data.defaultDate,
    "onUpdate:value": _cache[1] || (_cache[1] = ($event) => $data.defaultDate = $event),
    class: normalizeClass(["dps-form-datepicker", {
      "dps-form-datepicker--range": $props.range,
      [$options.outerClass]: true,
      "dps-form-datepicker--disabled": $props.disabled,
      "dps-form-datepicker--readonly": $props.readonly
    }]),
    format: "DD.MM.YYYY",
    type: "date",
    open: $data.isOpenDatepicker,
    range: $props.range,
    "popup-class": "dps-form-datepicker__popup" + ($props.range ? " range" : ""),
    placeholder: $props.range ? $data.startDate && $data.endDate ? `${$data.startDate} - ${$data.endDate}` : "TT.MM.JJJJ - TT.MM.JJJJ" : $props.placeholder,
    separator: " - ",
    disabled: $props.disabled || $props.readonly,
    "input-attr": _ctx.$attrs,
    clearable: $props.clearable,
    editable: $props.editable,
    confirm: $props.range,
    "confirm-text": "Übernehmen",
    onClick: $options.toggleDatepicker,
    onKeydown: withKeys(withModifiers($options.toggleDatepicker, ["stop", "prevent"]), ["enter"]),
    onClose: $options.handleClose,
    onCalendarChange: $options.handleCalendarChange,
    onChange: $options.handleChange,
    onPick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("pick-element", $event)),
    onPanelChange: $options.handlePanelChange
  }, createSlots({
    "icon-calendar": withCtx(() => [
      _cache[4] || (_cache[4] = createElementVNode("span", { class: "dps-icon dps-icon--calendar" }, null, -1))
    ]),
    _: 2
  }, [
    $props.range || $props.hasCheckbox ? {
      name: "footer",
      fn: withCtx(() => [
        $props.hasCheckbox ? (openBlock(), createBlock(_component_DpsFormCheckbox, {
          key: 0,
          modelValue: $data.isChecked,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event) => $data.isChecked = $event),
            $options.updateCheckbox
          ],
          title: $props.checkboxTitle
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString($props.checkboxTitle), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "title", "onUpdate:modelValue"])) : createCommentVNode("", true),
        $props.range ? (openBlock(), createBlock(_component_DpsButton, {
          key: 1,
          class: "dps-form-datepicker__button-cancel",
          variant: "secondary",
          title: "Abbrechen",
          size: "sm",
          onClick: $options.handleClose
        }, {
          default: withCtx(() => _cache[3] || (_cache[3] = [
            createTextVNode(" Abbrechen ")
          ])),
          _: 1,
          __: [3]
        }, 8, ["onClick"])) : createCommentVNode("", true)
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["value", "class", "open", "range", "popup-class", "placeholder", "disabled", "input-attr", "clearable", "editable", "confirm", "onClick", "onKeydown", "onClose", "onCalendarChange", "onChange", "onPanelChange"]);
}
const DpsFormDatepicker = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$6]]);
const _sfc_main$6 = {
  name: "DpsUploadFormGroup",
  components: { DpsFormFile, DpsFormGroup, DpsButton, DpsInputGroup },
  props: {
    /**
     * The unique identifier for the input (optional).
     * @default undefined
     */
    id: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * The label for the component.
     * @default ""
     */
    label: {
      type: String,
      required: false,
      default: ""
    },
    /**
     * Hides the label.
     * @default false
     */
    hideLabel: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * The label for the upload button.
     * @default "Hochladen"
     */
    uploadButtonLabel: {
      type: String,
      required: false,
      default: "Hochladen"
    },
    /**
     * The title for the upload button.
     * Defaults to the button label if no title is set.
     * @default undefined
     */
    uploadButtonTitle: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Which file formats to accept.
     * Can be either file extension or mime-type or mixed
     * e.g. ['.pdf'], ['application/pdf'] or ['.pdf', 'application/pdf']
     * @default []
     */
    fileAccept: {
      type: Array,
      required: false,
      default: void 0
    },
    /**
     * Allows selecting multiple files at once.
     * @default false
     */
    fileMultiple: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Disables the component.
     * @default false
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Title for the search button.
     * Defaults to the label if no title is set.
     * @default undefined
     */
    title: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Disables the upload button.
     * @default false
     */
    disableUploadButton: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Displays the component without the upload button.
     * @default false
     */
    hideUploadButton: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Changes the state to error and displays the provided error message.
     * @default ""
     */
    uploadErrorMessage: {
      type: String,
      required: false,
      default: ""
    },
    /**
     * Required attribute of the input.
     * @default false
     */
    fileRequired: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    /**
     * Emitted when the file selection changes.
     * @event module:DpsFormFile#input
     */
    "input",
    /**
     * Emitted when the upload button gets clicked.
     * @event module:DpsFormFile#upload
     */
    "upload"
  ],
  expose: ["resetSelection"],
  data() {
    return {
      hasError: false,
      filesSelected: null,
      uniqID: this.id ?? getUniqueId("dps-upload-form-group-"),
      rerenderCounter: 0
    };
  },
  computed: {
    fileSearchTitle() {
      return this.title ?? this.label;
    },
    acceptedFilesAsString() {
      if (!Array.isArray(this.fileAccept)) {
        return void 0;
      }
      return this.fileAccept.join(", ");
    },
    acceptedFilesDescription() {
      return this.acceptedFilesAsString ? `${this.fileAccept?.length > 1 ? "Erlaubte Dateiformate" : "Erlaubtes Dateiformat"}: ${this.acceptedFilesAsString}` : void 0;
    },
    acceptedFilesErrorMessage() {
      return this.acceptedFilesAsString ? `Die ${this.fileMultiple ? "gewählten Dateien entsprechen" : "gewählte Datei entspricht"} nicht ${this.fileAccept?.length > 1 ? "den erlaubten Dateiformaten" : "dem erlaubten Dateiformat"}` : "";
    },
    errorMessage() {
      return this.uploadErrorMessage ? this.uploadErrorMessage : this.acceptedFilesErrorMessage;
    },
    isUploadButtonDisabled() {
      return !(Array.isArray(this.filesSelected) ? this.filesSelected?.length : this.filesSelected) || this.disabled || this.disableUploadButton;
    }
  },
  watch: {
    uploadErrorMessage(value) {
      if (value) {
        this.hasError = true;
      }
    }
  },
  mounted() {
    this.hasError = !!this.uploadErrorMessage;
  },
  methods: {
    validateFileType(fileObj) {
      const fileExtension = "." + fileObj.name.toLowerCase().split(".").pop();
      return this.fileAccept.includes(fileObj.type) || this.fileAccept.includes(fileExtension);
    },
    handleSelectionChange(selectedFiles) {
      if (!selectedFiles) {
        this.filesSelected = null;
        this.$emit("input", this.filesSelected);
        return false;
      }
      this.filesSelected = Array.isArray(selectedFiles) ? selectedFiles : [selectedFiles];
      if (this.acceptedFilesAsString) {
        const isValid = Array.from(this.filesSelected).reduce(
          (acc, file) => acc && file && this.validateFileType(file),
          true
        );
        if (!isValid) {
          this.resetSelection(true);
          return false;
        }
      }
      this.hasError = false;
      this.$emit("input", this.filesSelected);
    },
    // May be called as an API method from outside - do not remove!
    resetSelection(onError = false) {
      this.filesSelected = this.fileMultiple ? [] : null;
      this.rerenderCounter++;
      this.$emit("input", this.filesSelected);
      this.hasError = onError;
    }
  }
};
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpsFormFile = resolveComponent("DpsFormFile");
  const _component_DpsButton = resolveComponent("DpsButton");
  const _component_DpsInputGroup = resolveComponent("DpsInputGroup");
  const _component_DpsFormGroup = resolveComponent("DpsFormGroup");
  return openBlock(), createBlock(_component_DpsFormGroup, {
    id: $data.uniqID + "-form-group",
    class: normalizeClass(["dps-upload-form-group", { "dps-upload-form-group--disabled": $props.disabled }]),
    label: $props.label,
    "hide-label": $props.hideLabel,
    description: $options.acceptedFilesDescription,
    "error-feedback": $options.errorMessage,
    valid: !$data.hasError,
    disabled: $props.disabled
  }, {
    default: withCtx(() => [
      createVNode(_component_DpsInputGroup, {
        id: $data.uniqID + "-input-group",
        collapsed: "",
        class: "dps-upload-form-group__input-group"
      }, {
        default: withCtx(() => [
          (openBlock(), createBlock(_component_DpsFormFile, {
            id: $data.uniqID,
            key: "file-input-" + $data.rerenderCounter,
            ref: "fileInput",
            "model-value": $data.filesSelected,
            accept: $options.acceptedFilesAsString,
            multiple: $props.fileMultiple,
            disabled: $props.disabled,
            error: $data.hasError,
            title: $options.fileSearchTitle,
            required: $props.fileRequired,
            "onUpdate:modelValue": $options.handleSelectionChange
          }, null, 8, ["id", "model-value", "accept", "multiple", "disabled", "error", "title", "required", "onUpdate:modelValue"]))
        ]),
        append: withCtx(() => [
          !$props.hideUploadButton ? (openBlock(), createBlock(_component_DpsButton, {
            key: 0,
            title: $props.uploadButtonTitle ?? $props.uploadButtonLabel,
            class: normalizeClass(["dps-upload-form-group__upload-button", {
              "dps-upload-form-group__upload-button--error": $data.hasError,
              "dps-upload-form-group__upload-button--all-disabled": $props.disabled
            }]),
            squared: "",
            size: "lg",
            disabled: $options.isUploadButtonDisabled,
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("upload", $data.uniqID))
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString($props.uploadButtonLabel), 1)
            ]),
            _: 1
          }, 8, ["title", "class", "disabled"])) : createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["id"])
    ]),
    _: 1
  }, 8, ["id", "class", "label", "hide-label", "description", "error-feedback", "valid", "disabled"]);
}
const DpsUploadFormGroup = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$5]]);
const _sfc_main$5 = {
  name: "DpsListGroup",
  props: {
    /**
     * Adds a border around the list group.
     * @default false
     */
    bordered: {
      type: Boolean,
      default: false,
      required: false
    },
    /**
     * Specifies the HTML tag to use for the root element of the component.
     * @default "div"
     */
    tag: {
      type: String,
      default: "div",
      required: false
    }
  }
};
const _hoisted_1$5 = { class: "dps-list-group" };
const _hoisted_2$4 = {
  key: 0,
  class: "dps-list-group__counter"
};
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$5, [
    _ctx.$slots.counter ? (openBlock(), createElementBlock("div", _hoisted_2$4, [
      renderSlot(_ctx.$slots, "counter")
    ])) : createCommentVNode("", true),
    (openBlock(), createBlock(resolveDynamicComponent($props.tag), {
      class: normalizeClass(["dps-list-group__content", {
        "dps-list-group__content--bordered": $props.bordered
      }])
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]))
  ]);
}
const DpsListGroup = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$4]]);
const _sfc_main$4 = defineComponent({
  name: "DpsListGroupItem",
  components: { DpsBadge, DpsIconButton },
  props: {
    /**
     * The unique identifier for the collapsible element. This identifier is used to associate the
     * collapsible content with its corresponding trigger for accessibility and Bootstrap's collapse functionality.
     *
     * @default undefined
     */
    collapseId: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Specifies the HTML tag to use for the root element.
     * @default "div"
     */
    tag: {
      type: String,
      required: false,
      default: "div"
    },
    /**
     * The URL that the hyperlink points to.
     * @default undefined
     */
    href: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Indicates whether the collapsible row content is initially expanded.
     * When set to true, the collapsible content will be visible by default.
     *
     * @default false
     */
    expanded: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    /**
     * This event is fired immediately when the show method has been called.
     */
    "show",
    /**
     * This event is fired immediately when the hide method has been called.
     */
    "hide"
  ],
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    uniqueId() {
      return this.collapseId ? this.collapseId : getUniqueId("dps-list-group-item-");
    },
    computedTag() {
      return this.href ? "a" : this.tag;
    },
    isCollapsible() {
      return !!this.$slots["collapsible-content"];
    }
  },
  watch: {
    expanded(value) {
      this.isExpanded = value;
    }
  },
  mounted() {
    const collapsibleEl = this.$refs.collapsible;
    this.isExpanded = this.expanded;
    if (!collapsibleEl) return;
    collapsibleEl.addEventListener("hide.bs.collapse", () => {
      this.isExpanded = false;
      this.$emit("hide");
    });
    collapsibleEl.addEventListener("show.bs.collapse", () => {
      this.isExpanded = true;
      this.$emit("show");
    });
  },
  methods: {
    handleEnter() {
      if (this.isCollapsible) {
        const trigger = this.$refs.trigger;
        trigger.click();
      }
    }
  }
});
const _hoisted_1$4 = ["data-bs-target", "aria-controls", "aria-expanded"];
const _hoisted_2$3 = { class: "dps-list-group-item__collapse" };
const _hoisted_3$3 = ["id"];
const _hoisted_4$3 = { class: "dps-list-group-item__collapsible-content" };
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent(_ctx.computedTag), {
    class: normalizeClass(["dps-list-group-item", {
      "dps-list-group-item--collapsible": _ctx.isCollapsible,
      "dps-list-group-item--expanded": _ctx.isCollapsible && _ctx.isExpanded
    }]),
    href: _ctx.href
  }, {
    default: withCtx(() => [
      _ctx.isCollapsible ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createElementVNode("div", {
          ref: "trigger",
          class: "dps-list-group-item__trigger",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#" + _ctx.uniqueId,
          "aria-controls": _ctx.uniqueId,
          "aria-expanded": _ctx.expanded,
          tabindex: "0",
          role: "button",
          onKeydown: _cache[0] || (_cache[0] = withKeys((...args) => _ctx.handleEnter && _ctx.handleEnter(...args), ["enter"]))
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 40, _hoisted_1$4),
        createElementVNode("div", _hoisted_2$3, [
          createElementVNode("div", {
            id: _ctx.uniqueId,
            ref: "collapsible",
            class: normalizeClass(["collapse", { show: _ctx.expanded }])
          }, [
            createElementVNode("div", _hoisted_4$3, [
              renderSlot(_ctx.$slots, "collapsible-content")
            ])
          ], 10, _hoisted_3$3)
        ])
      ], 64)) : renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 8, ["class", "href"]);
}
const DpsListGroupItem = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$3]]);
const _sfc_main$3 = defineComponent({
  name: "DpsTableRow",
  props: {
    /**
     * The unique identifier for the collapsible element. This identifier is used to associate the
     * collapsible content with its corresponding trigger for accessibility and Bootstrap's collapse functionality.
     * @default undefined
     */
    collapseId: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * The number of columns the collapsible content should span when expanded.
     * This controls the width of the collapsible content.
     *
     * @default undefined
     */
    collapseColspan: {
      type: Number,
      required: false,
      default: void 0
    },
    /**
     * The starting position (column index) where the collapsible content should be displayed.
     * This can be used to create an offset within the row.
     *
     * @default 0
     */
    collapseColstart: {
      type: Number,
      required: false,
      default: 0
    },
    /**
     * Indicates whether the collapsible row content is initially expanded.
     * When set to true, the collapsible content will be visible by default.
     *
     * @default false
     */
    expanded: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    /**
     * This event is fired immediately when the show method has been called.
     */
    "show",
    /**
     * This event is fired immediately when the hide method has been called.
     */
    "hide"
  ],
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    uniqueId() {
      return this.collapseId ? this.collapseId : getUniqueId("dps-table-row-");
    },
    isCollapsible() {
      return !!this.$slots["collapsible-content"];
    }
  },
  watch: {
    expanded(value) {
      this.isExpanded = value;
    }
  },
  mounted() {
    const collapsibleEl = this.$refs.collapsible;
    this.isExpanded = this.expanded;
    if (!collapsibleEl) return;
    collapsibleEl.addEventListener("hide.bs.collapse", () => {
      this.isExpanded = false;
      this.$emit("hide");
    });
    collapsibleEl.addEventListener("show.bs.collapse", () => {
      this.isExpanded = true;
      this.$emit("show");
    });
  },
  methods: {
    handleEnter() {
      if (this.isCollapsible) {
        const mainElement = this.$refs.mainElement;
        mainElement.click();
      }
    }
  }
});
const _hoisted_1$3 = ["data-bs-toggle", "data-bs-target", "aria-expanded", "aria-controls", "tabindex", "role"];
const _hoisted_2$2 = {
  key: 0,
  class: "dps-table-row dps-table-row--collapse"
};
const _hoisted_3$2 = ["colspan"];
const _hoisted_4$2 = ["colspan"];
const _hoisted_5$2 = ["id"];
const _hoisted_6$2 = { class: "dps-table-row__collapsible-content" };
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("tr", {
      ref: "mainElement",
      class: normalizeClass(["dps-table-row", {
        "dps-table-row--collapsible": _ctx.isCollapsible,
        "dps-table-row--expanded": _ctx.isCollapsible && _ctx.isExpanded
      }]),
      "data-bs-toggle": _ctx.isCollapsible ? "collapse" : void 0,
      "data-bs-target": _ctx.isCollapsible ? "#" + _ctx.uniqueId : void 0,
      "aria-expanded": _ctx.isCollapsible ? _ctx.expanded : void 0,
      "aria-controls": _ctx.isCollapsible ? _ctx.uniqueId : void 0,
      tabindex: _ctx.isCollapsible ? "0" : void 0,
      role: _ctx.isCollapsible ? "button" : void 0,
      onKeydown: _cache[0] || (_cache[0] = withKeys((...args) => _ctx.handleEnter && _ctx.handleEnter(...args), ["enter"]))
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 42, _hoisted_1$3),
    _ctx.isCollapsible ? (openBlock(), createElementBlock("tr", _hoisted_2$2, [
      _ctx.collapseColstart > 0 ? (openBlock(), createElementBlock("td", {
        key: 0,
        colspan: _ctx.collapseColstart
      }, null, 8, _hoisted_3$2)) : createCommentVNode("", true),
      createElementVNode("td", { colspan: _ctx.collapseColspan }, [
        createElementVNode("div", {
          id: _ctx.uniqueId,
          ref: "collapsible",
          class: normalizeClass(["collapse", { show: _ctx.expanded }])
        }, [
          createElementVNode("div", _hoisted_6$2, [
            renderSlot(_ctx.$slots, "collapsible-content")
          ])
        ], 10, _hoisted_5$2)
      ], 8, _hoisted_4$2)
    ])) : createCommentVNode("", true)
  ], 64);
}
const DpsTableRow = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$2]]);
const _sfc_main$2 = defineComponent({
  name: "DpsTable",
  components: { DpsTableRow, DpsFormCheckbox },
  props: {
    /**
     * An array of field definition objects, each defining the properties of a table column.
     *
     * @default []
     */
    fields: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * An array of data objects to be displayed in the table rows.
     * Each object should match the structure defined by the `fields` array.
     *
     * @default []
     */
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Whether to hide the table header while keeping it accessible for screen readers.
     * This is useful for visually minimalist tables while maintaining accessibility.
     *
     * @default false
     */
    hideHeader: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * The key of the field currently being used for sorting the table.
     * Should correspond to one of the `key` values defined in the `fields` array.
     *
     * @default undefined
     */
    sortBy: {
      type: String,
      required: false,
      default: void 0
    },
    /**
     * Indicates whether the sorting is in descending order.
     * When set to `true`, the table will be sorted in descending order; otherwise, it will be in ascending order.
     *
     * @default false
     */
    sortDesc: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * The starting column index where the collapsible content should be displayed.
     * This can create an offset within the table row for the collapsible section.
     *
     * @default undefined
     */
    collapseColstart: {
      type: Number,
      required: false,
      default: void 0
    },
    /**
     * The number of columns the collapsible content should span when expanded.
     * Determines the width of the collapsible content section.
     *
     * @default undefined
     */
    collapseColspan: {
      type: Number,
      required: false,
      default: void 0
    },
    /**
     * Determines the maximum width in percentage of the sticky column.
     *
     * @default undefined
     */
    maxStickyColumnWidth: {
      type: Number,
      required: false,
      default: void 0
    },
    /**
     * Determines the maximum lines of text in a sticky column
     *
     * @default undefined
     */
    maxStickyColumnLines: {
      type: Number,
      required: false,
      default: 2
    }
  },
  emits: [
    /**
     * Emitted when the sortBy property changes.
     *
     * @event update:sort-by
     * @property {string} - The key of the field being sorted. Corresponds to the `key` property in the `fields` array.
     */
    "update:sort-by",
    /**
     * Emitted when the sortDesc property changes.
     *
     * @event update:sort-desc
     * @property {boolean} - Indicates the sort direction. `true` for descending order, `false` for ascending order.
     */
    "update:sort-desc",
    /**
     * Emitted when the status of a header checkbox changes.
     *
     * @event change-checked
     * @property {number} - The key of the field whose checkbox status was changed.
     */
    "change-checked"
  ],
  data() {
    return {
      isScrollable: false,
      isScrolledToRight: false,
      isScrolledToLeft: true
    };
  },
  computed: {
    hasCustomTemplate() {
      return !!this.$slots["table-row"];
    },
    stickyColumns() {
      return this.fields.reduce((acc, field, index) => {
        if (field.sticky) {
          acc.push(index);
        }
        return acc;
      }, []);
    },
    sortedItems() {
      const keys = this.fields.map((field) => field.key);
      if (this.sortBy === void 0 || !keys.includes(this.sortBy)) {
        return this.items;
      }
      const isValidDate = (dateString) => {
        const parsedDate = new Date(dateString);
        return !isNaN(parsedDate.getTime());
      };
      return this.items.slice().sort((a2, b2) => {
        const sortBy = this.sortBy;
        const valA = a2[sortBy];
        const valB = b2[sortBy];
        if (isValidDate(valA) && isValidDate(valB)) {
          const dateValA = String(valA);
          const dateValB = String(valB);
          return this.sortDesc ? new Date(dateValB).getTime() - new Date(dateValA).getTime() : new Date(dateValA).getTime() - new Date(dateValB).getTime();
        }
        const strA = (valA || "").toString().toLowerCase();
        const strB = (valB || "").toString().toLowerCase();
        return this.sortDesc ? strB.localeCompare(strA) : strA.localeCompare(strB);
      });
    },
    ariaSort() {
      return this.fields.reduce(
        (obj, field) => (obj[field.key] = field.sortable ? this.sortBy === field.key ? this.sortDesc ? "descending" : "ascending" : "none" : void 0, obj),
        {}
      );
    }
  },
  watch: {
    items: {
      handler() {
        nextTick(this.setStickyStyles);
      },
      deep: true
    },
    isScrollable() {
      this.setStickyStyles();
    }
  },
  mounted() {
    this.observeTableWidth();
    this.observeScrollPos();
  },
  methods: {
    updateSorting(field) {
      if (!field.sortable) {
        return;
      }
      if (field.key !== this.sortBy) {
        this.$emit("update:sort-by", field.key);
        this.$emit("update:sort-desc", false);
      } else {
        this.$emit("update:sort-desc", !this.sortDesc);
      }
    },
    observeTableWidth() {
      const tableEl = this.$refs.table;
      const tableWrapperEl = this.$refs.tableWrapper;
      const resizeObserver = new ResizeObserver(() => {
        if (tableEl.clientWidth && tableWrapperEl.clientWidth) {
          this.isScrollable = tableEl.clientWidth > tableWrapperEl.clientWidth;
        }
      });
      resizeObserver.observe(tableWrapperEl);
      resizeObserver.observe(tableEl);
    },
    observeScrollPos() {
      const container2 = this.$refs.tableWrapper;
      container2.addEventListener("scroll", () => {
        this.isScrolledToRight = container2.scrollWidth - container2.scrollLeft - container2.clientWidth < 2;
        this.isScrolledToLeft = container2.scrollLeft < 2;
      });
    },
    setStickyStyles() {
      const tableEl = this.$refs.table;
      const tableWrapperEl = this.$refs.tableWrapper;
      const tableContainer = this.$refs.tableContainer;
      if (this.stickyColumns.length === 0) {
        return;
      }
      tableWrapperEl.scrollLeft = 0;
      const rows = tableEl.querySelectorAll("tr");
      for (const row of Array.from(rows)) {
        const cols = row.querySelectorAll(
          "th, td"
        );
        for (const [colIndex, col] of Array.from(cols).entries()) {
          col.style.removeProperty("left");
          col.removeAttribute("data-sticky");
          if (this.stickyColumns.includes(+colIndex)) {
            col.setAttribute("data-sticky", "");
            col.style.left = +colIndex !== this.stickyColumns[0] ? `${cols[colIndex - 1].getBoundingClientRect().width + 1}px` : `${col.offsetLeft}px`;
            if (this.maxStickyColumnWidth && tableContainer) {
              const { width } = tableContainer.getBoundingClientRect();
              col.style.maxWidth = `${width * (this.maxStickyColumnWidth / 100)}px`;
              const text = col.querySelector(".dps-text--clamp");
              if (text) {
                text.style.width = "max-content";
                text.style.maxWidth = "100%";
              }
            }
          }
        }
      }
    }
  }
});
const _hoisted_1$2 = {
  ref: "tableWrapper",
  class: "table-responsive"
};
const _hoisted_2$1 = {
  ref: "table",
  class: "table"
};
const _hoisted_3$1 = ["title", "aria-colindex", "aria-sort", "tabindex", "onClick"];
const _hoisted_4$1 = {
  key: 1,
  class: "dps-table__header-label"
};
const _hoisted_5$1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none"
};
const _hoisted_6$1 = ["fill"];
const _hoisted_7 = ["fill"];
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DpsFormCheckbox = resolveComponent("DpsFormCheckbox");
  const _component_DpsTableRow = resolveComponent("DpsTableRow");
  return openBlock(), createElementBlock("div", {
    ref: "tableContainer",
    class: normalizeClass(["dps-table", {
      "dps-table--scroll-shadow-right": _ctx.isScrollable && !_ctx.isScrolledToRight,
      "dps-table--scroll-shadow-left": _ctx.isScrollable && !_ctx.isScrolledToLeft,
      "dps-table--sticky": _ctx.stickyColumns.length > 0
    }])
  }, [
    createElementVNode("div", _hoisted_1$2, [
      createElementVNode("table", _hoisted_2$1, [
        createElementVNode("thead", {
          class: normalizeClass({ "visually-hidden": _ctx.hideHeader })
        }, [
          createElementVNode("tr", null, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.fields, (field, key) => {
              return openBlock(), createElementBlock("th", {
                key: "th-" + key,
                class: normalizeClass(field.class),
                title: field.sortable ? `Reihenfolge der Spalte "${field.label}" ändern` : void 0,
                scope: "col",
                "aria-colindex": key + 1,
                "aria-sort": _ctx.ariaSort[field.key],
                tabindex: field.sortable ? "0" : void 0,
                onClick: ($event) => _ctx.updateSorting(field)
              }, [
                field.checkbox ? (openBlock(), createBlock(_component_DpsFormCheckbox, {
                  key: 0,
                  modelValue: field.checkboxChecked,
                  "onUpdate:modelValue": [($event) => field.checkboxChecked = $event, ($event) => _ctx.$emit("change-checked", key)],
                  tooltip: field.label,
                  "hide-label": true,
                  disabled: field.checkboxDisabled
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(field.label), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "tooltip", "disabled"])) : (openBlock(), createElementBlock("div", _hoisted_4$1, [
                  createTextVNode(toDisplayString(field.label) + " ", 1),
                  field.sortable ? (openBlock(), createElementBlock("svg", _hoisted_5$1, [
                    createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M4.19526 6.0286C3.93491 6.28895 3.93491 6.71106 4.19526 6.97141C4.45561 7.23175 4.87772 7.23175 5.13807 6.97141L8 4.10948L10.8619 6.97141C11.1223 7.23175 11.5444 7.23176 11.8047 6.97141C12.0651 6.71106 12.0651 6.28895 11.8047 6.0286L8.47141 2.69526C8.34638 2.57024 8.17681 2.5 8 2.5C7.82319 2.5 7.65362 2.57024 7.5286 2.69526L4.19526 6.0286Z",
                      fill: _ctx.sortBy === field.key && !_ctx.sortDesc ? "#04071A" : "#C8CACC"
                    }, null, 8, _hoisted_6$1),
                    createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M11.8047 10.9714C12.0651 10.7111 12.0651 10.289 11.8047 10.0286C11.5444 9.76829 11.1223 9.76829 10.8619 10.0286L8 12.8906L5.13807 10.0286C4.87772 9.76829 4.45561 9.76829 4.19526 10.0286C3.93491 10.289 3.93491 10.7111 4.19526 10.9714L7.5286 14.3048C7.78895 14.5651 8.21106 14.5651 8.47141 14.3048L11.8047 10.9714Z",
                      fill: _ctx.sortBy === field.key && _ctx.sortDesc ? "#04071A" : "#C8CACC"
                    }, null, 8, _hoisted_7)
                  ])) : createCommentVNode("", true)
                ]))
              ], 10, _hoisted_3$1);
            }), 128))
          ])
        ], 2),
        createElementVNode("tbody", null, [
          _ctx.hasCustomTemplate ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(_ctx.sortedItems, (item, key) => {
            return openBlock(), createBlock(_component_DpsTableRow, {
              key: "table-row-" + key,
              "collapse-colspan": _ctx.collapseColspan ?? _ctx.fields.length,
              "collapse-colstart": _ctx.collapseColstart
            }, createSlots({
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "table-row", { content: item })
              ]),
              _: 2
            }, [
              _ctx.$slots["table-row-collapsible-content"] ? {
                name: "collapsible-content",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "table-row-collapsible-content", { content: item })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["collapse-colspan", "collapse-colstart"]);
          }), 128)) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(_ctx.sortedItems, (item, itemKey) => {
            return openBlock(), createElementBlock("tr", { key: itemKey }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.fields, (field, fieldIndex) => {
                return openBlock(), createElementBlock("td", {
                  key: itemKey + "-" + fieldIndex
                }, [
                  _ctx.maxStickyColumnWidth ? (openBlock(), createElementBlock("div", {
                    key: 0,
                    class: "dps-text--clamp",
                    style: normalizeStyle({ "--clamp-lines": _ctx.maxStickyColumnLines })
                  }, toDisplayString(item[field.key] ?? "-"), 5)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createTextVNode(toDisplayString(item[field.key] ?? "-"), 1)
                  ], 64))
                ]);
              }), 128))
            ]);
          }), 128))
        ])
      ], 512)
    ], 512)
  ], 2);
}
const DpsTable = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$1]]);
const _sfc_main$1 = defineComponent({
  name: "DpsLoadingSpinner",
  props: {
    /**
     * Aria label for the spinner.
     * @default undefined
     */
    ariaLabel: {
      type: String,
      required: false,
      default: "Laden"
    }
  }
});
const _hoisted_1$1 = ["aria-label"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "dps-loading-spinner align-content-center d-flex gap-2",
    "aria-busy": "true",
    "aria-label": _ctx.ariaLabel
  }, [
    renderSlot(_ctx.$slots, "default"),
    _cache[0] || (_cache[0] = createElementVNode("span", { class: "dps-icon dps-icon--loading-circle" }, null, -1))
  ], 8, _hoisted_1$1);
}
const DpsLoadingSpinner = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render]]);
const _hoisted_1 = { class: "dps-anchor-nav" };
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = ["href", "aria-label", "title"];
const _hoisted_4 = { class: "dps-anchor-nav--item__short" };
const _hoisted_5 = { class: "dps-anchor-nav--item__listing" };
const _hoisted_6 = { class: "dps-anchor-nav--item__name ps-2" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DpsAnchorNav",
  props: {
    ariaLabel: { default: "Seitennavigation" }
  },
  setup(__props) {
    const headerElement = ref(null);
    const sections = ref([]);
    const sectionsVisibility = reactive(/* @__PURE__ */ new Map());
    let visibilityHandler = null;
    const headerHeight = computed(() => {
      return headerElement.value?.clientHeight || 0;
    });
    function checkElementVisibility(elementId) {
      const element = document.getElementById(elementId);
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      return headerHeight.value <= rect.top && rect.top <= windowHeight || headerHeight.value <= rect.bottom && rect.bottom <= windowHeight;
    }
    function isSectionVisible(sectionId) {
      return sectionsVisibility.get(sectionId) || false;
    }
    function handleVisibilityCheck() {
      const visibleCount = Array.from(sectionsVisibility.values()).filter(
        Boolean
      ).length;
      sections.value.forEach(({ id }) => {
        const currentlyVisible = sectionsVisibility.get(id) || false;
        if (!(currentlyVisible && visibleCount === 1)) {
          sectionsVisibility.set(id, checkElementVisibility(id));
        }
      });
    }
    function calcAsideMargin() {
      const space = 60;
      const container2 = document.querySelector(
        "[data-dps-sidebar-navigation-container]"
      );
      if (!container2) return;
      const rect = container2.getBoundingClientRect();
      const margin = rect.left;
      const articles = Array.from(
        container2.querySelectorAll("[data-dps-sidebar-navigation-section]")
      );
      articles.forEach((el) => {
        el.style.marginLeft = `${Math.max(space - margin, 0)}px`;
      });
    }
    onMounted(() => {
      headerElement.value = document.querySelector("header");
      const container2 = document.querySelector(
        "[data-dps-sidebar-navigation-container]"
      );
      if (!container2) return;
      const articleElements = Array.from(
        container2.querySelectorAll("[data-dps-sidebar-navigation-section]")
      );
      sections.value = articleElements.map((article) => ({
        id: article.getAttribute("id") || "",
        label: article.getAttribute("data-label") || ""
      })).filter((el) => el.id && el.label);
      sectionsVisibility.clear();
      sections.value.forEach((navi) => {
        sectionsVisibility.set(navi.id, false);
      });
      calcAsideMargin();
      visibilityHandler = handleVisibilityCheck;
      window.addEventListener("scroll", visibilityHandler);
      window.addEventListener("resize", visibilityHandler);
      handleVisibilityCheck();
    });
    onBeforeUnmount(() => {
      if (visibilityHandler) {
        window.removeEventListener("scroll", visibilityHandler);
        window.removeEventListener("resize", visibilityHandler);
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("aside", _hoisted_1, [
        createElementVNode("nav", { "aria-label": _ctx.ariaLabel }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(sections.value, (section, index) => {
            return openBlock(), createElementBlock("div", {
              key: index,
              class: normalizeClass(["dps-anchor-nav--item", { active: isSectionVisible(section.id) }])
            }, [
              createElementVNode("a", {
                tabindex: "0",
                href: `#${section.id.toLowerCase()}`,
                "aria-label": `Navigiere zur ${index + 1}. Sektion: ${section.label}`,
                title: `Navigiere zur ${index + 1}. Sektion: ${section.label}`
              }, [
                withDirectives(createElementVNode("span", _hoisted_4, _cache[0] || (_cache[0] = [
                  createElementVNode("svg", {
                    width: "23",
                    height: "24",
                    viewBox: "0 0 23 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    createElementVNode("circle", {
                      cx: "11.5",
                      cy: "12",
                      r: "6.5",
                      class: "dps-anchor-nav--item__circle"
                    })
                  ], -1)
                ]), 512), [
                  [vShow, !isSectionVisible(section.id)]
                ]),
                createElementVNode("span", _hoisted_5, toDisplayString(index + 1), 1),
                createElementVNode("span", _hoisted_6, toDisplayString(section.label), 1)
              ], 8, _hoisted_3)
            ], 2);
          }), 128))
        ], 8, _hoisted_2)
      ]);
    };
  }
});
function setStickyColumnStyles(tableElement) {
  const cols = tableElement.querySelectorAll("[data-sticky]");
  for (const col of Array.from(cols)) {
    const { width, height } = col.getBoundingClientRect();
    const row = col.closest("tr");
    col.style.width = `${width}px`;
    col.style.minWidth = `${width}px`;
    col.style.height = `${height}px`;
    if (row) {
      row.style.height = `${height}px`;
    }
  }
}
window.Bootstrap = Bootstrap;
export {
  DpsActionMenu,
  DpsActionMenuItem,
  DpsAlert,
  DpsAlphabeticFilter,
  _sfc_main as DpsAnchorNav,
  DpsBadge,
  DpsButton,
  DpsCollapsible,
  DpsFilterButton,
  DpsFormCheckbox,
  DpsFormCheckboxGroup,
  DpsFormDatepicker,
  DpsFormFile,
  DpsFormGroup,
  DpsFormInput,
  DpsFormRadio,
  DpsFormRadioGroup,
  DpsFormSelect,
  DpsFormTextarea,
  DpsFormToggle,
  DpsIconButton,
  DpsInputGroup,
  DpsLink,
  DpsListGroup,
  DpsListGroupItem,
  DpsLoadingSpinner,
  DpsLogoutAlert,
  DpsPagination,
  DpsPrimeVuePlugin,
  DpsSortSelect,
  DpsTable,
  DpsTableRow,
  DpsUploadFormGroup,
  dpsPrimeVueConfig,
  getUniqueId,
  setStickyColumnStyles
};
